// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M7.3 24l-2.8-2.8 9.3-9.2-9.3-9.2L7.3 0l12.2 12z%27 fill=%27%233A4570%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M0 7.3l2.8-2.8 9.2 9.3 9.2-9.3L24 7.3 12 19.5z%27 fill=%27%233A4570%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inria+Serif&family=Quicksand:wght@500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** SCSS Imports */
.ais-Breadcrumb-list,
.ais-CurrentRefinements-list,
.ais-HierarchicalMenu-list,
.ais-Hits-list,
.ais-InfiniteHits-list,
.ais-InfiniteResults-list,
.ais-Menu-list,
.ais-NumericMenu-list,
.ais-Pagination-list,
.ais-RatingMenu-list,
.ais-RefinementList-list,
.ais-Results-list,
.ais-ToggleRefinement-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ais-ClearRefinements-button,
.ais-CurrentRefinements-delete,
.ais-CurrentRefinements-reset,
.ais-GeoSearch-redo,
.ais-GeoSearch-reset,
.ais-HierarchicalMenu-showMore,
.ais-InfiniteHits-loadMore,
.ais-InfiniteHits-loadPrevious,
.ais-InfiniteResults-loadMore,
.ais-Menu-showMore,
.ais-RangeInput-submit,
.ais-RefinementList-showMore,
.ais-SearchBox-reset,
.ais-SearchBox-submit,
.ais-VoiceSearch-button {
  padding: 0;
  overflow: visible;
  font: inherit;
  line-height: normal;
  color: inherit;
  background: none;
  border: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ais-ClearRefinements-button::-moz-focus-inner,
.ais-CurrentRefinements-delete::-moz-focus-inner,
.ais-CurrentRefinements-reset::-moz-focus-inner,
.ais-GeoSearch-redo::-moz-focus-inner,
.ais-GeoSearch-reset::-moz-focus-inner,
.ais-HierarchicalMenu-showMore::-moz-focus-inner,
.ais-InfiniteHits-loadMore::-moz-focus-inner,
.ais-InfiniteHits-loadPrevious::-moz-focus-inner,
.ais-InfiniteResults-loadMore::-moz-focus-inner,
.ais-Menu-showMore::-moz-focus-inner,
.ais-RangeInput-submit::-moz-focus-inner,
.ais-RefinementList-showMore::-moz-focus-inner,
.ais-SearchBox-reset::-moz-focus-inner,
.ais-SearchBox-submit::-moz-focus-inner,
.ais-VoiceSearch-button::-moz-focus-inner {
  padding: 0;
  border: 0;
}

.ais-ClearRefinements-button[disabled],
.ais-CurrentRefinements-delete[disabled],
.ais-CurrentRefinements-reset[disabled],
.ais-GeoSearch-redo[disabled],
.ais-GeoSearch-reset[disabled],
.ais-HierarchicalMenu-showMore[disabled],
.ais-InfiniteHits-loadMore[disabled],
.ais-InfiniteHits-loadPrevious[disabled],
.ais-InfiniteResults-loadMore[disabled],
.ais-Menu-showMore[disabled],
.ais-RangeInput-submit[disabled],
.ais-RefinementList-showMore[disabled],
.ais-SearchBox-reset[disabled],
.ais-SearchBox-submit[disabled],
.ais-VoiceSearch-button[disabled] {
  cursor: default;
}

.ais-Breadcrumb-item,
.ais-Breadcrumb-list,
.ais-Pagination-list,
.ais-PoweredBy,
.ais-RangeInput-form,
.ais-RatingMenu-link {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.ais-GeoSearch,
.ais-GeoSearch-map {
  height: 100%;
}

.ais-HierarchicalMenu-list .ais-HierarchicalMenu-list {
  margin-left: 1em;
}

.ais-PoweredBy-logo {
  display: block;
  height: 1.2em;
  width: auto;
}

.ais-RatingMenu-starIcon {
  display: block;
  width: 20px;
  height: 20px;
}

.ais-SearchBox-input::-ms-clear, .ais-SearchBox-input::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}
.ais-SearchBox-input::-webkit-search-cancel-button, .ais-SearchBox-input::-webkit-search-decoration, .ais-SearchBox-input::-webkit-search-results-button, .ais-SearchBox-input::-webkit-search-results-decoration {
  display: none;
}

.ais-RangeSlider .rheostat {
  overflow: visible;
  margin-top: 40px;
  margin-bottom: 40px;
}
.ais-RangeSlider .rheostat-background {
  height: 6px;
  top: 0;
  width: 100%;
}
.ais-RangeSlider .rheostat-handle {
  margin-left: -12px;
  top: -7px;
}
.ais-RangeSlider .rheostat-background {
  position: relative;
  background-color: #fff;
  border: 1px solid #aaa;
}
.ais-RangeSlider .rheostat-progress {
  position: absolute;
  top: 1px;
  height: 4px;
  background-color: #333;
}

.rheostat-handle {
  position: relative;
  z-index: 1;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 1px solid #333;
  border-radius: 50%;
  cursor: -webkit-grab;
  cursor: grab;
}

.rheostat-marker {
  margin-left: -1px;
  position: absolute;
  width: 1px;
  height: 5px;
  background-color: #aaa;
}

.rheostat-marker--large {
  height: 9px;
}

.rheostat-value {
  padding-top: 15px;
}

.rheostat-tooltip,
.rheostat-value {
  margin-left: 50%;
  position: absolute;
  text-align: center;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.rheostat-tooltip {
  top: -22px;
}

[class^=ais-] {
  font-size: 1rem;
  box-sizing: border-box;
}

a[class^=ais-] {
  text-decoration: none;
}

.ais-Breadcrumb,
.ais-ClearRefinements,
.ais-CurrentRefinements,
.ais-GeoSearch,
.ais-HierarchicalMenu,
.ais-Hits,
.ais-HitsPerPage,
.ais-InfiniteHits,
.ais-InfiniteResults,
.ais-Menu,
.ais-MenuSelect,
.ais-NumericMenu,
.ais-NumericSelector,
.ais-Pagination,
.ais-Panel,
.ais-PoweredBy,
.ais-RangeInput,
.ais-RangeSlider,
.ais-RatingMenu,
.ais-RefinementList,
.ais-Results,
.ais-ResultsPerPage,
.ais-SearchBox,
.ais-SortBy,
.ais-Stats,
.ais-ToggleRefinement {
  color: #3a4570;
}

.ais-Breadcrumb-item--selected,
.ais-HierarchicalMenu-item--selected,
.ais-Menu-item--selected {
  font-weight: 700;
}

.ais-Breadcrumb-separator {
  margin: 0 0.3em;
  font-weight: 400;
}

.ais-Breadcrumb-link,
.ais-HierarchicalMenu-link,
.ais-Menu-link,
.ais-Pagination-link,
.ais-RatingMenu-link {
  color: #0096db;
  transition: color 0.2s ease-out;
}

.ais-Breadcrumb-link:focus, .ais-Breadcrumb-link:hover {
  color: #0073a8;
}

.ais-HierarchicalMenu-link:focus, .ais-HierarchicalMenu-link:hover {
  color: #0073a8;
}

.ais-Menu-link:focus, .ais-Menu-link:hover {
  color: #0073a8;
}

.ais-Pagination-link:focus, .ais-Pagination-link:hover {
  color: #0073a8;
}

.ais-RatingMenu-link:focus, .ais-RatingMenu-link:hover {
  color: #0073a8;
}

.ais-ClearRefinements-button,
.ais-CurrentRefinements-reset,
.ais-GeoSearch-redo,
.ais-GeoSearch-reset,
.ais-HierarchicalMenu-showMore,
.ais-InfiniteHits-loadMore,
.ais-InfiniteHits-loadPrevious,
.ais-InfiniteResults-loadMore,
.ais-Menu-showMore,
.ais-RefinementList-showMore {
  padding: 0.3rem 0.5rem;
  font-size: 0.8rem;
  color: #fff;
  background-color: #0096db;
  border-radius: 5px;
  transition: background-color 0.2s ease-out;
  outline: none;
}

.ais-ClearRefinements-button:focus, .ais-ClearRefinements-button:hover {
  background-color: #0073a8;
}

.ais-CurrentRefinements-reset:focus, .ais-CurrentRefinements-reset:hover {
  background-color: #0073a8;
}

.ais-GeoSearch-redo:focus, .ais-GeoSearch-redo:hover {
  background-color: #0073a8;
}

.ais-GeoSearch-reset:focus, .ais-GeoSearch-reset:hover {
  background-color: #0073a8;
}

.ais-HierarchicalMenu-showMore:focus, .ais-HierarchicalMenu-showMore:hover {
  background-color: #0073a8;
}

.ais-InfiniteHits-loadMore:focus, .ais-InfiniteHits-loadMore:hover {
  background-color: #0073a8;
}

.ais-InfiniteHits-loadPrevious:focus, .ais-InfiniteHits-loadPrevious:hover {
  background-color: #0073a8;
}

.ais-InfiniteResults-loadMore:focus, .ais-InfiniteResults-loadMore:hover {
  background-color: #0073a8;
}

.ais-Menu-showMore:focus, .ais-Menu-showMore:hover {
  background-color: #0073a8;
}

.ais-RefinementList-showMore:focus, .ais-RefinementList-showMore:hover {
  background-color: #0073a8;
}

.ais-ClearRefinements-button--disabled,
.ais-GeoSearch-redo--disabled,
.ais-GeoSearch-reset--disabled,
.ais-HierarchicalMenu-showMore--disabled,
.ais-InfiniteHits-loadMore--disabled,
.ais-InfiniteResults-loadMore--disabled,
.ais-Menu-showMore--disabled,
.ais-RefinementList-showMore--disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ais-ClearRefinements-button--disabled:focus, .ais-ClearRefinements-button--disabled:hover {
  background-color: #0096db;
}

.ais-GeoSearch-redo--disabled:focus, .ais-GeoSearch-redo--disabled:hover {
  background-color: #0096db;
}

.ais-GeoSearch-reset--disabled:focus, .ais-GeoSearch-reset--disabled:hover {
  background-color: #0096db;
}

.ais-HierarchicalMenu-showMore--disabled:focus, .ais-HierarchicalMenu-showMore--disabled:hover {
  background-color: #0096db;
}

.ais-InfiniteHits-loadMore--disabled:focus, .ais-InfiniteHits-loadMore--disabled:hover {
  background-color: #0096db;
}

.ais-InfiniteResults-loadMore--disabled:focus, .ais-InfiniteResults-loadMore--disabled:hover {
  background-color: #0096db;
}

.ais-Menu-showMore--disabled:focus, .ais-Menu-showMore--disabled:hover {
  background-color: #0096db;
}

.ais-RefinementList-showMore--disabled:focus, .ais-RefinementList-showMore--disabled:hover {
  background-color: #0096db;
}

.ais-InfiniteHits-loadPrevious--disabled {
  display: none;
}

.ais-CurrentRefinements {
  margin-top: -0.3rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.ais-CurrentRefinements-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.ais-CurrentRefinements-item {
  margin-right: 0.3rem;
  margin-top: 0.3rem;
  padding: 0.3rem 0.5rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  background-color: #495588;
  border-radius: 5px;
}

.ais-CurrentRefinements-category {
  margin-left: 0.3em;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.ais-CurrentRefinements-delete {
  margin-left: 0.3rem;
}

.ais-CurrentRefinements-categoryLabel,
.ais-CurrentRefinements-delete,
.ais-CurrentRefinements-label {
  white-space: nowrap;
  font-size: 0.8rem;
  color: #fff;
}

.ais-CurrentRefinements-reset {
  margin-top: 0.3rem;
  white-space: nowrap;
}
.ais-CurrentRefinements-reset + .ais-CurrentRefinements-list {
  margin-left: 0.3rem;
}

.ais-GeoSearch {
  position: relative;
}

.ais-GeoSearch-control {
  position: absolute;
  top: 0.8rem;
  left: 3.75rem;
}

.ais-GeoSearch-label {
  display: block;
  padding: 0.3rem 0.5rem;
  font-size: 0.8rem;
  background-color: #fff;
  border-radius: 5px;
  transition: background-color 0.2s ease-out;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  outline: none;
}

.ais-GeoSearch-input {
  margin: 0 0.25rem 0 0;
}

.ais-GeoSearch-label,
.ais-GeoSearch-redo {
  white-space: nowrap;
}

.ais-GeoSearch-reset {
  white-space: nowrap;
  position: absolute;
  bottom: 1.25rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.ais-HierarchicalMenu-link,
.ais-Menu-link {
  display: block;
  line-height: 1.5;
}

.ais-HierarchicalMenu-list,
.ais-Menu-list,
.ais-NumericMenu-list,
.ais-RatingMenu-list,
.ais-RefinementList-list {
  font-weight: 400;
  line-height: 1.5;
}

.ais-HierarchicalMenu-link:after {
  margin-left: 0.3em;
  content: "";
  width: 10px;
  height: 10px;
  display: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
}

.ais-HierarchicalMenu-item--parent > .ais-HierarchicalMenu-link:after {
  display: inline-block;
}

.ais-HierarchicalMenu-item--selected > .ais-HierarchicalMenu-link:after {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.ais-CurrentRefinements-count,
.ais-RatingMenu-count {
  font-size: 0.8rem;
}

.ais-CurrentRefinements-count:before,
.ais-RatingMenu-count:before {
  content: "(";
}

.ais-CurrentRefinements-count:after,
.ais-RatingMenu-count:after {
  content: ")";
}

.ais-HierarchicalMenu-count,
.ais-Menu-count,
.ais-RefinementList-count,
.ais-ToggleRefinement-count {
  padding: 0.1rem 0.4rem;
  font-size: 0.8rem;
  color: #3a4570;
  background-color: #dfe2ee;
  border-radius: 8px;
}

.ais-HierarchicalMenu-showMore,
.ais-Menu-showMore,
.ais-RefinementList-showMore {
  margin-top: 0.5rem;
}

.ais-Highlight-highlighted,
.ais-Snippet-highlighted {
  background-color: #ffc168;
}

.ais-Hits-list,
.ais-InfiniteHits-list,
.ais-InfiniteResults-list,
.ais-Results-list {
  margin-top: -1rem;
  margin-left: -1rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.ais-Panel-body .ais-Hits-list,
.ais-Panel-body .ais-InfiniteHits-list,
.ais-Panel-body .ais-InfiniteResults-list,
.ais-Panel-body .ais-Results-list {
  margin: 0.5rem 0 0 -1rem;
}

.ais-Hits-item,
.ais-InfiniteHits-item,
.ais-InfiniteResults-item,
.ais-Results-item {
  margin-top: 1rem;
  margin-left: 1rem;
  padding: 1rem;
  width: calc(25% - 1rem);
  border: 1px solid #c4c8d8;
  box-shadow: 0 2px 5px 0 #e3e5ec;
}

.ais-Panel-body .ais-Hits-item,
.ais-Panel-body .ais-InfiniteHits-item,
.ais-Panel-body .ais-InfiniteResults-item,
.ais-Panel-body .ais-Results-item {
  margin: 0.5rem 0 0.5rem 1rem;
}

.ais-InfiniteHits-loadMore,
.ais-InfiniteResults-loadMore {
  margin-top: 1rem;
}

.ais-InfiniteHits-loadPrevious {
  margin-bottom: 1rem;
}

.ais-HitsPerPage-select,
.ais-MenuSelect-select,
.ais-NumericSelector-select,
.ais-ResultsPerPage-select,
.ais-SortBy-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0.3rem 2rem 0.3rem 0.3rem;
  max-width: 100%;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 10px 10px;
  background-position: 92% 50%;
  border: 1px solid #c4c8d8;
  border-radius: 5px;
}

.ais-Panel--collapsible {
  position: relative;
}
.ais-Panel--collapsible.ais-Panel--collapsed .ais-Panel-body,
.ais-Panel--collapsible.ais-Panel--collapsed .ais-Panel-footer {
  display: none;
}
.ais-Panel--collapsible .ais-Panel-collapseButton {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
  border: none;
  background: none;
}

.ais-Panel-header {
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #c4c8d8;
}

.ais-Panel-footer {
  margin-top: 0.5rem;
  font-size: 0.8rem;
}

.ais-RangeInput-input {
  padding: 0 0.2rem;
  width: 5rem;
  height: 1.5rem;
  line-height: 1.5rem;
}

.ais-RangeInput-separator {
  margin: 0 0.3rem;
}

.ais-RangeInput-submit {
  margin-left: 0.3rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0 0.5rem;
  height: 1.5rem;
  line-height: 1.5rem;
  font-size: 0.8rem;
  color: #fff;
  background-color: #0096db;
  border: none;
  border-radius: 5px;
  transition: 0.2s ease-out;
  outline: none;
}
.ais-RangeInput-submit:focus, .ais-RangeInput-submit:hover {
  background-color: #0073a8;
}

.ais-RatingMenu-count {
  color: #3a4570;
}

.ais-Pagination-list {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.ais-Pagination-item + .ais-Pagination-item {
  margin-left: 0.3rem;
}

.ais-Pagination-link {
  padding: 0.3rem 0.6rem;
  display: block;
  border: 1px solid #c4c8d8;
  border-radius: 5px;
  transition: background-color 0.2s ease-out;
}
.ais-Pagination-link:focus, .ais-Pagination-link:hover {
  background-color: #e3e5ec;
}

.ais-Pagination-item--disabled .ais-Pagination-link {
  opacity: 0.6;
  cursor: not-allowed;
  color: #a5abc4;
}
.ais-Pagination-item--disabled .ais-Pagination-link:focus, .ais-Pagination-item--disabled .ais-Pagination-link:hover {
  color: #a5abc4;
  background-color: #fff;
}

.ais-Pagination-item--selected .ais-Pagination-link {
  color: #fff;
  background-color: #0096db;
  border-color: #0096db;
}
.ais-Pagination-item--selected .ais-Pagination-link:focus, .ais-Pagination-item--selected .ais-Pagination-link:hover {
  color: #fff;
}

.ais-PoweredBy-text,
.ais-Stats-text,
.rheostat-tooltip,
.rheostat-value {
  font-size: 0.8rem;
}

.ais-PoweredBy-logo {
  margin-left: 0.3rem;
}

.ais-RangeSlider .rheostat-progress {
  background-color: #495588;
}
.ais-RangeSlider .rheostat-background {
  border-color: #878faf;
  box-sizing: border-box;
}
.ais-RangeSlider .rheostat-handle {
  border-color: #878faf;
}
.ais-RangeSlider .rheostat-marker {
  background-color: #878faf;
}

.ais-Panel-body .ais-RangeSlider {
  margin: 2rem 0;
}

.ais-RangeSlider-handle {
  width: 20px;
  height: 20px;
  position: relative;
  z-index: 1;
  background: #fff;
  border: 1px solid #46aeda;
  border-radius: 50%;
  cursor: pointer;
}

.ais-RangeSlider-tooltip {
  position: absolute;
  background: #fff;
  top: -22px;
  font-size: 0.8em;
}

.ais-RangeSlider-value {
  width: 40px;
  position: absolute;
  text-align: center;
  margin-left: -20px;
  padding-top: 15px;
  font-size: 0.8em;
}

.ais-RangeSlider-marker {
  position: absolute;
  background: #ddd;
  margin-left: -1px;
  width: 1px;
  height: 5px;
}

.ais-RatingMenu-item--disabled .ais-RatingMenu-count,
.ais-RatingMenu-item--disabled .ais-RatingMenu-label {
  color: #c4c8d8;
}

.ais-RatingMenu-item--selected {
  font-weight: 700;
}

.ais-RatingMenu-link {
  line-height: 1.5;
}
.ais-RatingMenu-link > * + * {
  margin-left: 0.3rem;
}

.ais-RatingMenu-starIcon {
  position: relative;
  top: -1px;
  width: 15px;
  fill: #ffc168;
}

.ais-RatingMenu-item--disabled .ais-RatingMenu-starIcon {
  fill: #c4c8d8;
}

.ais-HierarchicalMenu-searchBox > *,
.ais-Menu-searchBox > *,
.ais-RefinementList-searchBox > * {
  margin-bottom: 0.5rem;
}

.ais-SearchBox-form {
  display: block;
  position: relative;
}

.ais-SearchBox-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0.3rem 1.7rem;
  width: 100%;
  position: relative;
  background-color: #fff;
  border: 1px solid #c4c8d8;
  border-radius: 5px;
}
.ais-SearchBox-input::-webkit-input-placeholder, .ais-SearchBox-input::-moz-placeholder, .ais-SearchBox-input:-ms-input-placeholder, .ais-SearchBox-input:-moz-placeholder {
  color: #a5aed1;
}

.ais-SearchBox-loadingIndicator,
.ais-SearchBox-reset {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: absolute;
  z-index: 1;
  width: 20px;
  height: 20px;
  top: 50%;
  right: 0.3rem;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.ais-SearchBox-submit {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: absolute;
  z-index: 1;
  width: 20px;
  height: 20px;
  top: 50%;
  right: 0.3rem;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0.3rem;
}

.ais-SearchBox-reset {
  right: 0.3rem;
}

.ais-SearchBox-loadingIcon,
.ais-SearchBox-resetIcon,
.ais-SearchBox-submitIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}

.ais-SearchBox-resetIcon path {
  fill: #495588;
}

.ais-SearchBox-submitIcon {
  width: 14px;
  height: 14px;
}
.ais-SearchBox-submitIcon path {
  fill: #495588;
}

.ais-SearchBox-resetIcon {
  width: 12px;
  height: 12px;
}

.ais-SearchBox-loadingIcon {
  width: 16px;
  height: 16px;
}

.ais-VoiceSearch-button {
  border: none;
  width: 24px;
  height: 24px;
  padding: 4px;
  border-radius: 50%;
  color: #3a4570;
  background-color: transparent;
}
.ais-VoiceSearch-button svg {
  color: currentColor;
}
.ais-VoiceSearch-button:hover {
  cursor: pointer;
  background-color: #a5aed1;
  color: #fff;
}
.ais-VoiceSearch-button:disabled {
  color: #a5aed1;
}
.ais-VoiceSearch-button:disabled:hover {
  color: #a5aed1;
  cursor: not-allowed;
  background: inherit;
}

.btn {
  padding: 7.5px 15px;
  background: #306BD9;
  border: 1px #ffffff solid;
  border-radius: 4px;
}
.btn:hover {
  text-decoration: none;
  background-color: #ffffff;
  color: #9230D9;
  transition: ease-in 0.5s;
}

.btn.secondary {
  background: #306BD9;
  border-radius: 5px;
  border: 2px solid #306BD9;
  color: #ffffff;
}
.btn.secondary:hover {
  background-color: transparent;
  color: #9230D9;
  border-radius: 5px;
  border: 1px solid #9230D9;
  transition: ease-in 0.5s;
}

.btn.rounded {
  border-radius: 20px;
  padding: 15px;
}

/** Google Fonts */
/** Font Awesome */
/*!
 * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
.fa {
  font-family: var(--fa-style-family, "Font Awesome 6 Free");
  font-weight: var(--fa-style, 900);
}

.fa,
.fa-classic,
.fa-sharp,
.fas,
.fa-solid,
.far,
.fa-regular,
.fab,
.fa-brands {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
}

.fas,
.fa-classic,
.fa-solid,
.far,
.fa-regular {
  font-family: "Font Awesome 6 Free";
}

.fab,
.fa-brands {
  font-family: "Font Awesome 6 Brands";
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
  .fa-bounce,
  .fa-fade,
  .fa-beat-fade,
  .fa-flip,
  .fa-pulse,
  .fa-shake,
  .fa-spin,
  .fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: var(--fa-stack-z-index, auto);
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-0::before {
  content: "\\30 ";
}

.fa-1::before {
  content: "\\31 ";
}

.fa-2::before {
  content: "\\32 ";
}

.fa-3::before {
  content: "\\33 ";
}

.fa-4::before {
  content: "\\34 ";
}

.fa-5::before {
  content: "\\35 ";
}

.fa-6::before {
  content: "\\36 ";
}

.fa-7::before {
  content: "\\37 ";
}

.fa-8::before {
  content: "\\38 ";
}

.fa-9::before {
  content: "\\39 ";
}

.fa-fill-drip::before {
  content: "\\f576";
}

.fa-arrows-to-circle::before {
  content: "\\e4bd";
}

.fa-circle-chevron-right::before {
  content: "\\f138";
}

.fa-chevron-circle-right::before {
  content: "\\f138";
}

.fa-at::before {
  content: "\\@";
}

.fa-trash-can::before {
  content: "\\f2ed";
}

.fa-trash-alt::before {
  content: "\\f2ed";
}

.fa-text-height::before {
  content: "\\f034";
}

.fa-user-xmark::before {
  content: "\\f235";
}

.fa-user-times::before {
  content: "\\f235";
}

.fa-stethoscope::before {
  content: "\\f0f1";
}

.fa-message::before {
  content: "\\f27a";
}

.fa-comment-alt::before {
  content: "\\f27a";
}

.fa-info::before {
  content: "\\f129";
}

.fa-down-left-and-up-right-to-center::before {
  content: "\\f422";
}

.fa-compress-alt::before {
  content: "\\f422";
}

.fa-explosion::before {
  content: "\\e4e9";
}

.fa-file-lines::before {
  content: "\\f15c";
}

.fa-file-alt::before {
  content: "\\f15c";
}

.fa-file-text::before {
  content: "\\f15c";
}

.fa-wave-square::before {
  content: "\\f83e";
}

.fa-ring::before {
  content: "\\f70b";
}

.fa-building-un::before {
  content: "\\e4d9";
}

.fa-dice-three::before {
  content: "\\f527";
}

.fa-calendar-days::before {
  content: "\\f073";
}

.fa-calendar-alt::before {
  content: "\\f073";
}

.fa-anchor-circle-check::before {
  content: "\\e4aa";
}

.fa-building-circle-arrow-right::before {
  content: "\\e4d1";
}

.fa-volleyball::before {
  content: "\\f45f";
}

.fa-volleyball-ball::before {
  content: "\\f45f";
}

.fa-arrows-up-to-line::before {
  content: "\\e4c2";
}

.fa-sort-down::before {
  content: "\\f0dd";
}

.fa-sort-desc::before {
  content: "\\f0dd";
}

.fa-circle-minus::before {
  content: "\\f056";
}

.fa-minus-circle::before {
  content: "\\f056";
}

.fa-door-open::before {
  content: "\\f52b";
}

.fa-right-from-bracket::before {
  content: "\\f2f5";
}

.fa-sign-out-alt::before {
  content: "\\f2f5";
}

.fa-atom::before {
  content: "\\f5d2";
}

.fa-soap::before {
  content: "\\e06e";
}

.fa-icons::before {
  content: "\\f86d";
}

.fa-heart-music-camera-bolt::before {
  content: "\\f86d";
}

.fa-microphone-lines-slash::before {
  content: "\\f539";
}

.fa-microphone-alt-slash::before {
  content: "\\f539";
}

.fa-bridge-circle-check::before {
  content: "\\e4c9";
}

.fa-pump-medical::before {
  content: "\\e06a";
}

.fa-fingerprint::before {
  content: "\\f577";
}

.fa-hand-point-right::before {
  content: "\\f0a4";
}

.fa-magnifying-glass-location::before {
  content: "\\f689";
}

.fa-search-location::before {
  content: "\\f689";
}

.fa-forward-step::before {
  content: "\\f051";
}

.fa-step-forward::before {
  content: "\\f051";
}

.fa-face-smile-beam::before {
  content: "\\f5b8";
}

.fa-smile-beam::before {
  content: "\\f5b8";
}

.fa-flag-checkered::before {
  content: "\\f11e";
}

.fa-football::before {
  content: "\\f44e";
}

.fa-football-ball::before {
  content: "\\f44e";
}

.fa-school-circle-exclamation::before {
  content: "\\e56c";
}

.fa-crop::before {
  content: "\\f125";
}

.fa-angles-down::before {
  content: "\\f103";
}

.fa-angle-double-down::before {
  content: "\\f103";
}

.fa-users-rectangle::before {
  content: "\\e594";
}

.fa-people-roof::before {
  content: "\\e537";
}

.fa-people-line::before {
  content: "\\e534";
}

.fa-beer-mug-empty::before {
  content: "\\f0fc";
}

.fa-beer::before {
  content: "\\f0fc";
}

.fa-diagram-predecessor::before {
  content: "\\e477";
}

.fa-arrow-up-long::before {
  content: "\\f176";
}

.fa-long-arrow-up::before {
  content: "\\f176";
}

.fa-fire-flame-simple::before {
  content: "\\f46a";
}

.fa-burn::before {
  content: "\\f46a";
}

.fa-person::before {
  content: "\\f183";
}

.fa-male::before {
  content: "\\f183";
}

.fa-laptop::before {
  content: "\\f109";
}

.fa-file-csv::before {
  content: "\\f6dd";
}

.fa-menorah::before {
  content: "\\f676";
}

.fa-truck-plane::before {
  content: "\\e58f";
}

.fa-record-vinyl::before {
  content: "\\f8d9";
}

.fa-face-grin-stars::before {
  content: "\\f587";
}

.fa-grin-stars::before {
  content: "\\f587";
}

.fa-bong::before {
  content: "\\f55c";
}

.fa-spaghetti-monster-flying::before {
  content: "\\f67b";
}

.fa-pastafarianism::before {
  content: "\\f67b";
}

.fa-arrow-down-up-across-line::before {
  content: "\\e4af";
}

.fa-spoon::before {
  content: "\\f2e5";
}

.fa-utensil-spoon::before {
  content: "\\f2e5";
}

.fa-jar-wheat::before {
  content: "\\e517";
}

.fa-envelopes-bulk::before {
  content: "\\f674";
}

.fa-mail-bulk::before {
  content: "\\f674";
}

.fa-file-circle-exclamation::before {
  content: "\\e4eb";
}

.fa-circle-h::before {
  content: "\\f47e";
}

.fa-hospital-symbol::before {
  content: "\\f47e";
}

.fa-pager::before {
  content: "\\f815";
}

.fa-address-book::before {
  content: "\\f2b9";
}

.fa-contact-book::before {
  content: "\\f2b9";
}

.fa-strikethrough::before {
  content: "\\f0cc";
}

.fa-k::before {
  content: "K";
}

.fa-landmark-flag::before {
  content: "\\e51c";
}

.fa-pencil::before {
  content: "\\f303";
}

.fa-pencil-alt::before {
  content: "\\f303";
}

.fa-backward::before {
  content: "\\f04a";
}

.fa-caret-right::before {
  content: "\\f0da";
}

.fa-comments::before {
  content: "\\f086";
}

.fa-paste::before {
  content: "\\f0ea";
}

.fa-file-clipboard::before {
  content: "\\f0ea";
}

.fa-code-pull-request::before {
  content: "\\e13c";
}

.fa-clipboard-list::before {
  content: "\\f46d";
}

.fa-truck-ramp-box::before {
  content: "\\f4de";
}

.fa-truck-loading::before {
  content: "\\f4de";
}

.fa-user-check::before {
  content: "\\f4fc";
}

.fa-vial-virus::before {
  content: "\\e597";
}

.fa-sheet-plastic::before {
  content: "\\e571";
}

.fa-blog::before {
  content: "\\f781";
}

.fa-user-ninja::before {
  content: "\\f504";
}

.fa-person-arrow-up-from-line::before {
  content: "\\e539";
}

.fa-scroll-torah::before {
  content: "\\f6a0";
}

.fa-torah::before {
  content: "\\f6a0";
}

.fa-broom-ball::before {
  content: "\\f458";
}

.fa-quidditch::before {
  content: "\\f458";
}

.fa-quidditch-broom-ball::before {
  content: "\\f458";
}

.fa-toggle-off::before {
  content: "\\f204";
}

.fa-box-archive::before {
  content: "\\f187";
}

.fa-archive::before {
  content: "\\f187";
}

.fa-person-drowning::before {
  content: "\\e545";
}

.fa-arrow-down-9-1::before {
  content: "\\f886";
}

.fa-sort-numeric-desc::before {
  content: "\\f886";
}

.fa-sort-numeric-down-alt::before {
  content: "\\f886";
}

.fa-face-grin-tongue-squint::before {
  content: "\\f58a";
}

.fa-grin-tongue-squint::before {
  content: "\\f58a";
}

.fa-spray-can::before {
  content: "\\f5bd";
}

.fa-truck-monster::before {
  content: "\\f63b";
}

.fa-w::before {
  content: "W";
}

.fa-earth-africa::before {
  content: "\\f57c";
}

.fa-globe-africa::before {
  content: "\\f57c";
}

.fa-rainbow::before {
  content: "\\f75b";
}

.fa-circle-notch::before {
  content: "\\f1ce";
}

.fa-tablet-screen-button::before {
  content: "\\f3fa";
}

.fa-tablet-alt::before {
  content: "\\f3fa";
}

.fa-paw::before {
  content: "\\f1b0";
}

.fa-cloud::before {
  content: "\\f0c2";
}

.fa-trowel-bricks::before {
  content: "\\e58a";
}

.fa-face-flushed::before {
  content: "\\f579";
}

.fa-flushed::before {
  content: "\\f579";
}

.fa-hospital-user::before {
  content: "\\f80d";
}

.fa-tent-arrow-left-right::before {
  content: "\\e57f";
}

.fa-gavel::before {
  content: "\\f0e3";
}

.fa-legal::before {
  content: "\\f0e3";
}

.fa-binoculars::before {
  content: "\\f1e5";
}

.fa-microphone-slash::before {
  content: "\\f131";
}

.fa-box-tissue::before {
  content: "\\e05b";
}

.fa-motorcycle::before {
  content: "\\f21c";
}

.fa-bell-concierge::before {
  content: "\\f562";
}

.fa-concierge-bell::before {
  content: "\\f562";
}

.fa-pen-ruler::before {
  content: "\\f5ae";
}

.fa-pencil-ruler::before {
  content: "\\f5ae";
}

.fa-people-arrows::before {
  content: "\\e068";
}

.fa-people-arrows-left-right::before {
  content: "\\e068";
}

.fa-mars-and-venus-burst::before {
  content: "\\e523";
}

.fa-square-caret-right::before {
  content: "\\f152";
}

.fa-caret-square-right::before {
  content: "\\f152";
}

.fa-scissors::before {
  content: "\\f0c4";
}

.fa-cut::before {
  content: "\\f0c4";
}

.fa-sun-plant-wilt::before {
  content: "\\e57a";
}

.fa-toilets-portable::before {
  content: "\\e584";
}

.fa-hockey-puck::before {
  content: "\\f453";
}

.fa-table::before {
  content: "\\f0ce";
}

.fa-magnifying-glass-arrow-right::before {
  content: "\\e521";
}

.fa-tachograph-digital::before {
  content: "\\f566";
}

.fa-digital-tachograph::before {
  content: "\\f566";
}

.fa-users-slash::before {
  content: "\\e073";
}

.fa-clover::before {
  content: "\\e139";
}

.fa-reply::before {
  content: "\\f3e5";
}

.fa-mail-reply::before {
  content: "\\f3e5";
}

.fa-star-and-crescent::before {
  content: "\\f699";
}

.fa-house-fire::before {
  content: "\\e50c";
}

.fa-square-minus::before {
  content: "\\f146";
}

.fa-minus-square::before {
  content: "\\f146";
}

.fa-helicopter::before {
  content: "\\f533";
}

.fa-compass::before {
  content: "\\f14e";
}

.fa-square-caret-down::before {
  content: "\\f150";
}

.fa-caret-square-down::before {
  content: "\\f150";
}

.fa-file-circle-question::before {
  content: "\\e4ef";
}

.fa-laptop-code::before {
  content: "\\f5fc";
}

.fa-swatchbook::before {
  content: "\\f5c3";
}

.fa-prescription-bottle::before {
  content: "\\f485";
}

.fa-bars::before {
  content: "\\f0c9";
}

.fa-navicon::before {
  content: "\\f0c9";
}

.fa-people-group::before {
  content: "\\e533";
}

.fa-hourglass-end::before {
  content: "\\f253";
}

.fa-hourglass-3::before {
  content: "\\f253";
}

.fa-heart-crack::before {
  content: "\\f7a9";
}

.fa-heart-broken::before {
  content: "\\f7a9";
}

.fa-square-up-right::before {
  content: "\\f360";
}

.fa-external-link-square-alt::before {
  content: "\\f360";
}

.fa-face-kiss-beam::before {
  content: "\\f597";
}

.fa-kiss-beam::before {
  content: "\\f597";
}

.fa-film::before {
  content: "\\f008";
}

.fa-ruler-horizontal::before {
  content: "\\f547";
}

.fa-people-robbery::before {
  content: "\\e536";
}

.fa-lightbulb::before {
  content: "\\f0eb";
}

.fa-caret-left::before {
  content: "\\f0d9";
}

.fa-circle-exclamation::before {
  content: "\\f06a";
}

.fa-exclamation-circle::before {
  content: "\\f06a";
}

.fa-school-circle-xmark::before {
  content: "\\e56d";
}

.fa-arrow-right-from-bracket::before {
  content: "\\f08b";
}

.fa-sign-out::before {
  content: "\\f08b";
}

.fa-circle-chevron-down::before {
  content: "\\f13a";
}

.fa-chevron-circle-down::before {
  content: "\\f13a";
}

.fa-unlock-keyhole::before {
  content: "\\f13e";
}

.fa-unlock-alt::before {
  content: "\\f13e";
}

.fa-cloud-showers-heavy::before {
  content: "\\f740";
}

.fa-headphones-simple::before {
  content: "\\f58f";
}

.fa-headphones-alt::before {
  content: "\\f58f";
}

.fa-sitemap::before {
  content: "\\f0e8";
}

.fa-circle-dollar-to-slot::before {
  content: "\\f4b9";
}

.fa-donate::before {
  content: "\\f4b9";
}

.fa-memory::before {
  content: "\\f538";
}

.fa-road-spikes::before {
  content: "\\e568";
}

.fa-fire-burner::before {
  content: "\\e4f1";
}

.fa-flag::before {
  content: "\\f024";
}

.fa-hanukiah::before {
  content: "\\f6e6";
}

.fa-feather::before {
  content: "\\f52d";
}

.fa-volume-low::before {
  content: "\\f027";
}

.fa-volume-down::before {
  content: "\\f027";
}

.fa-comment-slash::before {
  content: "\\f4b3";
}

.fa-cloud-sun-rain::before {
  content: "\\f743";
}

.fa-compress::before {
  content: "\\f066";
}

.fa-wheat-awn::before {
  content: "\\e2cd";
}

.fa-wheat-alt::before {
  content: "\\e2cd";
}

.fa-ankh::before {
  content: "\\f644";
}

.fa-hands-holding-child::before {
  content: "\\e4fa";
}

.fa-asterisk::before {
  content: "\\*";
}

.fa-square-check::before {
  content: "\\f14a";
}

.fa-check-square::before {
  content: "\\f14a";
}

.fa-peseta-sign::before {
  content: "\\e221";
}

.fa-heading::before {
  content: "\\f1dc";
}

.fa-header::before {
  content: "\\f1dc";
}

.fa-ghost::before {
  content: "\\f6e2";
}

.fa-list::before {
  content: "\\f03a";
}

.fa-list-squares::before {
  content: "\\f03a";
}

.fa-square-phone-flip::before {
  content: "\\f87b";
}

.fa-phone-square-alt::before {
  content: "\\f87b";
}

.fa-cart-plus::before {
  content: "\\f217";
}

.fa-gamepad::before {
  content: "\\f11b";
}

.fa-circle-dot::before {
  content: "\\f192";
}

.fa-dot-circle::before {
  content: "\\f192";
}

.fa-face-dizzy::before {
  content: "\\f567";
}

.fa-dizzy::before {
  content: "\\f567";
}

.fa-egg::before {
  content: "\\f7fb";
}

.fa-house-medical-circle-xmark::before {
  content: "\\e513";
}

.fa-campground::before {
  content: "\\f6bb";
}

.fa-folder-plus::before {
  content: "\\f65e";
}

.fa-futbol::before {
  content: "\\f1e3";
}

.fa-futbol-ball::before {
  content: "\\f1e3";
}

.fa-soccer-ball::before {
  content: "\\f1e3";
}

.fa-paintbrush::before {
  content: "\\f1fc";
}

.fa-paint-brush::before {
  content: "\\f1fc";
}

.fa-lock::before {
  content: "\\f023";
}

.fa-gas-pump::before {
  content: "\\f52f";
}

.fa-hot-tub-person::before {
  content: "\\f593";
}

.fa-hot-tub::before {
  content: "\\f593";
}

.fa-map-location::before {
  content: "\\f59f";
}

.fa-map-marked::before {
  content: "\\f59f";
}

.fa-house-flood-water::before {
  content: "\\e50e";
}

.fa-tree::before {
  content: "\\f1bb";
}

.fa-bridge-lock::before {
  content: "\\e4cc";
}

.fa-sack-dollar::before {
  content: "\\f81d";
}

.fa-pen-to-square::before {
  content: "\\f044";
}

.fa-edit::before {
  content: "\\f044";
}

.fa-car-side::before {
  content: "\\f5e4";
}

.fa-share-nodes::before {
  content: "\\f1e0";
}

.fa-share-alt::before {
  content: "\\f1e0";
}

.fa-heart-circle-minus::before {
  content: "\\e4ff";
}

.fa-hourglass-half::before {
  content: "\\f252";
}

.fa-hourglass-2::before {
  content: "\\f252";
}

.fa-microscope::before {
  content: "\\f610";
}

.fa-sink::before {
  content: "\\e06d";
}

.fa-bag-shopping::before {
  content: "\\f290";
}

.fa-shopping-bag::before {
  content: "\\f290";
}

.fa-arrow-down-z-a::before {
  content: "\\f881";
}

.fa-sort-alpha-desc::before {
  content: "\\f881";
}

.fa-sort-alpha-down-alt::before {
  content: "\\f881";
}

.fa-mitten::before {
  content: "\\f7b5";
}

.fa-person-rays::before {
  content: "\\e54d";
}

.fa-users::before {
  content: "\\f0c0";
}

.fa-eye-slash::before {
  content: "\\f070";
}

.fa-flask-vial::before {
  content: "\\e4f3";
}

.fa-hand::before {
  content: "\\f256";
}

.fa-hand-paper::before {
  content: "\\f256";
}

.fa-om::before {
  content: "\\f679";
}

.fa-worm::before {
  content: "\\e599";
}

.fa-house-circle-xmark::before {
  content: "\\e50b";
}

.fa-plug::before {
  content: "\\f1e6";
}

.fa-chevron-up::before {
  content: "\\f077";
}

.fa-hand-spock::before {
  content: "\\f259";
}

.fa-stopwatch::before {
  content: "\\f2f2";
}

.fa-face-kiss::before {
  content: "\\f596";
}

.fa-kiss::before {
  content: "\\f596";
}

.fa-bridge-circle-xmark::before {
  content: "\\e4cb";
}

.fa-face-grin-tongue::before {
  content: "\\f589";
}

.fa-grin-tongue::before {
  content: "\\f589";
}

.fa-chess-bishop::before {
  content: "\\f43a";
}

.fa-face-grin-wink::before {
  content: "\\f58c";
}

.fa-grin-wink::before {
  content: "\\f58c";
}

.fa-ear-deaf::before {
  content: "\\f2a4";
}

.fa-deaf::before {
  content: "\\f2a4";
}

.fa-deafness::before {
  content: "\\f2a4";
}

.fa-hard-of-hearing::before {
  content: "\\f2a4";
}

.fa-road-circle-check::before {
  content: "\\e564";
}

.fa-dice-five::before {
  content: "\\f523";
}

.fa-square-rss::before {
  content: "\\f143";
}

.fa-rss-square::before {
  content: "\\f143";
}

.fa-land-mine-on::before {
  content: "\\e51b";
}

.fa-i-cursor::before {
  content: "\\f246";
}

.fa-stamp::before {
  content: "\\f5bf";
}

.fa-stairs::before {
  content: "\\e289";
}

.fa-i::before {
  content: "I";
}

.fa-hryvnia-sign::before {
  content: "\\f6f2";
}

.fa-hryvnia::before {
  content: "\\f6f2";
}

.fa-pills::before {
  content: "\\f484";
}

.fa-face-grin-wide::before {
  content: "\\f581";
}

.fa-grin-alt::before {
  content: "\\f581";
}

.fa-tooth::before {
  content: "\\f5c9";
}

.fa-v::before {
  content: "V";
}

.fa-bangladeshi-taka-sign::before {
  content: "\\e2e6";
}

.fa-bicycle::before {
  content: "\\f206";
}

.fa-staff-snake::before {
  content: "\\e579";
}

.fa-rod-asclepius::before {
  content: "\\e579";
}

.fa-rod-snake::before {
  content: "\\e579";
}

.fa-staff-aesculapius::before {
  content: "\\e579";
}

.fa-head-side-cough-slash::before {
  content: "\\e062";
}

.fa-truck-medical::before {
  content: "\\f0f9";
}

.fa-ambulance::before {
  content: "\\f0f9";
}

.fa-wheat-awn-circle-exclamation::before {
  content: "\\e598";
}

.fa-snowman::before {
  content: "\\f7d0";
}

.fa-mortar-pestle::before {
  content: "\\f5a7";
}

.fa-road-barrier::before {
  content: "\\e562";
}

.fa-school::before {
  content: "\\f549";
}

.fa-igloo::before {
  content: "\\f7ae";
}

.fa-joint::before {
  content: "\\f595";
}

.fa-angle-right::before {
  content: "\\f105";
}

.fa-horse::before {
  content: "\\f6f0";
}

.fa-q::before {
  content: "Q";
}

.fa-g::before {
  content: "G";
}

.fa-notes-medical::before {
  content: "\\f481";
}

.fa-temperature-half::before {
  content: "\\f2c9";
}

.fa-temperature-2::before {
  content: "\\f2c9";
}

.fa-thermometer-2::before {
  content: "\\f2c9";
}

.fa-thermometer-half::before {
  content: "\\f2c9";
}

.fa-dong-sign::before {
  content: "\\e169";
}

.fa-capsules::before {
  content: "\\f46b";
}

.fa-poo-storm::before {
  content: "\\f75a";
}

.fa-poo-bolt::before {
  content: "\\f75a";
}

.fa-face-frown-open::before {
  content: "\\f57a";
}

.fa-frown-open::before {
  content: "\\f57a";
}

.fa-hand-point-up::before {
  content: "\\f0a6";
}

.fa-money-bill::before {
  content: "\\f0d6";
}

.fa-bookmark::before {
  content: "\\f02e";
}

.fa-align-justify::before {
  content: "\\f039";
}

.fa-umbrella-beach::before {
  content: "\\f5ca";
}

.fa-helmet-un::before {
  content: "\\e503";
}

.fa-bullseye::before {
  content: "\\f140";
}

.fa-bacon::before {
  content: "\\f7e5";
}

.fa-hand-point-down::before {
  content: "\\f0a7";
}

.fa-arrow-up-from-bracket::before {
  content: "\\e09a";
}

.fa-folder::before {
  content: "\\f07b";
}

.fa-folder-blank::before {
  content: "\\f07b";
}

.fa-file-waveform::before {
  content: "\\f478";
}

.fa-file-medical-alt::before {
  content: "\\f478";
}

.fa-radiation::before {
  content: "\\f7b9";
}

.fa-chart-simple::before {
  content: "\\e473";
}

.fa-mars-stroke::before {
  content: "\\f229";
}

.fa-vial::before {
  content: "\\f492";
}

.fa-gauge::before {
  content: "\\f624";
}

.fa-dashboard::before {
  content: "\\f624";
}

.fa-gauge-med::before {
  content: "\\f624";
}

.fa-tachometer-alt-average::before {
  content: "\\f624";
}

.fa-wand-magic-sparkles::before {
  content: "\\e2ca";
}

.fa-magic-wand-sparkles::before {
  content: "\\e2ca";
}

.fa-e::before {
  content: "E";
}

.fa-pen-clip::before {
  content: "\\f305";
}

.fa-pen-alt::before {
  content: "\\f305";
}

.fa-bridge-circle-exclamation::before {
  content: "\\e4ca";
}

.fa-user::before {
  content: "\\f007";
}

.fa-school-circle-check::before {
  content: "\\e56b";
}

.fa-dumpster::before {
  content: "\\f793";
}

.fa-van-shuttle::before {
  content: "\\f5b6";
}

.fa-shuttle-van::before {
  content: "\\f5b6";
}

.fa-building-user::before {
  content: "\\e4da";
}

.fa-square-caret-left::before {
  content: "\\f191";
}

.fa-caret-square-left::before {
  content: "\\f191";
}

.fa-highlighter::before {
  content: "\\f591";
}

.fa-key::before {
  content: "\\f084";
}

.fa-bullhorn::before {
  content: "\\f0a1";
}

.fa-globe::before {
  content: "\\f0ac";
}

.fa-synagogue::before {
  content: "\\f69b";
}

.fa-person-half-dress::before {
  content: "\\e548";
}

.fa-road-bridge::before {
  content: "\\e563";
}

.fa-location-arrow::before {
  content: "\\f124";
}

.fa-c::before {
  content: "C";
}

.fa-tablet-button::before {
  content: "\\f10a";
}

.fa-building-lock::before {
  content: "\\e4d6";
}

.fa-pizza-slice::before {
  content: "\\f818";
}

.fa-money-bill-wave::before {
  content: "\\f53a";
}

.fa-chart-area::before {
  content: "\\f1fe";
}

.fa-area-chart::before {
  content: "\\f1fe";
}

.fa-house-flag::before {
  content: "\\e50d";
}

.fa-person-circle-minus::before {
  content: "\\e540";
}

.fa-ban::before {
  content: "\\f05e";
}

.fa-cancel::before {
  content: "\\f05e";
}

.fa-camera-rotate::before {
  content: "\\e0d8";
}

.fa-spray-can-sparkles::before {
  content: "\\f5d0";
}

.fa-air-freshener::before {
  content: "\\f5d0";
}

.fa-star::before {
  content: "\\f005";
}

.fa-repeat::before {
  content: "\\f363";
}

.fa-cross::before {
  content: "\\f654";
}

.fa-box::before {
  content: "\\f466";
}

.fa-venus-mars::before {
  content: "\\f228";
}

.fa-arrow-pointer::before {
  content: "\\f245";
}

.fa-mouse-pointer::before {
  content: "\\f245";
}

.fa-maximize::before {
  content: "\\f31e";
}

.fa-expand-arrows-alt::before {
  content: "\\f31e";
}

.fa-charging-station::before {
  content: "\\f5e7";
}

.fa-shapes::before {
  content: "\\f61f";
}

.fa-triangle-circle-square::before {
  content: "\\f61f";
}

.fa-shuffle::before {
  content: "\\f074";
}

.fa-random::before {
  content: "\\f074";
}

.fa-person-running::before {
  content: "\\f70c";
}

.fa-running::before {
  content: "\\f70c";
}

.fa-mobile-retro::before {
  content: "\\e527";
}

.fa-grip-lines-vertical::before {
  content: "\\f7a5";
}

.fa-spider::before {
  content: "\\f717";
}

.fa-hands-bound::before {
  content: "\\e4f9";
}

.fa-file-invoice-dollar::before {
  content: "\\f571";
}

.fa-plane-circle-exclamation::before {
  content: "\\e556";
}

.fa-x-ray::before {
  content: "\\f497";
}

.fa-spell-check::before {
  content: "\\f891";
}

.fa-slash::before {
  content: "\\f715";
}

.fa-computer-mouse::before {
  content: "\\f8cc";
}

.fa-mouse::before {
  content: "\\f8cc";
}

.fa-arrow-right-to-bracket::before {
  content: "\\f090";
}

.fa-sign-in::before {
  content: "\\f090";
}

.fa-shop-slash::before {
  content: "\\e070";
}

.fa-store-alt-slash::before {
  content: "\\e070";
}

.fa-server::before {
  content: "\\f233";
}

.fa-virus-covid-slash::before {
  content: "\\e4a9";
}

.fa-shop-lock::before {
  content: "\\e4a5";
}

.fa-hourglass-start::before {
  content: "\\f251";
}

.fa-hourglass-1::before {
  content: "\\f251";
}

.fa-blender-phone::before {
  content: "\\f6b6";
}

.fa-building-wheat::before {
  content: "\\e4db";
}

.fa-person-breastfeeding::before {
  content: "\\e53a";
}

.fa-right-to-bracket::before {
  content: "\\f2f6";
}

.fa-sign-in-alt::before {
  content: "\\f2f6";
}

.fa-venus::before {
  content: "\\f221";
}

.fa-passport::before {
  content: "\\f5ab";
}

.fa-heart-pulse::before {
  content: "\\f21e";
}

.fa-heartbeat::before {
  content: "\\f21e";
}

.fa-people-carry-box::before {
  content: "\\f4ce";
}

.fa-people-carry::before {
  content: "\\f4ce";
}

.fa-temperature-high::before {
  content: "\\f769";
}

.fa-microchip::before {
  content: "\\f2db";
}

.fa-crown::before {
  content: "\\f521";
}

.fa-weight-hanging::before {
  content: "\\f5cd";
}

.fa-xmarks-lines::before {
  content: "\\e59a";
}

.fa-file-prescription::before {
  content: "\\f572";
}

.fa-weight-scale::before {
  content: "\\f496";
}

.fa-weight::before {
  content: "\\f496";
}

.fa-user-group::before {
  content: "\\f500";
}

.fa-user-friends::before {
  content: "\\f500";
}

.fa-arrow-up-a-z::before {
  content: "\\f15e";
}

.fa-sort-alpha-up::before {
  content: "\\f15e";
}

.fa-chess-knight::before {
  content: "\\f441";
}

.fa-face-laugh-squint::before {
  content: "\\f59b";
}

.fa-laugh-squint::before {
  content: "\\f59b";
}

.fa-wheelchair::before {
  content: "\\f193";
}

.fa-circle-arrow-up::before {
  content: "\\f0aa";
}

.fa-arrow-circle-up::before {
  content: "\\f0aa";
}

.fa-toggle-on::before {
  content: "\\f205";
}

.fa-person-walking::before {
  content: "\\f554";
}

.fa-walking::before {
  content: "\\f554";
}

.fa-l::before {
  content: "L";
}

.fa-fire::before {
  content: "\\f06d";
}

.fa-bed-pulse::before {
  content: "\\f487";
}

.fa-procedures::before {
  content: "\\f487";
}

.fa-shuttle-space::before {
  content: "\\f197";
}

.fa-space-shuttle::before {
  content: "\\f197";
}

.fa-face-laugh::before {
  content: "\\f599";
}

.fa-laugh::before {
  content: "\\f599";
}

.fa-folder-open::before {
  content: "\\f07c";
}

.fa-heart-circle-plus::before {
  content: "\\e500";
}

.fa-code-fork::before {
  content: "\\e13b";
}

.fa-city::before {
  content: "\\f64f";
}

.fa-microphone-lines::before {
  content: "\\f3c9";
}

.fa-microphone-alt::before {
  content: "\\f3c9";
}

.fa-pepper-hot::before {
  content: "\\f816";
}

.fa-unlock::before {
  content: "\\f09c";
}

.fa-colon-sign::before {
  content: "\\e140";
}

.fa-headset::before {
  content: "\\f590";
}

.fa-store-slash::before {
  content: "\\e071";
}

.fa-road-circle-xmark::before {
  content: "\\e566";
}

.fa-user-minus::before {
  content: "\\f503";
}

.fa-mars-stroke-up::before {
  content: "\\f22a";
}

.fa-mars-stroke-v::before {
  content: "\\f22a";
}

.fa-champagne-glasses::before {
  content: "\\f79f";
}

.fa-glass-cheers::before {
  content: "\\f79f";
}

.fa-clipboard::before {
  content: "\\f328";
}

.fa-house-circle-exclamation::before {
  content: "\\e50a";
}

.fa-file-arrow-up::before {
  content: "\\f574";
}

.fa-file-upload::before {
  content: "\\f574";
}

.fa-wifi::before {
  content: "\\f1eb";
}

.fa-wifi-3::before {
  content: "\\f1eb";
}

.fa-wifi-strong::before {
  content: "\\f1eb";
}

.fa-bath::before {
  content: "\\f2cd";
}

.fa-bathtub::before {
  content: "\\f2cd";
}

.fa-underline::before {
  content: "\\f0cd";
}

.fa-user-pen::before {
  content: "\\f4ff";
}

.fa-user-edit::before {
  content: "\\f4ff";
}

.fa-signature::before {
  content: "\\f5b7";
}

.fa-stroopwafel::before {
  content: "\\f551";
}

.fa-bold::before {
  content: "\\f032";
}

.fa-anchor-lock::before {
  content: "\\e4ad";
}

.fa-building-ngo::before {
  content: "\\e4d7";
}

.fa-manat-sign::before {
  content: "\\e1d5";
}

.fa-not-equal::before {
  content: "\\f53e";
}

.fa-border-top-left::before {
  content: "\\f853";
}

.fa-border-style::before {
  content: "\\f853";
}

.fa-map-location-dot::before {
  content: "\\f5a0";
}

.fa-map-marked-alt::before {
  content: "\\f5a0";
}

.fa-jedi::before {
  content: "\\f669";
}

.fa-square-poll-vertical::before {
  content: "\\f681";
}

.fa-poll::before {
  content: "\\f681";
}

.fa-mug-hot::before {
  content: "\\f7b6";
}

.fa-car-battery::before {
  content: "\\f5df";
}

.fa-battery-car::before {
  content: "\\f5df";
}

.fa-gift::before {
  content: "\\f06b";
}

.fa-dice-two::before {
  content: "\\f528";
}

.fa-chess-queen::before {
  content: "\\f445";
}

.fa-glasses::before {
  content: "\\f530";
}

.fa-chess-board::before {
  content: "\\f43c";
}

.fa-building-circle-check::before {
  content: "\\e4d2";
}

.fa-person-chalkboard::before {
  content: "\\e53d";
}

.fa-mars-stroke-right::before {
  content: "\\f22b";
}

.fa-mars-stroke-h::before {
  content: "\\f22b";
}

.fa-hand-back-fist::before {
  content: "\\f255";
}

.fa-hand-rock::before {
  content: "\\f255";
}

.fa-square-caret-up::before {
  content: "\\f151";
}

.fa-caret-square-up::before {
  content: "\\f151";
}

.fa-cloud-showers-water::before {
  content: "\\e4e4";
}

.fa-chart-bar::before {
  content: "\\f080";
}

.fa-bar-chart::before {
  content: "\\f080";
}

.fa-hands-bubbles::before {
  content: "\\e05e";
}

.fa-hands-wash::before {
  content: "\\e05e";
}

.fa-less-than-equal::before {
  content: "\\f537";
}

.fa-train::before {
  content: "\\f238";
}

.fa-eye-low-vision::before {
  content: "\\f2a8";
}

.fa-low-vision::before {
  content: "\\f2a8";
}

.fa-crow::before {
  content: "\\f520";
}

.fa-sailboat::before {
  content: "\\e445";
}

.fa-window-restore::before {
  content: "\\f2d2";
}

.fa-square-plus::before {
  content: "\\f0fe";
}

.fa-plus-square::before {
  content: "\\f0fe";
}

.fa-torii-gate::before {
  content: "\\f6a1";
}

.fa-frog::before {
  content: "\\f52e";
}

.fa-bucket::before {
  content: "\\e4cf";
}

.fa-image::before {
  content: "\\f03e";
}

.fa-microphone::before {
  content: "\\f130";
}

.fa-cow::before {
  content: "\\f6c8";
}

.fa-caret-up::before {
  content: "\\f0d8";
}

.fa-screwdriver::before {
  content: "\\f54a";
}

.fa-folder-closed::before {
  content: "\\e185";
}

.fa-house-tsunami::before {
  content: "\\e515";
}

.fa-square-nfi::before {
  content: "\\e576";
}

.fa-arrow-up-from-ground-water::before {
  content: "\\e4b5";
}

.fa-martini-glass::before {
  content: "\\f57b";
}

.fa-glass-martini-alt::before {
  content: "\\f57b";
}

.fa-rotate-left::before {
  content: "\\f2ea";
}

.fa-rotate-back::before {
  content: "\\f2ea";
}

.fa-rotate-backward::before {
  content: "\\f2ea";
}

.fa-undo-alt::before {
  content: "\\f2ea";
}

.fa-table-columns::before {
  content: "\\f0db";
}

.fa-columns::before {
  content: "\\f0db";
}

.fa-lemon::before {
  content: "\\f094";
}

.fa-head-side-mask::before {
  content: "\\e063";
}

.fa-handshake::before {
  content: "\\f2b5";
}

.fa-gem::before {
  content: "\\f3a5";
}

.fa-dolly::before {
  content: "\\f472";
}

.fa-dolly-box::before {
  content: "\\f472";
}

.fa-smoking::before {
  content: "\\f48d";
}

.fa-minimize::before {
  content: "\\f78c";
}

.fa-compress-arrows-alt::before {
  content: "\\f78c";
}

.fa-monument::before {
  content: "\\f5a6";
}

.fa-snowplow::before {
  content: "\\f7d2";
}

.fa-angles-right::before {
  content: "\\f101";
}

.fa-angle-double-right::before {
  content: "\\f101";
}

.fa-cannabis::before {
  content: "\\f55f";
}

.fa-circle-play::before {
  content: "\\f144";
}

.fa-play-circle::before {
  content: "\\f144";
}

.fa-tablets::before {
  content: "\\f490";
}

.fa-ethernet::before {
  content: "\\f796";
}

.fa-euro-sign::before {
  content: "\\f153";
}

.fa-eur::before {
  content: "\\f153";
}

.fa-euro::before {
  content: "\\f153";
}

.fa-chair::before {
  content: "\\f6c0";
}

.fa-circle-check::before {
  content: "\\f058";
}

.fa-check-circle::before {
  content: "\\f058";
}

.fa-circle-stop::before {
  content: "\\f28d";
}

.fa-stop-circle::before {
  content: "\\f28d";
}

.fa-compass-drafting::before {
  content: "\\f568";
}

.fa-drafting-compass::before {
  content: "\\f568";
}

.fa-plate-wheat::before {
  content: "\\e55a";
}

.fa-icicles::before {
  content: "\\f7ad";
}

.fa-person-shelter::before {
  content: "\\e54f";
}

.fa-neuter::before {
  content: "\\f22c";
}

.fa-id-badge::before {
  content: "\\f2c1";
}

.fa-marker::before {
  content: "\\f5a1";
}

.fa-face-laugh-beam::before {
  content: "\\f59a";
}

.fa-laugh-beam::before {
  content: "\\f59a";
}

.fa-helicopter-symbol::before {
  content: "\\e502";
}

.fa-universal-access::before {
  content: "\\f29a";
}

.fa-circle-chevron-up::before {
  content: "\\f139";
}

.fa-chevron-circle-up::before {
  content: "\\f139";
}

.fa-lari-sign::before {
  content: "\\e1c8";
}

.fa-volcano::before {
  content: "\\f770";
}

.fa-person-walking-dashed-line-arrow-right::before {
  content: "\\e553";
}

.fa-sterling-sign::before {
  content: "\\f154";
}

.fa-gbp::before {
  content: "\\f154";
}

.fa-pound-sign::before {
  content: "\\f154";
}

.fa-viruses::before {
  content: "\\e076";
}

.fa-square-person-confined::before {
  content: "\\e577";
}

.fa-user-tie::before {
  content: "\\f508";
}

.fa-arrow-down-long::before {
  content: "\\f175";
}

.fa-long-arrow-down::before {
  content: "\\f175";
}

.fa-tent-arrow-down-to-line::before {
  content: "\\e57e";
}

.fa-certificate::before {
  content: "\\f0a3";
}

.fa-reply-all::before {
  content: "\\f122";
}

.fa-mail-reply-all::before {
  content: "\\f122";
}

.fa-suitcase::before {
  content: "\\f0f2";
}

.fa-person-skating::before {
  content: "\\f7c5";
}

.fa-skating::before {
  content: "\\f7c5";
}

.fa-filter-circle-dollar::before {
  content: "\\f662";
}

.fa-funnel-dollar::before {
  content: "\\f662";
}

.fa-camera-retro::before {
  content: "\\f083";
}

.fa-circle-arrow-down::before {
  content: "\\f0ab";
}

.fa-arrow-circle-down::before {
  content: "\\f0ab";
}

.fa-file-import::before {
  content: "\\f56f";
}

.fa-arrow-right-to-file::before {
  content: "\\f56f";
}

.fa-square-arrow-up-right::before {
  content: "\\f14c";
}

.fa-external-link-square::before {
  content: "\\f14c";
}

.fa-box-open::before {
  content: "\\f49e";
}

.fa-scroll::before {
  content: "\\f70e";
}

.fa-spa::before {
  content: "\\f5bb";
}

.fa-location-pin-lock::before {
  content: "\\e51f";
}

.fa-pause::before {
  content: "\\f04c";
}

.fa-hill-avalanche::before {
  content: "\\e507";
}

.fa-temperature-empty::before {
  content: "\\f2cb";
}

.fa-temperature-0::before {
  content: "\\f2cb";
}

.fa-thermometer-0::before {
  content: "\\f2cb";
}

.fa-thermometer-empty::before {
  content: "\\f2cb";
}

.fa-bomb::before {
  content: "\\f1e2";
}

.fa-registered::before {
  content: "\\f25d";
}

.fa-address-card::before {
  content: "\\f2bb";
}

.fa-contact-card::before {
  content: "\\f2bb";
}

.fa-vcard::before {
  content: "\\f2bb";
}

.fa-scale-unbalanced-flip::before {
  content: "\\f516";
}

.fa-balance-scale-right::before {
  content: "\\f516";
}

.fa-subscript::before {
  content: "\\f12c";
}

.fa-diamond-turn-right::before {
  content: "\\f5eb";
}

.fa-directions::before {
  content: "\\f5eb";
}

.fa-burst::before {
  content: "\\e4dc";
}

.fa-house-laptop::before {
  content: "\\e066";
}

.fa-laptop-house::before {
  content: "\\e066";
}

.fa-face-tired::before {
  content: "\\f5c8";
}

.fa-tired::before {
  content: "\\f5c8";
}

.fa-money-bills::before {
  content: "\\e1f3";
}

.fa-smog::before {
  content: "\\f75f";
}

.fa-crutch::before {
  content: "\\f7f7";
}

.fa-cloud-arrow-up::before {
  content: "\\f0ee";
}

.fa-cloud-upload::before {
  content: "\\f0ee";
}

.fa-cloud-upload-alt::before {
  content: "\\f0ee";
}

.fa-palette::before {
  content: "\\f53f";
}

.fa-arrows-turn-right::before {
  content: "\\e4c0";
}

.fa-vest::before {
  content: "\\e085";
}

.fa-ferry::before {
  content: "\\e4ea";
}

.fa-arrows-down-to-people::before {
  content: "\\e4b9";
}

.fa-seedling::before {
  content: "\\f4d8";
}

.fa-sprout::before {
  content: "\\f4d8";
}

.fa-left-right::before {
  content: "\\f337";
}

.fa-arrows-alt-h::before {
  content: "\\f337";
}

.fa-boxes-packing::before {
  content: "\\e4c7";
}

.fa-circle-arrow-left::before {
  content: "\\f0a8";
}

.fa-arrow-circle-left::before {
  content: "\\f0a8";
}

.fa-group-arrows-rotate::before {
  content: "\\e4f6";
}

.fa-bowl-food::before {
  content: "\\e4c6";
}

.fa-candy-cane::before {
  content: "\\f786";
}

.fa-arrow-down-wide-short::before {
  content: "\\f160";
}

.fa-sort-amount-asc::before {
  content: "\\f160";
}

.fa-sort-amount-down::before {
  content: "\\f160";
}

.fa-cloud-bolt::before {
  content: "\\f76c";
}

.fa-thunderstorm::before {
  content: "\\f76c";
}

.fa-text-slash::before {
  content: "\\f87d";
}

.fa-remove-format::before {
  content: "\\f87d";
}

.fa-face-smile-wink::before {
  content: "\\f4da";
}

.fa-smile-wink::before {
  content: "\\f4da";
}

.fa-file-word::before {
  content: "\\f1c2";
}

.fa-file-powerpoint::before {
  content: "\\f1c4";
}

.fa-arrows-left-right::before {
  content: "\\f07e";
}

.fa-arrows-h::before {
  content: "\\f07e";
}

.fa-house-lock::before {
  content: "\\e510";
}

.fa-cloud-arrow-down::before {
  content: "\\f0ed";
}

.fa-cloud-download::before {
  content: "\\f0ed";
}

.fa-cloud-download-alt::before {
  content: "\\f0ed";
}

.fa-children::before {
  content: "\\e4e1";
}

.fa-chalkboard::before {
  content: "\\f51b";
}

.fa-blackboard::before {
  content: "\\f51b";
}

.fa-user-large-slash::before {
  content: "\\f4fa";
}

.fa-user-alt-slash::before {
  content: "\\f4fa";
}

.fa-envelope-open::before {
  content: "\\f2b6";
}

.fa-handshake-simple-slash::before {
  content: "\\e05f";
}

.fa-handshake-alt-slash::before {
  content: "\\e05f";
}

.fa-mattress-pillow::before {
  content: "\\e525";
}

.fa-guarani-sign::before {
  content: "\\e19a";
}

.fa-arrows-rotate::before {
  content: "\\f021";
}

.fa-refresh::before {
  content: "\\f021";
}

.fa-sync::before {
  content: "\\f021";
}

.fa-fire-extinguisher::before {
  content: "\\f134";
}

.fa-cruzeiro-sign::before {
  content: "\\e152";
}

.fa-greater-than-equal::before {
  content: "\\f532";
}

.fa-shield-halved::before {
  content: "\\f3ed";
}

.fa-shield-alt::before {
  content: "\\f3ed";
}

.fa-book-atlas::before {
  content: "\\f558";
}

.fa-atlas::before {
  content: "\\f558";
}

.fa-virus::before {
  content: "\\e074";
}

.fa-envelope-circle-check::before {
  content: "\\e4e8";
}

.fa-layer-group::before {
  content: "\\f5fd";
}

.fa-arrows-to-dot::before {
  content: "\\e4be";
}

.fa-archway::before {
  content: "\\f557";
}

.fa-heart-circle-check::before {
  content: "\\e4fd";
}

.fa-house-chimney-crack::before {
  content: "\\f6f1";
}

.fa-house-damage::before {
  content: "\\f6f1";
}

.fa-file-zipper::before {
  content: "\\f1c6";
}

.fa-file-archive::before {
  content: "\\f1c6";
}

.fa-square::before {
  content: "\\f0c8";
}

.fa-martini-glass-empty::before {
  content: "\\f000";
}

.fa-glass-martini::before {
  content: "\\f000";
}

.fa-couch::before {
  content: "\\f4b8";
}

.fa-cedi-sign::before {
  content: "\\e0df";
}

.fa-italic::before {
  content: "\\f033";
}

.fa-table-cells-column-lock::before {
  content: "\\e678";
}

.fa-church::before {
  content: "\\f51d";
}

.fa-comments-dollar::before {
  content: "\\f653";
}

.fa-democrat::before {
  content: "\\f747";
}

.fa-z::before {
  content: "Z";
}

.fa-person-skiing::before {
  content: "\\f7c9";
}

.fa-skiing::before {
  content: "\\f7c9";
}

.fa-road-lock::before {
  content: "\\e567";
}

.fa-a::before {
  content: "A";
}

.fa-temperature-arrow-down::before {
  content: "\\e03f";
}

.fa-temperature-down::before {
  content: "\\e03f";
}

.fa-feather-pointed::before {
  content: "\\f56b";
}

.fa-feather-alt::before {
  content: "\\f56b";
}

.fa-p::before {
  content: "P";
}

.fa-snowflake::before {
  content: "\\f2dc";
}

.fa-newspaper::before {
  content: "\\f1ea";
}

.fa-rectangle-ad::before {
  content: "\\f641";
}

.fa-ad::before {
  content: "\\f641";
}

.fa-circle-arrow-right::before {
  content: "\\f0a9";
}

.fa-arrow-circle-right::before {
  content: "\\f0a9";
}

.fa-filter-circle-xmark::before {
  content: "\\e17b";
}

.fa-locust::before {
  content: "\\e520";
}

.fa-sort::before {
  content: "\\f0dc";
}

.fa-unsorted::before {
  content: "\\f0dc";
}

.fa-list-ol::before {
  content: "\\f0cb";
}

.fa-list-1-2::before {
  content: "\\f0cb";
}

.fa-list-numeric::before {
  content: "\\f0cb";
}

.fa-person-dress-burst::before {
  content: "\\e544";
}

.fa-money-check-dollar::before {
  content: "\\f53d";
}

.fa-money-check-alt::before {
  content: "\\f53d";
}

.fa-vector-square::before {
  content: "\\f5cb";
}

.fa-bread-slice::before {
  content: "\\f7ec";
}

.fa-language::before {
  content: "\\f1ab";
}

.fa-face-kiss-wink-heart::before {
  content: "\\f598";
}

.fa-kiss-wink-heart::before {
  content: "\\f598";
}

.fa-filter::before {
  content: "\\f0b0";
}

.fa-question::before {
  content: "\\?";
}

.fa-file-signature::before {
  content: "\\f573";
}

.fa-up-down-left-right::before {
  content: "\\f0b2";
}

.fa-arrows-alt::before {
  content: "\\f0b2";
}

.fa-house-chimney-user::before {
  content: "\\e065";
}

.fa-hand-holding-heart::before {
  content: "\\f4be";
}

.fa-puzzle-piece::before {
  content: "\\f12e";
}

.fa-money-check::before {
  content: "\\f53c";
}

.fa-star-half-stroke::before {
  content: "\\f5c0";
}

.fa-star-half-alt::before {
  content: "\\f5c0";
}

.fa-code::before {
  content: "\\f121";
}

.fa-whiskey-glass::before {
  content: "\\f7a0";
}

.fa-glass-whiskey::before {
  content: "\\f7a0";
}

.fa-building-circle-exclamation::before {
  content: "\\e4d3";
}

.fa-magnifying-glass-chart::before {
  content: "\\e522";
}

.fa-arrow-up-right-from-square::before {
  content: "\\f08e";
}

.fa-external-link::before {
  content: "\\f08e";
}

.fa-cubes-stacked::before {
  content: "\\e4e6";
}

.fa-won-sign::before {
  content: "\\f159";
}

.fa-krw::before {
  content: "\\f159";
}

.fa-won::before {
  content: "\\f159";
}

.fa-virus-covid::before {
  content: "\\e4a8";
}

.fa-austral-sign::before {
  content: "\\e0a9";
}

.fa-f::before {
  content: "F";
}

.fa-leaf::before {
  content: "\\f06c";
}

.fa-road::before {
  content: "\\f018";
}

.fa-taxi::before {
  content: "\\f1ba";
}

.fa-cab::before {
  content: "\\f1ba";
}

.fa-person-circle-plus::before {
  content: "\\e541";
}

.fa-chart-pie::before {
  content: "\\f200";
}

.fa-pie-chart::before {
  content: "\\f200";
}

.fa-bolt-lightning::before {
  content: "\\e0b7";
}

.fa-sack-xmark::before {
  content: "\\e56a";
}

.fa-file-excel::before {
  content: "\\f1c3";
}

.fa-file-contract::before {
  content: "\\f56c";
}

.fa-fish-fins::before {
  content: "\\e4f2";
}

.fa-building-flag::before {
  content: "\\e4d5";
}

.fa-face-grin-beam::before {
  content: "\\f582";
}

.fa-grin-beam::before {
  content: "\\f582";
}

.fa-object-ungroup::before {
  content: "\\f248";
}

.fa-poop::before {
  content: "\\f619";
}

.fa-location-pin::before {
  content: "\\f041";
}

.fa-map-marker::before {
  content: "\\f041";
}

.fa-kaaba::before {
  content: "\\f66b";
}

.fa-toilet-paper::before {
  content: "\\f71e";
}

.fa-helmet-safety::before {
  content: "\\f807";
}

.fa-hard-hat::before {
  content: "\\f807";
}

.fa-hat-hard::before {
  content: "\\f807";
}

.fa-eject::before {
  content: "\\f052";
}

.fa-circle-right::before {
  content: "\\f35a";
}

.fa-arrow-alt-circle-right::before {
  content: "\\f35a";
}

.fa-plane-circle-check::before {
  content: "\\e555";
}

.fa-face-rolling-eyes::before {
  content: "\\f5a5";
}

.fa-meh-rolling-eyes::before {
  content: "\\f5a5";
}

.fa-object-group::before {
  content: "\\f247";
}

.fa-chart-line::before {
  content: "\\f201";
}

.fa-line-chart::before {
  content: "\\f201";
}

.fa-mask-ventilator::before {
  content: "\\e524";
}

.fa-arrow-right::before {
  content: "\\f061";
}

.fa-signs-post::before {
  content: "\\f277";
}

.fa-map-signs::before {
  content: "\\f277";
}

.fa-cash-register::before {
  content: "\\f788";
}

.fa-person-circle-question::before {
  content: "\\e542";
}

.fa-h::before {
  content: "H";
}

.fa-tarp::before {
  content: "\\e57b";
}

.fa-screwdriver-wrench::before {
  content: "\\f7d9";
}

.fa-tools::before {
  content: "\\f7d9";
}

.fa-arrows-to-eye::before {
  content: "\\e4bf";
}

.fa-plug-circle-bolt::before {
  content: "\\e55b";
}

.fa-heart::before {
  content: "\\f004";
}

.fa-mars-and-venus::before {
  content: "\\f224";
}

.fa-house-user::before {
  content: "\\e1b0";
}

.fa-home-user::before {
  content: "\\e1b0";
}

.fa-dumpster-fire::before {
  content: "\\f794";
}

.fa-house-crack::before {
  content: "\\e3b1";
}

.fa-martini-glass-citrus::before {
  content: "\\f561";
}

.fa-cocktail::before {
  content: "\\f561";
}

.fa-face-surprise::before {
  content: "\\f5c2";
}

.fa-surprise::before {
  content: "\\f5c2";
}

.fa-bottle-water::before {
  content: "\\e4c5";
}

.fa-circle-pause::before {
  content: "\\f28b";
}

.fa-pause-circle::before {
  content: "\\f28b";
}

.fa-toilet-paper-slash::before {
  content: "\\e072";
}

.fa-apple-whole::before {
  content: "\\f5d1";
}

.fa-apple-alt::before {
  content: "\\f5d1";
}

.fa-kitchen-set::before {
  content: "\\e51a";
}

.fa-r::before {
  content: "R";
}

.fa-temperature-quarter::before {
  content: "\\f2ca";
}

.fa-temperature-1::before {
  content: "\\f2ca";
}

.fa-thermometer-1::before {
  content: "\\f2ca";
}

.fa-thermometer-quarter::before {
  content: "\\f2ca";
}

.fa-cube::before {
  content: "\\f1b2";
}

.fa-bitcoin-sign::before {
  content: "\\e0b4";
}

.fa-shield-dog::before {
  content: "\\e573";
}

.fa-solar-panel::before {
  content: "\\f5ba";
}

.fa-lock-open::before {
  content: "\\f3c1";
}

.fa-elevator::before {
  content: "\\e16d";
}

.fa-money-bill-transfer::before {
  content: "\\e528";
}

.fa-money-bill-trend-up::before {
  content: "\\e529";
}

.fa-house-flood-water-circle-arrow-right::before {
  content: "\\e50f";
}

.fa-square-poll-horizontal::before {
  content: "\\f682";
}

.fa-poll-h::before {
  content: "\\f682";
}

.fa-circle::before {
  content: "\\f111";
}

.fa-backward-fast::before {
  content: "\\f049";
}

.fa-fast-backward::before {
  content: "\\f049";
}

.fa-recycle::before {
  content: "\\f1b8";
}

.fa-user-astronaut::before {
  content: "\\f4fb";
}

.fa-plane-slash::before {
  content: "\\e069";
}

.fa-trademark::before {
  content: "\\f25c";
}

.fa-basketball::before {
  content: "\\f434";
}

.fa-basketball-ball::before {
  content: "\\f434";
}

.fa-satellite-dish::before {
  content: "\\f7c0";
}

.fa-circle-up::before {
  content: "\\f35b";
}

.fa-arrow-alt-circle-up::before {
  content: "\\f35b";
}

.fa-mobile-screen-button::before {
  content: "\\f3cd";
}

.fa-mobile-alt::before {
  content: "\\f3cd";
}

.fa-volume-high::before {
  content: "\\f028";
}

.fa-volume-up::before {
  content: "\\f028";
}

.fa-users-rays::before {
  content: "\\e593";
}

.fa-wallet::before {
  content: "\\f555";
}

.fa-clipboard-check::before {
  content: "\\f46c";
}

.fa-file-audio::before {
  content: "\\f1c7";
}

.fa-burger::before {
  content: "\\f805";
}

.fa-hamburger::before {
  content: "\\f805";
}

.fa-wrench::before {
  content: "\\f0ad";
}

.fa-bugs::before {
  content: "\\e4d0";
}

.fa-rupee-sign::before {
  content: "\\f156";
}

.fa-rupee::before {
  content: "\\f156";
}

.fa-file-image::before {
  content: "\\f1c5";
}

.fa-circle-question::before {
  content: "\\f059";
}

.fa-question-circle::before {
  content: "\\f059";
}

.fa-plane-departure::before {
  content: "\\f5b0";
}

.fa-handshake-slash::before {
  content: "\\e060";
}

.fa-book-bookmark::before {
  content: "\\e0bb";
}

.fa-code-branch::before {
  content: "\\f126";
}

.fa-hat-cowboy::before {
  content: "\\f8c0";
}

.fa-bridge::before {
  content: "\\e4c8";
}

.fa-phone-flip::before {
  content: "\\f879";
}

.fa-phone-alt::before {
  content: "\\f879";
}

.fa-truck-front::before {
  content: "\\e2b7";
}

.fa-cat::before {
  content: "\\f6be";
}

.fa-anchor-circle-exclamation::before {
  content: "\\e4ab";
}

.fa-truck-field::before {
  content: "\\e58d";
}

.fa-route::before {
  content: "\\f4d7";
}

.fa-clipboard-question::before {
  content: "\\e4e3";
}

.fa-panorama::before {
  content: "\\e209";
}

.fa-comment-medical::before {
  content: "\\f7f5";
}

.fa-teeth-open::before {
  content: "\\f62f";
}

.fa-file-circle-minus::before {
  content: "\\e4ed";
}

.fa-tags::before {
  content: "\\f02c";
}

.fa-wine-glass::before {
  content: "\\f4e3";
}

.fa-forward-fast::before {
  content: "\\f050";
}

.fa-fast-forward::before {
  content: "\\f050";
}

.fa-face-meh-blank::before {
  content: "\\f5a4";
}

.fa-meh-blank::before {
  content: "\\f5a4";
}

.fa-square-parking::before {
  content: "\\f540";
}

.fa-parking::before {
  content: "\\f540";
}

.fa-house-signal::before {
  content: "\\e012";
}

.fa-bars-progress::before {
  content: "\\f828";
}

.fa-tasks-alt::before {
  content: "\\f828";
}

.fa-faucet-drip::before {
  content: "\\e006";
}

.fa-cart-flatbed::before {
  content: "\\f474";
}

.fa-dolly-flatbed::before {
  content: "\\f474";
}

.fa-ban-smoking::before {
  content: "\\f54d";
}

.fa-smoking-ban::before {
  content: "\\f54d";
}

.fa-terminal::before {
  content: "\\f120";
}

.fa-mobile-button::before {
  content: "\\f10b";
}

.fa-house-medical-flag::before {
  content: "\\e514";
}

.fa-basket-shopping::before {
  content: "\\f291";
}

.fa-shopping-basket::before {
  content: "\\f291";
}

.fa-tape::before {
  content: "\\f4db";
}

.fa-bus-simple::before {
  content: "\\f55e";
}

.fa-bus-alt::before {
  content: "\\f55e";
}

.fa-eye::before {
  content: "\\f06e";
}

.fa-face-sad-cry::before {
  content: "\\f5b3";
}

.fa-sad-cry::before {
  content: "\\f5b3";
}

.fa-audio-description::before {
  content: "\\f29e";
}

.fa-person-military-to-person::before {
  content: "\\e54c";
}

.fa-file-shield::before {
  content: "\\e4f0";
}

.fa-user-slash::before {
  content: "\\f506";
}

.fa-pen::before {
  content: "\\f304";
}

.fa-tower-observation::before {
  content: "\\e586";
}

.fa-file-code::before {
  content: "\\f1c9";
}

.fa-signal::before {
  content: "\\f012";
}

.fa-signal-5::before {
  content: "\\f012";
}

.fa-signal-perfect::before {
  content: "\\f012";
}

.fa-bus::before {
  content: "\\f207";
}

.fa-heart-circle-xmark::before {
  content: "\\e501";
}

.fa-house-chimney::before {
  content: "\\e3af";
}

.fa-home-lg::before {
  content: "\\e3af";
}

.fa-window-maximize::before {
  content: "\\f2d0";
}

.fa-face-frown::before {
  content: "\\f119";
}

.fa-frown::before {
  content: "\\f119";
}

.fa-prescription::before {
  content: "\\f5b1";
}

.fa-shop::before {
  content: "\\f54f";
}

.fa-store-alt::before {
  content: "\\f54f";
}

.fa-floppy-disk::before {
  content: "\\f0c7";
}

.fa-save::before {
  content: "\\f0c7";
}

.fa-vihara::before {
  content: "\\f6a7";
}

.fa-scale-unbalanced::before {
  content: "\\f515";
}

.fa-balance-scale-left::before {
  content: "\\f515";
}

.fa-sort-up::before {
  content: "\\f0de";
}

.fa-sort-asc::before {
  content: "\\f0de";
}

.fa-comment-dots::before {
  content: "\\f4ad";
}

.fa-commenting::before {
  content: "\\f4ad";
}

.fa-plant-wilt::before {
  content: "\\e5aa";
}

.fa-diamond::before {
  content: "\\f219";
}

.fa-face-grin-squint::before {
  content: "\\f585";
}

.fa-grin-squint::before {
  content: "\\f585";
}

.fa-hand-holding-dollar::before {
  content: "\\f4c0";
}

.fa-hand-holding-usd::before {
  content: "\\f4c0";
}

.fa-bacterium::before {
  content: "\\e05a";
}

.fa-hand-pointer::before {
  content: "\\f25a";
}

.fa-drum-steelpan::before {
  content: "\\f56a";
}

.fa-hand-scissors::before {
  content: "\\f257";
}

.fa-hands-praying::before {
  content: "\\f684";
}

.fa-praying-hands::before {
  content: "\\f684";
}

.fa-arrow-rotate-right::before {
  content: "\\f01e";
}

.fa-arrow-right-rotate::before {
  content: "\\f01e";
}

.fa-arrow-rotate-forward::before {
  content: "\\f01e";
}

.fa-redo::before {
  content: "\\f01e";
}

.fa-biohazard::before {
  content: "\\f780";
}

.fa-location-crosshairs::before {
  content: "\\f601";
}

.fa-location::before {
  content: "\\f601";
}

.fa-mars-double::before {
  content: "\\f227";
}

.fa-child-dress::before {
  content: "\\e59c";
}

.fa-users-between-lines::before {
  content: "\\e591";
}

.fa-lungs-virus::before {
  content: "\\e067";
}

.fa-face-grin-tears::before {
  content: "\\f588";
}

.fa-grin-tears::before {
  content: "\\f588";
}

.fa-phone::before {
  content: "\\f095";
}

.fa-calendar-xmark::before {
  content: "\\f273";
}

.fa-calendar-times::before {
  content: "\\f273";
}

.fa-child-reaching::before {
  content: "\\e59d";
}

.fa-head-side-virus::before {
  content: "\\e064";
}

.fa-user-gear::before {
  content: "\\f4fe";
}

.fa-user-cog::before {
  content: "\\f4fe";
}

.fa-arrow-up-1-9::before {
  content: "\\f163";
}

.fa-sort-numeric-up::before {
  content: "\\f163";
}

.fa-door-closed::before {
  content: "\\f52a";
}

.fa-shield-virus::before {
  content: "\\e06c";
}

.fa-dice-six::before {
  content: "\\f526";
}

.fa-mosquito-net::before {
  content: "\\e52c";
}

.fa-bridge-water::before {
  content: "\\e4ce";
}

.fa-person-booth::before {
  content: "\\f756";
}

.fa-text-width::before {
  content: "\\f035";
}

.fa-hat-wizard::before {
  content: "\\f6e8";
}

.fa-pen-fancy::before {
  content: "\\f5ac";
}

.fa-person-digging::before {
  content: "\\f85e";
}

.fa-digging::before {
  content: "\\f85e";
}

.fa-trash::before {
  content: "\\f1f8";
}

.fa-gauge-simple::before {
  content: "\\f629";
}

.fa-gauge-simple-med::before {
  content: "\\f629";
}

.fa-tachometer-average::before {
  content: "\\f629";
}

.fa-book-medical::before {
  content: "\\f7e6";
}

.fa-poo::before {
  content: "\\f2fe";
}

.fa-quote-right::before {
  content: "\\f10e";
}

.fa-quote-right-alt::before {
  content: "\\f10e";
}

.fa-shirt::before {
  content: "\\f553";
}

.fa-t-shirt::before {
  content: "\\f553";
}

.fa-tshirt::before {
  content: "\\f553";
}

.fa-cubes::before {
  content: "\\f1b3";
}

.fa-divide::before {
  content: "\\f529";
}

.fa-tenge-sign::before {
  content: "\\f7d7";
}

.fa-tenge::before {
  content: "\\f7d7";
}

.fa-headphones::before {
  content: "\\f025";
}

.fa-hands-holding::before {
  content: "\\f4c2";
}

.fa-hands-clapping::before {
  content: "\\e1a8";
}

.fa-republican::before {
  content: "\\f75e";
}

.fa-arrow-left::before {
  content: "\\f060";
}

.fa-person-circle-xmark::before {
  content: "\\e543";
}

.fa-ruler::before {
  content: "\\f545";
}

.fa-align-left::before {
  content: "\\f036";
}

.fa-dice-d6::before {
  content: "\\f6d1";
}

.fa-restroom::before {
  content: "\\f7bd";
}

.fa-j::before {
  content: "J";
}

.fa-users-viewfinder::before {
  content: "\\e595";
}

.fa-file-video::before {
  content: "\\f1c8";
}

.fa-up-right-from-square::before {
  content: "\\f35d";
}

.fa-external-link-alt::before {
  content: "\\f35d";
}

.fa-table-cells::before {
  content: "\\f00a";
}

.fa-th::before {
  content: "\\f00a";
}

.fa-file-pdf::before {
  content: "\\f1c1";
}

.fa-book-bible::before {
  content: "\\f647";
}

.fa-bible::before {
  content: "\\f647";
}

.fa-o::before {
  content: "O";
}

.fa-suitcase-medical::before {
  content: "\\f0fa";
}

.fa-medkit::before {
  content: "\\f0fa";
}

.fa-user-secret::before {
  content: "\\f21b";
}

.fa-otter::before {
  content: "\\f700";
}

.fa-person-dress::before {
  content: "\\f182";
}

.fa-female::before {
  content: "\\f182";
}

.fa-comment-dollar::before {
  content: "\\f651";
}

.fa-business-time::before {
  content: "\\f64a";
}

.fa-briefcase-clock::before {
  content: "\\f64a";
}

.fa-table-cells-large::before {
  content: "\\f009";
}

.fa-th-large::before {
  content: "\\f009";
}

.fa-book-tanakh::before {
  content: "\\f827";
}

.fa-tanakh::before {
  content: "\\f827";
}

.fa-phone-volume::before {
  content: "\\f2a0";
}

.fa-volume-control-phone::before {
  content: "\\f2a0";
}

.fa-hat-cowboy-side::before {
  content: "\\f8c1";
}

.fa-clipboard-user::before {
  content: "\\f7f3";
}

.fa-child::before {
  content: "\\f1ae";
}

.fa-lira-sign::before {
  content: "\\f195";
}

.fa-satellite::before {
  content: "\\f7bf";
}

.fa-plane-lock::before {
  content: "\\e558";
}

.fa-tag::before {
  content: "\\f02b";
}

.fa-comment::before {
  content: "\\f075";
}

.fa-cake-candles::before {
  content: "\\f1fd";
}

.fa-birthday-cake::before {
  content: "\\f1fd";
}

.fa-cake::before {
  content: "\\f1fd";
}

.fa-envelope::before {
  content: "\\f0e0";
}

.fa-angles-up::before {
  content: "\\f102";
}

.fa-angle-double-up::before {
  content: "\\f102";
}

.fa-paperclip::before {
  content: "\\f0c6";
}

.fa-arrow-right-to-city::before {
  content: "\\e4b3";
}

.fa-ribbon::before {
  content: "\\f4d6";
}

.fa-lungs::before {
  content: "\\f604";
}

.fa-arrow-up-9-1::before {
  content: "\\f887";
}

.fa-sort-numeric-up-alt::before {
  content: "\\f887";
}

.fa-litecoin-sign::before {
  content: "\\e1d3";
}

.fa-border-none::before {
  content: "\\f850";
}

.fa-circle-nodes::before {
  content: "\\e4e2";
}

.fa-parachute-box::before {
  content: "\\f4cd";
}

.fa-indent::before {
  content: "\\f03c";
}

.fa-truck-field-un::before {
  content: "\\e58e";
}

.fa-hourglass::before {
  content: "\\f254";
}

.fa-hourglass-empty::before {
  content: "\\f254";
}

.fa-mountain::before {
  content: "\\f6fc";
}

.fa-user-doctor::before {
  content: "\\f0f0";
}

.fa-user-md::before {
  content: "\\f0f0";
}

.fa-circle-info::before {
  content: "\\f05a";
}

.fa-info-circle::before {
  content: "\\f05a";
}

.fa-cloud-meatball::before {
  content: "\\f73b";
}

.fa-camera::before {
  content: "\\f030";
}

.fa-camera-alt::before {
  content: "\\f030";
}

.fa-square-virus::before {
  content: "\\e578";
}

.fa-meteor::before {
  content: "\\f753";
}

.fa-car-on::before {
  content: "\\e4dd";
}

.fa-sleigh::before {
  content: "\\f7cc";
}

.fa-arrow-down-1-9::before {
  content: "\\f162";
}

.fa-sort-numeric-asc::before {
  content: "\\f162";
}

.fa-sort-numeric-down::before {
  content: "\\f162";
}

.fa-hand-holding-droplet::before {
  content: "\\f4c1";
}

.fa-hand-holding-water::before {
  content: "\\f4c1";
}

.fa-water::before {
  content: "\\f773";
}

.fa-calendar-check::before {
  content: "\\f274";
}

.fa-braille::before {
  content: "\\f2a1";
}

.fa-prescription-bottle-medical::before {
  content: "\\f486";
}

.fa-prescription-bottle-alt::before {
  content: "\\f486";
}

.fa-landmark::before {
  content: "\\f66f";
}

.fa-truck::before {
  content: "\\f0d1";
}

.fa-crosshairs::before {
  content: "\\f05b";
}

.fa-person-cane::before {
  content: "\\e53c";
}

.fa-tent::before {
  content: "\\e57d";
}

.fa-vest-patches::before {
  content: "\\e086";
}

.fa-check-double::before {
  content: "\\f560";
}

.fa-arrow-down-a-z::before {
  content: "\\f15d";
}

.fa-sort-alpha-asc::before {
  content: "\\f15d";
}

.fa-sort-alpha-down::before {
  content: "\\f15d";
}

.fa-money-bill-wheat::before {
  content: "\\e52a";
}

.fa-cookie::before {
  content: "\\f563";
}

.fa-arrow-rotate-left::before {
  content: "\\f0e2";
}

.fa-arrow-left-rotate::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-back::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-backward::before {
  content: "\\f0e2";
}

.fa-undo::before {
  content: "\\f0e2";
}

.fa-hard-drive::before {
  content: "\\f0a0";
}

.fa-hdd::before {
  content: "\\f0a0";
}

.fa-face-grin-squint-tears::before {
  content: "\\f586";
}

.fa-grin-squint-tears::before {
  content: "\\f586";
}

.fa-dumbbell::before {
  content: "\\f44b";
}

.fa-rectangle-list::before {
  content: "\\f022";
}

.fa-list-alt::before {
  content: "\\f022";
}

.fa-tarp-droplet::before {
  content: "\\e57c";
}

.fa-house-medical-circle-check::before {
  content: "\\e511";
}

.fa-person-skiing-nordic::before {
  content: "\\f7ca";
}

.fa-skiing-nordic::before {
  content: "\\f7ca";
}

.fa-calendar-plus::before {
  content: "\\f271";
}

.fa-plane-arrival::before {
  content: "\\f5af";
}

.fa-circle-left::before {
  content: "\\f359";
}

.fa-arrow-alt-circle-left::before {
  content: "\\f359";
}

.fa-train-subway::before {
  content: "\\f239";
}

.fa-subway::before {
  content: "\\f239";
}

.fa-chart-gantt::before {
  content: "\\e0e4";
}

.fa-indian-rupee-sign::before {
  content: "\\e1bc";
}

.fa-indian-rupee::before {
  content: "\\e1bc";
}

.fa-inr::before {
  content: "\\e1bc";
}

.fa-crop-simple::before {
  content: "\\f565";
}

.fa-crop-alt::before {
  content: "\\f565";
}

.fa-money-bill-1::before {
  content: "\\f3d1";
}

.fa-money-bill-alt::before {
  content: "\\f3d1";
}

.fa-left-long::before {
  content: "\\f30a";
}

.fa-long-arrow-alt-left::before {
  content: "\\f30a";
}

.fa-dna::before {
  content: "\\f471";
}

.fa-virus-slash::before {
  content: "\\e075";
}

.fa-minus::before {
  content: "\\f068";
}

.fa-subtract::before {
  content: "\\f068";
}

.fa-chess::before {
  content: "\\f439";
}

.fa-arrow-left-long::before {
  content: "\\f177";
}

.fa-long-arrow-left::before {
  content: "\\f177";
}

.fa-plug-circle-check::before {
  content: "\\e55c";
}

.fa-street-view::before {
  content: "\\f21d";
}

.fa-franc-sign::before {
  content: "\\e18f";
}

.fa-volume-off::before {
  content: "\\f026";
}

.fa-hands-asl-interpreting::before {
  content: "\\f2a3";
}

.fa-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.fa-asl-interpreting::before {
  content: "\\f2a3";
}

.fa-hands-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.fa-gear::before {
  content: "\\f013";
}

.fa-cog::before {
  content: "\\f013";
}

.fa-droplet-slash::before {
  content: "\\f5c7";
}

.fa-tint-slash::before {
  content: "\\f5c7";
}

.fa-mosque::before {
  content: "\\f678";
}

.fa-mosquito::before {
  content: "\\e52b";
}

.fa-star-of-david::before {
  content: "\\f69a";
}

.fa-person-military-rifle::before {
  content: "\\e54b";
}

.fa-cart-shopping::before {
  content: "\\f07a";
}

.fa-shopping-cart::before {
  content: "\\f07a";
}

.fa-vials::before {
  content: "\\f493";
}

.fa-plug-circle-plus::before {
  content: "\\e55f";
}

.fa-place-of-worship::before {
  content: "\\f67f";
}

.fa-grip-vertical::before {
  content: "\\f58e";
}

.fa-arrow-turn-up::before {
  content: "\\f148";
}

.fa-level-up::before {
  content: "\\f148";
}

.fa-u::before {
  content: "U";
}

.fa-square-root-variable::before {
  content: "\\f698";
}

.fa-square-root-alt::before {
  content: "\\f698";
}

.fa-clock::before {
  content: "\\f017";
}

.fa-clock-four::before {
  content: "\\f017";
}

.fa-backward-step::before {
  content: "\\f048";
}

.fa-step-backward::before {
  content: "\\f048";
}

.fa-pallet::before {
  content: "\\f482";
}

.fa-faucet::before {
  content: "\\e005";
}

.fa-baseball-bat-ball::before {
  content: "\\f432";
}

.fa-s::before {
  content: "S";
}

.fa-timeline::before {
  content: "\\e29c";
}

.fa-keyboard::before {
  content: "\\f11c";
}

.fa-caret-down::before {
  content: "\\f0d7";
}

.fa-house-chimney-medical::before {
  content: "\\f7f2";
}

.fa-clinic-medical::before {
  content: "\\f7f2";
}

.fa-temperature-three-quarters::before {
  content: "\\f2c8";
}

.fa-temperature-3::before {
  content: "\\f2c8";
}

.fa-thermometer-3::before {
  content: "\\f2c8";
}

.fa-thermometer-three-quarters::before {
  content: "\\f2c8";
}

.fa-mobile-screen::before {
  content: "\\f3cf";
}

.fa-mobile-android-alt::before {
  content: "\\f3cf";
}

.fa-plane-up::before {
  content: "\\e22d";
}

.fa-piggy-bank::before {
  content: "\\f4d3";
}

.fa-battery-half::before {
  content: "\\f242";
}

.fa-battery-3::before {
  content: "\\f242";
}

.fa-mountain-city::before {
  content: "\\e52e";
}

.fa-coins::before {
  content: "\\f51e";
}

.fa-khanda::before {
  content: "\\f66d";
}

.fa-sliders::before {
  content: "\\f1de";
}

.fa-sliders-h::before {
  content: "\\f1de";
}

.fa-folder-tree::before {
  content: "\\f802";
}

.fa-network-wired::before {
  content: "\\f6ff";
}

.fa-map-pin::before {
  content: "\\f276";
}

.fa-hamsa::before {
  content: "\\f665";
}

.fa-cent-sign::before {
  content: "\\e3f5";
}

.fa-flask::before {
  content: "\\f0c3";
}

.fa-person-pregnant::before {
  content: "\\e31e";
}

.fa-wand-sparkles::before {
  content: "\\f72b";
}

.fa-ellipsis-vertical::before {
  content: "\\f142";
}

.fa-ellipsis-v::before {
  content: "\\f142";
}

.fa-ticket::before {
  content: "\\f145";
}

.fa-power-off::before {
  content: "\\f011";
}

.fa-right-long::before {
  content: "\\f30b";
}

.fa-long-arrow-alt-right::before {
  content: "\\f30b";
}

.fa-flag-usa::before {
  content: "\\f74d";
}

.fa-laptop-file::before {
  content: "\\e51d";
}

.fa-tty::before {
  content: "\\f1e4";
}

.fa-teletype::before {
  content: "\\f1e4";
}

.fa-diagram-next::before {
  content: "\\e476";
}

.fa-person-rifle::before {
  content: "\\e54e";
}

.fa-house-medical-circle-exclamation::before {
  content: "\\e512";
}

.fa-closed-captioning::before {
  content: "\\f20a";
}

.fa-person-hiking::before {
  content: "\\f6ec";
}

.fa-hiking::before {
  content: "\\f6ec";
}

.fa-venus-double::before {
  content: "\\f226";
}

.fa-images::before {
  content: "\\f302";
}

.fa-calculator::before {
  content: "\\f1ec";
}

.fa-people-pulling::before {
  content: "\\e535";
}

.fa-n::before {
  content: "N";
}

.fa-cable-car::before {
  content: "\\f7da";
}

.fa-tram::before {
  content: "\\f7da";
}

.fa-cloud-rain::before {
  content: "\\f73d";
}

.fa-building-circle-xmark::before {
  content: "\\e4d4";
}

.fa-ship::before {
  content: "\\f21a";
}

.fa-arrows-down-to-line::before {
  content: "\\e4b8";
}

.fa-download::before {
  content: "\\f019";
}

.fa-face-grin::before {
  content: "\\f580";
}

.fa-grin::before {
  content: "\\f580";
}

.fa-delete-left::before {
  content: "\\f55a";
}

.fa-backspace::before {
  content: "\\f55a";
}

.fa-eye-dropper::before {
  content: "\\f1fb";
}

.fa-eye-dropper-empty::before {
  content: "\\f1fb";
}

.fa-eyedropper::before {
  content: "\\f1fb";
}

.fa-file-circle-check::before {
  content: "\\e5a0";
}

.fa-forward::before {
  content: "\\f04e";
}

.fa-mobile::before {
  content: "\\f3ce";
}

.fa-mobile-android::before {
  content: "\\f3ce";
}

.fa-mobile-phone::before {
  content: "\\f3ce";
}

.fa-face-meh::before {
  content: "\\f11a";
}

.fa-meh::before {
  content: "\\f11a";
}

.fa-align-center::before {
  content: "\\f037";
}

.fa-book-skull::before {
  content: "\\f6b7";
}

.fa-book-dead::before {
  content: "\\f6b7";
}

.fa-id-card::before {
  content: "\\f2c2";
}

.fa-drivers-license::before {
  content: "\\f2c2";
}

.fa-outdent::before {
  content: "\\f03b";
}

.fa-dedent::before {
  content: "\\f03b";
}

.fa-heart-circle-exclamation::before {
  content: "\\e4fe";
}

.fa-house::before {
  content: "\\f015";
}

.fa-home::before {
  content: "\\f015";
}

.fa-home-alt::before {
  content: "\\f015";
}

.fa-home-lg-alt::before {
  content: "\\f015";
}

.fa-calendar-week::before {
  content: "\\f784";
}

.fa-laptop-medical::before {
  content: "\\f812";
}

.fa-b::before {
  content: "B";
}

.fa-file-medical::before {
  content: "\\f477";
}

.fa-dice-one::before {
  content: "\\f525";
}

.fa-kiwi-bird::before {
  content: "\\f535";
}

.fa-arrow-right-arrow-left::before {
  content: "\\f0ec";
}

.fa-exchange::before {
  content: "\\f0ec";
}

.fa-rotate-right::before {
  content: "\\f2f9";
}

.fa-redo-alt::before {
  content: "\\f2f9";
}

.fa-rotate-forward::before {
  content: "\\f2f9";
}

.fa-utensils::before {
  content: "\\f2e7";
}

.fa-cutlery::before {
  content: "\\f2e7";
}

.fa-arrow-up-wide-short::before {
  content: "\\f161";
}

.fa-sort-amount-up::before {
  content: "\\f161";
}

.fa-mill-sign::before {
  content: "\\e1ed";
}

.fa-bowl-rice::before {
  content: "\\e2eb";
}

.fa-skull::before {
  content: "\\f54c";
}

.fa-tower-broadcast::before {
  content: "\\f519";
}

.fa-broadcast-tower::before {
  content: "\\f519";
}

.fa-truck-pickup::before {
  content: "\\f63c";
}

.fa-up-long::before {
  content: "\\f30c";
}

.fa-long-arrow-alt-up::before {
  content: "\\f30c";
}

.fa-stop::before {
  content: "\\f04d";
}

.fa-code-merge::before {
  content: "\\f387";
}

.fa-upload::before {
  content: "\\f093";
}

.fa-hurricane::before {
  content: "\\f751";
}

.fa-mound::before {
  content: "\\e52d";
}

.fa-toilet-portable::before {
  content: "\\e583";
}

.fa-compact-disc::before {
  content: "\\f51f";
}

.fa-file-arrow-down::before {
  content: "\\f56d";
}

.fa-file-download::before {
  content: "\\f56d";
}

.fa-caravan::before {
  content: "\\f8ff";
}

.fa-shield-cat::before {
  content: "\\e572";
}

.fa-bolt::before {
  content: "\\f0e7";
}

.fa-zap::before {
  content: "\\f0e7";
}

.fa-glass-water::before {
  content: "\\e4f4";
}

.fa-oil-well::before {
  content: "\\e532";
}

.fa-vault::before {
  content: "\\e2c5";
}

.fa-mars::before {
  content: "\\f222";
}

.fa-toilet::before {
  content: "\\f7d8";
}

.fa-plane-circle-xmark::before {
  content: "\\e557";
}

.fa-yen-sign::before {
  content: "\\f157";
}

.fa-cny::before {
  content: "\\f157";
}

.fa-jpy::before {
  content: "\\f157";
}

.fa-rmb::before {
  content: "\\f157";
}

.fa-yen::before {
  content: "\\f157";
}

.fa-ruble-sign::before {
  content: "\\f158";
}

.fa-rouble::before {
  content: "\\f158";
}

.fa-rub::before {
  content: "\\f158";
}

.fa-ruble::before {
  content: "\\f158";
}

.fa-sun::before {
  content: "\\f185";
}

.fa-guitar::before {
  content: "\\f7a6";
}

.fa-face-laugh-wink::before {
  content: "\\f59c";
}

.fa-laugh-wink::before {
  content: "\\f59c";
}

.fa-horse-head::before {
  content: "\\f7ab";
}

.fa-bore-hole::before {
  content: "\\e4c3";
}

.fa-industry::before {
  content: "\\f275";
}

.fa-circle-down::before {
  content: "\\f358";
}

.fa-arrow-alt-circle-down::before {
  content: "\\f358";
}

.fa-arrows-turn-to-dots::before {
  content: "\\e4c1";
}

.fa-florin-sign::before {
  content: "\\e184";
}

.fa-arrow-down-short-wide::before {
  content: "\\f884";
}

.fa-sort-amount-desc::before {
  content: "\\f884";
}

.fa-sort-amount-down-alt::before {
  content: "\\f884";
}

.fa-less-than::before {
  content: "\\<";
}

.fa-angle-down::before {
  content: "\\f107";
}

.fa-car-tunnel::before {
  content: "\\e4de";
}

.fa-head-side-cough::before {
  content: "\\e061";
}

.fa-grip-lines::before {
  content: "\\f7a4";
}

.fa-thumbs-down::before {
  content: "\\f165";
}

.fa-user-lock::before {
  content: "\\f502";
}

.fa-arrow-right-long::before {
  content: "\\f178";
}

.fa-long-arrow-right::before {
  content: "\\f178";
}

.fa-anchor-circle-xmark::before {
  content: "\\e4ac";
}

.fa-ellipsis::before {
  content: "\\f141";
}

.fa-ellipsis-h::before {
  content: "\\f141";
}

.fa-chess-pawn::before {
  content: "\\f443";
}

.fa-kit-medical::before {
  content: "\\f479";
}

.fa-first-aid::before {
  content: "\\f479";
}

.fa-person-through-window::before {
  content: "\\e5a9";
}

.fa-toolbox::before {
  content: "\\f552";
}

.fa-hands-holding-circle::before {
  content: "\\e4fb";
}

.fa-bug::before {
  content: "\\f188";
}

.fa-credit-card::before {
  content: "\\f09d";
}

.fa-credit-card-alt::before {
  content: "\\f09d";
}

.fa-car::before {
  content: "\\f1b9";
}

.fa-automobile::before {
  content: "\\f1b9";
}

.fa-hand-holding-hand::before {
  content: "\\e4f7";
}

.fa-book-open-reader::before {
  content: "\\f5da";
}

.fa-book-reader::before {
  content: "\\f5da";
}

.fa-mountain-sun::before {
  content: "\\e52f";
}

.fa-arrows-left-right-to-line::before {
  content: "\\e4ba";
}

.fa-dice-d20::before {
  content: "\\f6cf";
}

.fa-truck-droplet::before {
  content: "\\e58c";
}

.fa-file-circle-xmark::before {
  content: "\\e5a1";
}

.fa-temperature-arrow-up::before {
  content: "\\e040";
}

.fa-temperature-up::before {
  content: "\\e040";
}

.fa-medal::before {
  content: "\\f5a2";
}

.fa-bed::before {
  content: "\\f236";
}

.fa-square-h::before {
  content: "\\f0fd";
}

.fa-h-square::before {
  content: "\\f0fd";
}

.fa-podcast::before {
  content: "\\f2ce";
}

.fa-temperature-full::before {
  content: "\\f2c7";
}

.fa-temperature-4::before {
  content: "\\f2c7";
}

.fa-thermometer-4::before {
  content: "\\f2c7";
}

.fa-thermometer-full::before {
  content: "\\f2c7";
}

.fa-bell::before {
  content: "\\f0f3";
}

.fa-superscript::before {
  content: "\\f12b";
}

.fa-plug-circle-xmark::before {
  content: "\\e560";
}

.fa-star-of-life::before {
  content: "\\f621";
}

.fa-phone-slash::before {
  content: "\\f3dd";
}

.fa-paint-roller::before {
  content: "\\f5aa";
}

.fa-handshake-angle::before {
  content: "\\f4c4";
}

.fa-hands-helping::before {
  content: "\\f4c4";
}

.fa-location-dot::before {
  content: "\\f3c5";
}

.fa-map-marker-alt::before {
  content: "\\f3c5";
}

.fa-file::before {
  content: "\\f15b";
}

.fa-greater-than::before {
  content: "\\>";
}

.fa-person-swimming::before {
  content: "\\f5c4";
}

.fa-swimmer::before {
  content: "\\f5c4";
}

.fa-arrow-down::before {
  content: "\\f063";
}

.fa-droplet::before {
  content: "\\f043";
}

.fa-tint::before {
  content: "\\f043";
}

.fa-eraser::before {
  content: "\\f12d";
}

.fa-earth-americas::before {
  content: "\\f57d";
}

.fa-earth::before {
  content: "\\f57d";
}

.fa-earth-america::before {
  content: "\\f57d";
}

.fa-globe-americas::before {
  content: "\\f57d";
}

.fa-person-burst::before {
  content: "\\e53b";
}

.fa-dove::before {
  content: "\\f4ba";
}

.fa-battery-empty::before {
  content: "\\f244";
}

.fa-battery-0::before {
  content: "\\f244";
}

.fa-socks::before {
  content: "\\f696";
}

.fa-inbox::before {
  content: "\\f01c";
}

.fa-section::before {
  content: "\\e447";
}

.fa-gauge-high::before {
  content: "\\f625";
}

.fa-tachometer-alt::before {
  content: "\\f625";
}

.fa-tachometer-alt-fast::before {
  content: "\\f625";
}

.fa-envelope-open-text::before {
  content: "\\f658";
}

.fa-hospital::before {
  content: "\\f0f8";
}

.fa-hospital-alt::before {
  content: "\\f0f8";
}

.fa-hospital-wide::before {
  content: "\\f0f8";
}

.fa-wine-bottle::before {
  content: "\\f72f";
}

.fa-chess-rook::before {
  content: "\\f447";
}

.fa-bars-staggered::before {
  content: "\\f550";
}

.fa-reorder::before {
  content: "\\f550";
}

.fa-stream::before {
  content: "\\f550";
}

.fa-dharmachakra::before {
  content: "\\f655";
}

.fa-hotdog::before {
  content: "\\f80f";
}

.fa-person-walking-with-cane::before {
  content: "\\f29d";
}

.fa-blind::before {
  content: "\\f29d";
}

.fa-drum::before {
  content: "\\f569";
}

.fa-ice-cream::before {
  content: "\\f810";
}

.fa-heart-circle-bolt::before {
  content: "\\e4fc";
}

.fa-fax::before {
  content: "\\f1ac";
}

.fa-paragraph::before {
  content: "\\f1dd";
}

.fa-check-to-slot::before {
  content: "\\f772";
}

.fa-vote-yea::before {
  content: "\\f772";
}

.fa-star-half::before {
  content: "\\f089";
}

.fa-boxes-stacked::before {
  content: "\\f468";
}

.fa-boxes::before {
  content: "\\f468";
}

.fa-boxes-alt::before {
  content: "\\f468";
}

.fa-link::before {
  content: "\\f0c1";
}

.fa-chain::before {
  content: "\\f0c1";
}

.fa-ear-listen::before {
  content: "\\f2a2";
}

.fa-assistive-listening-systems::before {
  content: "\\f2a2";
}

.fa-tree-city::before {
  content: "\\e587";
}

.fa-play::before {
  content: "\\f04b";
}

.fa-font::before {
  content: "\\f031";
}

.fa-table-cells-row-lock::before {
  content: "\\e67a";
}

.fa-rupiah-sign::before {
  content: "\\e23d";
}

.fa-magnifying-glass::before {
  content: "\\f002";
}

.fa-search::before {
  content: "\\f002";
}

.fa-table-tennis-paddle-ball::before {
  content: "\\f45d";
}

.fa-ping-pong-paddle-ball::before {
  content: "\\f45d";
}

.fa-table-tennis::before {
  content: "\\f45d";
}

.fa-person-dots-from-line::before {
  content: "\\f470";
}

.fa-diagnoses::before {
  content: "\\f470";
}

.fa-trash-can-arrow-up::before {
  content: "\\f82a";
}

.fa-trash-restore-alt::before {
  content: "\\f82a";
}

.fa-naira-sign::before {
  content: "\\e1f6";
}

.fa-cart-arrow-down::before {
  content: "\\f218";
}

.fa-walkie-talkie::before {
  content: "\\f8ef";
}

.fa-file-pen::before {
  content: "\\f31c";
}

.fa-file-edit::before {
  content: "\\f31c";
}

.fa-receipt::before {
  content: "\\f543";
}

.fa-square-pen::before {
  content: "\\f14b";
}

.fa-pen-square::before {
  content: "\\f14b";
}

.fa-pencil-square::before {
  content: "\\f14b";
}

.fa-suitcase-rolling::before {
  content: "\\f5c1";
}

.fa-person-circle-exclamation::before {
  content: "\\e53f";
}

.fa-chevron-down::before {
  content: "\\f078";
}

.fa-battery-full::before {
  content: "\\f240";
}

.fa-battery::before {
  content: "\\f240";
}

.fa-battery-5::before {
  content: "\\f240";
}

.fa-skull-crossbones::before {
  content: "\\f714";
}

.fa-code-compare::before {
  content: "\\e13a";
}

.fa-list-ul::before {
  content: "\\f0ca";
}

.fa-list-dots::before {
  content: "\\f0ca";
}

.fa-school-lock::before {
  content: "\\e56f";
}

.fa-tower-cell::before {
  content: "\\e585";
}

.fa-down-long::before {
  content: "\\f309";
}

.fa-long-arrow-alt-down::before {
  content: "\\f309";
}

.fa-ranking-star::before {
  content: "\\e561";
}

.fa-chess-king::before {
  content: "\\f43f";
}

.fa-person-harassing::before {
  content: "\\e549";
}

.fa-brazilian-real-sign::before {
  content: "\\e46c";
}

.fa-landmark-dome::before {
  content: "\\f752";
}

.fa-landmark-alt::before {
  content: "\\f752";
}

.fa-arrow-up::before {
  content: "\\f062";
}

.fa-tv::before {
  content: "\\f26c";
}

.fa-television::before {
  content: "\\f26c";
}

.fa-tv-alt::before {
  content: "\\f26c";
}

.fa-shrimp::before {
  content: "\\e448";
}

.fa-list-check::before {
  content: "\\f0ae";
}

.fa-tasks::before {
  content: "\\f0ae";
}

.fa-jug-detergent::before {
  content: "\\e519";
}

.fa-circle-user::before {
  content: "\\f2bd";
}

.fa-user-circle::before {
  content: "\\f2bd";
}

.fa-user-shield::before {
  content: "\\f505";
}

.fa-wind::before {
  content: "\\f72e";
}

.fa-car-burst::before {
  content: "\\f5e1";
}

.fa-car-crash::before {
  content: "\\f5e1";
}

.fa-y::before {
  content: "Y";
}

.fa-person-snowboarding::before {
  content: "\\f7ce";
}

.fa-snowboarding::before {
  content: "\\f7ce";
}

.fa-truck-fast::before {
  content: "\\f48b";
}

.fa-shipping-fast::before {
  content: "\\f48b";
}

.fa-fish::before {
  content: "\\f578";
}

.fa-user-graduate::before {
  content: "\\f501";
}

.fa-circle-half-stroke::before {
  content: "\\f042";
}

.fa-adjust::before {
  content: "\\f042";
}

.fa-clapperboard::before {
  content: "\\e131";
}

.fa-circle-radiation::before {
  content: "\\f7ba";
}

.fa-radiation-alt::before {
  content: "\\f7ba";
}

.fa-baseball::before {
  content: "\\f433";
}

.fa-baseball-ball::before {
  content: "\\f433";
}

.fa-jet-fighter-up::before {
  content: "\\e518";
}

.fa-diagram-project::before {
  content: "\\f542";
}

.fa-project-diagram::before {
  content: "\\f542";
}

.fa-copy::before {
  content: "\\f0c5";
}

.fa-volume-xmark::before {
  content: "\\f6a9";
}

.fa-volume-mute::before {
  content: "\\f6a9";
}

.fa-volume-times::before {
  content: "\\f6a9";
}

.fa-hand-sparkles::before {
  content: "\\e05d";
}

.fa-grip::before {
  content: "\\f58d";
}

.fa-grip-horizontal::before {
  content: "\\f58d";
}

.fa-share-from-square::before {
  content: "\\f14d";
}

.fa-share-square::before {
  content: "\\f14d";
}

.fa-child-combatant::before {
  content: "\\e4e0";
}

.fa-child-rifle::before {
  content: "\\e4e0";
}

.fa-gun::before {
  content: "\\e19b";
}

.fa-square-phone::before {
  content: "\\f098";
}

.fa-phone-square::before {
  content: "\\f098";
}

.fa-plus::before {
  content: "\\+";
}

.fa-add::before {
  content: "\\+";
}

.fa-expand::before {
  content: "\\f065";
}

.fa-computer::before {
  content: "\\e4e5";
}

.fa-xmark::before {
  content: "\\f00d";
}

.fa-close::before {
  content: "\\f00d";
}

.fa-multiply::before {
  content: "\\f00d";
}

.fa-remove::before {
  content: "\\f00d";
}

.fa-times::before {
  content: "\\f00d";
}

.fa-arrows-up-down-left-right::before {
  content: "\\f047";
}

.fa-arrows::before {
  content: "\\f047";
}

.fa-chalkboard-user::before {
  content: "\\f51c";
}

.fa-chalkboard-teacher::before {
  content: "\\f51c";
}

.fa-peso-sign::before {
  content: "\\e222";
}

.fa-building-shield::before {
  content: "\\e4d8";
}

.fa-baby::before {
  content: "\\f77c";
}

.fa-users-line::before {
  content: "\\e592";
}

.fa-quote-left::before {
  content: "\\f10d";
}

.fa-quote-left-alt::before {
  content: "\\f10d";
}

.fa-tractor::before {
  content: "\\f722";
}

.fa-trash-arrow-up::before {
  content: "\\f829";
}

.fa-trash-restore::before {
  content: "\\f829";
}

.fa-arrow-down-up-lock::before {
  content: "\\e4b0";
}

.fa-lines-leaning::before {
  content: "\\e51e";
}

.fa-ruler-combined::before {
  content: "\\f546";
}

.fa-copyright::before {
  content: "\\f1f9";
}

.fa-equals::before {
  content: "\\=";
}

.fa-blender::before {
  content: "\\f517";
}

.fa-teeth::before {
  content: "\\f62e";
}

.fa-shekel-sign::before {
  content: "\\f20b";
}

.fa-ils::before {
  content: "\\f20b";
}

.fa-shekel::before {
  content: "\\f20b";
}

.fa-sheqel::before {
  content: "\\f20b";
}

.fa-sheqel-sign::before {
  content: "\\f20b";
}

.fa-map::before {
  content: "\\f279";
}

.fa-rocket::before {
  content: "\\f135";
}

.fa-photo-film::before {
  content: "\\f87c";
}

.fa-photo-video::before {
  content: "\\f87c";
}

.fa-folder-minus::before {
  content: "\\f65d";
}

.fa-store::before {
  content: "\\f54e";
}

.fa-arrow-trend-up::before {
  content: "\\e098";
}

.fa-plug-circle-minus::before {
  content: "\\e55e";
}

.fa-sign-hanging::before {
  content: "\\f4d9";
}

.fa-sign::before {
  content: "\\f4d9";
}

.fa-bezier-curve::before {
  content: "\\f55b";
}

.fa-bell-slash::before {
  content: "\\f1f6";
}

.fa-tablet::before {
  content: "\\f3fb";
}

.fa-tablet-android::before {
  content: "\\f3fb";
}

.fa-school-flag::before {
  content: "\\e56e";
}

.fa-fill::before {
  content: "\\f575";
}

.fa-angle-up::before {
  content: "\\f106";
}

.fa-drumstick-bite::before {
  content: "\\f6d7";
}

.fa-holly-berry::before {
  content: "\\f7aa";
}

.fa-chevron-left::before {
  content: "\\f053";
}

.fa-bacteria::before {
  content: "\\e059";
}

.fa-hand-lizard::before {
  content: "\\f258";
}

.fa-notdef::before {
  content: "\\e1fe";
}

.fa-disease::before {
  content: "\\f7fa";
}

.fa-briefcase-medical::before {
  content: "\\f469";
}

.fa-genderless::before {
  content: "\\f22d";
}

.fa-chevron-right::before {
  content: "\\f054";
}

.fa-retweet::before {
  content: "\\f079";
}

.fa-car-rear::before {
  content: "\\f5de";
}

.fa-car-alt::before {
  content: "\\f5de";
}

.fa-pump-soap::before {
  content: "\\e06b";
}

.fa-video-slash::before {
  content: "\\f4e2";
}

.fa-battery-quarter::before {
  content: "\\f243";
}

.fa-battery-2::before {
  content: "\\f243";
}

.fa-radio::before {
  content: "\\f8d7";
}

.fa-baby-carriage::before {
  content: "\\f77d";
}

.fa-carriage-baby::before {
  content: "\\f77d";
}

.fa-traffic-light::before {
  content: "\\f637";
}

.fa-thermometer::before {
  content: "\\f491";
}

.fa-vr-cardboard::before {
  content: "\\f729";
}

.fa-hand-middle-finger::before {
  content: "\\f806";
}

.fa-percent::before {
  content: "\\%";
}

.fa-percentage::before {
  content: "\\%";
}

.fa-truck-moving::before {
  content: "\\f4df";
}

.fa-glass-water-droplet::before {
  content: "\\e4f5";
}

.fa-display::before {
  content: "\\e163";
}

.fa-face-smile::before {
  content: "\\f118";
}

.fa-smile::before {
  content: "\\f118";
}

.fa-thumbtack::before {
  content: "\\f08d";
}

.fa-thumb-tack::before {
  content: "\\f08d";
}

.fa-trophy::before {
  content: "\\f091";
}

.fa-person-praying::before {
  content: "\\f683";
}

.fa-pray::before {
  content: "\\f683";
}

.fa-hammer::before {
  content: "\\f6e3";
}

.fa-hand-peace::before {
  content: "\\f25b";
}

.fa-rotate::before {
  content: "\\f2f1";
}

.fa-sync-alt::before {
  content: "\\f2f1";
}

.fa-spinner::before {
  content: "\\f110";
}

.fa-robot::before {
  content: "\\f544";
}

.fa-peace::before {
  content: "\\f67c";
}

.fa-gears::before {
  content: "\\f085";
}

.fa-cogs::before {
  content: "\\f085";
}

.fa-warehouse::before {
  content: "\\f494";
}

.fa-arrow-up-right-dots::before {
  content: "\\e4b7";
}

.fa-splotch::before {
  content: "\\f5bc";
}

.fa-face-grin-hearts::before {
  content: "\\f584";
}

.fa-grin-hearts::before {
  content: "\\f584";
}

.fa-dice-four::before {
  content: "\\f524";
}

.fa-sim-card::before {
  content: "\\f7c4";
}

.fa-transgender::before {
  content: "\\f225";
}

.fa-transgender-alt::before {
  content: "\\f225";
}

.fa-mercury::before {
  content: "\\f223";
}

.fa-arrow-turn-down::before {
  content: "\\f149";
}

.fa-level-down::before {
  content: "\\f149";
}

.fa-person-falling-burst::before {
  content: "\\e547";
}

.fa-award::before {
  content: "\\f559";
}

.fa-ticket-simple::before {
  content: "\\f3ff";
}

.fa-ticket-alt::before {
  content: "\\f3ff";
}

.fa-building::before {
  content: "\\f1ad";
}

.fa-angles-left::before {
  content: "\\f100";
}

.fa-angle-double-left::before {
  content: "\\f100";
}

.fa-qrcode::before {
  content: "\\f029";
}

.fa-clock-rotate-left::before {
  content: "\\f1da";
}

.fa-history::before {
  content: "\\f1da";
}

.fa-face-grin-beam-sweat::before {
  content: "\\f583";
}

.fa-grin-beam-sweat::before {
  content: "\\f583";
}

.fa-file-export::before {
  content: "\\f56e";
}

.fa-arrow-right-from-file::before {
  content: "\\f56e";
}

.fa-shield::before {
  content: "\\f132";
}

.fa-shield-blank::before {
  content: "\\f132";
}

.fa-arrow-up-short-wide::before {
  content: "\\f885";
}

.fa-sort-amount-up-alt::before {
  content: "\\f885";
}

.fa-house-medical::before {
  content: "\\e3b2";
}

.fa-golf-ball-tee::before {
  content: "\\f450";
}

.fa-golf-ball::before {
  content: "\\f450";
}

.fa-circle-chevron-left::before {
  content: "\\f137";
}

.fa-chevron-circle-left::before {
  content: "\\f137";
}

.fa-house-chimney-window::before {
  content: "\\e00d";
}

.fa-pen-nib::before {
  content: "\\f5ad";
}

.fa-tent-arrow-turn-left::before {
  content: "\\e580";
}

.fa-tents::before {
  content: "\\e582";
}

.fa-wand-magic::before {
  content: "\\f0d0";
}

.fa-magic::before {
  content: "\\f0d0";
}

.fa-dog::before {
  content: "\\f6d3";
}

.fa-carrot::before {
  content: "\\f787";
}

.fa-moon::before {
  content: "\\f186";
}

.fa-wine-glass-empty::before {
  content: "\\f5ce";
}

.fa-wine-glass-alt::before {
  content: "\\f5ce";
}

.fa-cheese::before {
  content: "\\f7ef";
}

.fa-yin-yang::before {
  content: "\\f6ad";
}

.fa-music::before {
  content: "\\f001";
}

.fa-code-commit::before {
  content: "\\f386";
}

.fa-temperature-low::before {
  content: "\\f76b";
}

.fa-person-biking::before {
  content: "\\f84a";
}

.fa-biking::before {
  content: "\\f84a";
}

.fa-broom::before {
  content: "\\f51a";
}

.fa-shield-heart::before {
  content: "\\e574";
}

.fa-gopuram::before {
  content: "\\f664";
}

.fa-earth-oceania::before {
  content: "\\e47b";
}

.fa-globe-oceania::before {
  content: "\\e47b";
}

.fa-square-xmark::before {
  content: "\\f2d3";
}

.fa-times-square::before {
  content: "\\f2d3";
}

.fa-xmark-square::before {
  content: "\\f2d3";
}

.fa-hashtag::before {
  content: "\\#";
}

.fa-up-right-and-down-left-from-center::before {
  content: "\\f424";
}

.fa-expand-alt::before {
  content: "\\f424";
}

.fa-oil-can::before {
  content: "\\f613";
}

.fa-t::before {
  content: "T";
}

.fa-hippo::before {
  content: "\\f6ed";
}

.fa-chart-column::before {
  content: "\\e0e3";
}

.fa-infinity::before {
  content: "\\f534";
}

.fa-vial-circle-check::before {
  content: "\\e596";
}

.fa-person-arrow-down-to-line::before {
  content: "\\e538";
}

.fa-voicemail::before {
  content: "\\f897";
}

.fa-fan::before {
  content: "\\f863";
}

.fa-person-walking-luggage::before {
  content: "\\e554";
}

.fa-up-down::before {
  content: "\\f338";
}

.fa-arrows-alt-v::before {
  content: "\\f338";
}

.fa-cloud-moon-rain::before {
  content: "\\f73c";
}

.fa-calendar::before {
  content: "\\f133";
}

.fa-trailer::before {
  content: "\\e041";
}

.fa-bahai::before {
  content: "\\f666";
}

.fa-haykal::before {
  content: "\\f666";
}

.fa-sd-card::before {
  content: "\\f7c2";
}

.fa-dragon::before {
  content: "\\f6d5";
}

.fa-shoe-prints::before {
  content: "\\f54b";
}

.fa-circle-plus::before {
  content: "\\f055";
}

.fa-plus-circle::before {
  content: "\\f055";
}

.fa-face-grin-tongue-wink::before {
  content: "\\f58b";
}

.fa-grin-tongue-wink::before {
  content: "\\f58b";
}

.fa-hand-holding::before {
  content: "\\f4bd";
}

.fa-plug-circle-exclamation::before {
  content: "\\e55d";
}

.fa-link-slash::before {
  content: "\\f127";
}

.fa-chain-broken::before {
  content: "\\f127";
}

.fa-chain-slash::before {
  content: "\\f127";
}

.fa-unlink::before {
  content: "\\f127";
}

.fa-clone::before {
  content: "\\f24d";
}

.fa-person-walking-arrow-loop-left::before {
  content: "\\e551";
}

.fa-arrow-up-z-a::before {
  content: "\\f882";
}

.fa-sort-alpha-up-alt::before {
  content: "\\f882";
}

.fa-fire-flame-curved::before {
  content: "\\f7e4";
}

.fa-fire-alt::before {
  content: "\\f7e4";
}

.fa-tornado::before {
  content: "\\f76f";
}

.fa-file-circle-plus::before {
  content: "\\e494";
}

.fa-book-quran::before {
  content: "\\f687";
}

.fa-quran::before {
  content: "\\f687";
}

.fa-anchor::before {
  content: "\\f13d";
}

.fa-border-all::before {
  content: "\\f84c";
}

.fa-face-angry::before {
  content: "\\f556";
}

.fa-angry::before {
  content: "\\f556";
}

.fa-cookie-bite::before {
  content: "\\f564";
}

.fa-arrow-trend-down::before {
  content: "\\e097";
}

.fa-rss::before {
  content: "\\f09e";
}

.fa-feed::before {
  content: "\\f09e";
}

.fa-draw-polygon::before {
  content: "\\f5ee";
}

.fa-scale-balanced::before {
  content: "\\f24e";
}

.fa-balance-scale::before {
  content: "\\f24e";
}

.fa-gauge-simple-high::before {
  content: "\\f62a";
}

.fa-tachometer::before {
  content: "\\f62a";
}

.fa-tachometer-fast::before {
  content: "\\f62a";
}

.fa-shower::before {
  content: "\\f2cc";
}

.fa-desktop::before {
  content: "\\f390";
}

.fa-desktop-alt::before {
  content: "\\f390";
}

.fa-m::before {
  content: "M";
}

.fa-table-list::before {
  content: "\\f00b";
}

.fa-th-list::before {
  content: "\\f00b";
}

.fa-comment-sms::before {
  content: "\\f7cd";
}

.fa-sms::before {
  content: "\\f7cd";
}

.fa-book::before {
  content: "\\f02d";
}

.fa-user-plus::before {
  content: "\\f234";
}

.fa-check::before {
  content: "\\f00c";
}

.fa-battery-three-quarters::before {
  content: "\\f241";
}

.fa-battery-4::before {
  content: "\\f241";
}

.fa-house-circle-check::before {
  content: "\\e509";
}

.fa-angle-left::before {
  content: "\\f104";
}

.fa-diagram-successor::before {
  content: "\\e47a";
}

.fa-truck-arrow-right::before {
  content: "\\e58b";
}

.fa-arrows-split-up-and-left::before {
  content: "\\e4bc";
}

.fa-hand-fist::before {
  content: "\\f6de";
}

.fa-fist-raised::before {
  content: "\\f6de";
}

.fa-cloud-moon::before {
  content: "\\f6c3";
}

.fa-briefcase::before {
  content: "\\f0b1";
}

.fa-person-falling::before {
  content: "\\e546";
}

.fa-image-portrait::before {
  content: "\\f3e0";
}

.fa-portrait::before {
  content: "\\f3e0";
}

.fa-user-tag::before {
  content: "\\f507";
}

.fa-rug::before {
  content: "\\e569";
}

.fa-earth-europe::before {
  content: "\\f7a2";
}

.fa-globe-europe::before {
  content: "\\f7a2";
}

.fa-cart-flatbed-suitcase::before {
  content: "\\f59d";
}

.fa-luggage-cart::before {
  content: "\\f59d";
}

.fa-rectangle-xmark::before {
  content: "\\f410";
}

.fa-rectangle-times::before {
  content: "\\f410";
}

.fa-times-rectangle::before {
  content: "\\f410";
}

.fa-window-close::before {
  content: "\\f410";
}

.fa-baht-sign::before {
  content: "\\e0ac";
}

.fa-book-open::before {
  content: "\\f518";
}

.fa-book-journal-whills::before {
  content: "\\f66a";
}

.fa-journal-whills::before {
  content: "\\f66a";
}

.fa-handcuffs::before {
  content: "\\e4f8";
}

.fa-triangle-exclamation::before {
  content: "\\f071";
}

.fa-exclamation-triangle::before {
  content: "\\f071";
}

.fa-warning::before {
  content: "\\f071";
}

.fa-database::before {
  content: "\\f1c0";
}

.fa-share::before {
  content: "\\f064";
}

.fa-mail-forward::before {
  content: "\\f064";
}

.fa-bottle-droplet::before {
  content: "\\e4c4";
}

.fa-mask-face::before {
  content: "\\e1d7";
}

.fa-hill-rockslide::before {
  content: "\\e508";
}

.fa-right-left::before {
  content: "\\f362";
}

.fa-exchange-alt::before {
  content: "\\f362";
}

.fa-paper-plane::before {
  content: "\\f1d8";
}

.fa-road-circle-exclamation::before {
  content: "\\e565";
}

.fa-dungeon::before {
  content: "\\f6d9";
}

.fa-align-right::before {
  content: "\\f038";
}

.fa-money-bill-1-wave::before {
  content: "\\f53b";
}

.fa-money-bill-wave-alt::before {
  content: "\\f53b";
}

.fa-life-ring::before {
  content: "\\f1cd";
}

.fa-hands::before {
  content: "\\f2a7";
}

.fa-sign-language::before {
  content: "\\f2a7";
}

.fa-signing::before {
  content: "\\f2a7";
}

.fa-calendar-day::before {
  content: "\\f783";
}

.fa-water-ladder::before {
  content: "\\f5c5";
}

.fa-ladder-water::before {
  content: "\\f5c5";
}

.fa-swimming-pool::before {
  content: "\\f5c5";
}

.fa-arrows-up-down::before {
  content: "\\f07d";
}

.fa-arrows-v::before {
  content: "\\f07d";
}

.fa-face-grimace::before {
  content: "\\f57f";
}

.fa-grimace::before {
  content: "\\f57f";
}

.fa-wheelchair-move::before {
  content: "\\e2ce";
}

.fa-wheelchair-alt::before {
  content: "\\e2ce";
}

.fa-turn-down::before {
  content: "\\f3be";
}

.fa-level-down-alt::before {
  content: "\\f3be";
}

.fa-person-walking-arrow-right::before {
  content: "\\e552";
}

.fa-square-envelope::before {
  content: "\\f199";
}

.fa-envelope-square::before {
  content: "\\f199";
}

.fa-dice::before {
  content: "\\f522";
}

.fa-bowling-ball::before {
  content: "\\f436";
}

.fa-brain::before {
  content: "\\f5dc";
}

.fa-bandage::before {
  content: "\\f462";
}

.fa-band-aid::before {
  content: "\\f462";
}

.fa-calendar-minus::before {
  content: "\\f272";
}

.fa-circle-xmark::before {
  content: "\\f057";
}

.fa-times-circle::before {
  content: "\\f057";
}

.fa-xmark-circle::before {
  content: "\\f057";
}

.fa-gifts::before {
  content: "\\f79c";
}

.fa-hotel::before {
  content: "\\f594";
}

.fa-earth-asia::before {
  content: "\\f57e";
}

.fa-globe-asia::before {
  content: "\\f57e";
}

.fa-id-card-clip::before {
  content: "\\f47f";
}

.fa-id-card-alt::before {
  content: "\\f47f";
}

.fa-magnifying-glass-plus::before {
  content: "\\f00e";
}

.fa-search-plus::before {
  content: "\\f00e";
}

.fa-thumbs-up::before {
  content: "\\f164";
}

.fa-user-clock::before {
  content: "\\f4fd";
}

.fa-hand-dots::before {
  content: "\\f461";
}

.fa-allergies::before {
  content: "\\f461";
}

.fa-file-invoice::before {
  content: "\\f570";
}

.fa-window-minimize::before {
  content: "\\f2d1";
}

.fa-mug-saucer::before {
  content: "\\f0f4";
}

.fa-coffee::before {
  content: "\\f0f4";
}

.fa-brush::before {
  content: "\\f55d";
}

.fa-mask::before {
  content: "\\f6fa";
}

.fa-magnifying-glass-minus::before {
  content: "\\f010";
}

.fa-search-minus::before {
  content: "\\f010";
}

.fa-ruler-vertical::before {
  content: "\\f548";
}

.fa-user-large::before {
  content: "\\f406";
}

.fa-user-alt::before {
  content: "\\f406";
}

.fa-train-tram::before {
  content: "\\e5b4";
}

.fa-user-nurse::before {
  content: "\\f82f";
}

.fa-syringe::before {
  content: "\\f48e";
}

.fa-cloud-sun::before {
  content: "\\f6c4";
}

.fa-stopwatch-20::before {
  content: "\\e06f";
}

.fa-square-full::before {
  content: "\\f45c";
}

.fa-magnet::before {
  content: "\\f076";
}

.fa-jar::before {
  content: "\\e516";
}

.fa-note-sticky::before {
  content: "\\f249";
}

.fa-sticky-note::before {
  content: "\\f249";
}

.fa-bug-slash::before {
  content: "\\e490";
}

.fa-arrow-up-from-water-pump::before {
  content: "\\e4b6";
}

.fa-bone::before {
  content: "\\f5d7";
}

.fa-user-injured::before {
  content: "\\f728";
}

.fa-face-sad-tear::before {
  content: "\\f5b4";
}

.fa-sad-tear::before {
  content: "\\f5b4";
}

.fa-plane::before {
  content: "\\f072";
}

.fa-tent-arrows-down::before {
  content: "\\e581";
}

.fa-exclamation::before {
  content: "\\!";
}

.fa-arrows-spin::before {
  content: "\\e4bb";
}

.fa-print::before {
  content: "\\f02f";
}

.fa-turkish-lira-sign::before {
  content: "\\e2bb";
}

.fa-try::before {
  content: "\\e2bb";
}

.fa-turkish-lira::before {
  content: "\\e2bb";
}

.fa-dollar-sign::before {
  content: "\\\$";
}

.fa-dollar::before {
  content: "\\\$";
}

.fa-usd::before {
  content: "\\\$";
}

.fa-x::before {
  content: "X";
}

.fa-magnifying-glass-dollar::before {
  content: "\\f688";
}

.fa-search-dollar::before {
  content: "\\f688";
}

.fa-users-gear::before {
  content: "\\f509";
}

.fa-users-cog::before {
  content: "\\f509";
}

.fa-person-military-pointing::before {
  content: "\\e54a";
}

.fa-building-columns::before {
  content: "\\f19c";
}

.fa-bank::before {
  content: "\\f19c";
}

.fa-institution::before {
  content: "\\f19c";
}

.fa-museum::before {
  content: "\\f19c";
}

.fa-university::before {
  content: "\\f19c";
}

.fa-umbrella::before {
  content: "\\f0e9";
}

.fa-trowel::before {
  content: "\\e589";
}

.fa-d::before {
  content: "D";
}

.fa-stapler::before {
  content: "\\e5af";
}

.fa-masks-theater::before {
  content: "\\f630";
}

.fa-theater-masks::before {
  content: "\\f630";
}

.fa-kip-sign::before {
  content: "\\e1c4";
}

.fa-hand-point-left::before {
  content: "\\f0a5";
}

.fa-handshake-simple::before {
  content: "\\f4c6";
}

.fa-handshake-alt::before {
  content: "\\f4c6";
}

.fa-jet-fighter::before {
  content: "\\f0fb";
}

.fa-fighter-jet::before {
  content: "\\f0fb";
}

.fa-square-share-nodes::before {
  content: "\\f1e1";
}

.fa-share-alt-square::before {
  content: "\\f1e1";
}

.fa-barcode::before {
  content: "\\f02a";
}

.fa-plus-minus::before {
  content: "\\e43c";
}

.fa-video::before {
  content: "\\f03d";
}

.fa-video-camera::before {
  content: "\\f03d";
}

.fa-graduation-cap::before {
  content: "\\f19d";
}

.fa-mortar-board::before {
  content: "\\f19d";
}

.fa-hand-holding-medical::before {
  content: "\\e05c";
}

.fa-person-circle-check::before {
  content: "\\e53e";
}

.fa-turn-up::before {
  content: "\\f3bf";
}

.fa-level-up-alt::before {
  content: "\\f3bf";
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/*!
 * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
:root, :host {
  --fa-style-family-classic: "Font Awesome 6 Free";
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
}

@font-face {
  font-family: "Font Awesome 6 Free";
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
.fas,
.fa-solid {
  font-weight: 900;
}

/*!
 * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
:root, :host {
  --fa-style-family-brands: "Font Awesome 6 Brands";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

@font-face {
  font-family: "Font Awesome 6 Brands";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
.fab,
.fa-brands {
  font-weight: 400;
}

.fa-monero:before {
  content: "\\f3d0";
}

.fa-hooli:before {
  content: "\\f427";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-shopware:before {
  content: "\\f5b5";
}

.fa-creative-commons-nc:before {
  content: "\\f4e8";
}

.fa-aws:before {
  content: "\\f375";
}

.fa-redhat:before {
  content: "\\f7bc";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-cloudflare:before {
  content: "\\e07d";
}

.fa-ups:before {
  content: "\\f7e0";
}

.fa-pixiv:before {
  content: "\\e640";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-dyalog:before {
  content: "\\f399";
}

.fa-bity:before {
  content: "\\f37a";
}

.fa-stackpath:before {
  content: "\\f842";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-guilded:before {
  content: "\\e07e";
}

.fa-vnv:before {
  content: "\\f40b";
}

.fa-square-js:before {
  content: "\\f3b9";
}

.fa-js-square:before {
  content: "\\f3b9";
}

.fa-microsoft:before {
  content: "\\f3ca";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-orcid:before {
  content: "\\f8d2";
}

.fa-java:before {
  content: "\\f4e4";
}

.fa-invision:before {
  content: "\\f7b0";
}

.fa-creative-commons-pd-alt:before {
  content: "\\f4ed";
}

.fa-centercode:before {
  content: "\\f380";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-jxl:before {
  content: "\\e67b";
}

.fa-hire-a-helper:before {
  content: "\\f3b0";
}

.fa-creative-commons-by:before {
  content: "\\f4e7";
}

.fa-unity:before {
  content: "\\e049";
}

.fa-whmcs:before {
  content: "\\f40d";
}

.fa-rocketchat:before {
  content: "\\f3e8";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-untappd:before {
  content: "\\f405";
}

.fa-mailchimp:before {
  content: "\\f59e";
}

.fa-css3-alt:before {
  content: "\\f38b";
}

.fa-square-reddit:before {
  content: "\\f1a2";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-vimeo-v:before {
  content: "\\f27d";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-square-font-awesome:before {
  content: "\\e5ad";
}

.fa-deskpro:before {
  content: "\\f38f";
}

.fa-brave:before {
  content: "\\e63c";
}

.fa-sistrix:before {
  content: "\\f3ee";
}

.fa-square-instagram:before {
  content: "\\e055";
}

.fa-instagram-square:before {
  content: "\\e055";
}

.fa-battle-net:before {
  content: "\\f835";
}

.fa-the-red-yeti:before {
  content: "\\f69d";
}

.fa-square-hacker-news:before {
  content: "\\f3af";
}

.fa-hacker-news-square:before {
  content: "\\f3af";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-threads:before {
  content: "\\e618";
}

.fa-napster:before {
  content: "\\f3d2";
}

.fa-square-snapchat:before {
  content: "\\f2ad";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-google-plus-g:before {
  content: "\\f0d5";
}

.fa-artstation:before {
  content: "\\f77a";
}

.fa-markdown:before {
  content: "\\f60f";
}

.fa-sourcetree:before {
  content: "\\f7d3";
}

.fa-google-plus:before {
  content: "\\f2b3";
}

.fa-diaspora:before {
  content: "\\f791";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-phoenix-squadron:before {
  content: "\\f511";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-algolia:before {
  content: "\\f36c";
}

.fa-red-river:before {
  content: "\\f3e3";
}

.fa-creative-commons-sa:before {
  content: "\\f4ef";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-square-font-awesome-stroke:before {
  content: "\\f35c";
}

.fa-font-awesome-alt:before {
  content: "\\f35c";
}

.fa-atlassian:before {
  content: "\\f77b";
}

.fa-linkedin-in:before {
  content: "\\f0e1";
}

.fa-digital-ocean:before {
  content: "\\f391";
}

.fa-nimblr:before {
  content: "\\f5a8";
}

.fa-chromecast:before {
  content: "\\f838";
}

.fa-evernote:before {
  content: "\\f839";
}

.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-creative-commons-sampling:before {
  content: "\\f4f0";
}

.fa-adversal:before {
  content: "\\f36a";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-watchman-monitoring:before {
  content: "\\e087";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-weixin:before {
  content: "\\f1d7";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-git-alt:before {
  content: "\\f841";
}

.fa-lyft:before {
  content: "\\f3c3";
}

.fa-rev:before {
  content: "\\f5b2";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-wizards-of-the-coast:before {
  content: "\\f730";
}

.fa-square-viadeo:before {
  content: "\\f2aa";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.fa-centos:before {
  content: "\\f789";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-cloudsmith:before {
  content: "\\f384";
}

.fa-opensuse:before {
  content: "\\e62b";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-square-dribbble:before {
  content: "\\f397";
}

.fa-dribbble-square:before {
  content: "\\f397";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-node:before {
  content: "\\f419";
}

.fa-mix:before {
  content: "\\f3cb";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-cc-apple-pay:before {
  content: "\\f416";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-debian:before {
  content: "\\e60b";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-instalod:before {
  content: "\\e081";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-sellcast:before {
  content: "\\f2da";
}

.fa-square-twitter:before {
  content: "\\f081";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-r-project:before {
  content: "\\f4f7";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-freebsd:before {
  content: "\\f3a4";
}

.fa-vuejs:before {
  content: "\\f41f";
}

.fa-accusoft:before {
  content: "\\f369";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-fonticons-fi:before {
  content: "\\f3a2";
}

.fa-app-store:before {
  content: "\\f36f";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-itunes-note:before {
  content: "\\f3b5";
}

.fa-golang:before {
  content: "\\e40f";
}

.fa-kickstarter:before {
  content: "\\f3bb";
}

.fa-square-kickstarter:before {
  content: "\\f3bb";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-uncharted:before {
  content: "\\e084";
}

.fa-firstdraft:before {
  content: "\\f3a1";
}

.fa-square-youtube:before {
  content: "\\f431";
}

.fa-youtube-square:before {
  content: "\\f431";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-wpressr:before {
  content: "\\f3e4";
}

.fa-rendact:before {
  content: "\\f3e4";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-galactic-republic:before {
  content: "\\f50c";
}

.fa-nfc-directional:before {
  content: "\\e530";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-joget:before {
  content: "\\f3b7";
}

.fa-fedora:before {
  content: "\\f798";
}

.fa-stripe-s:before {
  content: "\\f42a";
}

.fa-meta:before {
  content: "\\e49b";
}

.fa-laravel:before {
  content: "\\f3bd";
}

.fa-hotjar:before {
  content: "\\f3b1";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-square-letterboxd:before {
  content: "\\e62e";
}

.fa-sticker-mule:before {
  content: "\\f3f7";
}

.fa-creative-commons-zero:before {
  content: "\\f4f3";
}

.fa-hips:before {
  content: "\\f452";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-discord:before {
  content: "\\f392";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-app-store-ios:before {
  content: "\\f370";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-confluence:before {
  content: "\\f78d";
}

.fa-shoelace:before {
  content: "\\e60c";
}

.fa-mdb:before {
  content: "\\f8ca";
}

.fa-dochub:before {
  content: "\\f394";
}

.fa-accessible-icon:before {
  content: "\\f368";
}

.fa-ebay:before {
  content: "\\f4f4";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-unsplash:before {
  content: "\\e07c";
}

.fa-yarn:before {
  content: "\\f7e3";
}

.fa-square-steam:before {
  content: "\\f1b7";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-500px:before {
  content: "\\f26e";
}

.fa-square-vimeo:before {
  content: "\\f194";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-asymmetrik:before {
  content: "\\f372";
}

.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-font-awesome-flag:before {
  content: "\\f2b4";
}

.fa-font-awesome-logo-full:before {
  content: "\\f2b4";
}

.fa-gratipay:before {
  content: "\\f184";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-hive:before {
  content: "\\e07f";
}

.fa-gitkraken:before {
  content: "\\f3a6";
}

.fa-keybase:before {
  content: "\\f4f5";
}

.fa-apple-pay:before {
  content: "\\f415";
}

.fa-padlet:before {
  content: "\\e4a0";
}

.fa-amazon-pay:before {
  content: "\\f42c";
}

.fa-square-github:before {
  content: "\\f092";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-fedex:before {
  content: "\\f797";
}

.fa-phoenix-framework:before {
  content: "\\f3dc";
}

.fa-shopify:before {
  content: "\\e057";
}

.fa-neos:before {
  content: "\\f612";
}

.fa-square-threads:before {
  content: "\\e619";
}

.fa-hackerrank:before {
  content: "\\f5f7";
}

.fa-researchgate:before {
  content: "\\f4f8";
}

.fa-swift:before {
  content: "\\f8e1";
}

.fa-angular:before {
  content: "\\f420";
}

.fa-speakap:before {
  content: "\\f3f3";
}

.fa-angrycreative:before {
  content: "\\f36e";
}

.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-empire:before {
  content: "\\f1d1";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-google-scholar:before {
  content: "\\e63b";
}

.fa-square-gitlab:before {
  content: "\\e5ae";
}

.fa-gitlab-square:before {
  content: "\\e5ae";
}

.fa-studiovinari:before {
  content: "\\f3f8";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-goodreads:before {
  content: "\\f3a8";
}

.fa-square-odnoklassniki:before {
  content: "\\f264";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-sith:before {
  content: "\\f512";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-page4:before {
  content: "\\f3d7";
}

.fa-hashnode:before {
  content: "\\e499";
}

.fa-react:before {
  content: "\\f41b";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-squarespace:before {
  content: "\\f5be";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-creative-commons-share:before {
  content: "\\f4f2";
}

.fa-bitcoin:before {
  content: "\\f379";
}

.fa-keycdn:before {
  content: "\\f3ba";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-itch-io:before {
  content: "\\f83a";
}

.fa-umbraco:before {
  content: "\\f8e8";
}

.fa-galactic-senate:before {
  content: "\\f50d";
}

.fa-ubuntu:before {
  content: "\\f7df";
}

.fa-draft2digital:before {
  content: "\\f396";
}

.fa-stripe:before {
  content: "\\f429";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-dhl:before {
  content: "\\f790";
}

.fa-square-pinterest:before {
  content: "\\f0d3";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-blackberry:before {
  content: "\\f37b";
}

.fa-creative-commons-pd:before {
  content: "\\f4ec";
}

.fa-playstation:before {
  content: "\\f3df";
}

.fa-quinscape:before {
  content: "\\f459";
}

.fa-less:before {
  content: "\\f41d";
}

.fa-blogger-b:before {
  content: "\\f37d";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-signal-messenger:before {
  content: "\\e663";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-typo3:before {
  content: "\\f42b";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-dailymotion:before {
  content: "\\e052";
}

.fa-affiliatetheme:before {
  content: "\\f36b";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-bootstrap:before {
  content: "\\f836";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-nfc-symbol:before {
  content: "\\e531";
}

.fa-mintbit:before {
  content: "\\e62f";
}

.fa-ethereum:before {
  content: "\\f42e";
}

.fa-speaker-deck:before {
  content: "\\f83c";
}

.fa-creative-commons-nc-eu:before {
  content: "\\f4e9";
}

.fa-patreon:before {
  content: "\\f3d9";
}

.fa-avianex:before {
  content: "\\f374";
}

.fa-ello:before {
  content: "\\f5f1";
}

.fa-gofore:before {
  content: "\\f3a7";
}

.fa-bimobject:before {
  content: "\\f378";
}

.fa-brave-reverse:before {
  content: "\\e63d";
}

.fa-facebook-f:before {
  content: "\\f39e";
}

.fa-square-google-plus:before {
  content: "\\f0d4";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-web-awesome:before {
  content: "\\e682";
}

.fa-mandalorian:before {
  content: "\\f50f";
}

.fa-first-order-alt:before {
  content: "\\f50a";
}

.fa-osi:before {
  content: "\\f41a";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-d-and-d-beyond:before {
  content: "\\f6ca";
}

.fa-periscope:before {
  content: "\\f3da";
}

.fa-fulcrum:before {
  content: "\\f50b";
}

.fa-cloudscale:before {
  content: "\\f383";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-mizuni:before {
  content: "\\f3cc";
}

.fa-schlix:before {
  content: "\\f3ea";
}

.fa-square-xing:before {
  content: "\\f169";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-cloudversify:before {
  content: "\\f385";
}

.fa-usps:before {
  content: "\\f7e1";
}

.fa-megaport:before {
  content: "\\f5a3";
}

.fa-magento:before {
  content: "\\f3c4";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-fly:before {
  content: "\\f417";
}

.fa-aviato:before {
  content: "\\f421";
}

.fa-itunes:before {
  content: "\\f3b4";
}

.fa-cuttlefish:before {
  content: "\\f38c";
}

.fa-blogger:before {
  content: "\\f37c";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-viber:before {
  content: "\\f409";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-letterboxd:before {
  content: "\\e62d";
}

.fa-symfony:before {
  content: "\\f83d";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-facebook-messenger:before {
  content: "\\f39f";
}

.fa-audible:before {
  content: "\\f373";
}

.fa-think-peaks:before {
  content: "\\f731";
}

.fa-bilibili:before {
  content: "\\e3d9";
}

.fa-erlang:before {
  content: "\\f39d";
}

.fa-x-twitter:before {
  content: "\\e61b";
}

.fa-cotton-bureau:before {
  content: "\\f89e";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-42-group:before {
  content: "\\e080";
}

.fa-innosoft:before {
  content: "\\e080";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-elementor:before {
  content: "\\f430";
}

.fa-square-pied-piper:before {
  content: "\\e01e";
}

.fa-pied-piper-square:before {
  content: "\\e01e";
}

.fa-creative-commons-nd:before {
  content: "\\f4eb";
}

.fa-palfed:before {
  content: "\\f3d8";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-resolving:before {
  content: "\\f3e7";
}

.fa-xbox:before {
  content: "\\f412";
}

.fa-square-web-awesome-stroke:before {
  content: "\\e684";
}

.fa-searchengin:before {
  content: "\\f3eb";
}

.fa-tiktok:before {
  content: "\\e07b";
}

.fa-square-facebook:before {
  content: "\\f082";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-linkedin:before {
  content: "\\f08c";
}

.fa-hubspot:before {
  content: "\\f3b2";
}

.fa-deploydog:before {
  content: "\\f38e";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-mixer:before {
  content: "\\e056";
}

.fa-square-lastfm:before {
  content: "\\f203";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-vimeo:before {
  content: "\\f40a";
}

.fa-mendeley:before {
  content: "\\f7b3";
}

.fa-uniregistry:before {
  content: "\\f404";
}

.fa-figma:before {
  content: "\\f799";
}

.fa-creative-commons-remix:before {
  content: "\\f4ee";
}

.fa-cc-amazon-pay:before {
  content: "\\f42d";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-cmplid:before {
  content: "\\e360";
}

.fa-upwork:before {
  content: "\\e641";
}

.fa-facebook:before {
  content: "\\f09a";
}

.fa-gripfire:before {
  content: "\\f3ac";
}

.fa-jedi-order:before {
  content: "\\f50e";
}

.fa-uikit:before {
  content: "\\f403";
}

.fa-fort-awesome-alt:before {
  content: "\\f3a3";
}

.fa-phabricator:before {
  content: "\\f3db";
}

.fa-ussunnah:before {
  content: "\\f407";
}

.fa-earlybirds:before {
  content: "\\f39a";
}

.fa-trade-federation:before {
  content: "\\f513";
}

.fa-autoprefixer:before {
  content: "\\f41c";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-square-upwork:before {
  content: "\\e67c";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-google-play:before {
  content: "\\f3ab";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-line:before {
  content: "\\f3c0";
}

.fa-google-drive:before {
  content: "\\f3aa";
}

.fa-servicestack:before {
  content: "\\f3ec";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-deezer:before {
  content: "\\e077";
}

.fa-raspberry-pi:before {
  content: "\\f7bb";
}

.fa-jira:before {
  content: "\\f7b1";
}

.fa-docker:before {
  content: "\\f395";
}

.fa-screenpal:before {
  content: "\\e570";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-gitter:before {
  content: "\\f426";
}

.fa-d-and-d:before {
  content: "\\f38d";
}

.fa-microblog:before {
  content: "\\e01a";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-pied-piper-hat:before {
  content: "\\f4e5";
}

.fa-kickstarter-k:before {
  content: "\\f3bc";
}

.fa-yandex:before {
  content: "\\f413";
}

.fa-readme:before {
  content: "\\f4d5";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-square-web-awesome:before {
  content: "\\e683";
}

.fa-sass:before {
  content: "\\f41e";
}

.fa-wirsindhandwerk:before {
  content: "\\e2d0";
}

.fa-wsh:before {
  content: "\\e2d0";
}

.fa-buromobelexperte:before {
  content: "\\f37f";
}

.fa-salesforce:before {
  content: "\\f83b";
}

.fa-octopus-deploy:before {
  content: "\\e082";
}

.fa-medapps:before {
  content: "\\f3c6";
}

.fa-ns8:before {
  content: "\\f3d5";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-apper:before {
  content: "\\f371";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-waze:before {
  content: "\\f83f";
}

.fa-bluesky:before {
  content: "\\e671";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ab";
}

.fa-fantasy-flight-games:before {
  content: "\\f6dc";
}

.fa-rust:before {
  content: "\\e07a";
}

.fa-wix:before {
  content: "\\f5cf";
}

.fa-square-behance:before {
  content: "\\f1b5";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-supple:before {
  content: "\\f3f9";
}

.fa-webflow:before {
  content: "\\e65c";
}

.fa-rebel:before {
  content: "\\f1d0";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-staylinked:before {
  content: "\\f3f5";
}

.fa-kaggle:before {
  content: "\\f5fa";
}

.fa-space-awesome:before {
  content: "\\e5ac";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-cpanel:before {
  content: "\\f388";
}

.fa-goodreads-g:before {
  content: "\\f3a9";
}

.fa-square-git:before {
  content: "\\f1d2";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-square-tumblr:before {
  content: "\\f174";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-creative-commons-nc-jp:before {
  content: "\\f4ea";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-perbyte:before {
  content: "\\e083";
}

.fa-grunt:before {
  content: "\\f3ad";
}

.fa-weebly:before {
  content: "\\f5cc";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-themeco:before {
  content: "\\f5c6";
}

.fa-python:before {
  content: "\\f3e2";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-bots:before {
  content: "\\e340";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-hornbill:before {
  content: "\\f592";
}

.fa-js:before {
  content: "\\f3b8";
}

.fa-ideal:before {
  content: "\\e013";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-dev:before {
  content: "\\f6cc";
}

.fa-sketch:before {
  content: "\\f7c6";
}

.fa-yandex-international:before {
  content: "\\f414";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-uber:before {
  content: "\\f402";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-php:before {
  content: "\\f457";
}

.fa-alipay:before {
  content: "\\f642";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-firefox-browser:before {
  content: "\\e007";
}

.fa-replyd:before {
  content: "\\f3e6";
}

.fa-suse:before {
  content: "\\f7d6";
}

.fa-jenkins:before {
  content: "\\f3b6";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-rockrms:before {
  content: "\\f3e9";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-buffer:before {
  content: "\\f837";
}

.fa-npm:before {
  content: "\\f3d4";
}

.fa-yammer:before {
  content: "\\f840";
}

.fa-btc:before {
  content: "\\f15a";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-stubber:before {
  content: "\\e5c7";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-telegram-plane:before {
  content: "\\f2c6";
}

.fa-old-republic:before {
  content: "\\f510";
}

.fa-odysee:before {
  content: "\\e5c6";
}

.fa-square-whatsapp:before {
  content: "\\f40c";
}

.fa-whatsapp-square:before {
  content: "\\f40c";
}

.fa-node-js:before {
  content: "\\f3d3";
}

.fa-edge-legacy:before {
  content: "\\e078";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-slack-hash:before {
  content: "\\f198";
}

.fa-medrt:before {
  content: "\\f3c8";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-vaadin:before {
  content: "\\f408";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-square-x-twitter:before {
  content: "\\e61a";
}

.fa-reacteurope:before {
  content: "\\f75d";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-medium-m:before {
  content: "\\f23a";
}

.fa-amilia:before {
  content: "\\f36d";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-flipboard:before {
  content: "\\f44d";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-critical-role:before {
  content: "\\f6c9";
}

.fa-sitrox:before {
  content: "\\e44a";
}

.fa-discourse:before {
  content: "\\f393";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-mastodon:before {
  content: "\\f4f6";
}

.fa-airbnb:before {
  content: "\\f834";
}

.fa-wolf-pack-battalion:before {
  content: "\\f514";
}

.fa-buy-n-large:before {
  content: "\\f8a6";
}

.fa-gulp:before {
  content: "\\f3ae";
}

.fa-creative-commons-sampling-plus:before {
  content: "\\f4f1";
}

.fa-strava:before {
  content: "\\f428";
}

.fa-ember:before {
  content: "\\f423";
}

.fa-canadian-maple-leaf:before {
  content: "\\f785";
}

.fa-teamspeak:before {
  content: "\\f4f9";
}

.fa-pushed:before {
  content: "\\f3e1";
}

.fa-wordpress-simple:before {
  content: "\\f411";
}

.fa-nutritionix:before {
  content: "\\f3d6";
}

.fa-wodu:before {
  content: "\\e088";
}

.fa-google-pay:before {
  content: "\\e079";
}

.fa-intercom:before {
  content: "\\f7af";
}

.fa-zhihu:before {
  content: "\\f63f";
}

.fa-korvue:before {
  content: "\\f42f";
}

.fa-pix:before {
  content: "\\e43a";
}

.fa-steam-symbol:before {
  content: "\\f3f6";
}

/** SCSS Starts Here */
html,
body {
  height: 100%;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

body {
  font-family: "Inria Serif", serif;
  display: flex;
  flex-direction: column;
}

button {
  font-family: "Inria Serif", serif;
}

.container {
  flex: 1 0 auto;
  margin: 1em;
}

/** WIP on the Flexbox */
/**
main {
    display: flex;
}

article {
    display: flex;
}

aside {
    display: flex;
}

.footer {
    flex-shrink: 0;
    padding: 20px;
}
**/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Quicksand", sans-serif;
}

nav {
  background: #9230D9;
  padding: 5px 20px;
}
nav a {
  font-size: 20px;
}

ul {
  list-style-type: none;
}

a {
  color: #ffffff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.logo a:hover {
  text-decoration: none;
}

.menu li {
  font-size: 16px;
  padding: 15px 5px;
  white-space: nowrap;
}

.logo a,
.toggle a {
  font-size: 20px;
}

.button.secondary {
  border: 1px solid #ffffff;
}

/** Basic Styling */
footer {
  background-color: #9230D9;
  text-align: center;
  color: #ffffff;
  font-size: 20px;
}

input:invalid {
  border-color: #900;
  background-color: #FDD;
}

input:focus:invalid {
  outline: none;
}

/* This is the style of our error messages */
.error {
  width: 100%;
  padding: 0;
  font-size: 80%;
  color: #ffffff;
  background-color: #900;
  border-radius: 0 5px 5px;
  box-sizing: border-box;
}

.error.active {
  padding: 0.3em;
}

/** Hidden Class */
.hidden {
  visibility: hidden;
}

/** Navbar */
nav {
  background: #9230D9;
  padding: 0 15px;
}

a {
  color: #ffffff;
  text-decoration: none;
}

.menu,
.submenu {
  list-style-type: none;
}

.logo {
  font-size: 20px;
  padding: 7.5px 10px 7.5px 0;
}

.item {
  padding: 10px;
}
.item.button {
  padding: 9px 5px;
}
.item:not(.button) a:hover,
.item a:hover::after {
  color: #ffffff;
}

/* Mobile menu */
.menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.menu li a {
  display: block;
  padding: 15px 5px;
}
.menu li.subitem a {
  padding: 15px;
}

.toggle {
  order: 1;
  font-size: 20px;
}

.item {
  order: 3;
  width: 100%;
  text-align: center;
  display: none;
}
.item.button {
  order: 2;
}

.active .item {
  display: block;
}

.button.secondary {
  /* divider between buttons and menu links */
  border-bottom: 1px #444 solid;
}

/* Submenu up from mobile screens */
.submenu {
  display: none;
}

.submenu-active .submenu {
  display: block;
}

.has-submenu i {
  font-size: 12px;
}
.has-submenu > a::after {
  font-family: "Font Awesome 5 Free";
  font-size: 12px;
  line-height: 16px;
  font-weight: 900;
  content: "\\f078";
  color: #ffffff;
  padding-left: 5px;
}

.subitem a {
  padding: 10px 15px;
}

.submenu-active {
  background-color: inverse(#ffffff);
  border-radius: 3px;
}

/* Tablet menu */
@media all and (min-width: 700px) {
  .menu {
    justify-content: center;
  }
  .logo {
    flex: 1;
  }
  .item.button {
    width: auto;
    order: 1;
    display: block;
  }
  .toggle {
    flex: 1;
    text-align: right;
    order: 2;
  }
  /* Button up from tablet screen */
  .menu li.button a {
    padding: 10px 15px;
    margin: 5px 0;
  }
  .button a {
    background: #306BD9;
    border: 3px #306BD9 solid;
  }
  .button.secondary {
    border: 0;
  }
  .button.secondary a {
    background: transparent;
    border-radius: 27px;
    border: 3px #306BD9 solid;
  }
  .button.secondary a:hover {
    background: #F4BB38;
    color: #ffffff;
    border: 3px #ffffff solid;
  }
  .button a:hover {
    text-decoration: none;
  }
  .button:not(.secondary) a:hover {
    background: #9230D9;
    border-color: #ffffff;
    color: #ffffff;
  }
}
/* Desktop menu */
@media all and (min-width: 960px) {
  .menu {
    align-items: flex-start;
    flex-wrap: nowrap;
    background: none;
  }
  .logo {
    order: 0;
  }
  .item {
    order: 1;
    position: relative;
    display: block;
    width: auto;
  }
  .button {
    order: 2;
  }
  .submenu-active .submenu {
    display: block;
    position: absolute;
    left: 0;
    top: 68px;
    background: #111;
  }
  .toggle {
    display: none;
  }
  .submenu-active {
    border-radius: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./src/scss/_algolia.scss","webpack://./src/scss/_buttons.scss","webpack://./src/scss/_colors.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/fontawesome.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_core.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_sizing.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_mixins.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_fixed-width.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_variables.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_list.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_bordered-pulled.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_animated.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_rotated-flipped.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_stacked.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_icons.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_screen-reader.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/solid.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/brands.scss"],"names":[],"mappings":"AAAA,kBAAA;ACAA;;;;;;;;;;;;;EAaI,SAAA;EACA,UAAA;EACA,gBAAA;ADGJ;;ACAA;;;;;;;;;;;;;;;EAeI,UAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;ADGJ;;ACAA;;;;;;;;;;;;;;;EAeI,UAAA;EACA,SAAA;ADGJ;;ACAA;;;;;;;;;;;;;;;EAeI,eAAA;ADGJ;;ACAA;;;;;;EAMI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;ADGJ;;ACAA;;EAEI,YAAA;ADGJ;;ACAA;EACI,gBAAA;ADGJ;;ACAA;EACI,cAAA;EACA,aAAA;EACA,WAAA;ADGJ;;ACAA;EACI,cAAA;EACA,WAAA;EACA,YAAA;ADGJ;;ACCI;EAEI,aAAA;EACA,QAAA;EACA,SAAA;ADCR;ACCI;EAII,aAAA;ADFR;;ACOI;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;ADJR;ACMI;EACI,WAAA;EACA,MAAA;EACA,WAAA;ADJR;ACMI;EACI,kBAAA;EACA,SAAA;ADJR;ACMI;EACI,kBAAA;EACA,sBAAA;EACA,sBAAA;ADJR;ACMI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,sBAAA;ADJR;;ACQA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;ADLJ;;ACQA;EACI,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;ADLJ;;ACQA;EACI,WAAA;ADLJ;;ACQA;EACI,iBAAA;ADLJ;;ACQA;;EAEI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,2BAAA;ADLJ;;ACQA;EACI,UAAA;ADLJ;;ACQA;EACI,eAAA;EACA,sBAAA;ADLJ;;ACQA;EACI,qBAAA;ADLJ;;ACQA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BI,cAAA;ADLJ;;ACQA;;;EAGI,gBAAA;ADLJ;;ACQA;EACI,eAAA;EACA,gBAAA;ADLJ;;ACQA;;;;;EAKI,cAAA;EACA,+BAAA;ADLJ;;ACSI;EAEI,cAAA;ADPR;;ACYI;EAEI,cAAA;ADVR;;ACeI;EAEI,cAAA;ADbR;;ACkBI;EAEI,cAAA;ADhBR;;ACqBI;EAEI,cAAA;ADnBR;;ACuBA;;;;;;;;;;EAUI,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;ADpBJ;;ACwBI;EAEI,yBAAA;ADtBR;;AC2BI;EAEI,yBAAA;ADzBR;;AC8BI;EAEI,yBAAA;AD5BR;;ACiCI;EAEI,yBAAA;AD/BR;;ACoCI;EAEI,yBAAA;ADlCR;;ACuCI;EAEI,yBAAA;ADrCR;;AC0CI;EAEI,yBAAA;ADxCR;;AC6CI;EAEI,yBAAA;AD3CR;;ACgDI;EAEI,yBAAA;AD9CR;;ACmDI;EAEI,yBAAA;ADjDR;;ACqDA;;;;;;;;EAQI,YAAA;EACA,mBAAA;ADlDJ;;ACsDI;EAEI,yBAAA;ADpDR;;ACyDI;EAEI,yBAAA;ADvDR;;AC4DI;EAEI,yBAAA;AD1DR;;AC+DI;EAEI,yBAAA;AD7DR;;ACkEI;EAEI,yBAAA;ADhER;;ACqEI;EAEI,yBAAA;ADnER;;ACwEI;EAEI,yBAAA;ADtER;;AC2EI;EAEI,yBAAA;ADzER;;AC6EA;EACI,aAAA;AD1EJ;;AC6EA;EACI,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AD1EJ;;AC6EA;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AD1EJ;;AC6EA;EACI,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AD1EJ;;AC6EA;EACI,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,aAAA;AD1EJ;;AC6EA;EACI,mBAAA;AD1EJ;;AC6EA;;;EAGI,mBAAA;EACA,iBAAA;EACA,WAAA;AD1EJ;;AC6EA;EACI,kBAAA;EACA,mBAAA;AD1EJ;AC2EI;EACI,mBAAA;ADzER;;AC6EA;EACI,kBAAA;AD1EJ;;AC6EA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;AD1EJ;;AC6EA;EACI,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0CAAA;EACA,wCAAA;EACA,aAAA;AD1EJ;;AC6EA;EACI,qBAAA;AD1EJ;;AC6EA;;EAEI,mBAAA;AD1EJ;;AC6EA;EACI,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,mCAAA;EACA,2BAAA;AD1EJ;;AC6EA;;EAEI,cAAA;EACA,gBAAA;AD1EJ;;AC6EA;;;;;EAKI,gBAAA;EACA,gBAAA;AD1EJ;;AC6EA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,0BAAA;AD1EJ;;AC6EA;EACI,qBAAA;AD1EJ;;AC6EA;EACI,gCAAA;EACA,wBAAA;AD1EJ;;AC6EA;;EAEI,iBAAA;AD1EJ;;AC6EA;;EAEI,YAAA;AD1EJ;;AC6EA;;EAEI,YAAA;AD1EJ;;AC6EA;;;;EAII,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AD1EJ;;AC6EA;;;EAGI,kBAAA;AD1EJ;;AC6EA;;EAEI,yBAAA;AD1EJ;;AC6EA;;;;EAII,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AD1EJ;;AC8EI;;;;EAII,wBAAA;AD3ER;;AC+EA;;;;EAII,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;AD5EJ;;ACgFI;;;;EAII,4BAAA;AD7ER;;ACiFA;;EAEI,gBAAA;AD9EJ;;ACiFA;EACI,mBAAA;AD9EJ;;ACiFA;;;;;EAKI,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kCAAA;EACA,eAAA;EACA,sBAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;AD9EJ;;ACiFA;EACI,kBAAA;AD9EJ;ACgFQ;;EAEI,aAAA;AD9EZ;ACiFI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AD/ER;;ACmFA;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gCAAA;ADhFJ;;ACmFA;EACI,kBAAA;EACA,iBAAA;ADhFJ;;ACmFA;EACI,iBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;ADhFJ;;ACmFA;EACI,gBAAA;ADhFJ;;ACmFA;EACI,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;ADhFJ;ACiFI;EAEI,yBAAA;ADhFR;;ACoFA;EACI,cAAA;ADjFJ;;ACoFA;EACI,wBAAA;EACA,qBAAA;EACA,uBAAA;ADjFJ;;ACoFA;EACI,mBAAA;ADjFJ;;ACoFA;EACI,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;ADjFJ;ACkFI;EAEI,yBAAA;ADjFR;;ACqFA;EACI,YAAA;EACA,mBAAA;EACA,cAAA;ADlFJ;ACmFI;EAEI,cAAA;EACA,sBAAA;ADlFR;;ACsFA;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;ADnFJ;ACoFI;EAEI,WAAA;ADnFR;;ACuFA;;;;EAII,iBAAA;ADpFJ;;ACuFA;EACI,mBAAA;ADpFJ;;ACwFI;EACI,yBAAA;ADrFR;ACuFI;EACI,qBAAA;EACA,sBAAA;ADrFR;ACuFI;EACI,qBAAA;ADrFR;ACuFI;EACI,yBAAA;ADrFR;;ACyFA;EACI,cAAA;ADtFJ;;ACyFA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ADtFJ;;ACyFA;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;ADtFJ;;ACyFA;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;ADtFJ;;ACyFA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;ADtFJ;;AC0FI;;EAEI,cAAA;ADvFR;;AC2FA;EACI,gBAAA;ADxFJ;;AC2FA;EACI,gBAAA;ADxFJ;ACyFI;EACI,mBAAA;ADvFR;;AC2FA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;ADxFJ;;AC2FA;EACI,aAAA;ADxFJ;;AC2FA;;;EAGI,qBAAA;ADxFJ;;AC2FA;EACI,cAAA;EACA,kBAAA;ADxFJ;;AC2FA;EACI,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;ADxFJ;ACyFI;EAII,cAAA;AD1FR;;AC8FA;;EAEI,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,aAAA;EACA,mCAAA;EACA,2BAAA;AD3FJ;;AC8FA;EACI,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,aAAA;EACA,mCAAA;EACA,2BAAA;EACA,YAAA;AD3FJ;;AC8FA;EACI,aAAA;AD3FJ;;AC8FA;;;EAGI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oDAAA;EACA,4CAAA;AD3FJ;;AC8FA;EACI,aAAA;AD3FJ;;AC8FA;EAII,WAAA;EACA,YAAA;AD9FJ;AC0FI;EACI,aAAA;ADxFR;;AC8FA;EACI,WAAA;EACA,YAAA;AD3FJ;;AC8FA;EACI,WAAA;EACA,YAAA;AD3FJ;;AC8FA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;AD3FJ;AC4FI;EACI,mBAAA;AD1FR;AC4FI;EACI,eAAA;EACA,yBAAA;EACA,WAAA;AD1FR;AC4FI;EACI,cAAA;AD1FR;AC2FQ;EACI,cAAA;EACA,mBAAA;EACA,mBAAA;ADzFZ;;AE95BA;EACI,mBAAA;EACA,mBCEQ;EDDR,yBAAA;EACA,kBAAA;AFi6BJ;AEh6BI;EACI,qBAAA;EACA,yBCDA;EDEA,cCHK;EDIL,wBAAA;AFk6BR;;AE95BA;EACI,mBCVQ;EDWR,kBAAA;EACA,yBAAA;EACA,cCXI;AH46BR;AEh6BI;EACI,6BAAA;EACA,cCfK;EDgBL,kBAAA;EACA,yBAAA;EACA,wBAAA;AFk6BR;;AE95BA;EACI,mBAAA;EACA,aAAA;AFi6BJ;;AAv7BA,kBAAA;AAKA,kBAAA;AIZA;;;;EAAA;ACGA;EACE,0DAAA;EACA,iCAAA;ALq8BF;;AKl8BA;;;;;;;;;EASE,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;ALq8BF;;AKl8BA;;;;;EAKE,kCAAA;ALq8BF;;AKl8BA;;EAEE,oCAAA;ALq8BF;;AMp+BE;EACE,cAAA;ANu+BJ;;AMx+BE;EACE,cAAA;AN2+BJ;;AM5+BE;EACE,cAAA;AN++BJ;;AMh/BE;EACE,cAAA;ANm/BJ;;AMp/BE;EACE,cAAA;ANu/BJ;;AMx/BE;EACE,cAAA;AN2/BJ;;AM5/BE;EACE,cAAA;AN+/BJ;;AMhgCE;EACE,cAAA;ANmgCJ;;AMpgCE;EACE,cAAA;ANugCJ;;AMxgCE;EACE,eAAA;AN2gCJ;;AMrgCE;ECIA,kBAAA;EACA,kBAAA;EACA,uBAAA;APqgCF;;AM3gCE;ECIA,iBAAA;EACA,2BAAA;EACA,uBAAA;AP2gCF;;AMjhCE;ECIA,kBAAA;EACA,2BAAA;EACA,8BAAA;APihCF;;AMvhCE;ECIA,iBAAA;EACA,mBAAA;EACA,wBAAA;APuhCF;;AM7hCE;ECIA,gBAAA;EACA,2BAAA;EACA,wBAAA;AP6hCF;;AMniCE;ECIA,cAAA;EACA,sBAAA;EACA,yBAAA;APmiCF;;AQljCA;EACE,kBAAA;EACA,aCIwB;ATijC1B;;AUvjCA;EACE,qBAAA;EACA,uCAAA;EACA,eAAA;AV0jCF;AUxjCE;EAAO,kBAAA;AV2jCT;;AUxjCA;EACE,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;AV2jCF;;AWxkCA;EACE,0CAAA;EACA,6CAAA;EACA,2CAAA;EACA,4CAAA;EACA,sDAAA;AX2kCF;;AWxkCA;EACE,WAAA;EACA,0CAAA;AX2kCF;;AWxkCA;EACE,YAAA;EACA,yCAAA;AX2kCF;;AY1lCA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;AZ6lCF;;AY1lCA;EACE,yBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,wFAAA;AZ6lCF;;AY1lCA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;AZ6lCF;;AY1lCA;EACE,4BAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;AZ6lCF;;AY1lCA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;AZ6lCF;;AY1lCA;EACE,wBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;AZ6lCF;;AY1lCA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;AZ6lCF;;AY1lCA;EACE,iCAAA;AZ6lCF;;AY1lCA;;EAEE,uBAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,+DAAA;AZ6lCF;;AYvlCA;EACE;;;;;;;;;IASE,qBAAA;IACA,uBAAA;IACA,4BAAA;IACA,oBAAA;IACA,uBAAA;EZ0lCF;AACF;AYvlCA;EACE;IAAU,mBAAA;EZ0lCV;EYzlCA;IAAM,4CAAA;EZ4lCN;AACF;AY1lCA;EACE;IAAO,oCAAA;EZ6lCP;EY5lCA;IAAO,wGAAA;EZ+lCP;EY9lCA;IAAO,oIAAA;EZimCP;EYhmCA;IAAO,wGAAA;EZmmCP;EYlmCA;IAAO,qEAAA;EZqmCP;EYpmCA;IAAO,oCAAA;EZumCP;EYtmCA;IAAO,oCAAA;EZymCP;AACF;AYvmCA;EACE;IAAM,oCAAA;EZ0mCN;AACF;AYxmCA;EACE;IACE,yCAAA;IACA,mBAAA;EZ0mCF;EYxmCA;IACE,UAAA;IACA,kDAAA;EZ0mCF;AACF;AYvmCA;EACE;IACE,iHAAA;EZymCF;AACF;AYtmCA;EACE;IAAK,yBAAA;EZymCL;EYxmCA;IAAK,wBAAA;EZ2mCL;EY1mCA;IAAU,yBAAA;EZ6mCV;EY5mCA;IAAW,wBAAA;EZ+mCX;EY9mCA;IAAM,yBAAA;EZinCN;EYhnCA;IAAM,wBAAA;EZmnCN;EYlnCA;IAAM,yBAAA;EZqnCN;EYpnCA;IAAM,wBAAA;EZunCN;EYtnCA;IAAY,uBAAA;EZynCZ;AACF;AYvnCA;EACE;IAAK,uBAAA;EZ0nCL;EYznCA;IAAO,yBAAA;EZ4nCP;AACF;AahxCA;EACE,wBAAA;AbkxCF;;Aa/wCA;EACE,yBAAA;AbkxCF;;Aa/wCA;EACE,yBAAA;AbkxCF;;Aa/wCA;EACE,uBAAA;AbkxCF;;Aa/wCA;EACE,uBAAA;AbkxCF;;Aa/wCA;;EAEE,wBAAA;AbkxCF;;Aa/wCA;EACE,4CAAA;AbkxCF;;Ac5yCA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBLmCwB;EKlCxB,YLmCwB;AT4wC1B;;Ac5yCA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;Ad+yCF;;Ac5yCA;EACE,oBAAA;Ad+yCF;;Ac5yCA;EACE,cAAA;Ad+yCF;;Ac5yCA;EACE,8BAAA;Ad+yCF;;Ae10CA;gEAAA;AAIE;EAAsC,eAAA;Af40CxC;;Ae50CE;EAAsC,eAAA;Afg1CxC;;Aeh1CE;EAAsC,eAAA;Afo1CxC;;Aep1CE;EAAsC,eAAA;Afw1CxC;;Aex1CE;EAAsC,eAAA;Af41CxC;;Ae51CE;EAAsC,eAAA;Afg2CxC;;Aeh2CE;EAAsC,eAAA;Afo2CxC;;Aep2CE;EAAsC,eAAA;Afw2CxC;;Aex2CE;EAAsC,eAAA;Af42CxC;;Ae52CE;EAAsC,eAAA;Afg3CxC;;Aeh3CE;EAAsC,gBAAA;Afo3CxC;;Aep3CE;EAAsC,gBAAA;Afw3CxC;;Aex3CE;EAAsC,gBAAA;Af43CxC;;Ae53CE;EAAsC,gBAAA;Afg4CxC;;Aeh4CE;EAAsC,aAAA;Afo4CxC;;Aep4CE;EAAsC,gBAAA;Afw4CxC;;Aex4CE;EAAsC,gBAAA;Af44CxC;;Ae54CE;EAAsC,gBAAA;Afg5CxC;;Aeh5CE;EAAsC,gBAAA;Afo5CxC;;Aep5CE;EAAsC,gBAAA;Afw5CxC;;Aex5CE;EAAsC,gBAAA;Af45CxC;;Ae55CE;EAAsC,gBAAA;Afg6CxC;;Aeh6CE;EAAsC,gBAAA;Afo6CxC;;Aep6CE;EAAsC,gBAAA;Afw6CxC;;Aex6CE;EAAsC,gBAAA;Af46CxC;;Ae56CE;EAAsC,gBAAA;Afg7CxC;;Aeh7CE;EAAsC,gBAAA;Afo7CxC;;Aep7CE;EAAsC,gBAAA;Afw7CxC;;Aex7CE;EAAsC,gBAAA;Af47CxC;;Ae57CE;EAAsC,gBAAA;Afg8CxC;;Aeh8CE;EAAsC,gBAAA;Afo8CxC;;Aep8CE;EAAsC,gBAAA;Afw8CxC;;Aex8CE;EAAsC,gBAAA;Af48CxC;;Ae58CE;EAAsC,gBAAA;Afg9CxC;;Aeh9CE;EAAsC,gBAAA;Afo9CxC;;Aep9CE;EAAsC,gBAAA;Afw9CxC;;Aex9CE;EAAsC,gBAAA;Af49CxC;;Ae59CE;EAAsC,gBAAA;Afg+CxC;;Aeh+CE;EAAsC,gBAAA;Afo+CxC;;Aep+CE;EAAsC,gBAAA;Afw+CxC;;Aex+CE;EAAsC,gBAAA;Af4+CxC;;Ae5+CE;EAAsC,gBAAA;Afg/CxC;;Aeh/CE;EAAsC,gBAAA;Afo/CxC;;Aep/CE;EAAsC,gBAAA;Afw/CxC;;Aex/CE;EAAsC,gBAAA;Af4/CxC;;Ae5/CE;EAAsC,gBAAA;AfggDxC;;AehgDE;EAAsC,gBAAA;AfogDxC;;AepgDE;EAAsC,gBAAA;AfwgDxC;;AexgDE;EAAsC,gBAAA;Af4gDxC;;Ae5gDE;EAAsC,gBAAA;AfghDxC;;AehhDE;EAAsC,gBAAA;AfohDxC;;AephDE;EAAsC,gBAAA;AfwhDxC;;AexhDE;EAAsC,gBAAA;Af4hDxC;;Ae5hDE;EAAsC,gBAAA;AfgiDxC;;AehiDE;EAAsC,gBAAA;AfoiDxC;;AepiDE;EAAsC,gBAAA;AfwiDxC;;AexiDE;EAAsC,gBAAA;Af4iDxC;;Ae5iDE;EAAsC,gBAAA;AfgjDxC;;AehjDE;EAAsC,gBAAA;AfojDxC;;AepjDE;EAAsC,gBAAA;AfwjDxC;;AexjDE;EAAsC,gBAAA;Af4jDxC;;Ae5jDE;EAAsC,gBAAA;AfgkDxC;;AehkDE;EAAsC,gBAAA;AfokDxC;;AepkDE;EAAsC,gBAAA;AfwkDxC;;AexkDE;EAAsC,gBAAA;Af4kDxC;;Ae5kDE;EAAsC,gBAAA;AfglDxC;;AehlDE;EAAsC,gBAAA;AfolDxC;;AeplDE;EAAsC,gBAAA;AfwlDxC;;AexlDE;EAAsC,gBAAA;Af4lDxC;;Ae5lDE;EAAsC,gBAAA;AfgmDxC;;AehmDE;EAAsC,gBAAA;AfomDxC;;AepmDE;EAAsC,gBAAA;AfwmDxC;;AexmDE;EAAsC,gBAAA;Af4mDxC;;Ae5mDE;EAAsC,gBAAA;AfgnDxC;;AehnDE;EAAsC,gBAAA;AfonDxC;;AepnDE;EAAsC,gBAAA;AfwnDxC;;AexnDE;EAAsC,gBAAA;Af4nDxC;;Ae5nDE;EAAsC,gBAAA;AfgoDxC;;AehoDE;EAAsC,gBAAA;AfooDxC;;AepoDE;EAAsC,gBAAA;AfwoDxC;;AexoDE;EAAsC,gBAAA;Af4oDxC;;Ae5oDE;EAAsC,gBAAA;AfgpDxC;;AehpDE;EAAsC,gBAAA;AfopDxC;;AeppDE;EAAsC,gBAAA;AfwpDxC;;AexpDE;EAAsC,gBAAA;Af4pDxC;;Ae5pDE;EAAsC,gBAAA;AfgqDxC;;AehqDE;EAAsC,gBAAA;AfoqDxC;;AepqDE;EAAsC,gBAAA;AfwqDxC;;AexqDE;EAAsC,gBAAA;Af4qDxC;;Ae5qDE;EAAsC,gBAAA;AfgrDxC;;AehrDE;EAAsC,gBAAA;AforDxC;;AeprDE;EAAsC,gBAAA;AfwrDxC;;AexrDE;EAAsC,gBAAA;Af4rDxC;;Ae5rDE;EAAsC,gBAAA;AfgsDxC;;AehsDE;EAAsC,gBAAA;AfosDxC;;AepsDE;EAAsC,gBAAA;AfwsDxC;;AexsDE;EAAsC,gBAAA;Af4sDxC;;Ae5sDE;EAAsC,gBAAA;AfgtDxC;;AehtDE;EAAsC,gBAAA;AfotDxC;;AeptDE;EAAsC,gBAAA;AfwtDxC;;AextDE;EAAsC,gBAAA;Af4tDxC;;Ae5tDE;EAAsC,gBAAA;AfguDxC;;AehuDE;EAAsC,gBAAA;AfouDxC;;AepuDE;EAAsC,gBAAA;AfwuDxC;;AexuDE;EAAsC,gBAAA;Af4uDxC;;Ae5uDE;EAAsC,gBAAA;AfgvDxC;;AehvDE;EAAsC,YAAA;AfovDxC;;AepvDE;EAAsC,gBAAA;AfwvDxC;;AexvDE;EAAsC,gBAAA;Af4vDxC;;Ae5vDE;EAAsC,gBAAA;AfgwDxC;;AehwDE;EAAsC,gBAAA;AfowDxC;;AepwDE;EAAsC,gBAAA;AfwwDxC;;AexwDE;EAAsC,gBAAA;Af4wDxC;;Ae5wDE;EAAsC,gBAAA;AfgxDxC;;AehxDE;EAAsC,gBAAA;AfoxDxC;;AepxDE;EAAsC,gBAAA;AfwxDxC;;AexxDE;EAAsC,gBAAA;Af4xDxC;;Ae5xDE;EAAsC,gBAAA;AfgyDxC;;AehyDE;EAAsC,gBAAA;AfoyDxC;;AepyDE;EAAsC,gBAAA;AfwyDxC;;AexyDE;EAAsC,gBAAA;Af4yDxC;;Ae5yDE;EAAsC,gBAAA;AfgzDxC;;AehzDE;EAAsC,gBAAA;AfozDxC;;AepzDE;EAAsC,gBAAA;AfwzDxC;;AexzDE;EAAsC,gBAAA;Af4zDxC;;Ae5zDE;EAAsC,gBAAA;Afg0DxC;;Aeh0DE;EAAsC,gBAAA;Afo0DxC;;Aep0DE;EAAsC,gBAAA;Afw0DxC;;Aex0DE;EAAsC,gBAAA;Af40DxC;;Ae50DE;EAAsC,gBAAA;Afg1DxC;;Aeh1DE;EAAsC,gBAAA;Afo1DxC;;Aep1DE;EAAsC,gBAAA;Afw1DxC;;Aex1DE;EAAsC,gBAAA;Af41DxC;;Ae51DE;EAAsC,gBAAA;Afg2DxC;;Aeh2DE;EAAsC,gBAAA;Afo2DxC;;Aep2DE;EAAsC,gBAAA;Afw2DxC;;Aex2DE;EAAsC,gBAAA;Af42DxC;;Ae52DE;EAAsC,gBAAA;Afg3DxC;;Aeh3DE;EAAsC,gBAAA;Afo3DxC;;Aep3DE;EAAsC,gBAAA;Afw3DxC;;Aex3DE;EAAsC,gBAAA;Af43DxC;;Ae53DE;EAAsC,YAAA;Afg4DxC;;Aeh4DE;EAAsC,gBAAA;Afo4DxC;;Aep4DE;EAAsC,gBAAA;Afw4DxC;;Aex4DE;EAAsC,gBAAA;Af44DxC;;Ae54DE;EAAsC,gBAAA;Afg5DxC;;Aeh5DE;EAAsC,gBAAA;Afo5DxC;;Aep5DE;EAAsC,gBAAA;Afw5DxC;;Aex5DE;EAAsC,gBAAA;Af45DxC;;Ae55DE;EAAsC,gBAAA;Afg6DxC;;Aeh6DE;EAAsC,gBAAA;Afo6DxC;;Aep6DE;EAAsC,gBAAA;Afw6DxC;;Aex6DE;EAAsC,gBAAA;Af46DxC;;Ae56DE;EAAsC,gBAAA;Afg7DxC;;Aeh7DE;EAAsC,gBAAA;Afo7DxC;;Aep7DE;EAAsC,gBAAA;Afw7DxC;;Aex7DE;EAAsC,gBAAA;Af47DxC;;Ae57DE;EAAsC,gBAAA;Afg8DxC;;Aeh8DE;EAAsC,gBAAA;Afo8DxC;;Aep8DE;EAAsC,gBAAA;Afw8DxC;;Aex8DE;EAAsC,gBAAA;Af48DxC;;Ae58DE;EAAsC,gBAAA;Afg9DxC;;Aeh9DE;EAAsC,gBAAA;Afo9DxC;;Aep9DE;EAAsC,gBAAA;Afw9DxC;;Aex9DE;EAAsC,gBAAA;Af49DxC;;Ae59DE;EAAsC,gBAAA;Afg+DxC;;Aeh+DE;EAAsC,gBAAA;Afo+DxC;;Aep+DE;EAAsC,gBAAA;Afw+DxC;;Aex+DE;EAAsC,gBAAA;Af4+DxC;;Ae5+DE;EAAsC,gBAAA;Afg/DxC;;Aeh/DE;EAAsC,gBAAA;Afo/DxC;;Aep/DE;EAAsC,gBAAA;Afw/DxC;;Aex/DE;EAAsC,gBAAA;Af4/DxC;;Ae5/DE;EAAsC,gBAAA;AfggExC;;AehgEE;EAAsC,gBAAA;AfogExC;;AepgEE;EAAsC,gBAAA;AfwgExC;;AexgEE;EAAsC,gBAAA;Af4gExC;;Ae5gEE;EAAsC,gBAAA;AfghExC;;AehhEE;EAAsC,gBAAA;AfohExC;;AephEE;EAAsC,gBAAA;AfwhExC;;AexhEE;EAAsC,gBAAA;Af4hExC;;Ae5hEE;EAAsC,gBAAA;AfgiExC;;AehiEE;EAAsC,gBAAA;AfoiExC;;AepiEE;EAAsC,gBAAA;AfwiExC;;AexiEE;EAAsC,gBAAA;Af4iExC;;Ae5iEE;EAAsC,gBAAA;AfgjExC;;AehjEE;EAAsC,gBAAA;AfojExC;;AepjEE;EAAsC,gBAAA;AfwjExC;;AexjEE;EAAsC,gBAAA;Af4jExC;;Ae5jEE;EAAsC,gBAAA;AfgkExC;;AehkEE;EAAsC,gBAAA;AfokExC;;AepkEE;EAAsC,gBAAA;AfwkExC;;AexkEE;EAAsC,gBAAA;Af4kExC;;Ae5kEE;EAAsC,gBAAA;AfglExC;;AehlEE;EAAsC,gBAAA;AfolExC;;AeplEE;EAAsC,gBAAA;AfwlExC;;AexlEE;EAAsC,gBAAA;Af4lExC;;Ae5lEE;EAAsC,gBAAA;AfgmExC;;AehmEE;EAAsC,gBAAA;AfomExC;;AepmEE;EAAsC,gBAAA;AfwmExC;;AexmEE;EAAsC,gBAAA;Af4mExC;;Ae5mEE;EAAsC,gBAAA;AfgnExC;;AehnEE;EAAsC,gBAAA;AfonExC;;AepnEE;EAAsC,gBAAA;AfwnExC;;AexnEE;EAAsC,gBAAA;Af4nExC;;Ae5nEE;EAAsC,gBAAA;AfgoExC;;AehoEE;EAAsC,gBAAA;AfooExC;;AepoEE;EAAsC,gBAAA;AfwoExC;;AexoEE;EAAsC,gBAAA;Af4oExC;;Ae5oEE;EAAsC,gBAAA;AfgpExC;;AehpEE;EAAsC,gBAAA;AfopExC;;AeppEE;EAAsC,gBAAA;AfwpExC;;AexpEE;EAAsC,gBAAA;Af4pExC;;Ae5pEE;EAAsC,gBAAA;AfgqExC;;AehqEE;EAAsC,gBAAA;AfoqExC;;AepqEE;EAAsC,gBAAA;AfwqExC;;AexqEE;EAAsC,gBAAA;Af4qExC;;Ae5qEE;EAAsC,gBAAA;AfgrExC;;AehrEE;EAAsC,gBAAA;AforExC;;AeprEE;EAAsC,gBAAA;AfwrExC;;AexrEE;EAAsC,gBAAA;Af4rExC;;Ae5rEE;EAAsC,gBAAA;AfgsExC;;AehsEE;EAAsC,gBAAA;AfosExC;;AepsEE;EAAsC,gBAAA;AfwsExC;;AexsEE;EAAsC,gBAAA;Af4sExC;;Ae5sEE;EAAsC,gBAAA;AfgtExC;;AehtEE;EAAsC,gBAAA;AfotExC;;AeptEE;EAAsC,gBAAA;AfwtExC;;AextEE;EAAsC,gBAAA;Af4tExC;;Ae5tEE;EAAsC,gBAAA;AfguExC;;AehuEE;EAAsC,gBAAA;AfouExC;;AepuEE;EAAsC,gBAAA;AfwuExC;;AexuEE;EAAsC,gBAAA;Af4uExC;;Ae5uEE;EAAsC,gBAAA;AfgvExC;;AehvEE;EAAsC,gBAAA;AfovExC;;AepvEE;EAAsC,gBAAA;AfwvExC;;AexvEE;EAAsC,gBAAA;Af4vExC;;Ae5vEE;EAAsC,gBAAA;AfgwExC;;AehwEE;EAAsC,gBAAA;AfowExC;;AepwEE;EAAsC,gBAAA;AfwwExC;;AexwEE;EAAsC,gBAAA;Af4wExC;;Ae5wEE;EAAsC,aAAA;AfgxExC;;AehxEE;EAAsC,gBAAA;AfoxExC;;AepxEE;EAAsC,gBAAA;AfwxExC;;AexxEE;EAAsC,gBAAA;Af4xExC;;Ae5xEE;EAAsC,gBAAA;AfgyExC;;AehyEE;EAAsC,gBAAA;AfoyExC;;AepyEE;EAAsC,gBAAA;AfwyExC;;AexyEE;EAAsC,gBAAA;Af4yExC;;Ae5yEE;EAAsC,gBAAA;AfgzExC;;AehzEE;EAAsC,gBAAA;AfozExC;;AepzEE;EAAsC,gBAAA;AfwzExC;;AexzEE;EAAsC,gBAAA;Af4zExC;;Ae5zEE;EAAsC,gBAAA;Afg0ExC;;Aeh0EE;EAAsC,gBAAA;Afo0ExC;;Aep0EE;EAAsC,gBAAA;Afw0ExC;;Aex0EE;EAAsC,gBAAA;Af40ExC;;Ae50EE;EAAsC,gBAAA;Afg1ExC;;Aeh1EE;EAAsC,gBAAA;Afo1ExC;;Aep1EE;EAAsC,gBAAA;Afw1ExC;;Aex1EE;EAAsC,gBAAA;Af41ExC;;Ae51EE;EAAsC,gBAAA;Afg2ExC;;Aeh2EE;EAAsC,gBAAA;Afo2ExC;;Aep2EE;EAAsC,gBAAA;Afw2ExC;;Aex2EE;EAAsC,gBAAA;Af42ExC;;Ae52EE;EAAsC,gBAAA;Afg3ExC;;Aeh3EE;EAAsC,gBAAA;Afo3ExC;;Aep3EE;EAAsC,gBAAA;Afw3ExC;;Aex3EE;EAAsC,gBAAA;Af43ExC;;Ae53EE;EAAsC,gBAAA;Afg4ExC;;Aeh4EE;EAAsC,gBAAA;Afo4ExC;;Aep4EE;EAAsC,gBAAA;Afw4ExC;;Aex4EE;EAAsC,gBAAA;Af44ExC;;Ae54EE;EAAsC,gBAAA;Afg5ExC;;Aeh5EE;EAAsC,gBAAA;Afo5ExC;;Aep5EE;EAAsC,gBAAA;Afw5ExC;;Aex5EE;EAAsC,gBAAA;Af45ExC;;Ae55EE;EAAsC,gBAAA;Afg6ExC;;Aeh6EE;EAAsC,gBAAA;Afo6ExC;;Aep6EE;EAAsC,gBAAA;Afw6ExC;;Aex6EE;EAAsC,gBAAA;Af46ExC;;Ae56EE;EAAsC,gBAAA;Afg7ExC;;Aeh7EE;EAAsC,gBAAA;Afo7ExC;;Aep7EE;EAAsC,gBAAA;Afw7ExC;;Aex7EE;EAAsC,gBAAA;Af47ExC;;Ae57EE;EAAsC,gBAAA;Afg8ExC;;Aeh8EE;EAAsC,gBAAA;Afo8ExC;;Aep8EE;EAAsC,gBAAA;Afw8ExC;;Aex8EE;EAAsC,gBAAA;Af48ExC;;Ae58EE;EAAsC,gBAAA;Afg9ExC;;Aeh9EE;EAAsC,gBAAA;Afo9ExC;;Aep9EE;EAAsC,gBAAA;Afw9ExC;;Aex9EE;EAAsC,gBAAA;Af49ExC;;Ae59EE;EAAsC,gBAAA;Afg+ExC;;Aeh+EE;EAAsC,gBAAA;Afo+ExC;;Aep+EE;EAAsC,gBAAA;Afw+ExC;;Aex+EE;EAAsC,gBAAA;Af4+ExC;;Ae5+EE;EAAsC,gBAAA;Afg/ExC;;Aeh/EE;EAAsC,gBAAA;Afo/ExC;;Aep/EE;EAAsC,gBAAA;Afw/ExC;;Aex/EE;EAAsC,gBAAA;Af4/ExC;;Ae5/EE;EAAsC,gBAAA;AfggFxC;;AehgFE;EAAsC,gBAAA;AfogFxC;;AepgFE;EAAsC,gBAAA;AfwgFxC;;AexgFE;EAAsC,gBAAA;Af4gFxC;;Ae5gFE;EAAsC,gBAAA;AfghFxC;;AehhFE;EAAsC,gBAAA;AfohFxC;;AephFE;EAAsC,gBAAA;AfwhFxC;;AexhFE;EAAsC,gBAAA;Af4hFxC;;Ae5hFE;EAAsC,gBAAA;AfgiFxC;;AehiFE;EAAsC,gBAAA;AfoiFxC;;AepiFE;EAAsC,gBAAA;AfwiFxC;;AexiFE;EAAsC,gBAAA;Af4iFxC;;Ae5iFE;EAAsC,gBAAA;AfgjFxC;;AehjFE;EAAsC,gBAAA;AfojFxC;;AepjFE;EAAsC,gBAAA;AfwjFxC;;AexjFE;EAAsC,gBAAA;Af4jFxC;;Ae5jFE;EAAsC,gBAAA;AfgkFxC;;AehkFE;EAAsC,gBAAA;AfokFxC;;AepkFE;EAAsC,gBAAA;AfwkFxC;;AexkFE;EAAsC,gBAAA;Af4kFxC;;Ae5kFE;EAAsC,gBAAA;AfglFxC;;AehlFE;EAAsC,gBAAA;AfolFxC;;AeplFE;EAAsC,gBAAA;AfwlFxC;;AexlFE;EAAsC,gBAAA;Af4lFxC;;Ae5lFE;EAAsC,gBAAA;AfgmFxC;;AehmFE;EAAsC,YAAA;AfomFxC;;AepmFE;EAAsC,gBAAA;AfwmFxC;;AexmFE;EAAsC,gBAAA;Af4mFxC;;Ae5mFE;EAAsC,gBAAA;AfgnFxC;;AehnFE;EAAsC,gBAAA;AfonFxC;;AepnFE;EAAsC,gBAAA;AfwnFxC;;AexnFE;EAAsC,gBAAA;Af4nFxC;;Ae5nFE;EAAsC,YAAA;AfgoFxC;;AehoFE;EAAsC,gBAAA;AfooFxC;;AepoFE;EAAsC,gBAAA;AfwoFxC;;AexoFE;EAAsC,gBAAA;Af4oFxC;;Ae5oFE;EAAsC,gBAAA;AfgpFxC;;AehpFE;EAAsC,gBAAA;AfopFxC;;AeppFE;EAAsC,gBAAA;AfwpFxC;;AexpFE;EAAsC,gBAAA;Af4pFxC;;Ae5pFE;EAAsC,gBAAA;AfgqFxC;;AehqFE;EAAsC,gBAAA;AfoqFxC;;AepqFE;EAAsC,gBAAA;AfwqFxC;;AexqFE;EAAsC,gBAAA;Af4qFxC;;Ae5qFE;EAAsC,gBAAA;AfgrFxC;;AehrFE;EAAsC,gBAAA;AforFxC;;AeprFE;EAAsC,gBAAA;AfwrFxC;;AexrFE;EAAsC,gBAAA;Af4rFxC;;Ae5rFE;EAAsC,gBAAA;AfgsFxC;;AehsFE;EAAsC,gBAAA;AfosFxC;;AepsFE;EAAsC,gBAAA;AfwsFxC;;AexsFE;EAAsC,YAAA;Af4sFxC;;Ae5sFE;EAAsC,YAAA;AfgtFxC;;AehtFE;EAAsC,gBAAA;AfotFxC;;AeptFE;EAAsC,gBAAA;AfwtFxC;;AextFE;EAAsC,gBAAA;Af4tFxC;;Ae5tFE;EAAsC,gBAAA;AfguFxC;;AehuFE;EAAsC,gBAAA;AfouFxC;;AepuFE;EAAsC,gBAAA;AfwuFxC;;AexuFE;EAAsC,gBAAA;Af4uFxC;;Ae5uFE;EAAsC,gBAAA;AfgvFxC;;AehvFE;EAAsC,gBAAA;AfovFxC;;AepvFE;EAAsC,gBAAA;AfwvFxC;;AexvFE;EAAsC,gBAAA;Af4vFxC;;Ae5vFE;EAAsC,gBAAA;AfgwFxC;;AehwFE;EAAsC,gBAAA;AfowFxC;;AepwFE;EAAsC,gBAAA;AfwwFxC;;AexwFE;EAAsC,gBAAA;Af4wFxC;;Ae5wFE;EAAsC,gBAAA;AfgxFxC;;AehxFE;EAAsC,gBAAA;AfoxFxC;;AepxFE;EAAsC,gBAAA;AfwxFxC;;AexxFE;EAAsC,gBAAA;Af4xFxC;;Ae5xFE;EAAsC,gBAAA;AfgyFxC;;AehyFE;EAAsC,gBAAA;AfoyFxC;;AepyFE;EAAsC,gBAAA;AfwyFxC;;AexyFE;EAAsC,gBAAA;Af4yFxC;;Ae5yFE;EAAsC,gBAAA;AfgzFxC;;AehzFE;EAAsC,gBAAA;AfozFxC;;AepzFE;EAAsC,gBAAA;AfwzFxC;;AexzFE;EAAsC,gBAAA;Af4zFxC;;Ae5zFE;EAAsC,gBAAA;Afg0FxC;;Aeh0FE;EAAsC,gBAAA;Afo0FxC;;Aep0FE;EAAsC,gBAAA;Afw0FxC;;Aex0FE;EAAsC,gBAAA;Af40FxC;;Ae50FE;EAAsC,gBAAA;Afg1FxC;;Aeh1FE;EAAsC,gBAAA;Afo1FxC;;Aep1FE;EAAsC,gBAAA;Afw1FxC;;Aex1FE;EAAsC,gBAAA;Af41FxC;;Ae51FE;EAAsC,YAAA;Afg2FxC;;Aeh2FE;EAAsC,gBAAA;Afo2FxC;;Aep2FE;EAAsC,gBAAA;Afw2FxC;;Aex2FE;EAAsC,gBAAA;Af42FxC;;Ae52FE;EAAsC,gBAAA;Afg3FxC;;Aeh3FE;EAAsC,gBAAA;Afo3FxC;;Aep3FE;EAAsC,gBAAA;Afw3FxC;;Aex3FE;EAAsC,gBAAA;Af43FxC;;Ae53FE;EAAsC,gBAAA;Afg4FxC;;Aeh4FE;EAAsC,gBAAA;Afo4FxC;;Aep4FE;EAAsC,gBAAA;Afw4FxC;;Aex4FE;EAAsC,gBAAA;Af44FxC;;Ae54FE;EAAsC,gBAAA;Afg5FxC;;Aeh5FE;EAAsC,gBAAA;Afo5FxC;;Aep5FE;EAAsC,gBAAA;Afw5FxC;;Aex5FE;EAAsC,gBAAA;Af45FxC;;Ae55FE;EAAsC,gBAAA;Afg6FxC;;Aeh6FE;EAAsC,gBAAA;Afo6FxC;;Aep6FE;EAAsC,gBAAA;Afw6FxC;;Aex6FE;EAAsC,gBAAA;Af46FxC;;Ae56FE;EAAsC,YAAA;Afg7FxC;;Aeh7FE;EAAsC,gBAAA;Afo7FxC;;Aep7FE;EAAsC,gBAAA;Afw7FxC;;Aex7FE;EAAsC,gBAAA;Af47FxC;;Ae57FE;EAAsC,gBAAA;Afg8FxC;;Aeh8FE;EAAsC,gBAAA;Afo8FxC;;Aep8FE;EAAsC,gBAAA;Afw8FxC;;Aex8FE;EAAsC,gBAAA;Af48FxC;;Ae58FE;EAAsC,gBAAA;Afg9FxC;;Aeh9FE;EAAsC,gBAAA;Afo9FxC;;Aep9FE;EAAsC,gBAAA;Afw9FxC;;Aex9FE;EAAsC,gBAAA;Af49FxC;;Ae59FE;EAAsC,gBAAA;Afg+FxC;;Aeh+FE;EAAsC,gBAAA;Afo+FxC;;Aep+FE;EAAsC,gBAAA;Afw+FxC;;Aex+FE;EAAsC,gBAAA;Af4+FxC;;Ae5+FE;EAAsC,gBAAA;Afg/FxC;;Aeh/FE;EAAsC,gBAAA;Afo/FxC;;Aep/FE;EAAsC,gBAAA;Afw/FxC;;Aex/FE;EAAsC,gBAAA;Af4/FxC;;Ae5/FE;EAAsC,gBAAA;AfggGxC;;AehgGE;EAAsC,gBAAA;AfogGxC;;AepgGE;EAAsC,gBAAA;AfwgGxC;;AexgGE;EAAsC,gBAAA;Af4gGxC;;Ae5gGE;EAAsC,gBAAA;AfghGxC;;AehhGE;EAAsC,gBAAA;AfohGxC;;AephGE;EAAsC,gBAAA;AfwhGxC;;AexhGE;EAAsC,gBAAA;Af4hGxC;;Ae5hGE;EAAsC,gBAAA;AfgiGxC;;AehiGE;EAAsC,gBAAA;AfoiGxC;;AepiGE;EAAsC,gBAAA;AfwiGxC;;AexiGE;EAAsC,gBAAA;Af4iGxC;;Ae5iGE;EAAsC,gBAAA;AfgjGxC;;AehjGE;EAAsC,gBAAA;AfojGxC;;AepjGE;EAAsC,gBAAA;AfwjGxC;;AexjGE;EAAsC,gBAAA;Af4jGxC;;Ae5jGE;EAAsC,gBAAA;AfgkGxC;;AehkGE;EAAsC,gBAAA;AfokGxC;;AepkGE;EAAsC,gBAAA;AfwkGxC;;AexkGE;EAAsC,gBAAA;Af4kGxC;;Ae5kGE;EAAsC,gBAAA;AfglGxC;;AehlGE;EAAsC,gBAAA;AfolGxC;;AeplGE;EAAsC,gBAAA;AfwlGxC;;AexlGE;EAAsC,gBAAA;Af4lGxC;;Ae5lGE;EAAsC,gBAAA;AfgmGxC;;AehmGE;EAAsC,gBAAA;AfomGxC;;AepmGE;EAAsC,gBAAA;AfwmGxC;;AexmGE;EAAsC,gBAAA;Af4mGxC;;Ae5mGE;EAAsC,gBAAA;AfgnGxC;;AehnGE;EAAsC,gBAAA;AfonGxC;;AepnGE;EAAsC,gBAAA;AfwnGxC;;AexnGE;EAAsC,gBAAA;Af4nGxC;;Ae5nGE;EAAsC,gBAAA;AfgoGxC;;AehoGE;EAAsC,gBAAA;AfooGxC;;AepoGE;EAAsC,gBAAA;AfwoGxC;;AexoGE;EAAsC,gBAAA;Af4oGxC;;Ae5oGE;EAAsC,gBAAA;AfgpGxC;;AehpGE;EAAsC,gBAAA;AfopGxC;;AeppGE;EAAsC,gBAAA;AfwpGxC;;AexpGE;EAAsC,gBAAA;Af4pGxC;;Ae5pGE;EAAsC,gBAAA;AfgqGxC;;AehqGE;EAAsC,gBAAA;AfoqGxC;;AepqGE;EAAsC,gBAAA;AfwqGxC;;AexqGE;EAAsC,gBAAA;Af4qGxC;;Ae5qGE;EAAsC,gBAAA;AfgrGxC;;AehrGE;EAAsC,gBAAA;AforGxC;;AeprGE;EAAsC,gBAAA;AfwrGxC;;AexrGE;EAAsC,gBAAA;Af4rGxC;;Ae5rGE;EAAsC,gBAAA;AfgsGxC;;AehsGE;EAAsC,gBAAA;AfosGxC;;AepsGE;EAAsC,gBAAA;AfwsGxC;;AexsGE;EAAsC,gBAAA;Af4sGxC;;Ae5sGE;EAAsC,gBAAA;AfgtGxC;;AehtGE;EAAsC,gBAAA;AfotGxC;;AeptGE;EAAsC,gBAAA;AfwtGxC;;AextGE;EAAsC,gBAAA;Af4tGxC;;Ae5tGE;EAAsC,gBAAA;AfguGxC;;AehuGE;EAAsC,gBAAA;AfouGxC;;AepuGE;EAAsC,gBAAA;AfwuGxC;;AexuGE;EAAsC,gBAAA;Af4uGxC;;Ae5uGE;EAAsC,gBAAA;AfgvGxC;;AehvGE;EAAsC,gBAAA;AfovGxC;;AepvGE;EAAsC,YAAA;AfwvGxC;;AexvGE;EAAsC,gBAAA;Af4vGxC;;Ae5vGE;EAAsC,gBAAA;AfgwGxC;;AehwGE;EAAsC,gBAAA;AfowGxC;;AepwGE;EAAsC,gBAAA;AfwwGxC;;AexwGE;EAAsC,gBAAA;Af4wGxC;;Ae5wGE;EAAsC,gBAAA;AfgxGxC;;AehxGE;EAAsC,gBAAA;AfoxGxC;;AepxGE;EAAsC,gBAAA;AfwxGxC;;AexxGE;EAAsC,gBAAA;Af4xGxC;;Ae5xGE;EAAsC,gBAAA;AfgyGxC;;AehyGE;EAAsC,gBAAA;AfoyGxC;;AepyGE;EAAsC,gBAAA;AfwyGxC;;AexyGE;EAAsC,gBAAA;Af4yGxC;;Ae5yGE;EAAsC,gBAAA;AfgzGxC;;AehzGE;EAAsC,gBAAA;AfozGxC;;AepzGE;EAAsC,gBAAA;AfwzGxC;;AexzGE;EAAsC,gBAAA;Af4zGxC;;Ae5zGE;EAAsC,gBAAA;Afg0GxC;;Aeh0GE;EAAsC,gBAAA;Afo0GxC;;Aep0GE;EAAsC,gBAAA;Afw0GxC;;Aex0GE;EAAsC,gBAAA;Af40GxC;;Ae50GE;EAAsC,gBAAA;Afg1GxC;;Aeh1GE;EAAsC,gBAAA;Afo1GxC;;Aep1GE;EAAsC,gBAAA;Afw1GxC;;Aex1GE;EAAsC,gBAAA;Af41GxC;;Ae51GE;EAAsC,gBAAA;Afg2GxC;;Aeh2GE;EAAsC,gBAAA;Afo2GxC;;Aep2GE;EAAsC,gBAAA;Afw2GxC;;Aex2GE;EAAsC,gBAAA;Af42GxC;;Ae52GE;EAAsC,gBAAA;Afg3GxC;;Aeh3GE;EAAsC,gBAAA;Afo3GxC;;Aep3GE;EAAsC,gBAAA;Afw3GxC;;Aex3GE;EAAsC,gBAAA;Af43GxC;;Ae53GE;EAAsC,gBAAA;Afg4GxC;;Aeh4GE;EAAsC,gBAAA;Afo4GxC;;Aep4GE;EAAsC,gBAAA;Afw4GxC;;Aex4GE;EAAsC,gBAAA;Af44GxC;;Ae54GE;EAAsC,gBAAA;Afg5GxC;;Aeh5GE;EAAsC,gBAAA;Afo5GxC;;Aep5GE;EAAsC,gBAAA;Afw5GxC;;Aex5GE;EAAsC,gBAAA;Af45GxC;;Ae55GE;EAAsC,gBAAA;Afg6GxC;;Aeh6GE;EAAsC,gBAAA;Afo6GxC;;Aep6GE;EAAsC,gBAAA;Afw6GxC;;Aex6GE;EAAsC,gBAAA;Af46GxC;;Ae56GE;EAAsC,gBAAA;Afg7GxC;;Aeh7GE;EAAsC,gBAAA;Afo7GxC;;Aep7GE;EAAsC,gBAAA;Afw7GxC;;Aex7GE;EAAsC,gBAAA;Af47GxC;;Ae57GE;EAAsC,gBAAA;Afg8GxC;;Aeh8GE;EAAsC,gBAAA;Afo8GxC;;Aep8GE;EAAsC,gBAAA;Afw8GxC;;Aex8GE;EAAsC,gBAAA;Af48GxC;;Ae58GE;EAAsC,gBAAA;Afg9GxC;;Aeh9GE;EAAsC,gBAAA;Afo9GxC;;Aep9GE;EAAsC,gBAAA;Afw9GxC;;Aex9GE;EAAsC,gBAAA;Af49GxC;;Ae59GE;EAAsC,gBAAA;Afg+GxC;;Aeh+GE;EAAsC,gBAAA;Afo+GxC;;Aep+GE;EAAsC,gBAAA;Afw+GxC;;Aex+GE;EAAsC,gBAAA;Af4+GxC;;Ae5+GE;EAAsC,gBAAA;Afg/GxC;;Aeh/GE;EAAsC,gBAAA;Afo/GxC;;Aep/GE;EAAsC,gBAAA;Afw/GxC;;Aex/GE;EAAsC,gBAAA;Af4/GxC;;Ae5/GE;EAAsC,gBAAA;AfggHxC;;AehgHE;EAAsC,gBAAA;AfogHxC;;AepgHE;EAAsC,gBAAA;AfwgHxC;;AexgHE;EAAsC,gBAAA;Af4gHxC;;Ae5gHE;EAAsC,gBAAA;AfghHxC;;AehhHE;EAAsC,gBAAA;AfohHxC;;AephHE;EAAsC,gBAAA;AfwhHxC;;AexhHE;EAAsC,gBAAA;Af4hHxC;;Ae5hHE;EAAsC,gBAAA;AfgiHxC;;AehiHE;EAAsC,gBAAA;AfoiHxC;;AepiHE;EAAsC,gBAAA;AfwiHxC;;AexiHE;EAAsC,gBAAA;Af4iHxC;;Ae5iHE;EAAsC,gBAAA;AfgjHxC;;AehjHE;EAAsC,gBAAA;AfojHxC;;AepjHE;EAAsC,gBAAA;AfwjHxC;;AexjHE;EAAsC,gBAAA;Af4jHxC;;Ae5jHE;EAAsC,gBAAA;AfgkHxC;;AehkHE;EAAsC,gBAAA;AfokHxC;;AepkHE;EAAsC,gBAAA;AfwkHxC;;AexkHE;EAAsC,gBAAA;Af4kHxC;;Ae5kHE;EAAsC,gBAAA;AfglHxC;;AehlHE;EAAsC,gBAAA;AfolHxC;;AeplHE;EAAsC,gBAAA;AfwlHxC;;AexlHE;EAAsC,gBAAA;Af4lHxC;;Ae5lHE;EAAsC,gBAAA;AfgmHxC;;AehmHE;EAAsC,gBAAA;AfomHxC;;AepmHE;EAAsC,gBAAA;AfwmHxC;;AexmHE;EAAsC,gBAAA;Af4mHxC;;Ae5mHE;EAAsC,gBAAA;AfgnHxC;;AehnHE;EAAsC,gBAAA;AfonHxC;;AepnHE;EAAsC,gBAAA;AfwnHxC;;AexnHE;EAAsC,gBAAA;Af4nHxC;;Ae5nHE;EAAsC,gBAAA;AfgoHxC;;AehoHE;EAAsC,gBAAA;AfooHxC;;AepoHE;EAAsC,gBAAA;AfwoHxC;;AexoHE;EAAsC,gBAAA;Af4oHxC;;Ae5oHE;EAAsC,gBAAA;AfgpHxC;;AehpHE;EAAsC,gBAAA;AfopHxC;;AeppHE;EAAsC,gBAAA;AfwpHxC;;AexpHE;EAAsC,gBAAA;Af4pHxC;;Ae5pHE;EAAsC,gBAAA;AfgqHxC;;AehqHE;EAAsC,gBAAA;AfoqHxC;;AepqHE;EAAsC,gBAAA;AfwqHxC;;AexqHE;EAAsC,gBAAA;Af4qHxC;;Ae5qHE;EAAsC,gBAAA;AfgrHxC;;AehrHE;EAAsC,gBAAA;AforHxC;;AeprHE;EAAsC,gBAAA;AfwrHxC;;AexrHE;EAAsC,gBAAA;Af4rHxC;;Ae5rHE;EAAsC,gBAAA;AfgsHxC;;AehsHE;EAAsC,gBAAA;AfosHxC;;AepsHE;EAAsC,gBAAA;AfwsHxC;;AexsHE;EAAsC,gBAAA;Af4sHxC;;Ae5sHE;EAAsC,gBAAA;AfgtHxC;;AehtHE;EAAsC,gBAAA;AfotHxC;;AeptHE;EAAsC,gBAAA;AfwtHxC;;AextHE;EAAsC,gBAAA;Af4tHxC;;Ae5tHE;EAAsC,gBAAA;AfguHxC;;AehuHE;EAAsC,gBAAA;AfouHxC;;AepuHE;EAAsC,gBAAA;AfwuHxC;;AexuHE;EAAsC,gBAAA;Af4uHxC;;Ae5uHE;EAAsC,gBAAA;AfgvHxC;;AehvHE;EAAsC,gBAAA;AfovHxC;;AepvHE;EAAsC,gBAAA;AfwvHxC;;AexvHE;EAAsC,gBAAA;Af4vHxC;;Ae5vHE;EAAsC,gBAAA;AfgwHxC;;AehwHE;EAAsC,gBAAA;AfowHxC;;AepwHE;EAAsC,gBAAA;AfwwHxC;;AexwHE;EAAsC,gBAAA;Af4wHxC;;Ae5wHE;EAAsC,gBAAA;AfgxHxC;;AehxHE;EAAsC,gBAAA;AfoxHxC;;AepxHE;EAAsC,gBAAA;AfwxHxC;;AexxHE;EAAsC,gBAAA;Af4xHxC;;Ae5xHE;EAAsC,gBAAA;AfgyHxC;;AehyHE;EAAsC,gBAAA;AfoyHxC;;AepyHE;EAAsC,gBAAA;AfwyHxC;;AexyHE;EAAsC,gBAAA;Af4yHxC;;Ae5yHE;EAAsC,gBAAA;AfgzHxC;;AehzHE;EAAsC,gBAAA;AfozHxC;;AepzHE;EAAsC,gBAAA;AfwzHxC;;AexzHE;EAAsC,gBAAA;Af4zHxC;;Ae5zHE;EAAsC,gBAAA;Afg0HxC;;Aeh0HE;EAAsC,gBAAA;Afo0HxC;;Aep0HE;EAAsC,gBAAA;Afw0HxC;;Aex0HE;EAAsC,gBAAA;Af40HxC;;Ae50HE;EAAsC,gBAAA;Afg1HxC;;Aeh1HE;EAAsC,gBAAA;Afo1HxC;;Aep1HE;EAAsC,gBAAA;Afw1HxC;;Aex1HE;EAAsC,gBAAA;Af41HxC;;Ae51HE;EAAsC,gBAAA;Afg2HxC;;Aeh2HE;EAAsC,gBAAA;Afo2HxC;;Aep2HE;EAAsC,gBAAA;Afw2HxC;;Aex2HE;EAAsC,gBAAA;Af42HxC;;Ae52HE;EAAsC,gBAAA;Afg3HxC;;Aeh3HE;EAAsC,gBAAA;Afo3HxC;;Aep3HE;EAAsC,gBAAA;Afw3HxC;;Aex3HE;EAAsC,gBAAA;Af43HxC;;Ae53HE;EAAsC,gBAAA;Afg4HxC;;Aeh4HE;EAAsC,gBAAA;Afo4HxC;;Aep4HE;EAAsC,gBAAA;Afw4HxC;;Aex4HE;EAAsC,gBAAA;Af44HxC;;Ae54HE;EAAsC,gBAAA;Afg5HxC;;Aeh5HE;EAAsC,gBAAA;Afo5HxC;;Aep5HE;EAAsC,gBAAA;Afw5HxC;;Aex5HE;EAAsC,gBAAA;Af45HxC;;Ae55HE;EAAsC,gBAAA;Afg6HxC;;Aeh6HE;EAAsC,gBAAA;Afo6HxC;;Aep6HE;EAAsC,gBAAA;Afw6HxC;;Aex6HE;EAAsC,gBAAA;Af46HxC;;Ae56HE;EAAsC,gBAAA;Afg7HxC;;Aeh7HE;EAAsC,gBAAA;Afo7HxC;;Aep7HE;EAAsC,gBAAA;Afw7HxC;;Aex7HE;EAAsC,gBAAA;Af47HxC;;Ae57HE;EAAsC,gBAAA;Afg8HxC;;Aeh8HE;EAAsC,gBAAA;Afo8HxC;;Aep8HE;EAAsC,gBAAA;Afw8HxC;;Aex8HE;EAAsC,gBAAA;Af48HxC;;Ae58HE;EAAsC,gBAAA;Afg9HxC;;Aeh9HE;EAAsC,gBAAA;Afo9HxC;;Aep9HE;EAAsC,gBAAA;Afw9HxC;;Aex9HE;EAAsC,gBAAA;Af49HxC;;Ae59HE;EAAsC,gBAAA;Afg+HxC;;Aeh+HE;EAAsC,gBAAA;Afo+HxC;;Aep+HE;EAAsC,gBAAA;Afw+HxC;;Aex+HE;EAAsC,gBAAA;Af4+HxC;;Ae5+HE;EAAsC,gBAAA;Afg/HxC;;Aeh/HE;EAAsC,gBAAA;Afo/HxC;;Aep/HE;EAAsC,gBAAA;Afw/HxC;;Aex/HE;EAAsC,gBAAA;Af4/HxC;;Ae5/HE;EAAsC,gBAAA;AfggIxC;;AehgIE;EAAsC,gBAAA;AfogIxC;;AepgIE;EAAsC,gBAAA;AfwgIxC;;AexgIE;EAAsC,gBAAA;Af4gIxC;;Ae5gIE;EAAsC,gBAAA;AfghIxC;;AehhIE;EAAsC,gBAAA;AfohIxC;;AephIE;EAAsC,gBAAA;AfwhIxC;;AexhIE;EAAsC,gBAAA;Af4hIxC;;Ae5hIE;EAAsC,gBAAA;AfgiIxC;;AehiIE;EAAsC,gBAAA;AfoiIxC;;AepiIE;EAAsC,gBAAA;AfwiIxC;;AexiIE;EAAsC,gBAAA;Af4iIxC;;Ae5iIE;EAAsC,gBAAA;AfgjIxC;;AehjIE;EAAsC,gBAAA;AfojIxC;;AepjIE;EAAsC,gBAAA;AfwjIxC;;AexjIE;EAAsC,gBAAA;Af4jIxC;;Ae5jIE;EAAsC,gBAAA;AfgkIxC;;AehkIE;EAAsC,gBAAA;AfokIxC;;AepkIE;EAAsC,gBAAA;AfwkIxC;;AexkIE;EAAsC,gBAAA;Af4kIxC;;Ae5kIE;EAAsC,gBAAA;AfglIxC;;AehlIE;EAAsC,gBAAA;AfolIxC;;AeplIE;EAAsC,gBAAA;AfwlIxC;;AexlIE;EAAsC,gBAAA;Af4lIxC;;Ae5lIE;EAAsC,gBAAA;AfgmIxC;;AehmIE;EAAsC,gBAAA;AfomIxC;;AepmIE;EAAsC,gBAAA;AfwmIxC;;AexmIE;EAAsC,gBAAA;Af4mIxC;;Ae5mIE;EAAsC,gBAAA;AfgnIxC;;AehnIE;EAAsC,gBAAA;AfonIxC;;AepnIE;EAAsC,gBAAA;AfwnIxC;;AexnIE;EAAsC,gBAAA;Af4nIxC;;Ae5nIE;EAAsC,gBAAA;AfgoIxC;;AehoIE;EAAsC,gBAAA;AfooIxC;;AepoIE;EAAsC,gBAAA;AfwoIxC;;AexoIE;EAAsC,gBAAA;Af4oIxC;;Ae5oIE;EAAsC,gBAAA;AfgpIxC;;AehpIE;EAAsC,gBAAA;AfopIxC;;AeppIE;EAAsC,gBAAA;AfwpIxC;;AexpIE;EAAsC,gBAAA;Af4pIxC;;Ae5pIE;EAAsC,gBAAA;AfgqIxC;;AehqIE;EAAsC,gBAAA;AfoqIxC;;AepqIE;EAAsC,gBAAA;AfwqIxC;;AexqIE;EAAsC,gBAAA;Af4qIxC;;Ae5qIE;EAAsC,gBAAA;AfgrIxC;;AehrIE;EAAsC,gBAAA;AforIxC;;AeprIE;EAAsC,gBAAA;AfwrIxC;;AexrIE;EAAsC,gBAAA;Af4rIxC;;Ae5rIE;EAAsC,gBAAA;AfgsIxC;;AehsIE;EAAsC,gBAAA;AfosIxC;;AepsIE;EAAsC,gBAAA;AfwsIxC;;AexsIE;EAAsC,gBAAA;Af4sIxC;;Ae5sIE;EAAsC,gBAAA;AfgtIxC;;AehtIE;EAAsC,gBAAA;AfotIxC;;AeptIE;EAAsC,gBAAA;AfwtIxC;;AextIE;EAAsC,gBAAA;Af4tIxC;;Ae5tIE;EAAsC,gBAAA;AfguIxC;;AehuIE;EAAsC,gBAAA;AfouIxC;;AepuIE;EAAsC,gBAAA;AfwuIxC;;AexuIE;EAAsC,gBAAA;Af4uIxC;;Ae5uIE;EAAsC,gBAAA;AfgvIxC;;AehvIE;EAAsC,gBAAA;AfovIxC;;AepvIE;EAAsC,gBAAA;AfwvIxC;;AexvIE;EAAsC,gBAAA;Af4vIxC;;Ae5vIE;EAAsC,gBAAA;AfgwIxC;;AehwIE;EAAsC,gBAAA;AfowIxC;;AepwIE;EAAsC,gBAAA;AfwwIxC;;AexwIE;EAAsC,gBAAA;Af4wIxC;;Ae5wIE;EAAsC,gBAAA;AfgxIxC;;AehxIE;EAAsC,gBAAA;AfoxIxC;;AepxIE;EAAsC,gBAAA;AfwxIxC;;AexxIE;EAAsC,gBAAA;Af4xIxC;;Ae5xIE;EAAsC,gBAAA;AfgyIxC;;AehyIE;EAAsC,gBAAA;AfoyIxC;;AepyIE;EAAsC,gBAAA;AfwyIxC;;AexyIE;EAAsC,gBAAA;Af4yIxC;;Ae5yIE;EAAsC,gBAAA;AfgzIxC;;AehzIE;EAAsC,YAAA;AfozIxC;;AepzIE;EAAsC,gBAAA;AfwzIxC;;AexzIE;EAAsC,gBAAA;Af4zIxC;;Ae5zIE;EAAsC,gBAAA;Afg0IxC;;Aeh0IE;EAAsC,YAAA;Afo0IxC;;Aep0IE;EAAsC,gBAAA;Afw0IxC;;Aex0IE;EAAsC,gBAAA;Af40IxC;;Ae50IE;EAAsC,gBAAA;Afg1IxC;;Aeh1IE;EAAsC,gBAAA;Afo1IxC;;Aep1IE;EAAsC,YAAA;Afw1IxC;;Aex1IE;EAAsC,gBAAA;Af41IxC;;Ae51IE;EAAsC,gBAAA;Afg2IxC;;Aeh2IE;EAAsC,gBAAA;Afo2IxC;;Aep2IE;EAAsC,gBAAA;Afw2IxC;;Aex2IE;EAAsC,gBAAA;Af42IxC;;Ae52IE;EAAsC,gBAAA;Afg3IxC;;Aeh3IE;EAAsC,gBAAA;Afo3IxC;;Aep3IE;EAAsC,gBAAA;Afw3IxC;;Aex3IE;EAAsC,gBAAA;Af43IxC;;Ae53IE;EAAsC,gBAAA;Afg4IxC;;Aeh4IE;EAAsC,gBAAA;Afo4IxC;;Aep4IE;EAAsC,gBAAA;Afw4IxC;;Aex4IE;EAAsC,gBAAA;Af44IxC;;Ae54IE;EAAsC,gBAAA;Afg5IxC;;Aeh5IE;EAAsC,gBAAA;Afo5IxC;;Aep5IE;EAAsC,gBAAA;Afw5IxC;;Aex5IE;EAAsC,gBAAA;Af45IxC;;Ae55IE;EAAsC,gBAAA;Afg6IxC;;Aeh6IE;EAAsC,gBAAA;Afo6IxC;;Aep6IE;EAAsC,gBAAA;Afw6IxC;;Aex6IE;EAAsC,gBAAA;Af46IxC;;Ae56IE;EAAsC,gBAAA;Afg7IxC;;Aeh7IE;EAAsC,aAAA;Afo7IxC;;Aep7IE;EAAsC,gBAAA;Afw7IxC;;Aex7IE;EAAsC,gBAAA;Af47IxC;;Ae57IE;EAAsC,gBAAA;Afg8IxC;;Aeh8IE;EAAsC,gBAAA;Afo8IxC;;Aep8IE;EAAsC,gBAAA;Afw8IxC;;Aex8IE;EAAsC,gBAAA;Af48IxC;;Ae58IE;EAAsC,gBAAA;Afg9IxC;;Aeh9IE;EAAsC,gBAAA;Afo9IxC;;Aep9IE;EAAsC,gBAAA;Afw9IxC;;Aex9IE;EAAsC,gBAAA;Af49IxC;;Ae59IE;EAAsC,gBAAA;Afg+IxC;;Aeh+IE;EAAsC,gBAAA;Afo+IxC;;Aep+IE;EAAsC,gBAAA;Afw+IxC;;Aex+IE;EAAsC,gBAAA;Af4+IxC;;Ae5+IE;EAAsC,gBAAA;Afg/IxC;;Aeh/IE;EAAsC,gBAAA;Afo/IxC;;Aep/IE;EAAsC,gBAAA;Afw/IxC;;Aex/IE;EAAsC,gBAAA;Af4/IxC;;Ae5/IE;EAAsC,gBAAA;AfggJxC;;AehgJE;EAAsC,gBAAA;AfogJxC;;AepgJE;EAAsC,gBAAA;AfwgJxC;;AexgJE;EAAsC,gBAAA;Af4gJxC;;Ae5gJE;EAAsC,YAAA;AfghJxC;;AehhJE;EAAsC,gBAAA;AfohJxC;;AephJE;EAAsC,gBAAA;AfwhJxC;;AexhJE;EAAsC,gBAAA;Af4hJxC;;Ae5hJE;EAAsC,gBAAA;AfgiJxC;;AehiJE;EAAsC,gBAAA;AfoiJxC;;AepiJE;EAAsC,gBAAA;AfwiJxC;;AexiJE;EAAsC,gBAAA;Af4iJxC;;Ae5iJE;EAAsC,gBAAA;AfgjJxC;;AehjJE;EAAsC,gBAAA;AfojJxC;;AepjJE;EAAsC,gBAAA;AfwjJxC;;AexjJE;EAAsC,gBAAA;Af4jJxC;;Ae5jJE;EAAsC,gBAAA;AfgkJxC;;AehkJE;EAAsC,gBAAA;AfokJxC;;AepkJE;EAAsC,gBAAA;AfwkJxC;;AexkJE;EAAsC,gBAAA;Af4kJxC;;Ae5kJE;EAAsC,gBAAA;AfglJxC;;AehlJE;EAAsC,gBAAA;AfolJxC;;AeplJE;EAAsC,gBAAA;AfwlJxC;;AexlJE;EAAsC,gBAAA;Af4lJxC;;Ae5lJE;EAAsC,gBAAA;AfgmJxC;;AehmJE;EAAsC,gBAAA;AfomJxC;;AepmJE;EAAsC,gBAAA;AfwmJxC;;AexmJE;EAAsC,gBAAA;Af4mJxC;;Ae5mJE;EAAsC,gBAAA;AfgnJxC;;AehnJE;EAAsC,gBAAA;AfonJxC;;AepnJE;EAAsC,gBAAA;AfwnJxC;;AexnJE;EAAsC,gBAAA;Af4nJxC;;Ae5nJE;EAAsC,gBAAA;AfgoJxC;;AehoJE;EAAsC,gBAAA;AfooJxC;;AepoJE;EAAsC,gBAAA;AfwoJxC;;AexoJE;EAAsC,gBAAA;Af4oJxC;;Ae5oJE;EAAsC,gBAAA;AfgpJxC;;AehpJE;EAAsC,gBAAA;AfopJxC;;AeppJE;EAAsC,gBAAA;AfwpJxC;;AexpJE;EAAsC,gBAAA;Af4pJxC;;Ae5pJE;EAAsC,gBAAA;AfgqJxC;;AehqJE;EAAsC,gBAAA;AfoqJxC;;AepqJE;EAAsC,gBAAA;AfwqJxC;;AexqJE;EAAsC,gBAAA;Af4qJxC;;Ae5qJE;EAAsC,YAAA;AfgrJxC;;AehrJE;EAAsC,gBAAA;AforJxC;;AeprJE;EAAsC,gBAAA;AfwrJxC;;AexrJE;EAAsC,gBAAA;Af4rJxC;;Ae5rJE;EAAsC,gBAAA;AfgsJxC;;AehsJE;EAAsC,gBAAA;AfosJxC;;AepsJE;EAAsC,gBAAA;AfwsJxC;;AexsJE;EAAsC,gBAAA;Af4sJxC;;Ae5sJE;EAAsC,gBAAA;AfgtJxC;;AehtJE;EAAsC,gBAAA;AfotJxC;;AeptJE;EAAsC,gBAAA;AfwtJxC;;AextJE;EAAsC,gBAAA;Af4tJxC;;Ae5tJE;EAAsC,gBAAA;AfguJxC;;AehuJE;EAAsC,gBAAA;AfouJxC;;AepuJE;EAAsC,gBAAA;AfwuJxC;;AexuJE;EAAsC,gBAAA;Af4uJxC;;Ae5uJE;EAAsC,gBAAA;AfgvJxC;;AehvJE;EAAsC,gBAAA;AfovJxC;;AepvJE;EAAsC,gBAAA;AfwvJxC;;AexvJE;EAAsC,gBAAA;Af4vJxC;;Ae5vJE;EAAsC,gBAAA;AfgwJxC;;AehwJE;EAAsC,gBAAA;AfowJxC;;AepwJE;EAAsC,gBAAA;AfwwJxC;;AexwJE;EAAsC,YAAA;Af4wJxC;;Ae5wJE;EAAsC,gBAAA;AfgxJxC;;AehxJE;EAAsC,gBAAA;AfoxJxC;;AepxJE;EAAsC,gBAAA;AfwxJxC;;AexxJE;EAAsC,gBAAA;Af4xJxC;;Ae5xJE;EAAsC,gBAAA;AfgyJxC;;AehyJE;EAAsC,gBAAA;AfoyJxC;;AepyJE;EAAsC,gBAAA;AfwyJxC;;AexyJE;EAAsC,gBAAA;Af4yJxC;;Ae5yJE;EAAsC,gBAAA;AfgzJxC;;AehzJE;EAAsC,gBAAA;AfozJxC;;AepzJE;EAAsC,gBAAA;AfwzJxC;;AexzJE;EAAsC,gBAAA;Af4zJxC;;Ae5zJE;EAAsC,gBAAA;Afg0JxC;;Aeh0JE;EAAsC,gBAAA;Afo0JxC;;Aep0JE;EAAsC,gBAAA;Afw0JxC;;Aex0JE;EAAsC,gBAAA;Af40JxC;;Ae50JE;EAAsC,gBAAA;Afg1JxC;;Aeh1JE;EAAsC,gBAAA;Afo1JxC;;Aep1JE;EAAsC,gBAAA;Afw1JxC;;Aex1JE;EAAsC,gBAAA;Af41JxC;;Ae51JE;EAAsC,gBAAA;Afg2JxC;;Aeh2JE;EAAsC,gBAAA;Afo2JxC;;Aep2JE;EAAsC,gBAAA;Afw2JxC;;Aex2JE;EAAsC,gBAAA;Af42JxC;;Ae52JE;EAAsC,gBAAA;Afg3JxC;;Aeh3JE;EAAsC,gBAAA;Afo3JxC;;Aep3JE;EAAsC,gBAAA;Afw3JxC;;Aex3JE;EAAsC,gBAAA;Af43JxC;;Ae53JE;EAAsC,gBAAA;Afg4JxC;;Aeh4JE;EAAsC,gBAAA;Afo4JxC;;Aep4JE;EAAsC,gBAAA;Afw4JxC;;Aex4JE;EAAsC,gBAAA;Af44JxC;;Ae54JE;EAAsC,gBAAA;Afg5JxC;;Aeh5JE;EAAsC,gBAAA;Afo5JxC;;Aep5JE;EAAsC,gBAAA;Afw5JxC;;Aex5JE;EAAsC,gBAAA;Af45JxC;;Ae55JE;EAAsC,gBAAA;Afg6JxC;;Aeh6JE;EAAsC,gBAAA;Afo6JxC;;Aep6JE;EAAsC,gBAAA;Afw6JxC;;Aex6JE;EAAsC,gBAAA;Af46JxC;;Ae56JE;EAAsC,gBAAA;Afg7JxC;;Aeh7JE;EAAsC,gBAAA;Afo7JxC;;Aep7JE;EAAsC,gBAAA;Afw7JxC;;Aex7JE;EAAsC,gBAAA;Af47JxC;;Ae57JE;EAAsC,gBAAA;Afg8JxC;;Aeh8JE;EAAsC,gBAAA;Afo8JxC;;Aep8JE;EAAsC,gBAAA;Afw8JxC;;Aex8JE;EAAsC,gBAAA;Af48JxC;;Ae58JE;EAAsC,gBAAA;Afg9JxC;;Aeh9JE;EAAsC,gBAAA;Afo9JxC;;Aep9JE;EAAsC,gBAAA;Afw9JxC;;Aex9JE;EAAsC,gBAAA;Af49JxC;;Ae59JE;EAAsC,gBAAA;Afg+JxC;;Aeh+JE;EAAsC,gBAAA;Afo+JxC;;Aep+JE;EAAsC,gBAAA;Afw+JxC;;Aex+JE;EAAsC,gBAAA;Af4+JxC;;Ae5+JE;EAAsC,gBAAA;Afg/JxC;;Aeh/JE;EAAsC,gBAAA;Afo/JxC;;Aep/JE;EAAsC,gBAAA;Afw/JxC;;Aex/JE;EAAsC,gBAAA;Af4/JxC;;Ae5/JE;EAAsC,gBAAA;AfggKxC;;AehgKE;EAAsC,gBAAA;AfogKxC;;AepgKE;EAAsC,gBAAA;AfwgKxC;;AexgKE;EAAsC,gBAAA;Af4gKxC;;Ae5gKE;EAAsC,gBAAA;AfghKxC;;AehhKE;EAAsC,gBAAA;AfohKxC;;AephKE;EAAsC,gBAAA;AfwhKxC;;AexhKE;EAAsC,gBAAA;Af4hKxC;;Ae5hKE;EAAsC,gBAAA;AfgiKxC;;AehiKE;EAAsC,gBAAA;AfoiKxC;;AepiKE;EAAsC,gBAAA;AfwiKxC;;AexiKE;EAAsC,gBAAA;Af4iKxC;;Ae5iKE;EAAsC,gBAAA;AfgjKxC;;AehjKE;EAAsC,gBAAA;AfojKxC;;AepjKE;EAAsC,gBAAA;AfwjKxC;;AexjKE;EAAsC,gBAAA;Af4jKxC;;Ae5jKE;EAAsC,gBAAA;AfgkKxC;;AehkKE;EAAsC,gBAAA;AfokKxC;;AepkKE;EAAsC,gBAAA;AfwkKxC;;AexkKE;EAAsC,gBAAA;Af4kKxC;;Ae5kKE;EAAsC,gBAAA;AfglKxC;;AehlKE;EAAsC,gBAAA;AfolKxC;;AeplKE;EAAsC,gBAAA;AfwlKxC;;AexlKE;EAAsC,gBAAA;Af4lKxC;;Ae5lKE;EAAsC,gBAAA;AfgmKxC;;AehmKE;EAAsC,gBAAA;AfomKxC;;AepmKE;EAAsC,gBAAA;AfwmKxC;;AexmKE;EAAsC,gBAAA;Af4mKxC;;Ae5mKE;EAAsC,gBAAA;AfgnKxC;;AehnKE;EAAsC,gBAAA;AfonKxC;;AepnKE;EAAsC,gBAAA;AfwnKxC;;AexnKE;EAAsC,gBAAA;Af4nKxC;;Ae5nKE;EAAsC,gBAAA;AfgoKxC;;AehoKE;EAAsC,gBAAA;AfooKxC;;AepoKE;EAAsC,gBAAA;AfwoKxC;;AexoKE;EAAsC,gBAAA;Af4oKxC;;Ae5oKE;EAAsC,gBAAA;AfgpKxC;;AehpKE;EAAsC,gBAAA;AfopKxC;;AeppKE;EAAsC,gBAAA;AfwpKxC;;AexpKE;EAAsC,gBAAA;Af4pKxC;;Ae5pKE;EAAsC,gBAAA;AfgqKxC;;AehqKE;EAAsC,gBAAA;AfoqKxC;;AepqKE;EAAsC,gBAAA;AfwqKxC;;AexqKE;EAAsC,gBAAA;Af4qKxC;;Ae5qKE;EAAsC,gBAAA;AfgrKxC;;AehrKE;EAAsC,gBAAA;AforKxC;;AeprKE;EAAsC,gBAAA;AfwrKxC;;AexrKE;EAAsC,gBAAA;Af4rKxC;;Ae5rKE;EAAsC,gBAAA;AfgsKxC;;AehsKE;EAAsC,gBAAA;AfosKxC;;AepsKE;EAAsC,gBAAA;AfwsKxC;;AexsKE;EAAsC,gBAAA;Af4sKxC;;Ae5sKE;EAAsC,gBAAA;AfgtKxC;;AehtKE;EAAsC,gBAAA;AfotKxC;;AeptKE;EAAsC,gBAAA;AfwtKxC;;AextKE;EAAsC,gBAAA;Af4tKxC;;Ae5tKE;EAAsC,gBAAA;AfguKxC;;AehuKE;EAAsC,gBAAA;AfouKxC;;AepuKE;EAAsC,gBAAA;AfwuKxC;;AexuKE;EAAsC,gBAAA;Af4uKxC;;Ae5uKE;EAAsC,gBAAA;AfgvKxC;;AehvKE;EAAsC,gBAAA;AfovKxC;;AepvKE;EAAsC,gBAAA;AfwvKxC;;AexvKE;EAAsC,gBAAA;Af4vKxC;;Ae5vKE;EAAsC,gBAAA;AfgwKxC;;AehwKE;EAAsC,gBAAA;AfowKxC;;AepwKE;EAAsC,gBAAA;AfwwKxC;;AexwKE;EAAsC,gBAAA;Af4wKxC;;Ae5wKE;EAAsC,gBAAA;AfgxKxC;;AehxKE;EAAsC,gBAAA;AfoxKxC;;AepxKE;EAAsC,gBAAA;AfwxKxC;;AexxKE;EAAsC,gBAAA;Af4xKxC;;Ae5xKE;EAAsC,gBAAA;AfgyKxC;;AehyKE;EAAsC,gBAAA;AfoyKxC;;AepyKE;EAAsC,gBAAA;AfwyKxC;;AexyKE;EAAsC,gBAAA;Af4yKxC;;Ae5yKE;EAAsC,gBAAA;AfgzKxC;;AehzKE;EAAsC,gBAAA;AfozKxC;;AepzKE;EAAsC,gBAAA;AfwzKxC;;AexzKE;EAAsC,gBAAA;Af4zKxC;;Ae5zKE;EAAsC,gBAAA;Afg0KxC;;Aeh0KE;EAAsC,gBAAA;Afo0KxC;;Aep0KE;EAAsC,gBAAA;Afw0KxC;;Aex0KE;EAAsC,gBAAA;Af40KxC;;Ae50KE;EAAsC,gBAAA;Afg1KxC;;Aeh1KE;EAAsC,gBAAA;Afo1KxC;;Aep1KE;EAAsC,gBAAA;Afw1KxC;;Aex1KE;EAAsC,gBAAA;Af41KxC;;Ae51KE;EAAsC,gBAAA;Afg2KxC;;Aeh2KE;EAAsC,gBAAA;Afo2KxC;;Aep2KE;EAAsC,gBAAA;Afw2KxC;;Aex2KE;EAAsC,gBAAA;Af42KxC;;Ae52KE;EAAsC,gBAAA;Afg3KxC;;Aeh3KE;EAAsC,gBAAA;Afo3KxC;;Aep3KE;EAAsC,gBAAA;Afw3KxC;;Aex3KE;EAAsC,gBAAA;Af43KxC;;Ae53KE;EAAsC,gBAAA;Afg4KxC;;Aeh4KE;EAAsC,gBAAA;Afo4KxC;;Aep4KE;EAAsC,gBAAA;Afw4KxC;;Aex4KE;EAAsC,gBAAA;Af44KxC;;Ae54KE;EAAsC,gBAAA;Afg5KxC;;Aeh5KE;EAAsC,gBAAA;Afo5KxC;;Aep5KE;EAAsC,gBAAA;Afw5KxC;;Aex5KE;EAAsC,gBAAA;Af45KxC;;Ae55KE;EAAsC,gBAAA;Afg6KxC;;Aeh6KE;EAAsC,gBAAA;Afo6KxC;;Aep6KE;EAAsC,gBAAA;Afw6KxC;;Aex6KE;EAAsC,gBAAA;Af46KxC;;Ae56KE;EAAsC,gBAAA;Afg7KxC;;Aeh7KE;EAAsC,gBAAA;Afo7KxC;;Aep7KE;EAAsC,gBAAA;Afw7KxC;;Aex7KE;EAAsC,gBAAA;Af47KxC;;Ae57KE;EAAsC,gBAAA;Afg8KxC;;Aeh8KE;EAAsC,gBAAA;Afo8KxC;;Aep8KE;EAAsC,gBAAA;Afw8KxC;;Aex8KE;EAAsC,gBAAA;Af48KxC;;Ae58KE;EAAsC,gBAAA;Afg9KxC;;Aeh9KE;EAAsC,gBAAA;Afo9KxC;;Aep9KE;EAAsC,gBAAA;Afw9KxC;;Aex9KE;EAAsC,gBAAA;Af49KxC;;Ae59KE;EAAsC,gBAAA;Afg+KxC;;Aeh+KE;EAAsC,gBAAA;Afo+KxC;;Aep+KE;EAAsC,gBAAA;Afw+KxC;;Aex+KE;EAAsC,gBAAA;Af4+KxC;;Ae5+KE;EAAsC,gBAAA;Afg/KxC;;Aeh/KE;EAAsC,gBAAA;Afo/KxC;;Aep/KE;EAAsC,gBAAA;Afw/KxC;;Aex/KE;EAAsC,gBAAA;Af4/KxC;;Ae5/KE;EAAsC,YAAA;AfggLxC;;AehgLE;EAAsC,gBAAA;AfogLxC;;AepgLE;EAAsC,gBAAA;AfwgLxC;;AexgLE;EAAsC,gBAAA;Af4gLxC;;Ae5gLE;EAAsC,gBAAA;AfghLxC;;AehhLE;EAAsC,gBAAA;AfohLxC;;AephLE;EAAsC,gBAAA;AfwhLxC;;AexhLE;EAAsC,gBAAA;Af4hLxC;;Ae5hLE;EAAsC,gBAAA;AfgiLxC;;AehiLE;EAAsC,gBAAA;AfoiLxC;;AepiLE;EAAsC,YAAA;AfwiLxC;;AexiLE;EAAsC,gBAAA;Af4iLxC;;Ae5iLE;EAAsC,gBAAA;AfgjLxC;;AehjLE;EAAsC,gBAAA;AfojLxC;;AepjLE;EAAsC,gBAAA;AfwjLxC;;AexjLE;EAAsC,gBAAA;Af4jLxC;;Ae5jLE;EAAsC,gBAAA;AfgkLxC;;AehkLE;EAAsC,gBAAA;AfokLxC;;AepkLE;EAAsC,gBAAA;AfwkLxC;;AexkLE;EAAsC,gBAAA;Af4kLxC;;Ae5kLE;EAAsC,gBAAA;AfglLxC;;AehlLE;EAAsC,gBAAA;AfolLxC;;AeplLE;EAAsC,gBAAA;AfwlLxC;;AexlLE;EAAsC,gBAAA;Af4lLxC;;Ae5lLE;EAAsC,gBAAA;AfgmLxC;;AehmLE;EAAsC,gBAAA;AfomLxC;;AepmLE;EAAsC,gBAAA;AfwmLxC;;AexmLE;EAAsC,gBAAA;Af4mLxC;;Ae5mLE;EAAsC,gBAAA;AfgnLxC;;AehnLE;EAAsC,gBAAA;AfonLxC;;AepnLE;EAAsC,gBAAA;AfwnLxC;;AexnLE;EAAsC,gBAAA;Af4nLxC;;Ae5nLE;EAAsC,gBAAA;AfgoLxC;;AehoLE;EAAsC,gBAAA;AfooLxC;;AepoLE;EAAsC,gBAAA;AfwoLxC;;AexoLE;EAAsC,gBAAA;Af4oLxC;;Ae5oLE;EAAsC,gBAAA;AfgpLxC;;AehpLE;EAAsC,gBAAA;AfopLxC;;AeppLE;EAAsC,gBAAA;AfwpLxC;;AexpLE;EAAsC,gBAAA;Af4pLxC;;Ae5pLE;EAAsC,gBAAA;AfgqLxC;;AehqLE;EAAsC,gBAAA;AfoqLxC;;AepqLE;EAAsC,gBAAA;AfwqLxC;;AexqLE;EAAsC,gBAAA;Af4qLxC;;Ae5qLE;EAAsC,gBAAA;AfgrLxC;;AehrLE;EAAsC,gBAAA;AforLxC;;AeprLE;EAAsC,gBAAA;AfwrLxC;;AexrLE;EAAsC,gBAAA;Af4rLxC;;Ae5rLE;EAAsC,gBAAA;AfgsLxC;;AehsLE;EAAsC,gBAAA;AfosLxC;;AepsLE;EAAsC,gBAAA;AfwsLxC;;AexsLE;EAAsC,gBAAA;Af4sLxC;;Ae5sLE;EAAsC,gBAAA;AfgtLxC;;AehtLE;EAAsC,gBAAA;AfotLxC;;AeptLE;EAAsC,gBAAA;AfwtLxC;;AextLE;EAAsC,gBAAA;Af4tLxC;;Ae5tLE;EAAsC,gBAAA;AfguLxC;;AehuLE;EAAsC,gBAAA;AfouLxC;;AepuLE;EAAsC,gBAAA;AfwuLxC;;AexuLE;EAAsC,gBAAA;Af4uLxC;;Ae5uLE;EAAsC,gBAAA;AfgvLxC;;AehvLE;EAAsC,gBAAA;AfovLxC;;AepvLE;EAAsC,gBAAA;AfwvLxC;;AexvLE;EAAsC,gBAAA;Af4vLxC;;Ae5vLE;EAAsC,gBAAA;AfgwLxC;;AehwLE;EAAsC,gBAAA;AfowLxC;;AepwLE;EAAsC,gBAAA;AfwwLxC;;AexwLE;EAAsC,gBAAA;Af4wLxC;;Ae5wLE;EAAsC,gBAAA;AfgxLxC;;AehxLE;EAAsC,gBAAA;AfoxLxC;;AepxLE;EAAsC,gBAAA;AfwxLxC;;AexxLE;EAAsC,gBAAA;Af4xLxC;;Ae5xLE;EAAsC,gBAAA;AfgyLxC;;AehyLE;EAAsC,gBAAA;AfoyLxC;;AepyLE;EAAsC,gBAAA;AfwyLxC;;AexyLE;EAAsC,gBAAA;Af4yLxC;;Ae5yLE;EAAsC,gBAAA;AfgzLxC;;AehzLE;EAAsC,gBAAA;AfozLxC;;AepzLE;EAAsC,gBAAA;AfwzLxC;;AexzLE;EAAsC,gBAAA;Af4zLxC;;Ae5zLE;EAAsC,gBAAA;Afg0LxC;;Aeh0LE;EAAsC,gBAAA;Afo0LxC;;Aep0LE;EAAsC,gBAAA;Afw0LxC;;Aex0LE;EAAsC,gBAAA;Af40LxC;;Ae50LE;EAAsC,gBAAA;Afg1LxC;;Aeh1LE;EAAsC,gBAAA;Afo1LxC;;Aep1LE;EAAsC,gBAAA;Afw1LxC;;Aex1LE;EAAsC,gBAAA;Af41LxC;;Ae51LE;EAAsC,gBAAA;Afg2LxC;;Aeh2LE;EAAsC,gBAAA;Afo2LxC;;Aep2LE;EAAsC,gBAAA;Afw2LxC;;Aex2LE;EAAsC,gBAAA;Af42LxC;;Ae52LE;EAAsC,gBAAA;Afg3LxC;;Aeh3LE;EAAsC,gBAAA;Afo3LxC;;Aep3LE;EAAsC,gBAAA;Afw3LxC;;Aex3LE;EAAsC,gBAAA;Af43LxC;;Ae53LE;EAAsC,gBAAA;Afg4LxC;;Aeh4LE;EAAsC,gBAAA;Afo4LxC;;Aep4LE;EAAsC,gBAAA;Afw4LxC;;Aex4LE;EAAsC,gBAAA;Af44LxC;;Ae54LE;EAAsC,gBAAA;Afg5LxC;;Aeh5LE;EAAsC,gBAAA;Afo5LxC;;Aep5LE;EAAsC,gBAAA;Afw5LxC;;Aex5LE;EAAsC,gBAAA;Af45LxC;;Ae55LE;EAAsC,gBAAA;Afg6LxC;;Aeh6LE;EAAsC,gBAAA;Afo6LxC;;Aep6LE;EAAsC,gBAAA;Afw6LxC;;Aex6LE;EAAsC,gBAAA;Af46LxC;;Ae56LE;EAAsC,gBAAA;Afg7LxC;;Aeh7LE;EAAsC,gBAAA;Afo7LxC;;Aep7LE;EAAsC,gBAAA;Afw7LxC;;Aex7LE;EAAsC,gBAAA;Af47LxC;;Ae57LE;EAAsC,gBAAA;Afg8LxC;;Aeh8LE;EAAsC,gBAAA;Afo8LxC;;Aep8LE;EAAsC,gBAAA;Afw8LxC;;Aex8LE;EAAsC,gBAAA;Af48LxC;;Ae58LE;EAAsC,gBAAA;Afg9LxC;;Aeh9LE;EAAsC,gBAAA;Afo9LxC;;Aep9LE;EAAsC,gBAAA;Afw9LxC;;Aex9LE;EAAsC,gBAAA;Af49LxC;;Ae59LE;EAAsC,gBAAA;Afg+LxC;;Aeh+LE;EAAsC,gBAAA;Afo+LxC;;Aep+LE;EAAsC,gBAAA;Afw+LxC;;Aex+LE;EAAsC,gBAAA;Af4+LxC;;Ae5+LE;EAAsC,gBAAA;Afg/LxC;;Aeh/LE;EAAsC,gBAAA;Afo/LxC;;Aep/LE;EAAsC,gBAAA;Afw/LxC;;Aex/LE;EAAsC,gBAAA;Af4/LxC;;Ae5/LE;EAAsC,gBAAA;AfggMxC;;AehgME;EAAsC,gBAAA;AfogMxC;;AepgME;EAAsC,gBAAA;AfwgMxC;;AexgME;EAAsC,gBAAA;Af4gMxC;;Ae5gME;EAAsC,gBAAA;AfghMxC;;AehhME;EAAsC,gBAAA;AfohMxC;;AephME;EAAsC,gBAAA;AfwhMxC;;AexhME;EAAsC,gBAAA;Af4hMxC;;Ae5hME;EAAsC,gBAAA;AfgiMxC;;AehiME;EAAsC,gBAAA;AfoiMxC;;AepiME;EAAsC,gBAAA;AfwiMxC;;AexiME;EAAsC,gBAAA;Af4iMxC;;Ae5iME;EAAsC,gBAAA;AfgjMxC;;AehjME;EAAsC,gBAAA;AfojMxC;;AepjME;EAAsC,gBAAA;AfwjMxC;;AexjME;EAAsC,gBAAA;Af4jMxC;;Ae5jME;EAAsC,gBAAA;AfgkMxC;;AehkME;EAAsC,gBAAA;AfokMxC;;AepkME;EAAsC,gBAAA;AfwkMxC;;AexkME;EAAsC,gBAAA;Af4kMxC;;Ae5kME;EAAsC,gBAAA;AfglMxC;;AehlME;EAAsC,gBAAA;AfolMxC;;AeplME;EAAsC,gBAAA;AfwlMxC;;AexlME;EAAsC,YAAA;Af4lMxC;;Ae5lME;EAAsC,gBAAA;AfgmMxC;;AehmME;EAAsC,gBAAA;AfomMxC;;AepmME;EAAsC,gBAAA;AfwmMxC;;AexmME;EAAsC,gBAAA;Af4mMxC;;Ae5mME;EAAsC,gBAAA;AfgnMxC;;AehnME;EAAsC,gBAAA;AfonMxC;;AepnME;EAAsC,gBAAA;AfwnMxC;;AexnME;EAAsC,gBAAA;Af4nMxC;;Ae5nME;EAAsC,gBAAA;AfgoMxC;;AehoME;EAAsC,YAAA;AfooMxC;;AepoME;EAAsC,gBAAA;AfwoMxC;;AexoME;EAAsC,gBAAA;Af4oMxC;;Ae5oME;EAAsC,gBAAA;AfgpMxC;;AehpME;EAAsC,gBAAA;AfopMxC;;AeppME;EAAsC,gBAAA;AfwpMxC;;AexpME;EAAsC,gBAAA;Af4pMxC;;Ae5pME;EAAsC,gBAAA;AfgqMxC;;AehqME;EAAsC,gBAAA;AfoqMxC;;AepqME;EAAsC,gBAAA;AfwqMxC;;AexqME;EAAsC,gBAAA;Af4qMxC;;Ae5qME;EAAsC,gBAAA;AfgrMxC;;AehrME;EAAsC,gBAAA;AforMxC;;AeprME;EAAsC,gBAAA;AfwrMxC;;AexrME;EAAsC,gBAAA;Af4rMxC;;Ae5rME;EAAsC,gBAAA;AfgsMxC;;AehsME;EAAsC,gBAAA;AfosMxC;;AepsME;EAAsC,gBAAA;AfwsMxC;;AexsME;EAAsC,gBAAA;Af4sMxC;;Ae5sME;EAAsC,gBAAA;AfgtMxC;;AehtME;EAAsC,gBAAA;AfotMxC;;AeptME;EAAsC,gBAAA;AfwtMxC;;AextME;EAAsC,gBAAA;Af4tMxC;;Ae5tME;EAAsC,gBAAA;AfguMxC;;AehuME;EAAsC,gBAAA;AfouMxC;;AepuME;EAAsC,gBAAA;AfwuMxC;;AexuME;EAAsC,gBAAA;Af4uMxC;;Ae5uME;EAAsC,gBAAA;AfgvMxC;;AehvME;EAAsC,gBAAA;AfovMxC;;AepvME;EAAsC,gBAAA;AfwvMxC;;AexvME;EAAsC,gBAAA;Af4vMxC;;Ae5vME;EAAsC,gBAAA;AfgwMxC;;AehwME;EAAsC,gBAAA;AfowMxC;;AepwME;EAAsC,gBAAA;AfwwMxC;;AexwME;EAAsC,gBAAA;Af4wMxC;;Ae5wME;EAAsC,gBAAA;AfgxMxC;;AehxME;EAAsC,gBAAA;AfoxMxC;;AepxME;EAAsC,gBAAA;AfwxMxC;;AexxME;EAAsC,gBAAA;Af4xMxC;;Ae5xME;EAAsC,gBAAA;AfgyMxC;;AehyME;EAAsC,gBAAA;AfoyMxC;;AepyME;EAAsC,gBAAA;AfwyMxC;;AexyME;EAAsC,gBAAA;Af4yMxC;;Ae5yME;EAAsC,gBAAA;AfgzMxC;;AehzME;EAAsC,gBAAA;AfozMxC;;AepzME;EAAsC,gBAAA;AfwzMxC;;AexzME;EAAsC,gBAAA;Af4zMxC;;Ae5zME;EAAsC,gBAAA;Afg0MxC;;Aeh0ME;EAAsC,gBAAA;Afo0MxC;;Aep0ME;EAAsC,YAAA;Afw0MxC;;Aex0ME;EAAsC,gBAAA;Af40MxC;;Ae50ME;EAAsC,gBAAA;Afg1MxC;;Aeh1ME;EAAsC,gBAAA;Afo1MxC;;Aep1ME;EAAsC,gBAAA;Afw1MxC;;Aex1ME;EAAsC,gBAAA;Af41MxC;;Ae51ME;EAAsC,gBAAA;Afg2MxC;;Aeh2ME;EAAsC,gBAAA;Afo2MxC;;Aep2ME;EAAsC,gBAAA;Afw2MxC;;Aex2ME;EAAsC,gBAAA;Af42MxC;;Ae52ME;EAAsC,gBAAA;Afg3MxC;;Aeh3ME;EAAsC,gBAAA;Afo3MxC;;Aep3ME;EAAsC,gBAAA;Afw3MxC;;Aex3ME;EAAsC,gBAAA;Af43MxC;;Ae53ME;EAAsC,gBAAA;Afg4MxC;;Aeh4ME;EAAsC,gBAAA;Afo4MxC;;Aep4ME;EAAsC,gBAAA;Afw4MxC;;Aex4ME;EAAsC,gBAAA;Af44MxC;;Ae54ME;EAAsC,gBAAA;Afg5MxC;;Aeh5ME;EAAsC,gBAAA;Afo5MxC;;Aep5ME;EAAsC,gBAAA;Afw5MxC;;Aex5ME;EAAsC,gBAAA;Af45MxC;;Ae55ME;EAAsC,gBAAA;Afg6MxC;;Aeh6ME;EAAsC,gBAAA;Afo6MxC;;Aep6ME;EAAsC,gBAAA;Afw6MxC;;Aex6ME;EAAsC,gBAAA;Af46MxC;;Ae56ME;EAAsC,gBAAA;Afg7MxC;;Aeh7ME;EAAsC,gBAAA;Afo7MxC;;Aep7ME;EAAsC,gBAAA;Afw7MxC;;Aex7ME;EAAsC,gBAAA;Af47MxC;;Ae57ME;EAAsC,gBAAA;Afg8MxC;;Aeh8ME;EAAsC,gBAAA;Afo8MxC;;Aep8ME;EAAsC,gBAAA;Afw8MxC;;Aex8ME;EAAsC,gBAAA;Af48MxC;;Ae58ME;EAAsC,gBAAA;Afg9MxC;;Aeh9ME;EAAsC,gBAAA;Afo9MxC;;Aep9ME;EAAsC,YAAA;Afw9MxC;;Aex9ME;EAAsC,gBAAA;Af49MxC;;Ae59ME;EAAsC,gBAAA;Afg+MxC;;Aeh+ME;EAAsC,gBAAA;Afo+MxC;;Aep+ME;EAAsC,gBAAA;Afw+MxC;;Aex+ME;EAAsC,gBAAA;Af4+MxC;;Ae5+ME;EAAsC,gBAAA;Afg/MxC;;Aeh/ME;EAAsC,gBAAA;Afo/MxC;;Aep/ME;EAAsC,gBAAA;Afw/MxC;;Aex/ME;EAAsC,gBAAA;Af4/MxC;;Ae5/ME;EAAsC,gBAAA;AfggNxC;;AehgNE;EAAsC,gBAAA;AfogNxC;;AepgNE;EAAsC,gBAAA;AfwgNxC;;AexgNE;EAAsC,gBAAA;Af4gNxC;;Ae5gNE;EAAsC,gBAAA;AfghNxC;;AehhNE;EAAsC,gBAAA;AfohNxC;;AephNE;EAAsC,gBAAA;AfwhNxC;;AexhNE;EAAsC,gBAAA;Af4hNxC;;Ae5hNE;EAAsC,gBAAA;AfgiNxC;;AehiNE;EAAsC,gBAAA;AfoiNxC;;AepiNE;EAAsC,gBAAA;AfwiNxC;;AexiNE;EAAsC,gBAAA;Af4iNxC;;Ae5iNE;EAAsC,gBAAA;AfgjNxC;;AehjNE;EAAsC,gBAAA;AfojNxC;;AepjNE;EAAsC,gBAAA;AfwjNxC;;AexjNE;EAAsC,gBAAA;Af4jNxC;;Ae5jNE;EAAsC,gBAAA;AfgkNxC;;AehkNE;EAAsC,gBAAA;AfokNxC;;AepkNE;EAAsC,gBAAA;AfwkNxC;;AexkNE;EAAsC,gBAAA;Af4kNxC;;Ae5kNE;EAAsC,gBAAA;AfglNxC;;AehlNE;EAAsC,gBAAA;AfolNxC;;AeplNE;EAAsC,gBAAA;AfwlNxC;;AexlNE;EAAsC,gBAAA;Af4lNxC;;Ae5lNE;EAAsC,gBAAA;AfgmNxC;;AehmNE;EAAsC,gBAAA;AfomNxC;;AepmNE;EAAsC,gBAAA;AfwmNxC;;AexmNE;EAAsC,gBAAA;Af4mNxC;;Ae5mNE;EAAsC,gBAAA;AfgnNxC;;AehnNE;EAAsC,gBAAA;AfonNxC;;AepnNE;EAAsC,gBAAA;AfwnNxC;;AexnNE;EAAsC,gBAAA;Af4nNxC;;Ae5nNE;EAAsC,gBAAA;AfgoNxC;;AehoNE;EAAsC,gBAAA;AfooNxC;;AepoNE;EAAsC,gBAAA;AfwoNxC;;AexoNE;EAAsC,gBAAA;Af4oNxC;;Ae5oNE;EAAsC,gBAAA;AfgpNxC;;AehpNE;EAAsC,gBAAA;AfopNxC;;AeppNE;EAAsC,gBAAA;AfwpNxC;;AexpNE;EAAsC,gBAAA;Af4pNxC;;Ae5pNE;EAAsC,gBAAA;AfgqNxC;;AehqNE;EAAsC,gBAAA;AfoqNxC;;AepqNE;EAAsC,gBAAA;AfwqNxC;;AexqNE;EAAsC,gBAAA;Af4qNxC;;Ae5qNE;EAAsC,gBAAA;AfgrNxC;;AehrNE;EAAsC,gBAAA;AforNxC;;AeprNE;EAAsC,gBAAA;AfwrNxC;;AexrNE;EAAsC,gBAAA;Af4rNxC;;Ae5rNE;EAAsC,gBAAA;AfgsNxC;;AehsNE;EAAsC,gBAAA;AfosNxC;;AepsNE;EAAsC,gBAAA;AfwsNxC;;AexsNE;EAAsC,gBAAA;Af4sNxC;;Ae5sNE;EAAsC,gBAAA;AfgtNxC;;AehtNE;EAAsC,aAAA;AfotNxC;;AeptNE;EAAsC,gBAAA;AfwtNxC;;AextNE;EAAsC,gBAAA;Af4tNxC;;Ae5tNE;EAAsC,gBAAA;AfguNxC;;AehuNE;EAAsC,gBAAA;AfouNxC;;AepuNE;EAAsC,gBAAA;AfwuNxC;;AexuNE;EAAsC,gBAAA;Af4uNxC;;Ae5uNE;EAAsC,gBAAA;AfgvNxC;;AehvNE;EAAsC,gBAAA;AfovNxC;;AepvNE;EAAsC,gBAAA;AfwvNxC;;AexvNE;EAAsC,gBAAA;Af4vNxC;;Ae5vNE;EAAsC,gBAAA;AfgwNxC;;AehwNE;EAAsC,gBAAA;AfowNxC;;AepwNE;EAAsC,gBAAA;AfwwNxC;;AexwNE;EAAsC,gBAAA;Af4wNxC;;Ae5wNE;EAAsC,gBAAA;AfgxNxC;;AehxNE;EAAsC,gBAAA;AfoxNxC;;AepxNE;EAAsC,gBAAA;AfwxNxC;;AexxNE;EAAsC,gBAAA;Af4xNxC;;Ae5xNE;EAAsC,gBAAA;AfgyNxC;;AehyNE;EAAsC,gBAAA;AfoyNxC;;AepyNE;EAAsC,gBAAA;AfwyNxC;;AexyNE;EAAsC,gBAAA;Af4yNxC;;Ae5yNE;EAAsC,gBAAA;AfgzNxC;;AehzNE;EAAsC,gBAAA;AfozNxC;;AepzNE;EAAsC,gBAAA;AfwzNxC;;AexzNE;EAAsC,gBAAA;Af4zNxC;;Ae5zNE;EAAsC,gBAAA;Afg0NxC;;Aeh0NE;EAAsC,gBAAA;Afo0NxC;;Aep0NE;EAAsC,gBAAA;Afw0NxC;;Aex0NE;EAAsC,gBAAA;Af40NxC;;Ae50NE;EAAsC,gBAAA;Afg1NxC;;Aeh1NE;EAAsC,gBAAA;Afo1NxC;;Aep1NE;EAAsC,gBAAA;Afw1NxC;;Aex1NE;EAAsC,gBAAA;Af41NxC;;Ae51NE;EAAsC,gBAAA;Afg2NxC;;Aeh2NE;EAAsC,gBAAA;Afo2NxC;;Aep2NE;EAAsC,gBAAA;Afw2NxC;;Aex2NE;EAAsC,gBAAA;Af42NxC;;Ae52NE;EAAsC,gBAAA;Afg3NxC;;Aeh3NE;EAAsC,gBAAA;Afo3NxC;;Aep3NE;EAAsC,gBAAA;Afw3NxC;;Aex3NE;EAAsC,gBAAA;Af43NxC;;Ae53NE;EAAsC,gBAAA;Afg4NxC;;Aeh4NE;EAAsC,gBAAA;Afo4NxC;;Aep4NE;EAAsC,gBAAA;Afw4NxC;;Aex4NE;EAAsC,gBAAA;Af44NxC;;Ae54NE;EAAsC,gBAAA;Afg5NxC;;Aeh5NE;EAAsC,gBAAA;Afo5NxC;;Aep5NE;EAAsC,gBAAA;Afw5NxC;;Aex5NE;EAAsC,gBAAA;Af45NxC;;Ae55NE;EAAsC,gBAAA;Afg6NxC;;Aeh6NE;EAAsC,gBAAA;Afo6NxC;;Aep6NE;EAAsC,aAAA;Afw6NxC;;Aex6NE;EAAsC,gBAAA;Af46NxC;;Ae56NE;EAAsC,gBAAA;Afg7NxC;;Aeh7NE;EAAsC,gBAAA;Afo7NxC;;Aep7NE;EAAsC,gBAAA;Afw7NxC;;Aex7NE;EAAsC,gBAAA;Af47NxC;;Ae57NE;EAAsC,gBAAA;Afg8NxC;;Aeh8NE;EAAsC,gBAAA;Afo8NxC;;Aep8NE;EAAsC,gBAAA;Afw8NxC;;Aex8NE;EAAsC,gBAAA;Af48NxC;;Ae58NE;EAAsC,gBAAA;Afg9NxC;;Aeh9NE;EAAsC,gBAAA;Afo9NxC;;Aep9NE;EAAsC,gBAAA;Afw9NxC;;Aex9NE;EAAsC,gBAAA;Af49NxC;;Ae59NE;EAAsC,gBAAA;Afg+NxC;;Aeh+NE;EAAsC,gBAAA;Afo+NxC;;Aep+NE;EAAsC,gBAAA;Afw+NxC;;Aex+NE;EAAsC,gBAAA;Af4+NxC;;Ae5+NE;EAAsC,gBAAA;Afg/NxC;;Aeh/NE;EAAsC,gBAAA;Afo/NxC;;Aep/NE;EAAsC,gBAAA;Afw/NxC;;Aex/NE;EAAsC,gBAAA;Af4/NxC;;Ae5/NE;EAAsC,gBAAA;AfggOxC;;AehgOE;EAAsC,gBAAA;AfogOxC;;AepgOE;EAAsC,gBAAA;AfwgOxC;;AexgOE;EAAsC,gBAAA;Af4gOxC;;Ae5gOE;EAAsC,gBAAA;AfghOxC;;AehhOE;EAAsC,gBAAA;AfohOxC;;AephOE;EAAsC,gBAAA;AfwhOxC;;AexhOE;EAAsC,gBAAA;Af4hOxC;;Ae5hOE;EAAsC,gBAAA;AfgiOxC;;AehiOE;EAAsC,gBAAA;AfoiOxC;;AepiOE;EAAsC,gBAAA;AfwiOxC;;AexiOE;EAAsC,gBAAA;Af4iOxC;;Ae5iOE;EAAsC,gBAAA;AfgjOxC;;AehjOE;EAAsC,gBAAA;AfojOxC;;AepjOE;EAAsC,gBAAA;AfwjOxC;;AexjOE;EAAsC,gBAAA;Af4jOxC;;Ae5jOE;EAAsC,gBAAA;AfgkOxC;;AehkOE;EAAsC,gBAAA;AfokOxC;;AepkOE;EAAsC,gBAAA;AfwkOxC;;AexkOE;EAAsC,gBAAA;Af4kOxC;;Ae5kOE;EAAsC,gBAAA;AfglOxC;;AehlOE;EAAsC,gBAAA;AfolOxC;;AeplOE;EAAsC,gBAAA;AfwlOxC;;AexlOE;EAAsC,gBAAA;Af4lOxC;;Ae5lOE;EAAsC,gBAAA;AfgmOxC;;AehmOE;EAAsC,gBAAA;AfomOxC;;AepmOE;EAAsC,gBAAA;AfwmOxC;;AexmOE;EAAsC,gBAAA;Af4mOxC;;Ae5mOE;EAAsC,gBAAA;AfgnOxC;;AehnOE;EAAsC,gBAAA;AfonOxC;;AepnOE;EAAsC,gBAAA;AfwnOxC;;AexnOE;EAAsC,gBAAA;Af4nOxC;;Ae5nOE;EAAsC,gBAAA;AfgoOxC;;AehoOE;EAAsC,gBAAA;AfooOxC;;AepoOE;EAAsC,gBAAA;AfwoOxC;;AexoOE;EAAsC,gBAAA;Af4oOxC;;Ae5oOE;EAAsC,gBAAA;AfgpOxC;;AehpOE;EAAsC,gBAAA;AfopOxC;;AeppOE;EAAsC,gBAAA;AfwpOxC;;AexpOE;EAAsC,gBAAA;Af4pOxC;;Ae5pOE;EAAsC,gBAAA;AfgqOxC;;AehqOE;EAAsC,gBAAA;AfoqOxC;;AepqOE;EAAsC,gBAAA;AfwqOxC;;AexqOE;EAAsC,gBAAA;Af4qOxC;;Ae5qOE;EAAsC,gBAAA;AfgrOxC;;AehrOE;EAAsC,gBAAA;AforOxC;;AeprOE;EAAsC,gBAAA;AfwrOxC;;AexrOE;EAAsC,gBAAA;Af4rOxC;;Ae5rOE;EAAsC,gBAAA;AfgsOxC;;AehsOE;EAAsC,gBAAA;AfosOxC;;AepsOE;EAAsC,gBAAA;AfwsOxC;;AexsOE;EAAsC,gBAAA;Af4sOxC;;Ae5sOE;EAAsC,gBAAA;AfgtOxC;;AehtOE;EAAsC,gBAAA;AfotOxC;;AeptOE;EAAsC,gBAAA;AfwtOxC;;AextOE;EAAsC,gBAAA;Af4tOxC;;Ae5tOE;EAAsC,gBAAA;AfguOxC;;AehuOE;EAAsC,gBAAA;AfouOxC;;AepuOE;EAAsC,gBAAA;AfwuOxC;;AexuOE;EAAsC,gBAAA;Af4uOxC;;Ae5uOE;EAAsC,gBAAA;AfgvOxC;;AehvOE;EAAsC,gBAAA;AfovOxC;;AepvOE;EAAsC,gBAAA;AfwvOxC;;AexvOE;EAAsC,gBAAA;Af4vOxC;;Ae5vOE;EAAsC,gBAAA;AfgwOxC;;AehwOE;EAAsC,gBAAA;AfowOxC;;AepwOE;EAAsC,gBAAA;AfwwOxC;;AexwOE;EAAsC,gBAAA;Af4wOxC;;Ae5wOE;EAAsC,gBAAA;AfgxOxC;;AehxOE;EAAsC,gBAAA;AfoxOxC;;AepxOE;EAAsC,gBAAA;AfwxOxC;;AexxOE;EAAsC,gBAAA;Af4xOxC;;Ae5xOE;EAAsC,gBAAA;AfgyOxC;;AehyOE;EAAsC,gBAAA;AfoyOxC;;AepyOE;EAAsC,gBAAA;AfwyOxC;;AexyOE;EAAsC,gBAAA;Af4yOxC;;Ae5yOE;EAAsC,gBAAA;AfgzOxC;;AehzOE;EAAsC,gBAAA;AfozOxC;;AepzOE;EAAsC,gBAAA;AfwzOxC;;AexzOE;EAAsC,gBAAA;Af4zOxC;;Ae5zOE;EAAsC,gBAAA;Afg0OxC;;Aeh0OE;EAAsC,gBAAA;Afo0OxC;;Aep0OE;EAAsC,gBAAA;Afw0OxC;;Aex0OE;EAAsC,gBAAA;Af40OxC;;Ae50OE;EAAsC,YAAA;Afg1OxC;;Aeh1OE;EAAsC,gBAAA;Afo1OxC;;Aep1OE;EAAsC,gBAAA;Afw1OxC;;Aex1OE;EAAsC,gBAAA;Af41OxC;;Ae51OE;EAAsC,gBAAA;Afg2OxC;;Aeh2OE;EAAsC,gBAAA;Afo2OxC;;Aep2OE;EAAsC,gBAAA;Afw2OxC;;Aex2OE;EAAsC,gBAAA;Af42OxC;;Ae52OE;EAAsC,gBAAA;Afg3OxC;;Aeh3OE;EAAsC,gBAAA;Afo3OxC;;Aep3OE;EAAsC,gBAAA;Afw3OxC;;Aex3OE;EAAsC,gBAAA;Af43OxC;;Ae53OE;EAAsC,gBAAA;Afg4OxC;;Aeh4OE;EAAsC,gBAAA;Afo4OxC;;Aep4OE;EAAsC,gBAAA;Afw4OxC;;Aex4OE;EAAsC,gBAAA;Af44OxC;;Ae54OE;EAAsC,gBAAA;Afg5OxC;;Aeh5OE;EAAsC,gBAAA;Afo5OxC;;Aep5OE;EAAsC,gBAAA;Afw5OxC;;Aex5OE;EAAsC,gBAAA;Af45OxC;;Ae55OE;EAAsC,gBAAA;Afg6OxC;;Aeh6OE;EAAsC,gBAAA;Afo6OxC;;Aep6OE;EAAsC,gBAAA;Afw6OxC;;Aex6OE;EAAsC,gBAAA;Af46OxC;;Ae56OE;EAAsC,gBAAA;Afg7OxC;;Aeh7OE;EAAsC,gBAAA;Afo7OxC;;Aep7OE;EAAsC,gBAAA;Afw7OxC;;Aex7OE;EAAsC,gBAAA;Af47OxC;;Ae57OE;EAAsC,gBAAA;Afg8OxC;;Aeh8OE;EAAsC,gBAAA;Afo8OxC;;Aep8OE;EAAsC,gBAAA;Afw8OxC;;Aex8OE;EAAsC,aAAA;Af48OxC;;Ae58OE;EAAsC,aAAA;Afg9OxC;;Aeh9OE;EAAsC,gBAAA;Afo9OxC;;Aep9OE;EAAsC,gBAAA;Afw9OxC;;Aex9OE;EAAsC,gBAAA;Af49OxC;;Ae59OE;EAAsC,gBAAA;Afg+OxC;;Aeh+OE;EAAsC,gBAAA;Afo+OxC;;Aep+OE;EAAsC,gBAAA;Afw+OxC;;Aex+OE;EAAsC,gBAAA;Af4+OxC;;Ae5+OE;EAAsC,gBAAA;Afg/OxC;;Aeh/OE;EAAsC,gBAAA;Afo/OxC;;Aep/OE;EAAsC,gBAAA;Afw/OxC;;Aex/OE;EAAsC,gBAAA;Af4/OxC;;Ae5/OE;EAAsC,gBAAA;AfggPxC;;AehgPE;EAAsC,gBAAA;AfogPxC;;AepgPE;EAAsC,gBAAA;AfwgPxC;;AexgPE;EAAsC,gBAAA;Af4gPxC;;Ae5gPE;EAAsC,gBAAA;AfghPxC;;AehhPE;EAAsC,gBAAA;AfohPxC;;AephPE;EAAsC,gBAAA;AfwhPxC;;AexhPE;EAAsC,gBAAA;Af4hPxC;;Ae5hPE;EAAsC,gBAAA;AfgiPxC;;AehiPE;EAAsC,gBAAA;AfoiPxC;;AepiPE;EAAsC,gBAAA;AfwiPxC;;AexiPE;EAAsC,gBAAA;Af4iPxC;;Ae5iPE;EAAsC,gBAAA;AfgjPxC;;AehjPE;EAAsC,aAAA;AfojPxC;;AepjPE;EAAsC,gBAAA;AfwjPxC;;AexjPE;EAAsC,gBAAA;Af4jPxC;;Ae5jPE;EAAsC,gBAAA;AfgkPxC;;AehkPE;EAAsC,gBAAA;AfokPxC;;AepkPE;EAAsC,gBAAA;AfwkPxC;;AexkPE;EAAsC,gBAAA;Af4kPxC;;Ae5kPE;EAAsC,gBAAA;AfglPxC;;AehlPE;EAAsC,gBAAA;AfolPxC;;AeplPE;EAAsC,gBAAA;AfwlPxC;;AexlPE;EAAsC,gBAAA;Af4lPxC;;Ae5lPE;EAAsC,gBAAA;AfgmPxC;;AehmPE;EAAsC,gBAAA;AfomPxC;;AepmPE;EAAsC,gBAAA;AfwmPxC;;AexmPE;EAAsC,gBAAA;Af4mPxC;;Ae5mPE;EAAsC,gBAAA;AfgnPxC;;AehnPE;EAAsC,gBAAA;AfonPxC;;AepnPE;EAAsC,gBAAA;AfwnPxC;;AexnPE;EAAsC,gBAAA;Af4nPxC;;Ae5nPE;EAAsC,gBAAA;AfgoPxC;;AehoPE;EAAsC,gBAAA;AfooPxC;;AepoPE;EAAsC,gBAAA;AfwoPxC;;AexoPE;EAAsC,gBAAA;Af4oPxC;;Ae5oPE;EAAsC,gBAAA;AfgpPxC;;AehpPE;EAAsC,gBAAA;AfopPxC;;AeppPE;EAAsC,gBAAA;AfwpPxC;;AexpPE;EAAsC,gBAAA;Af4pPxC;;Ae5pPE;EAAsC,gBAAA;AfgqPxC;;AehqPE;EAAsC,gBAAA;AfoqPxC;;AepqPE;EAAsC,gBAAA;AfwqPxC;;AexqPE;EAAsC,gBAAA;Af4qPxC;;Ae5qPE;EAAsC,gBAAA;AfgrPxC;;AehrPE;EAAsC,gBAAA;AforPxC;;AeprPE;EAAsC,gBAAA;AfwrPxC;;AexrPE;EAAsC,gBAAA;Af4rPxC;;Ae5rPE;EAAsC,gBAAA;AfgsPxC;;AehsPE;EAAsC,gBAAA;AfosPxC;;AepsPE;EAAsC,gBAAA;AfwsPxC;;AexsPE;EAAsC,gBAAA;Af4sPxC;;Ae5sPE;EAAsC,gBAAA;AfgtPxC;;AehtPE;EAAsC,gBAAA;AfotPxC;;AeptPE;EAAsC,gBAAA;AfwtPxC;;AextPE;EAAsC,gBAAA;Af4tPxC;;Ae5tPE;EAAsC,gBAAA;AfguPxC;;AehuPE;EAAsC,gBAAA;AfouPxC;;AepuPE;EAAsC,gBAAA;AfwuPxC;;AexuPE;EAAsC,gBAAA;Af4uPxC;;Ae5uPE;EAAsC,gBAAA;AfgvPxC;;AehvPE;EAAsC,gBAAA;AfovPxC;;AepvPE;EAAsC,aAAA;AfwvPxC;;AexvPE;EAAsC,aAAA;Af4vPxC;;Ae5vPE;EAAsC,gBAAA;AfgwPxC;;AehwPE;EAAsC,gBAAA;AfowPxC;;AepwPE;EAAsC,gBAAA;AfwwPxC;;AexwPE;EAAsC,gBAAA;Af4wPxC;;Ae5wPE;EAAsC,gBAAA;AfgxPxC;;AehxPE;EAAsC,gBAAA;AfoxPxC;;AepxPE;EAAsC,gBAAA;AfwxPxC;;AexxPE;EAAsC,gBAAA;Af4xPxC;;Ae5xPE;EAAsC,gBAAA;AfgyPxC;;AehyPE;EAAsC,gBAAA;AfoyPxC;;AepyPE;EAAsC,gBAAA;AfwyPxC;;AexyPE;EAAsC,gBAAA;Af4yPxC;;Ae5yPE;EAAsC,gBAAA;AfgzPxC;;AehzPE;EAAsC,gBAAA;AfozPxC;;AepzPE;EAAsC,gBAAA;AfwzPxC;;AexzPE;EAAsC,gBAAA;Af4zPxC;;Ae5zPE;EAAsC,gBAAA;Afg0PxC;;Aeh0PE;EAAsC,gBAAA;Afo0PxC;;Aep0PE;EAAsC,gBAAA;Afw0PxC;;Aex0PE;EAAsC,gBAAA;Af40PxC;;Ae50PE;EAAsC,gBAAA;Afg1PxC;;Aeh1PE;EAAsC,gBAAA;Afo1PxC;;Aep1PE;EAAsC,gBAAA;Afw1PxC;;Aex1PE;EAAsC,gBAAA;Af41PxC;;Ae51PE;EAAsC,gBAAA;Afg2PxC;;Aeh2PE;EAAsC,gBAAA;Afo2PxC;;Aep2PE;EAAsC,gBAAA;Afw2PxC;;Aex2PE;EAAsC,gBAAA;Af42PxC;;Ae52PE;EAAsC,gBAAA;Afg3PxC;;Aeh3PE;EAAsC,gBAAA;Afo3PxC;;Aep3PE;EAAsC,gBAAA;Afw3PxC;;Aex3PE;EAAsC,gBAAA;Af43PxC;;Ae53PE;EAAsC,gBAAA;Afg4PxC;;Aeh4PE;EAAsC,gBAAA;Afo4PxC;;Aep4PE;EAAsC,gBAAA;Afw4PxC;;Aex4PE;EAAsC,gBAAA;Af44PxC;;Ae54PE;EAAsC,gBAAA;Afg5PxC;;Aeh5PE;EAAsC,gBAAA;Afo5PxC;;Aep5PE;EAAsC,gBAAA;Afw5PxC;;Aex5PE;EAAsC,gBAAA;Af45PxC;;Ae55PE;EAAsC,gBAAA;Afg6PxC;;Aeh6PE;EAAsC,gBAAA;Afo6PxC;;Aep6PE;EAAsC,gBAAA;Afw6PxC;;Aex6PE;EAAsC,gBAAA;Af46PxC;;Ae56PE;EAAsC,gBAAA;Afg7PxC;;Aeh7PE;EAAsC,gBAAA;Afo7PxC;;Aep7PE;EAAsC,gBAAA;Afw7PxC;;Aex7PE;EAAsC,gBAAA;Af47PxC;;Ae57PE;EAAsC,gBAAA;Afg8PxC;;Aeh8PE;EAAsC,gBAAA;Afo8PxC;;Aep8PE;EAAsC,gBAAA;Afw8PxC;;Aex8PE;EAAsC,gBAAA;Af48PxC;;Ae58PE;EAAsC,gBAAA;Afg9PxC;;Aeh9PE;EAAsC,gBAAA;Afo9PxC;;Aep9PE;EAAsC,gBAAA;Afw9PxC;;Aex9PE;EAAsC,gBAAA;Af49PxC;;Ae59PE;EAAsC,gBAAA;Afg+PxC;;Aeh+PE;EAAsC,gBAAA;Afo+PxC;;Aep+PE;EAAsC,gBAAA;Afw+PxC;;Aex+PE;EAAsC,gBAAA;Af4+PxC;;Ae5+PE;EAAsC,gBAAA;Afg/PxC;;Aeh/PE;EAAsC,gBAAA;Afo/PxC;;Aep/PE;EAAsC,gBAAA;Afw/PxC;;Aex/PE;EAAsC,gBAAA;Af4/PxC;;Ae5/PE;EAAsC,gBAAA;AfggQxC;;AehgQE;EAAsC,gBAAA;AfogQxC;;AepgQE;EAAsC,gBAAA;AfwgQxC;;AexgQE;EAAsC,gBAAA;Af4gQxC;;Ae5gQE;EAAsC,gBAAA;AfghQxC;;AehhQE;EAAsC,gBAAA;AfohQxC;;AephQE;EAAsC,gBAAA;AfwhQxC;;AexhQE;EAAsC,gBAAA;Af4hQxC;;Ae5hQE;EAAsC,gBAAA;AfgiQxC;;AehiQE;EAAsC,gBAAA;AfoiQxC;;AepiQE;EAAsC,gBAAA;AfwiQxC;;AexiQE;EAAsC,gBAAA;Af4iQxC;;Ae5iQE;EAAsC,gBAAA;AfgjQxC;;AehjQE;EAAsC,gBAAA;AfojQxC;;AepjQE;EAAsC,gBAAA;AfwjQxC;;AexjQE;EAAsC,gBAAA;Af4jQxC;;Ae5jQE;EAAsC,aAAA;AfgkQxC;;AehkQE;EAAsC,gBAAA;AfokQxC;;AepkQE;EAAsC,gBAAA;AfwkQxC;;AexkQE;EAAsC,gBAAA;Af4kQxC;;Ae5kQE;EAAsC,YAAA;AfglQxC;;AehlQE;EAAsC,gBAAA;AfolQxC;;AeplQE;EAAsC,gBAAA;AfwlQxC;;AexlQE;EAAsC,gBAAA;Af4lQxC;;Ae5lQE;EAAsC,gBAAA;AfgmQxC;;AehmQE;EAAsC,gBAAA;AfomQxC;;AepmQE;EAAsC,gBAAA;AfwmQxC;;AexmQE;EAAsC,gBAAA;Af4mQxC;;Ae5mQE;EAAsC,gBAAA;AfgnQxC;;AehnQE;EAAsC,gBAAA;AfonQxC;;AepnQE;EAAsC,gBAAA;AfwnQxC;;AexnQE;EAAsC,gBAAA;Af4nQxC;;Ae5nQE;EAAsC,gBAAA;AfgoQxC;;AehoQE;EAAsC,gBAAA;AfooQxC;;AepoQE;EAAsC,gBAAA;AfwoQxC;;AexoQE;EAAsC,gBAAA;Af4oQxC;;Ae5oQE;EAAsC,gBAAA;AfgpQxC;;AehpQE;EAAsC,gBAAA;AfopQxC;;AeppQE;EAAsC,gBAAA;AfwpQxC;;AexpQE;EAAsC,gBAAA;Af4pQxC;;Ae5pQE;EAAsC,gBAAA;AfgqQxC;;AehqQE;EAAsC,gBAAA;AfoqQxC;;AepqQE;EAAsC,gBAAA;AfwqQxC;;AexqQE;EAAsC,gBAAA;Af4qQxC;;Ae5qQE;EAAsC,gBAAA;AfgrQxC;;AehrQE;EAAsC,gBAAA;AforQxC;;AeprQE;EAAsC,gBAAA;AfwrQxC;;AexrQE;EAAsC,gBAAA;Af4rQxC;;Ae5rQE;EAAsC,gBAAA;AfgsQxC;;AehsQE;EAAsC,gBAAA;AfosQxC;;AepsQE;EAAsC,gBAAA;AfwsQxC;;AexsQE;EAAsC,gBAAA;Af4sQxC;;Ae5sQE;EAAsC,gBAAA;AfgtQxC;;AehtQE;EAAsC,gBAAA;AfotQxC;;AeptQE;EAAsC,gBAAA;AfwtQxC;;AextQE;EAAsC,gBAAA;Af4tQxC;;Ae5tQE;EAAsC,gBAAA;AfguQxC;;AehuQE;EAAsC,gBAAA;AfouQxC;;AepuQE;EAAsC,gBAAA;AfwuQxC;;AexuQE;EAAsC,gBAAA;Af4uQxC;;Ae5uQE;EAAsC,gBAAA;AfgvQxC;;AehvQE;EAAsC,gBAAA;AfovQxC;;AepvQE;EAAsC,gBAAA;AfwvQxC;;AexvQE;EAAsC,gBAAA;Af4vQxC;;Ae5vQE;EAAsC,gBAAA;AfgwQxC;;AehwQE;EAAsC,gBAAA;AfowQxC;;AepwQE;EAAsC,gBAAA;AfwwQxC;;AexwQE;EAAsC,gBAAA;Af4wQxC;;Ae5wQE;EAAsC,gBAAA;AfgxQxC;;AehxQE;EAAsC,gBAAA;AfoxQxC;;AepxQE;EAAsC,gBAAA;AfwxQxC;;AexxQE;EAAsC,gBAAA;Af4xQxC;;Ae5xQE;EAAsC,gBAAA;AfgyQxC;;AehyQE;EAAsC,gBAAA;AfoyQxC;;AepyQE;EAAsC,gBAAA;AfwyQxC;;AexyQE;EAAsC,gBAAA;Af4yQxC;;Ae5yQE;EAAsC,YAAA;AfgzQxC;;AehzQE;EAAsC,gBAAA;AfozQxC;;AepzQE;EAAsC,gBAAA;AfwzQxC;;AexzQE;EAAsC,gBAAA;Af4zQxC;;Ae5zQE;EAAsC,gBAAA;Afg0QxC;;Aeh0QE;EAAsC,gBAAA;Afo0QxC;;Aep0QE;EAAsC,gBAAA;Afw0QxC;;Aex0QE;EAAsC,gBAAA;Af40QxC;;Ae50QE;EAAsC,gBAAA;Afg1QxC;;Aeh1QE;EAAsC,gBAAA;Afo1QxC;;Aep1QE;EAAsC,gBAAA;Afw1QxC;;Aex1QE;EAAsC,gBAAA;Af41QxC;;Ae51QE;EAAsC,gBAAA;Afg2QxC;;Aeh2QE;EAAsC,gBAAA;Afo2QxC;;Aep2QE;EAAsC,gBAAA;Afw2QxC;;Aex2QE;EAAsC,gBAAA;Af42QxC;;Ae52QE;EAAsC,gBAAA;Afg3QxC;;Aeh3QE;EAAsC,gBAAA;Afo3QxC;;Aep3QE;EAAsC,gBAAA;Afw3QxC;;Aex3QE;EAAsC,gBAAA;Af43QxC;;Ae53QE;EAAsC,gBAAA;Afg4QxC;;Aeh4QE;EAAsC,gBAAA;Afo4QxC;;Aep4QE;EAAsC,gBAAA;Afw4QxC;;Aex4QE;EAAsC,gBAAA;Af44QxC;;Ae54QE;EAAsC,gBAAA;Afg5QxC;;Aeh5QE;EAAsC,gBAAA;Afo5QxC;;Aep5QE;EAAsC,gBAAA;Afw5QxC;;Aex5QE;EAAsC,gBAAA;Af45QxC;;Ae55QE;EAAsC,gBAAA;Afg6QxC;;Aeh6QE;EAAsC,gBAAA;Afo6QxC;;Aep6QE;EAAsC,gBAAA;Afw6QxC;;Aex6QE;EAAsC,gBAAA;Af46QxC;;Ae56QE;EAAsC,gBAAA;Afg7QxC;;Aeh7QE;EAAsC,gBAAA;Afo7QxC;;Aep7QE;EAAsC,gBAAA;Afw7QxC;;Aex7QE;EAAsC,gBAAA;Af47QxC;;Ae57QE;EAAsC,gBAAA;Afg8QxC;;Aeh8QE;EAAsC,gBAAA;Afo8QxC;;Aep8QE;EAAsC,gBAAA;Afw8QxC;;Aex8QE;EAAsC,gBAAA;Af48QxC;;Ae58QE;EAAsC,gBAAA;Afg9QxC;;Aeh9QE;EAAsC,gBAAA;Afo9QxC;;Aep9QE;EAAsC,gBAAA;Afw9QxC;;Aex9QE;EAAsC,gBAAA;Af49QxC;;Ae59QE;EAAsC,gBAAA;Afg+QxC;;Aeh+QE;EAAsC,gBAAA;Afo+QxC;;Aep+QE;EAAsC,gBAAA;Afw+QxC;;Aex+QE;EAAsC,gBAAA;Af4+QxC;;Ae5+QE;EAAsC,gBAAA;Afg/QxC;;Aeh/QE;EAAsC,gBAAA;Afo/QxC;;Aep/QE;EAAsC,gBAAA;Afw/QxC;;Aex/QE;EAAsC,gBAAA;Af4/QxC;;Ae5/QE;EAAsC,gBAAA;AfggRxC;;AehgRE;EAAsC,gBAAA;AfogRxC;;AepgRE;EAAsC,gBAAA;AfwgRxC;;AexgRE;EAAsC,gBAAA;Af4gRxC;;Ae5gRE;EAAsC,gBAAA;AfghRxC;;AehhRE;EAAsC,gBAAA;AfohRxC;;AephRE;EAAsC,gBAAA;AfwhRxC;;AexhRE;EAAsC,gBAAA;Af4hRxC;;Ae5hRE;EAAsC,gBAAA;AfgiRxC;;AehiRE;EAAsC,gBAAA;AfoiRxC;;AepiRE;EAAsC,gBAAA;AfwiRxC;;AexiRE;EAAsC,gBAAA;Af4iRxC;;Ae5iRE;EAAsC,gBAAA;AfgjRxC;;AehjRE;EAAsC,gBAAA;AfojRxC;;AepjRE;EAAsC,gBAAA;AfwjRxC;;AexjRE;EAAsC,gBAAA;Af4jRxC;;Ae5jRE;EAAsC,gBAAA;AfgkRxC;;AehkRE;EAAsC,gBAAA;AfokRxC;;AepkRE;EAAsC,gBAAA;AfwkRxC;;AexkRE;EAAsC,gBAAA;Af4kRxC;;Ae5kRE;EAAsC,gBAAA;AfglRxC;;AehlRE;EAAsC,gBAAA;AfolRxC;;AeplRE;EAAsC,gBAAA;AfwlRxC;;AexlRE;EAAsC,gBAAA;Af4lRxC;;Ae5lRE;EAAsC,gBAAA;AfgmRxC;;AehmRE;EAAsC,gBAAA;AfomRxC;;AepmRE;EAAsC,gBAAA;AfwmRxC;;AexmRE;EAAsC,gBAAA;Af4mRxC;;Ae5mRE;EAAsC,gBAAA;AfgnRxC;;AehnRE;EAAsC,gBAAA;AfonRxC;;AepnRE;EAAsC,gBAAA;AfwnRxC;;AexnRE;EAAsC,gBAAA;Af4nRxC;;Ae5nRE;EAAsC,gBAAA;AfgoRxC;;AehoRE;EAAsC,gBAAA;AfooRxC;;AepoRE;EAAsC,gBAAA;AfwoRxC;;AexoRE;EAAsC,gBAAA;Af4oRxC;;Ae5oRE;EAAsC,gBAAA;AfgpRxC;;AehpRE;EAAsC,gBAAA;AfopRxC;;AeppRE;EAAsC,gBAAA;AfwpRxC;;AexpRE;EAAsC,gBAAA;Af4pRxC;;Ae5pRE;EAAsC,gBAAA;AfgqRxC;;AehqRE;EAAsC,gBAAA;AfoqRxC;;AepqRE;EAAsC,gBAAA;AfwqRxC;;AexqRE;EAAsC,gBAAA;Af4qRxC;;Ae5qRE;EAAsC,gBAAA;AfgrRxC;;AehrRE;EAAsC,gBAAA;AforRxC;;AeprRE;EAAsC,gBAAA;AfwrRxC;;AexrRE;EAAsC,gBAAA;Af4rRxC;;Ae5rRE;EAAsC,gBAAA;AfgsRxC;;AehsRE;EAAsC,gBAAA;AfosRxC;;AepsRE;EAAsC,gBAAA;AfwsRxC;;AexsRE;EAAsC,gBAAA;Af4sRxC;;Ae5sRE;EAAsC,gBAAA;AfgtRxC;;AehtRE;EAAsC,gBAAA;AfotRxC;;AeptRE;EAAsC,gBAAA;AfwtRxC;;AextRE;EAAsC,gBAAA;Af4tRxC;;Ae5tRE;EAAsC,gBAAA;AfguRxC;;AehuRE;EAAsC,gBAAA;AfouRxC;;AepuRE;EAAsC,gBAAA;AfwuRxC;;AexuRE;EAAsC,gBAAA;Af4uRxC;;Ae5uRE;EAAsC,gBAAA;AfgvRxC;;AehvRE;EAAsC,gBAAA;AfovRxC;;AepvRE;EAAsC,gBAAA;AfwvRxC;;AexvRE;EAAsC,gBAAA;Af4vRxC;;Ae5vRE;EAAsC,gBAAA;AfgwRxC;;AehwRE;EAAsC,gBAAA;AfowRxC;;AepwRE;EAAsC,gBAAA;AfwwRxC;;AexwRE;EAAsC,gBAAA;Af4wRxC;;Ae5wRE;EAAsC,gBAAA;AfgxRxC;;AehxRE;EAAsC,gBAAA;AfoxRxC;;AepxRE;EAAsC,gBAAA;AfwxRxC;;AexxRE;EAAsC,aAAA;Af4xRxC;;Ae5xRE;EAAsC,gBAAA;AfgyRxC;;AehyRE;EAAsC,gBAAA;AfoyRxC;;AepyRE;EAAsC,gBAAA;AfwyRxC;;AexyRE;EAAsC,gBAAA;Af4yRxC;;Ae5yRE;EAAsC,gBAAA;AfgzRxC;;AehzRE;EAAsC,aAAA;AfozRxC;;AepzRE;EAAsC,aAAA;AfwzRxC;;AexzRE;EAAsC,aAAA;Af4zRxC;;Ae5zRE;EAAsC,YAAA;Afg0RxC;;Aeh0RE;EAAsC,gBAAA;Afo0RxC;;Aep0RE;EAAsC,gBAAA;Afw0RxC;;Aex0RE;EAAsC,gBAAA;Af40RxC;;Ae50RE;EAAsC,gBAAA;Afg1RxC;;Aeh1RE;EAAsC,gBAAA;Afo1RxC;;Aep1RE;EAAsC,gBAAA;Afw1RxC;;Aex1RE;EAAsC,gBAAA;Af41RxC;;Ae51RE;EAAsC,gBAAA;Afg2RxC;;Aeh2RE;EAAsC,gBAAA;Afo2RxC;;Aep2RE;EAAsC,gBAAA;Afw2RxC;;Aex2RE;EAAsC,gBAAA;Af42RxC;;Ae52RE;EAAsC,gBAAA;Afg3RxC;;Aeh3RE;EAAsC,YAAA;Afo3RxC;;Aep3RE;EAAsC,gBAAA;Afw3RxC;;Aex3RE;EAAsC,gBAAA;Af43RxC;;Ae53RE;EAAsC,gBAAA;Afg4RxC;;Aeh4RE;EAAsC,gBAAA;Afo4RxC;;Aep4RE;EAAsC,gBAAA;Afw4RxC;;Aex4RE;EAAsC,gBAAA;Af44RxC;;Ae54RE;EAAsC,gBAAA;Afg5RxC;;Aeh5RE;EAAsC,gBAAA;Afo5RxC;;Aep5RE;EAAsC,gBAAA;Afw5RxC;;Aex5RE;EAAsC,gBAAA;Af45RxC;;Ae55RE;EAAsC,gBAAA;Afg6RxC;;Aeh6RE;EAAsC,gBAAA;Afo6RxC;;Aep6RE;EAAsC,gBAAA;Afw6RxC;;Aex6RE;EAAsC,gBAAA;Af46RxC;;Ae56RE;EAAsC,gBAAA;Afg7RxC;;Aeh7RE;EAAsC,gBAAA;Afo7RxC;;Aep7RE;EAAsC,gBAAA;Afw7RxC;;Aex7RE;EAAsC,gBAAA;Af47RxC;;Ae57RE;EAAsC,gBAAA;Afg8RxC;;Aeh8RE;EAAsC,gBAAA;Afo8RxC;;Aep8RE;EAAsC,gBAAA;Afw8RxC;;AgB38RA;;ETqBE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AP27RF;;AOt7RE;;EAbA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;APw8RF;;AiBz+RA;;;;EAAA;AAQA;EACE,gDAAA;EACA,uDAAA;AjBy+RF;;AiBt+RA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBR8BwB;EQ7BxB,wHAAA;AjBy+RF;AiBr+RA;;EAEE,gBAAA;AjBu+RF;;AkB//RA;;;;EAAA;AAQA;EACE,iDAAA;EACA,0DAAA;AlB+/RF;;AkB5/RA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBT8BwB;ES7BxB,wHAAA;AlB+/RF;AkB3/RA;;EAEE,gBAAA;AlB6/RF;;AkBz/RE;EAAqC,gBAAA;AlB6/RvC;;AkB7/RE;EAAqC,gBAAA;AlBigSvC;;AkBjgSE;EAAqC,gBAAA;AlBqgSvC;;AkBrgSE;EAAqC,gBAAA;AlBygSvC;;AkBzgSE;EAAqC,gBAAA;AlB6gSvC;;AkB7gSE;EAAqC,gBAAA;AlBihSvC;;AkBjhSE;EAAqC,gBAAA;AlBqhSvC;;AkBrhSE;EAAqC,gBAAA;AlByhSvC;;AkBzhSE;EAAqC,gBAAA;AlB6hSvC;;AkB7hSE;EAAqC,gBAAA;AlBiiSvC;;AkBjiSE;EAAqC,gBAAA;AlBqiSvC;;AkBriSE;EAAqC,gBAAA;AlByiSvC;;AkBziSE;EAAqC,gBAAA;AlB6iSvC;;AkB7iSE;EAAqC,gBAAA;AlBijSvC;;AkBjjSE;EAAqC,gBAAA;AlBqjSvC;;AkBrjSE;EAAqC,gBAAA;AlByjSvC;;AkBzjSE;EAAqC,gBAAA;AlB6jSvC;;AkB7jSE;EAAqC,gBAAA;AlBikSvC;;AkBjkSE;EAAqC,gBAAA;AlBqkSvC;;AkBrkSE;EAAqC,gBAAA;AlBykSvC;;AkBzkSE;EAAqC,gBAAA;AlB6kSvC;;AkB7kSE;EAAqC,gBAAA;AlBilSvC;;AkBjlSE;EAAqC,gBAAA;AlBqlSvC;;AkBrlSE;EAAqC,gBAAA;AlBylSvC;;AkBzlSE;EAAqC,gBAAA;AlB6lSvC;;AkB7lSE;EAAqC,gBAAA;AlBimSvC;;AkBjmSE;EAAqC,gBAAA;AlBqmSvC;;AkBrmSE;EAAqC,gBAAA;AlBymSvC;;AkBzmSE;EAAqC,gBAAA;AlB6mSvC;;AkB7mSE;EAAqC,gBAAA;AlBinSvC;;AkBjnSE;EAAqC,gBAAA;AlBqnSvC;;AkBrnSE;EAAqC,gBAAA;AlBynSvC;;AkBznSE;EAAqC,gBAAA;AlB6nSvC;;AkB7nSE;EAAqC,gBAAA;AlBioSvC;;AkBjoSE;EAAqC,gBAAA;AlBqoSvC;;AkBroSE;EAAqC,gBAAA;AlByoSvC;;AkBzoSE;EAAqC,gBAAA;AlB6oSvC;;AkB7oSE;EAAqC,gBAAA;AlBipSvC;;AkBjpSE;EAAqC,gBAAA;AlBqpSvC;;AkBrpSE;EAAqC,gBAAA;AlBypSvC;;AkBzpSE;EAAqC,gBAAA;AlB6pSvC;;AkB7pSE;EAAqC,gBAAA;AlBiqSvC;;AkBjqSE;EAAqC,gBAAA;AlBqqSvC;;AkBrqSE;EAAqC,gBAAA;AlByqSvC;;AkBzqSE;EAAqC,gBAAA;AlB6qSvC;;AkB7qSE;EAAqC,gBAAA;AlBirSvC;;AkBjrSE;EAAqC,gBAAA;AlBqrSvC;;AkBrrSE;EAAqC,gBAAA;AlByrSvC;;AkBzrSE;EAAqC,gBAAA;AlB6rSvC;;AkB7rSE;EAAqC,gBAAA;AlBisSvC;;AkBjsSE;EAAqC,gBAAA;AlBqsSvC;;AkBrsSE;EAAqC,gBAAA;AlBysSvC;;AkBzsSE;EAAqC,gBAAA;AlB6sSvC;;AkB7sSE;EAAqC,gBAAA;AlBitSvC;;AkBjtSE;EAAqC,gBAAA;AlBqtSvC;;AkBrtSE;EAAqC,gBAAA;AlBytSvC;;AkBztSE;EAAqC,gBAAA;AlB6tSvC;;AkB7tSE;EAAqC,gBAAA;AlBiuSvC;;AkBjuSE;EAAqC,gBAAA;AlBquSvC;;AkBruSE;EAAqC,gBAAA;AlByuSvC;;AkBzuSE;EAAqC,gBAAA;AlB6uSvC;;AkB7uSE;EAAqC,gBAAA;AlBivSvC;;AkBjvSE;EAAqC,gBAAA;AlBqvSvC;;AkBrvSE;EAAqC,gBAAA;AlByvSvC;;AkBzvSE;EAAqC,gBAAA;AlB6vSvC;;AkB7vSE;EAAqC,gBAAA;AlBiwSvC;;AkBjwSE;EAAqC,gBAAA;AlBqwSvC;;AkBrwSE;EAAqC,gBAAA;AlBywSvC;;AkBzwSE;EAAqC,gBAAA;AlB6wSvC;;AkB7wSE;EAAqC,gBAAA;AlBixSvC;;AkBjxSE;EAAqC,gBAAA;AlBqxSvC;;AkBrxSE;EAAqC,gBAAA;AlByxSvC;;AkBzxSE;EAAqC,gBAAA;AlB6xSvC;;AkB7xSE;EAAqC,gBAAA;AlBiySvC;;AkBjySE;EAAqC,gBAAA;AlBqySvC;;AkBrySE;EAAqC,gBAAA;AlByySvC;;AkBzySE;EAAqC,gBAAA;AlB6ySvC;;AkB7ySE;EAAqC,gBAAA;AlBizSvC;;AkBjzSE;EAAqC,gBAAA;AlBqzSvC;;AkBrzSE;EAAqC,gBAAA;AlByzSvC;;AkBzzSE;EAAqC,gBAAA;AlB6zSvC;;AkB7zSE;EAAqC,gBAAA;AlBi0SvC;;AkBj0SE;EAAqC,gBAAA;AlBq0SvC;;AkBr0SE;EAAqC,gBAAA;AlBy0SvC;;AkBz0SE;EAAqC,gBAAA;AlB60SvC;;AkB70SE;EAAqC,gBAAA;AlBi1SvC;;AkBj1SE;EAAqC,gBAAA;AlBq1SvC;;AkBr1SE;EAAqC,gBAAA;AlBy1SvC;;AkBz1SE;EAAqC,gBAAA;AlB61SvC;;AkB71SE;EAAqC,gBAAA;AlBi2SvC;;AkBj2SE;EAAqC,gBAAA;AlBq2SvC;;AkBr2SE;EAAqC,gBAAA;AlBy2SvC;;AkBz2SE;EAAqC,gBAAA;AlB62SvC;;AkB72SE;EAAqC,gBAAA;AlBi3SvC;;AkBj3SE;EAAqC,gBAAA;AlBq3SvC;;AkBr3SE;EAAqC,gBAAA;AlBy3SvC;;AkBz3SE;EAAqC,gBAAA;AlB63SvC;;AkB73SE;EAAqC,gBAAA;AlBi4SvC;;AkBj4SE;EAAqC,gBAAA;AlBq4SvC;;AkBr4SE;EAAqC,gBAAA;AlBy4SvC;;AkBz4SE;EAAqC,gBAAA;AlB64SvC;;AkB74SE;EAAqC,gBAAA;AlBi5SvC;;AkBj5SE;EAAqC,gBAAA;AlBq5SvC;;AkBr5SE;EAAqC,gBAAA;AlBy5SvC;;AkBz5SE;EAAqC,gBAAA;AlB65SvC;;AkB75SE;EAAqC,gBAAA;AlBi6SvC;;AkBj6SE;EAAqC,gBAAA;AlBq6SvC;;AkBr6SE;EAAqC,gBAAA;AlBy6SvC;;AkBz6SE;EAAqC,gBAAA;AlB66SvC;;AkB76SE;EAAqC,gBAAA;AlBi7SvC;;AkBj7SE;EAAqC,gBAAA;AlBq7SvC;;AkBr7SE;EAAqC,gBAAA;AlBy7SvC;;AkBz7SE;EAAqC,gBAAA;AlB67SvC;;AkB77SE;EAAqC,gBAAA;AlBi8SvC;;AkBj8SE;EAAqC,gBAAA;AlBq8SvC;;AkBr8SE;EAAqC,gBAAA;AlBy8SvC;;AkBz8SE;EAAqC,gBAAA;AlB68SvC;;AkB78SE;EAAqC,gBAAA;AlBi9SvC;;AkBj9SE;EAAqC,gBAAA;AlBq9SvC;;AkBr9SE;EAAqC,gBAAA;AlBy9SvC;;AkBz9SE;EAAqC,gBAAA;AlB69SvC;;AkB79SE;EAAqC,gBAAA;AlBi+SvC;;AkBj+SE;EAAqC,gBAAA;AlBq+SvC;;AkBr+SE;EAAqC,gBAAA;AlBy+SvC;;AkBz+SE;EAAqC,gBAAA;AlB6+SvC;;AkB7+SE;EAAqC,gBAAA;AlBi/SvC;;AkBj/SE;EAAqC,gBAAA;AlBq/SvC;;AkBr/SE;EAAqC,gBAAA;AlBy/SvC;;AkBz/SE;EAAqC,gBAAA;AlB6/SvC;;AkB7/SE;EAAqC,gBAAA;AlBigTvC;;AkBjgTE;EAAqC,gBAAA;AlBqgTvC;;AkBrgTE;EAAqC,gBAAA;AlBygTvC;;AkBzgTE;EAAqC,gBAAA;AlB6gTvC;;AkB7gTE;EAAqC,gBAAA;AlBihTvC;;AkBjhTE;EAAqC,gBAAA;AlBqhTvC;;AkBrhTE;EAAqC,gBAAA;AlByhTvC;;AkBzhTE;EAAqC,gBAAA;AlB6hTvC;;AkB7hTE;EAAqC,gBAAA;AlBiiTvC;;AkBjiTE;EAAqC,gBAAA;AlBqiTvC;;AkBriTE;EAAqC,gBAAA;AlByiTvC;;AkBziTE;EAAqC,gBAAA;AlB6iTvC;;AkB7iTE;EAAqC,gBAAA;AlBijTvC;;AkBjjTE;EAAqC,gBAAA;AlBqjTvC;;AkBrjTE;EAAqC,gBAAA;AlByjTvC;;AkBzjTE;EAAqC,gBAAA;AlB6jTvC;;AkB7jTE;EAAqC,gBAAA;AlBikTvC;;AkBjkTE;EAAqC,gBAAA;AlBqkTvC;;AkBrkTE;EAAqC,gBAAA;AlBykTvC;;AkBzkTE;EAAqC,gBAAA;AlB6kTvC;;AkB7kTE;EAAqC,gBAAA;AlBilTvC;;AkBjlTE;EAAqC,gBAAA;AlBqlTvC;;AkBrlTE;EAAqC,gBAAA;AlBylTvC;;AkBzlTE;EAAqC,gBAAA;AlB6lTvC;;AkB7lTE;EAAqC,gBAAA;AlBimTvC;;AkBjmTE;EAAqC,gBAAA;AlBqmTvC;;AkBrmTE;EAAqC,gBAAA;AlBymTvC;;AkBzmTE;EAAqC,gBAAA;AlB6mTvC;;AkB7mTE;EAAqC,gBAAA;AlBinTvC;;AkBjnTE;EAAqC,gBAAA;AlBqnTvC;;AkBrnTE;EAAqC,gBAAA;AlBynTvC;;AkBznTE;EAAqC,gBAAA;AlB6nTvC;;AkB7nTE;EAAqC,gBAAA;AlBioTvC;;AkBjoTE;EAAqC,gBAAA;AlBqoTvC;;AkBroTE;EAAqC,gBAAA;AlByoTvC;;AkBzoTE;EAAqC,gBAAA;AlB6oTvC;;AkB7oTE;EAAqC,gBAAA;AlBipTvC;;AkBjpTE;EAAqC,gBAAA;AlBqpTvC;;AkBrpTE;EAAqC,gBAAA;AlBypTvC;;AkBzpTE;EAAqC,gBAAA;AlB6pTvC;;AkB7pTE;EAAqC,gBAAA;AlBiqTvC;;AkBjqTE;EAAqC,gBAAA;AlBqqTvC;;AkBrqTE;EAAqC,gBAAA;AlByqTvC;;AkBzqTE;EAAqC,gBAAA;AlB6qTvC;;AkB7qTE;EAAqC,gBAAA;AlBirTvC;;AkBjrTE;EAAqC,gBAAA;AlBqrTvC;;AkBrrTE;EAAqC,gBAAA;AlByrTvC;;AkBzrTE;EAAqC,gBAAA;AlB6rTvC;;AkB7rTE;EAAqC,gBAAA;AlBisTvC;;AkBjsTE;EAAqC,gBAAA;AlBqsTvC;;AkBrsTE;EAAqC,gBAAA;AlBysTvC;;AkBzsTE;EAAqC,gBAAA;AlB6sTvC;;AkB7sTE;EAAqC,gBAAA;AlBitTvC;;AkBjtTE;EAAqC,gBAAA;AlBqtTvC;;AkBrtTE;EAAqC,gBAAA;AlBytTvC;;AkBztTE;EAAqC,gBAAA;AlB6tTvC;;AkB7tTE;EAAqC,gBAAA;AlBiuTvC;;AkBjuTE;EAAqC,gBAAA;AlBquTvC;;AkBruTE;EAAqC,gBAAA;AlByuTvC;;AkBzuTE;EAAqC,gBAAA;AlB6uTvC;;AkB7uTE;EAAqC,gBAAA;AlBivTvC;;AkBjvTE;EAAqC,gBAAA;AlBqvTvC;;AkBrvTE;EAAqC,gBAAA;AlByvTvC;;AkBzvTE;EAAqC,gBAAA;AlB6vTvC;;AkB7vTE;EAAqC,gBAAA;AlBiwTvC;;AkBjwTE;EAAqC,gBAAA;AlBqwTvC;;AkBrwTE;EAAqC,gBAAA;AlBywTvC;;AkBzwTE;EAAqC,gBAAA;AlB6wTvC;;AkB7wTE;EAAqC,gBAAA;AlBixTvC;;AkBjxTE;EAAqC,gBAAA;AlBqxTvC;;AkBrxTE;EAAqC,gBAAA;AlByxTvC;;AkBzxTE;EAAqC,gBAAA;AlB6xTvC;;AkB7xTE;EAAqC,gBAAA;AlBiyTvC;;AkBjyTE;EAAqC,gBAAA;AlBqyTvC;;AkBryTE;EAAqC,gBAAA;AlByyTvC;;AkBzyTE;EAAqC,gBAAA;AlB6yTvC;;AkB7yTE;EAAqC,gBAAA;AlBizTvC;;AkBjzTE;EAAqC,gBAAA;AlBqzTvC;;AkBrzTE;EAAqC,gBAAA;AlByzTvC;;AkBzzTE;EAAqC,gBAAA;AlB6zTvC;;AkB7zTE;EAAqC,gBAAA;AlBi0TvC;;AkBj0TE;EAAqC,gBAAA;AlBq0TvC;;AkBr0TE;EAAqC,gBAAA;AlBy0TvC;;AkBz0TE;EAAqC,gBAAA;AlB60TvC;;AkB70TE;EAAqC,gBAAA;AlBi1TvC;;AkBj1TE;EAAqC,gBAAA;AlBq1TvC;;AkBr1TE;EAAqC,gBAAA;AlBy1TvC;;AkBz1TE;EAAqC,gBAAA;AlB61TvC;;AkB71TE;EAAqC,gBAAA;AlBi2TvC;;AkBj2TE;EAAqC,gBAAA;AlBq2TvC;;AkBr2TE;EAAqC,gBAAA;AlBy2TvC;;AkBz2TE;EAAqC,gBAAA;AlB62TvC;;AkB72TE;EAAqC,gBAAA;AlBi3TvC;;AkBj3TE;EAAqC,gBAAA;AlBq3TvC;;AkBr3TE;EAAqC,gBAAA;AlBy3TvC;;AkBz3TE;EAAqC,gBAAA;AlB63TvC;;AkB73TE;EAAqC,gBAAA;AlBi4TvC;;AkBj4TE;EAAqC,gBAAA;AlBq4TvC;;AkBr4TE;EAAqC,gBAAA;AlBy4TvC;;AkBz4TE;EAAqC,gBAAA;AlB64TvC;;AkB74TE;EAAqC,gBAAA;AlBi5TvC;;AkBj5TE;EAAqC,gBAAA;AlBq5TvC;;AkBr5TE;EAAqC,gBAAA;AlBy5TvC;;AkBz5TE;EAAqC,gBAAA;AlB65TvC;;AkB75TE;EAAqC,gBAAA;AlBi6TvC;;AkBj6TE;EAAqC,gBAAA;AlBq6TvC;;AkBr6TE;EAAqC,gBAAA;AlBy6TvC;;AkBz6TE;EAAqC,gBAAA;AlB66TvC;;AkB76TE;EAAqC,gBAAA;AlBi7TvC;;AkBj7TE;EAAqC,gBAAA;AlBq7TvC;;AkBr7TE;EAAqC,gBAAA;AlBy7TvC;;AkBz7TE;EAAqC,gBAAA;AlB67TvC;;AkB77TE;EAAqC,gBAAA;AlBi8TvC;;AkBj8TE;EAAqC,gBAAA;AlBq8TvC;;AkBr8TE;EAAqC,gBAAA;AlBy8TvC;;AkBz8TE;EAAqC,gBAAA;AlB68TvC;;AkB78TE;EAAqC,gBAAA;AlBi9TvC;;AkBj9TE;EAAqC,gBAAA;AlBq9TvC;;AkBr9TE;EAAqC,gBAAA;AlBy9TvC;;AkBz9TE;EAAqC,gBAAA;AlB69TvC;;AkB79TE;EAAqC,gBAAA;AlBi+TvC;;AkBj+TE;EAAqC,gBAAA;AlBq+TvC;;AkBr+TE;EAAqC,gBAAA;AlBy+TvC;;AkBz+TE;EAAqC,gBAAA;AlB6+TvC;;AkB7+TE;EAAqC,gBAAA;AlBi/TvC;;AkBj/TE;EAAqC,gBAAA;AlBq/TvC;;AkBr/TE;EAAqC,gBAAA;AlBy/TvC;;AkBz/TE;EAAqC,gBAAA;AlB6/TvC;;AkB7/TE;EAAqC,gBAAA;AlBigUvC;;AkBjgUE;EAAqC,gBAAA;AlBqgUvC;;AkBrgUE;EAAqC,gBAAA;AlBygUvC;;AkBzgUE;EAAqC,gBAAA;AlB6gUvC;;AkB7gUE;EAAqC,gBAAA;AlBihUvC;;AkBjhUE;EAAqC,gBAAA;AlBqhUvC;;AkBrhUE;EAAqC,gBAAA;AlByhUvC;;AkBzhUE;EAAqC,gBAAA;AlB6hUvC;;AkB7hUE;EAAqC,gBAAA;AlBiiUvC;;AkBjiUE;EAAqC,gBAAA;AlBqiUvC;;AkBriUE;EAAqC,gBAAA;AlByiUvC;;AkBziUE;EAAqC,gBAAA;AlB6iUvC;;AkB7iUE;EAAqC,gBAAA;AlBijUvC;;AkBjjUE;EAAqC,gBAAA;AlBqjUvC;;AkBrjUE;EAAqC,gBAAA;AlByjUvC;;AkBzjUE;EAAqC,gBAAA;AlB6jUvC;;AkB7jUE;EAAqC,gBAAA;AlBikUvC;;AkBjkUE;EAAqC,gBAAA;AlBqkUvC;;AkBrkUE;EAAqC,gBAAA;AlBykUvC;;AkBzkUE;EAAqC,gBAAA;AlB6kUvC;;AkB7kUE;EAAqC,gBAAA;AlBilUvC;;AkBjlUE;EAAqC,gBAAA;AlBqlUvC;;AkBrlUE;EAAqC,gBAAA;AlBylUvC;;AkBzlUE;EAAqC,gBAAA;AlB6lUvC;;AkB7lUE;EAAqC,gBAAA;AlBimUvC;;AkBjmUE;EAAqC,gBAAA;AlBqmUvC;;AkBrmUE;EAAqC,gBAAA;AlBymUvC;;AkBzmUE;EAAqC,gBAAA;AlB6mUvC;;AkB7mUE;EAAqC,gBAAA;AlBinUvC;;AkBjnUE;EAAqC,gBAAA;AlBqnUvC;;AkBrnUE;EAAqC,gBAAA;AlBynUvC;;AkBznUE;EAAqC,gBAAA;AlB6nUvC;;AkB7nUE;EAAqC,gBAAA;AlBioUvC;;AkBjoUE;EAAqC,gBAAA;AlBqoUvC;;AkBroUE;EAAqC,gBAAA;AlByoUvC;;AkBzoUE;EAAqC,gBAAA;AlB6oUvC;;AkB7oUE;EAAqC,gBAAA;AlBipUvC;;AkBjpUE;EAAqC,gBAAA;AlBqpUvC;;AkBrpUE;EAAqC,gBAAA;AlBypUvC;;AkBzpUE;EAAqC,gBAAA;AlB6pUvC;;AkB7pUE;EAAqC,gBAAA;AlBiqUvC;;AkBjqUE;EAAqC,gBAAA;AlBqqUvC;;AkBrqUE;EAAqC,gBAAA;AlByqUvC;;AkBzqUE;EAAqC,gBAAA;AlB6qUvC;;AkB7qUE;EAAqC,gBAAA;AlBirUvC;;AkBjrUE;EAAqC,gBAAA;AlBqrUvC;;AkBrrUE;EAAqC,gBAAA;AlByrUvC;;AkBzrUE;EAAqC,gBAAA;AlB6rUvC;;AkB7rUE;EAAqC,gBAAA;AlBisUvC;;AkBjsUE;EAAqC,gBAAA;AlBqsUvC;;AkBrsUE;EAAqC,gBAAA;AlBysUvC;;AkBzsUE;EAAqC,gBAAA;AlB6sUvC;;AkB7sUE;EAAqC,gBAAA;AlBitUvC;;AkBjtUE;EAAqC,gBAAA;AlBqtUvC;;AkBrtUE;EAAqC,gBAAA;AlBytUvC;;AkBztUE;EAAqC,gBAAA;AlB6tUvC;;AkB7tUE;EAAqC,gBAAA;AlBiuUvC;;AkBjuUE;EAAqC,gBAAA;AlBquUvC;;AkBruUE;EAAqC,gBAAA;AlByuUvC;;AkBzuUE;EAAqC,gBAAA;AlB6uUvC;;AkB7uUE;EAAqC,gBAAA;AlBivUvC;;AkBjvUE;EAAqC,gBAAA;AlBqvUvC;;AkBrvUE;EAAqC,gBAAA;AlByvUvC;;AkBzvUE;EAAqC,gBAAA;AlB6vUvC;;AkB7vUE;EAAqC,gBAAA;AlBiwUvC;;AkBjwUE;EAAqC,gBAAA;AlBqwUvC;;AkBrwUE;EAAqC,gBAAA;AlBywUvC;;AkBzwUE;EAAqC,gBAAA;AlB6wUvC;;AkB7wUE;EAAqC,gBAAA;AlBixUvC;;AkBjxUE;EAAqC,gBAAA;AlBqxUvC;;AkBrxUE;EAAqC,gBAAA;AlByxUvC;;AkBzxUE;EAAqC,gBAAA;AlB6xUvC;;AkB7xUE;EAAqC,gBAAA;AlBiyUvC;;AkBjyUE;EAAqC,gBAAA;AlBqyUvC;;AkBryUE;EAAqC,gBAAA;AlByyUvC;;AkBzyUE;EAAqC,gBAAA;AlB6yUvC;;AkB7yUE;EAAqC,gBAAA;AlBizUvC;;AkBjzUE;EAAqC,gBAAA;AlBqzUvC;;AkBrzUE;EAAqC,gBAAA;AlByzUvC;;AkBzzUE;EAAqC,gBAAA;AlB6zUvC;;AkB7zUE;EAAqC,gBAAA;AlBi0UvC;;AkBj0UE;EAAqC,gBAAA;AlBq0UvC;;AkBr0UE;EAAqC,gBAAA;AlBy0UvC;;AkBz0UE;EAAqC,gBAAA;AlB60UvC;;AkB70UE;EAAqC,gBAAA;AlBi1UvC;;AkBj1UE;EAAqC,gBAAA;AlBq1UvC;;AkBr1UE;EAAqC,gBAAA;AlBy1UvC;;AkBz1UE;EAAqC,gBAAA;AlB61UvC;;AkB71UE;EAAqC,gBAAA;AlBi2UvC;;AkBj2UE;EAAqC,gBAAA;AlBq2UvC;;AkBr2UE;EAAqC,gBAAA;AlBy2UvC;;AkBz2UE;EAAqC,gBAAA;AlB62UvC;;AkB72UE;EAAqC,gBAAA;AlBi3UvC;;AkBj3UE;EAAqC,gBAAA;AlBq3UvC;;AkBr3UE;EAAqC,gBAAA;AlBy3UvC;;AkBz3UE;EAAqC,gBAAA;AlB63UvC;;AkB73UE;EAAqC,gBAAA;AlBi4UvC;;AkBj4UE;EAAqC,gBAAA;AlBq4UvC;;AkBr4UE;EAAqC,gBAAA;AlBy4UvC;;AkBz4UE;EAAqC,gBAAA;AlB64UvC;;AkB74UE;EAAqC,gBAAA;AlBi5UvC;;AkBj5UE;EAAqC,gBAAA;AlBq5UvC;;AkBr5UE;EAAqC,gBAAA;AlBy5UvC;;AkBz5UE;EAAqC,gBAAA;AlB65UvC;;AkB75UE;EAAqC,gBAAA;AlBi6UvC;;AkBj6UE;EAAqC,gBAAA;AlBq6UvC;;AkBr6UE;EAAqC,gBAAA;AlBy6UvC;;AkBz6UE;EAAqC,gBAAA;AlB66UvC;;AkB76UE;EAAqC,gBAAA;AlBi7UvC;;AkBj7UE;EAAqC,gBAAA;AlBq7UvC;;AkBr7UE;EAAqC,gBAAA;AlBy7UvC;;AkBz7UE;EAAqC,gBAAA;AlB67UvC;;AkB77UE;EAAqC,gBAAA;AlBi8UvC;;AkBj8UE;EAAqC,gBAAA;AlBq8UvC;;AkBr8UE;EAAqC,gBAAA;AlBy8UvC;;AkBz8UE;EAAqC,gBAAA;AlB68UvC;;AkB78UE;EAAqC,gBAAA;AlBi9UvC;;AkBj9UE;EAAqC,gBAAA;AlBq9UvC;;AkBr9UE;EAAqC,gBAAA;AlBy9UvC;;AkBz9UE;EAAqC,gBAAA;AlB69UvC;;AkB79UE;EAAqC,gBAAA;AlBi+UvC;;AkBj+UE;EAAqC,gBAAA;AlBq+UvC;;AkBr+UE;EAAqC,gBAAA;AlBy+UvC;;AkBz+UE;EAAqC,gBAAA;AlB6+UvC;;AkB7+UE;EAAqC,gBAAA;AlBi/UvC;;AkBj/UE;EAAqC,gBAAA;AlBq/UvC;;AkBr/UE;EAAqC,gBAAA;AlBy/UvC;;AkBz/UE;EAAqC,gBAAA;AlB6/UvC;;AkB7/UE;EAAqC,gBAAA;AlBigVvC;;AkBjgVE;EAAqC,gBAAA;AlBqgVvC;;AkBrgVE;EAAqC,gBAAA;AlBygVvC;;AkBzgVE;EAAqC,gBAAA;AlB6gVvC;;AkB7gVE;EAAqC,gBAAA;AlBihVvC;;AkBjhVE;EAAqC,gBAAA;AlBqhVvC;;AkBrhVE;EAAqC,gBAAA;AlByhVvC;;AkBzhVE;EAAqC,gBAAA;AlB6hVvC;;AkB7hVE;EAAqC,gBAAA;AlBiiVvC;;AkBjiVE;EAAqC,gBAAA;AlBqiVvC;;AkBriVE;EAAqC,gBAAA;AlByiVvC;;AkBziVE;EAAqC,gBAAA;AlB6iVvC;;AkB7iVE;EAAqC,gBAAA;AlBijVvC;;AkBjjVE;EAAqC,gBAAA;AlBqjVvC;;AkBrjVE;EAAqC,gBAAA;AlByjVvC;;AkBzjVE;EAAqC,gBAAA;AlB6jVvC;;AkB7jVE;EAAqC,gBAAA;AlBikVvC;;AkBjkVE;EAAqC,gBAAA;AlBqkVvC;;AkBrkVE;EAAqC,gBAAA;AlBykVvC;;AkBzkVE;EAAqC,gBAAA;AlB6kVvC;;AkB7kVE;EAAqC,gBAAA;AlBilVvC;;AkBjlVE;EAAqC,gBAAA;AlBqlVvC;;AkBrlVE;EAAqC,gBAAA;AlBylVvC;;AkBzlVE;EAAqC,gBAAA;AlB6lVvC;;AkB7lVE;EAAqC,gBAAA;AlBimVvC;;AkBjmVE;EAAqC,gBAAA;AlBqmVvC;;AkBrmVE;EAAqC,gBAAA;AlBymVvC;;AkBzmVE;EAAqC,gBAAA;AlB6mVvC;;AkB7mVE;EAAqC,gBAAA;AlBinVvC;;AkBjnVE;EAAqC,gBAAA;AlBqnVvC;;AkBrnVE;EAAqC,gBAAA;AlBynVvC;;AkBznVE;EAAqC,gBAAA;AlB6nVvC;;AkB7nVE;EAAqC,gBAAA;AlBioVvC;;AkBjoVE;EAAqC,gBAAA;AlBqoVvC;;AkBroVE;EAAqC,gBAAA;AlByoVvC;;AkBzoVE;EAAqC,gBAAA;AlB6oVvC;;AkB7oVE;EAAqC,gBAAA;AlBipVvC;;AkBjpVE;EAAqC,gBAAA;AlBqpVvC;;AkBrpVE;EAAqC,gBAAA;AlBypVvC;;AkBzpVE;EAAqC,gBAAA;AlB6pVvC;;AkB7pVE;EAAqC,gBAAA;AlBiqVvC;;AkBjqVE;EAAqC,gBAAA;AlBqqVvC;;AkBrqVE;EAAqC,gBAAA;AlByqVvC;;AkBzqVE;EAAqC,gBAAA;AlB6qVvC;;AkB7qVE;EAAqC,gBAAA;AlBirVvC;;AkBjrVE;EAAqC,gBAAA;AlBqrVvC;;AkBrrVE;EAAqC,gBAAA;AlByrVvC;;AkBzrVE;EAAqC,gBAAA;AlB6rVvC;;AkB7rVE;EAAqC,gBAAA;AlBisVvC;;AkBjsVE;EAAqC,gBAAA;AlBqsVvC;;AkBrsVE;EAAqC,gBAAA;AlBysVvC;;AkBzsVE;EAAqC,gBAAA;AlB6sVvC;;AkB7sVE;EAAqC,gBAAA;AlBitVvC;;AkBjtVE;EAAqC,gBAAA;AlBqtVvC;;AkBrtVE;EAAqC,gBAAA;AlBytVvC;;AkBztVE;EAAqC,gBAAA;AlB6tVvC;;AkB7tVE;EAAqC,gBAAA;AlBiuVvC;;AkBjuVE;EAAqC,gBAAA;AlBquVvC;;AkBruVE;EAAqC,gBAAA;AlByuVvC;;AkBzuVE;EAAqC,gBAAA;AlB6uVvC;;AkB7uVE;EAAqC,gBAAA;AlBivVvC;;AkBjvVE;EAAqC,gBAAA;AlBqvVvC;;AkBrvVE;EAAqC,gBAAA;AlByvVvC;;AkBzvVE;EAAqC,gBAAA;AlB6vVvC;;AkB7vVE;EAAqC,gBAAA;AlBiwVvC;;AkBjwVE;EAAqC,gBAAA;AlBqwVvC;;AkBrwVE;EAAqC,gBAAA;AlBywVvC;;AkBzwVE;EAAqC,gBAAA;AlB6wVvC;;AkB7wVE;EAAqC,gBAAA;AlBixVvC;;AkBjxVE;EAAqC,gBAAA;AlBqxVvC;;AkBrxVE;EAAqC,gBAAA;AlByxVvC;;AkBzxVE;EAAqC,gBAAA;AlB6xVvC;;AkB7xVE;EAAqC,gBAAA;AlBiyVvC;;AkBjyVE;EAAqC,gBAAA;AlBqyVvC;;AkBryVE;EAAqC,gBAAA;AlByyVvC;;AkBzyVE;EAAqC,gBAAA;AlB6yVvC;;AkB7yVE;EAAqC,gBAAA;AlBizVvC;;AkBjzVE;EAAqC,gBAAA;AlBqzVvC;;AkBrzVE;EAAqC,gBAAA;AlByzVvC;;AkBzzVE;EAAqC,gBAAA;AlB6zVvC;;AkB7zVE;EAAqC,gBAAA;AlBi0VvC;;AkBj0VE;EAAqC,gBAAA;AlBq0VvC;;AkBr0VE;EAAqC,gBAAA;AlBy0VvC;;AkBz0VE;EAAqC,gBAAA;AlB60VvC;;AkB70VE;EAAqC,gBAAA;AlBi1VvC;;AkBj1VE;EAAqC,gBAAA;AlBq1VvC;;AkBr1VE;EAAqC,gBAAA;AlBy1VvC;;AkBz1VE;EAAqC,gBAAA;AlB61VvC;;AkB71VE;EAAqC,gBAAA;AlBi2VvC;;AkBj2VE;EAAqC,gBAAA;AlBq2VvC;;AkBr2VE;EAAqC,gBAAA;AlBy2VvC;;AkBz2VE;EAAqC,gBAAA;AlB62VvC;;AkB72VE;EAAqC,gBAAA;AlBi3VvC;;AkBj3VE;EAAqC,gBAAA;AlBq3VvC;;AkBr3VE;EAAqC,gBAAA;AlBy3VvC;;AkBz3VE;EAAqC,gBAAA;AlB63VvC;;AkB73VE;EAAqC,gBAAA;AlBi4VvC;;AkBj4VE;EAAqC,gBAAA;AlBq4VvC;;AkBr4VE;EAAqC,gBAAA;AlBy4VvC;;AkBz4VE;EAAqC,gBAAA;AlB64VvC;;AkB74VE;EAAqC,gBAAA;AlBi5VvC;;AkBj5VE;EAAqC,gBAAA;AlBq5VvC;;AkBr5VE;EAAqC,gBAAA;AlBy5VvC;;AkBz5VE;EAAqC,gBAAA;AlB65VvC;;AkB75VE;EAAqC,gBAAA;AlBi6VvC;;AkBj6VE;EAAqC,gBAAA;AlBq6VvC;;AkBr6VE;EAAqC,gBAAA;AlBy6VvC;;AkBz6VE;EAAqC,gBAAA;AlB66VvC;;AkB76VE;EAAqC,gBAAA;AlBi7VvC;;AkBj7VE;EAAqC,gBAAA;AlBq7VvC;;AkBr7VE;EAAqC,gBAAA;AlBy7VvC;;AkBz7VE;EAAqC,gBAAA;AlB67VvC;;AkB77VE;EAAqC,gBAAA;AlBi8VvC;;AkBj8VE;EAAqC,gBAAA;AlBq8VvC;;AkBr8VE;EAAqC,gBAAA;AlBy8VvC;;AkBz8VE;EAAqC,gBAAA;AlB68VvC;;AkB78VE;EAAqC,gBAAA;AlBi9VvC;;AkBj9VE;EAAqC,gBAAA;AlBq9VvC;;AkBr9VE;EAAqC,gBAAA;AlBy9VvC;;AkBz9VE;EAAqC,gBAAA;AlB69VvC;;AkB79VE;EAAqC,gBAAA;AlBi+VvC;;AkBj+VE;EAAqC,gBAAA;AlBq+VvC;;AkBr+VE;EAAqC,gBAAA;AlBy+VvC;;AkBz+VE;EAAqC,gBAAA;AlB6+VvC;;AkB7+VE;EAAqC,gBAAA;AlBi/VvC;;AkBj/VE;EAAqC,gBAAA;AlBq/VvC;;AkBr/VE;EAAqC,gBAAA;AlBy/VvC;;AkBz/VE;EAAqC,gBAAA;AlB6/VvC;;AkB7/VE;EAAqC,gBAAA;AlBigWvC;;AkBjgWE;EAAqC,gBAAA;AlBqgWvC;;AkBrgWE;EAAqC,gBAAA;AlBygWvC;;AkBzgWE;EAAqC,gBAAA;AlB6gWvC;;AkB7gWE;EAAqC,gBAAA;AlBihWvC;;AkBjhWE;EAAqC,gBAAA;AlBqhWvC;;AkBrhWE;EAAqC,gBAAA;AlByhWvC;;AkBzhWE;EAAqC,gBAAA;AlB6hWvC;;AkB7hWE;EAAqC,gBAAA;AlBiiWvC;;AkBjiWE;EAAqC,gBAAA;AlBqiWvC;;AkBriWE;EAAqC,gBAAA;AlByiWvC;;AkBziWE;EAAqC,gBAAA;AlB6iWvC;;AAtjWA,sBAAA;AAEA;;EAEI,YAAA;AAwjWJ;;AArjWA;EACI,sBAAA;EACA,UAAA;EACA,SAAA;AAwjWJ;;AArjWA;EACI,iCAAA;EACA,aAAA;EACA,sBAAA;AAwjWJ;;AArjWA;EACI,iCAAA;AAwjWJ;;AArjWA;EACI,cAAA;EACA,WAAA;AAwjWJ;;AApjWA,wBAAA;AAGA;;;;;;;;;;;;;;;;;EAAA;AAmBA;;;;;;EAMI,oCAAA;AAojWJ;;AAjjWA;EACI,mBG3ES;EH4ET,iBAAA;AAojWJ;AAljWI;EACI,eAAA;AAojWR;;AAhjWA;EACI,qBAAA;AAmjWJ;;AAhjWA;EACI,cGvFI;EHwFJ,qBAAA;AAmjWJ;;AAhjWA;EACI,0BAAA;AAmjWJ;;AAhjWA;EACI,qBAAA;AAmjWJ;;AAhjWA;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AAmjWJ;;AAhjWA;;EAEI,eAAA;AAmjWJ;;AAhjWA;EACI,yBAAA;AAmjWJ;;AA/iWA,mBAAA;AAEA;EACI,yBGvHS;EHwHT,kBAAA;EACA,cGxHI;EHyHJ,eAAA;AAijWJ;;AA7iWA;EACI,kBAAA;EACA,sBAAA;AAgjWJ;;AA7iWA;EACI,aAAA;AAgjWJ;;AA5iWA,4CAAA;AAEA;EACI,WAAA;EACA,UAAA;EACA,cAAA;EACA,cG7II;EH8IJ,sBAAA;EACA,wBAAA;EACA,sBAAA;AA8iWJ;;AA3iWA;EACI,cAAA;AA8iWJ;;AA1iWA,kBAAA;AAEA;EACI,kBAAA;AA4iWJ;;AAxiWA,YAAA;AAEA;EACI,mBGnKS;EHoKT,eAAA;AA0iWJ;;AAviWA;EACI,cGvKI;EHwKJ,qBAAA;AA0iWJ;;AAviWA;;EAEI,qBAAA;AA0iWJ;;AAviWA;EACI,eAAA;EACA,2BAAA;AA0iWJ;;AAviWA;EACI,aAAA;AA0iWJ;AAxiWI;EACI,gBAAA;AA0iWR;AAviWI;;EAEI,cG9LA;AHuuWR;;AApiWA,gBAAA;AAEA;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;AAsiWJ;AAniWQ;EACI,cAAA;EACA,iBAAA;AAqiWZ;AAliWQ;EACI,aAAA;AAoiWZ;;AA/hWA;EACI,QAAA;EACA,eAAA;AAkiWJ;;AA/hWA;EAKI,QAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AA8hWJ;AAriWI;EACI,QAAA;AAuiWR;;AA9hWA;EACI,cAAA;AAiiWJ;;AA9hWA;EACI,2CAAA;EACA,6BAAA;AAiiWJ;;AA7hWA,mCAAA;AAEA;EACI,aAAA;AA+hWJ;;AA5hWA;EACI,cAAA;AA+hWJ;;AA3hWI;EACI,eAAA;AA8hWR;AA3hWI;EACI,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cGtQA;EHuQA,iBAAA;AA6hWR;;AAzhWA;EACI,kBAAA;AA4hWJ;;AAzhWA;EACI,kCAAA;EACA,kBAAA;AA4hWJ;;AAxhWA,gBAAA;AAEA;EACI;IACI,uBAAA;EA0hWN;EAvhWE;IACI,OAAA;EAyhWN;EAthWE;IACI,WAAA;IACA,QAAA;IACA,cAAA;EAwhWN;EArhWE;IACI,OAAA;IACA,iBAAA;IACA,QAAA;EAuhWN;EAphWE,iCAAA;EACA;IACI,kBAAA;IACA,aAAA;EAshWN;EAlhWM;IACI,mBGtTA;IHuTA,yBAAA;EAohWV;EAjhWM;IACI,SAAA;EAmhWV;EAjhWU;IACI,uBAAA;IACA,mBAAA;IACA,yBAAA;EAmhWd;EAjhWc;IACI,mBGtUX;IHuUW,cGlUZ;IHmUY,yBAAA;EAmhWlB;EA9gWM;IACI,qBAAA;EAghWV;EA7gWM;IACI,mBG9UC;IH+UD,qBG9UJ;IH+UI,cG/UJ;EH81WN;AACF;AA1gWA,iBAAA;AAEA;EACI;IACI,uBAAA;IACA,iBAAA;IACA,gBAAA;EA2gWN;EAxgWE;IACI,QAAA;EA0gWN;EAvgWE;IACI,QAAA;IACA,kBAAA;IACA,cAAA;IACA,WAAA;EAygWN;EAtgWE;IACI,QAAA;EAwgWN;EArgWE;IACI,cAAA;IACA,kBAAA;IACA,OAAA;IACA,SAAA;IACA,gBAAA;EAugWN;EApgWE;IACI,aAAA;EAsgWN;EAngWE;IACI,gBAAA;EAqgWN;AACF","sourcesContent":["/** SCSS Imports */\n\n@import 'algolia';\n@import 'mediaqueries';\n@import 'colors';\n@import 'buttons';\n\n/** Google Fonts */\n\n@import url('https://fonts.googleapis.com/css2?family=Inria+Serif&family=Quicksand:wght@500&display=swap');\n\n\n/** Font Awesome */\n\n$fa-font-path: \"~@fortawesome/fontawesome-free/webfonts\";\n@import '~@fortawesome/fontawesome-free/scss/fontawesome';\n@import '~@fortawesome/fontawesome-free/scss/solid';\n@import '~@fortawesome/fontawesome-free/scss/brands';\n\n/** SCSS Starts Here */\n\nhtml,\nbody {\n    height: 100%;\n}\n\n* {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n}\n\nbody {\n    font-family: 'Inria Serif', serif;\n    display: flex;\n    flex-direction: column;\n}\n\nbutton {\n    font-family: 'Inria Serif', serif;\n}\n\n.container {\n    flex: 1 0 auto;\n    margin: 1em;\n}\n\n\n/** WIP on the Flexbox */\n\n\n/**\nmain {\n    display: flex;\n}\n\narticle {\n    display: flex;\n}\n\naside {\n    display: flex;\n}\n\n.footer {\n    flex-shrink: 0;\n    padding: 20px;\n}\n**/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-family: 'Quicksand', sans-serif;\n}\n\nnav {\n    background: $blueviolet;\n    padding: 5px 20px;\n\n    a {\n        font-size: 20px;\n    }\n}\n\nul {\n    list-style-type: none;\n}\n\na {\n    color: $white;\n    text-decoration: none;\n}\n\na:hover {\n    text-decoration: underline;\n}\n\n.logo a:hover {\n    text-decoration: none;\n}\n\n.menu li {\n    font-size: 16px;\n    padding: 15px 5px;\n    white-space: nowrap;\n}\n\n.logo a,\n.toggle a {\n    font-size: 20px;\n}\n\n.button.secondary {\n    border: 1px solid $white;\n}\n\n\n/** Basic Styling */\n\nfooter {\n    background-color: $blueviolet;\n    text-align: center;\n    color: $white;\n    font-size: 20px;\n}\n\n// JS Form Validation - To be refactored\ninput:invalid {\n    border-color: #900;\n    background-color: #FDD;\n}\n\ninput:focus:invalid {\n    outline: none;\n}\n\n\n/* This is the style of our error messages */\n\n.error {\n    width: 100%;\n    padding: 0;\n    font-size: 80%;\n    color: $white;\n    background-color: #900;\n    border-radius: 0 05px 5px;\n    box-sizing: border-box;\n}\n\n.error.active {\n    padding: 0.3em;\n}\n\n\n/** Hidden Class */\n\n.hidden {\n    visibility: hidden;\n}\n\n\n/** Navbar */\n\nnav {\n    background: $blueviolet;\n    padding: 0 15px;\n}\n\na {\n    color: $white;\n    text-decoration: none;\n}\n\n.menu,\n.submenu {\n    list-style-type: none;\n}\n\n.logo {\n    font-size: 20px;\n    padding: 7.5px 10px 7.5px 0;\n}\n\n.item {\n    padding: 10px;\n\n    &.button {\n        padding: 9px 5px;\n    }\n\n    &:not(.button) a:hover,\n    a:hover::after {\n        color: $white;\n    }\n}\n\n\n/* Mobile menu */\n\n.menu {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n\n    li {\n        a {\n            display: block;\n            padding: 15px 5px;\n        }\n\n        &.subitem a {\n            padding: 15px;\n        }\n    }\n}\n\n.toggle {\n    order: 1;\n    font-size: 20px;\n}\n\n.item {\n    &.button {\n        order: 2;\n    }\n\n    order: 3;\n    width: 100%;\n    text-align: center;\n    display: none;\n}\n\n.active .item {\n    display: block;\n}\n\n.button.secondary {\n    /* divider between buttons and menu links */\n    border-bottom: 1px #444 solid;\n}\n\n\n/* Submenu up from mobile screens */\n\n.submenu {\n    display: none;\n}\n\n.submenu-active .submenu {\n    display: block;\n}\n\n.has-submenu {\n    i {\n        font-size: 12px;\n    }\n\n    >a::after {\n        font-family: \"Font Awesome 5 Free\";\n        font-size: 12px;\n        line-height: 16px;\n        font-weight: 900;\n        content: \"\\f078\";\n        color: $white;\n        padding-left: 5px;\n    }\n}\n\n.subitem a {\n    padding: 10px 15px;\n}\n\n.submenu-active {\n    background-color: inverse($white);\n    border-radius: 3px;\n}\n\n\n/* Tablet menu */\n\n@media all and (min-width: 700px) {\n    .menu {\n        justify-content: center;\n    }\n\n    .logo {\n        flex: 1;\n    }\n\n    .item.button {\n        width: auto;\n        order: 1;\n        display: block;\n    }\n\n    .toggle {\n        flex: 1;\n        text-align: right;\n        order: 2;\n    }\n\n    /* Button up from tablet screen */\n    .menu li.button a {\n        padding: 10px 15px;\n        margin: 5px 0;\n    }\n\n    .button {\n        a {\n            background: $royalblue;\n            border: 3px $royalblue solid;\n        }\n\n        &.secondary {\n            border: 0;\n\n            a {\n                background: transparent;\n                border-radius: 27px;\n                border: 3px $royalblue solid;\n\n                &:hover {\n                    background: $safron;\n                    color: $white;\n                    border: 3px $white solid;\n                }\n            }\n        }\n\n        a:hover {\n            text-decoration: none;\n        }\n\n        &:not(.secondary) a:hover {\n            background: $blueviolet;\n            border-color: $white;\n            color: $white;\n        }\n    }\n}\n\n\n/* Desktop menu */\n\n@media all and (min-width: 960px) {\n    .menu {\n        align-items: flex-start;\n        flex-wrap: nowrap;\n        background: none;\n    }\n\n    .logo {\n        order: 0;\n    }\n\n    .item {\n        order: 1;\n        position: relative;\n        display: block;\n        width: auto;\n    }\n\n    .button {\n        order: 2;\n    }\n\n    .submenu-active .submenu {\n        display: block;\n        position: absolute;\n        left: 0;\n        top: 68px;\n        background: #111;\n    }\n\n    .toggle {\n        display: none;\n    }\n\n    .submenu-active {\n        border-radius: 0;\n    }\n}",".ais-Breadcrumb-list,\n.ais-CurrentRefinements-list,\n.ais-HierarchicalMenu-list,\n.ais-Hits-list,\n.ais-InfiniteHits-list,\n.ais-InfiniteResults-list,\n.ais-Menu-list,\n.ais-NumericMenu-list,\n.ais-Pagination-list,\n.ais-RatingMenu-list,\n.ais-RefinementList-list,\n.ais-Results-list,\n.ais-ToggleRefinement-list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.ais-ClearRefinements-button,\n.ais-CurrentRefinements-delete,\n.ais-CurrentRefinements-reset,\n.ais-GeoSearch-redo,\n.ais-GeoSearch-reset,\n.ais-HierarchicalMenu-showMore,\n.ais-InfiniteHits-loadMore,\n.ais-InfiniteHits-loadPrevious,\n.ais-InfiniteResults-loadMore,\n.ais-Menu-showMore,\n.ais-RangeInput-submit,\n.ais-RefinementList-showMore,\n.ais-SearchBox-reset,\n.ais-SearchBox-submit,\n.ais-VoiceSearch-button {\n    padding: 0;\n    overflow: visible;\n    font: inherit;\n    line-height: normal;\n    color: inherit;\n    background: none;\n    border: 0;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.ais-ClearRefinements-button::-moz-focus-inner,\n.ais-CurrentRefinements-delete::-moz-focus-inner,\n.ais-CurrentRefinements-reset::-moz-focus-inner,\n.ais-GeoSearch-redo::-moz-focus-inner,\n.ais-GeoSearch-reset::-moz-focus-inner,\n.ais-HierarchicalMenu-showMore::-moz-focus-inner,\n.ais-InfiniteHits-loadMore::-moz-focus-inner,\n.ais-InfiniteHits-loadPrevious::-moz-focus-inner,\n.ais-InfiniteResults-loadMore::-moz-focus-inner,\n.ais-Menu-showMore::-moz-focus-inner,\n.ais-RangeInput-submit::-moz-focus-inner,\n.ais-RefinementList-showMore::-moz-focus-inner,\n.ais-SearchBox-reset::-moz-focus-inner,\n.ais-SearchBox-submit::-moz-focus-inner,\n.ais-VoiceSearch-button::-moz-focus-inner {\n    padding: 0;\n    border: 0;\n}\n\n.ais-ClearRefinements-button[disabled],\n.ais-CurrentRefinements-delete[disabled],\n.ais-CurrentRefinements-reset[disabled],\n.ais-GeoSearch-redo[disabled],\n.ais-GeoSearch-reset[disabled],\n.ais-HierarchicalMenu-showMore[disabled],\n.ais-InfiniteHits-loadMore[disabled],\n.ais-InfiniteHits-loadPrevious[disabled],\n.ais-InfiniteResults-loadMore[disabled],\n.ais-Menu-showMore[disabled],\n.ais-RangeInput-submit[disabled],\n.ais-RefinementList-showMore[disabled],\n.ais-SearchBox-reset[disabled],\n.ais-SearchBox-submit[disabled],\n.ais-VoiceSearch-button[disabled] {\n    cursor: default;\n}\n\n.ais-Breadcrumb-item,\n.ais-Breadcrumb-list,\n.ais-Pagination-list,\n.ais-PoweredBy,\n.ais-RangeInput-form,\n.ais-RatingMenu-link {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.ais-GeoSearch,\n.ais-GeoSearch-map {\n    height: 100%;\n}\n\n.ais-HierarchicalMenu-list .ais-HierarchicalMenu-list {\n    margin-left: 1em;\n}\n\n.ais-PoweredBy-logo {\n    display: block;\n    height: 1.2em;\n    width: auto;\n}\n\n.ais-RatingMenu-starIcon {\n    display: block;\n    width: 20px;\n    height: 20px;\n}\n\n.ais-SearchBox-input {\n    &::-ms-clear,\n    &::-ms-reveal {\n        display: none;\n        width: 0;\n        height: 0;\n    }\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-decoration,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n        display: none;\n    }\n}\n\n.ais-RangeSlider {\n    .rheostat {\n        overflow: visible;\n        margin-top: 40px;\n        margin-bottom: 40px;\n    }\n    .rheostat-background {\n        height: 6px;\n        top: 0;\n        width: 100%;\n    }\n    .rheostat-handle {\n        margin-left: -12px;\n        top: -7px;\n    }\n    .rheostat-background {\n        position: relative;\n        background-color: #fff;\n        border: 1px solid #aaa;\n    }\n    .rheostat-progress {\n        position: absolute;\n        top: 1px;\n        height: 4px;\n        background-color: #333;\n    }\n}\n\n.rheostat-handle {\n    position: relative;\n    z-index: 1;\n    width: 20px;\n    height: 20px;\n    background-color: #fff;\n    border: 1px solid #333;\n    border-radius: 50%;\n    cursor: -webkit-grab;\n    cursor: grab;\n}\n\n.rheostat-marker {\n    margin-left: -1px;\n    position: absolute;\n    width: 1px;\n    height: 5px;\n    background-color: #aaa;\n}\n\n.rheostat-marker--large {\n    height: 9px;\n}\n\n.rheostat-value {\n    padding-top: 15px;\n}\n\n.rheostat-tooltip,\n.rheostat-value {\n    margin-left: 50%;\n    position: absolute;\n    text-align: center;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n}\n\n.rheostat-tooltip {\n    top: -22px;\n}\n\n[class^=ais-] {\n    font-size: 1rem;\n    box-sizing: border-box;\n}\n\na[class^=ais-] {\n    text-decoration: none;\n}\n\n.ais-Breadcrumb,\n.ais-ClearRefinements,\n.ais-CurrentRefinements,\n.ais-GeoSearch,\n.ais-HierarchicalMenu,\n.ais-Hits,\n.ais-HitsPerPage,\n.ais-InfiniteHits,\n.ais-InfiniteResults,\n.ais-Menu,\n.ais-MenuSelect,\n.ais-NumericMenu,\n.ais-NumericSelector,\n.ais-Pagination,\n.ais-Panel,\n.ais-PoweredBy,\n.ais-RangeInput,\n.ais-RangeSlider,\n.ais-RatingMenu,\n.ais-RefinementList,\n.ais-Results,\n.ais-ResultsPerPage,\n.ais-SearchBox,\n.ais-SortBy,\n.ais-Stats,\n.ais-ToggleRefinement {\n    color: #3a4570;\n}\n\n.ais-Breadcrumb-item--selected,\n.ais-HierarchicalMenu-item--selected,\n.ais-Menu-item--selected {\n    font-weight: 700;\n}\n\n.ais-Breadcrumb-separator {\n    margin: 0 .3em;\n    font-weight: 400;\n}\n\n.ais-Breadcrumb-link,\n.ais-HierarchicalMenu-link,\n.ais-Menu-link,\n.ais-Pagination-link,\n.ais-RatingMenu-link {\n    color: #0096db;\n    transition: color .2s ease-out;\n}\n\n.ais-Breadcrumb-link {\n    &:focus,\n    &:hover {\n        color: #0073a8;\n    }\n}\n\n.ais-HierarchicalMenu-link {\n    &:focus,\n    &:hover {\n        color: #0073a8;\n    }\n}\n\n.ais-Menu-link {\n    &:focus,\n    &:hover {\n        color: #0073a8;\n    }\n}\n\n.ais-Pagination-link {\n    &:focus,\n    &:hover {\n        color: #0073a8;\n    }\n}\n\n.ais-RatingMenu-link {\n    &:focus,\n    &:hover {\n        color: #0073a8;\n    }\n}\n\n.ais-ClearRefinements-button,\n.ais-CurrentRefinements-reset,\n.ais-GeoSearch-redo,\n.ais-GeoSearch-reset,\n.ais-HierarchicalMenu-showMore,\n.ais-InfiniteHits-loadMore,\n.ais-InfiniteHits-loadPrevious,\n.ais-InfiniteResults-loadMore,\n.ais-Menu-showMore,\n.ais-RefinementList-showMore {\n    padding: .3rem .5rem;\n    font-size: .8rem;\n    color: #fff;\n    background-color: #0096db;\n    border-radius: 5px;\n    transition: background-color .2s ease-out;\n    outline: none;\n}\n\n.ais-ClearRefinements-button {\n    &:focus,\n    &:hover {\n        background-color: #0073a8;\n    }\n}\n\n.ais-CurrentRefinements-reset {\n    &:focus,\n    &:hover {\n        background-color: #0073a8;\n    }\n}\n\n.ais-GeoSearch-redo {\n    &:focus,\n    &:hover {\n        background-color: #0073a8;\n    }\n}\n\n.ais-GeoSearch-reset {\n    &:focus,\n    &:hover {\n        background-color: #0073a8;\n    }\n}\n\n.ais-HierarchicalMenu-showMore {\n    &:focus,\n    &:hover {\n        background-color: #0073a8;\n    }\n}\n\n.ais-InfiniteHits-loadMore {\n    &:focus,\n    &:hover {\n        background-color: #0073a8;\n    }\n}\n\n.ais-InfiniteHits-loadPrevious {\n    &:focus,\n    &:hover {\n        background-color: #0073a8;\n    }\n}\n\n.ais-InfiniteResults-loadMore {\n    &:focus,\n    &:hover {\n        background-color: #0073a8;\n    }\n}\n\n.ais-Menu-showMore {\n    &:focus,\n    &:hover {\n        background-color: #0073a8;\n    }\n}\n\n.ais-RefinementList-showMore {\n    &:focus,\n    &:hover {\n        background-color: #0073a8;\n    }\n}\n\n.ais-ClearRefinements-button--disabled,\n.ais-GeoSearch-redo--disabled,\n.ais-GeoSearch-reset--disabled,\n.ais-HierarchicalMenu-showMore--disabled,\n.ais-InfiniteHits-loadMore--disabled,\n.ais-InfiniteResults-loadMore--disabled,\n.ais-Menu-showMore--disabled,\n.ais-RefinementList-showMore--disabled {\n    opacity: .6;\n    cursor: not-allowed;\n}\n\n.ais-ClearRefinements-button--disabled {\n    &:focus,\n    &:hover {\n        background-color: #0096db;\n    }\n}\n\n.ais-GeoSearch-redo--disabled {\n    &:focus,\n    &:hover {\n        background-color: #0096db;\n    }\n}\n\n.ais-GeoSearch-reset--disabled {\n    &:focus,\n    &:hover {\n        background-color: #0096db;\n    }\n}\n\n.ais-HierarchicalMenu-showMore--disabled {\n    &:focus,\n    &:hover {\n        background-color: #0096db;\n    }\n}\n\n.ais-InfiniteHits-loadMore--disabled {\n    &:focus,\n    &:hover {\n        background-color: #0096db;\n    }\n}\n\n.ais-InfiniteResults-loadMore--disabled {\n    &:focus,\n    &:hover {\n        background-color: #0096db;\n    }\n}\n\n.ais-Menu-showMore--disabled {\n    &:focus,\n    &:hover {\n        background-color: #0096db;\n    }\n}\n\n.ais-RefinementList-showMore--disabled {\n    &:focus,\n    &:hover {\n        background-color: #0096db;\n    }\n}\n\n.ais-InfiniteHits-loadPrevious--disabled {\n    display: none;\n}\n\n.ais-CurrentRefinements {\n    margin-top: -.3rem;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n.ais-CurrentRefinements-list {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n.ais-CurrentRefinements-item {\n    margin-right: .3rem;\n    margin-top: .3rem;\n    padding: .3rem .5rem;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    background-color: #495588;\n    border-radius: 5px;\n}\n\n.ais-CurrentRefinements-category {\n    margin-left: .3em;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.ais-CurrentRefinements-delete {\n    margin-left: .3rem;\n}\n\n.ais-CurrentRefinements-categoryLabel,\n.ais-CurrentRefinements-delete,\n.ais-CurrentRefinements-label {\n    white-space: nowrap;\n    font-size: .8rem;\n    color: #fff;\n}\n\n.ais-CurrentRefinements-reset {\n    margin-top: .3rem;\n    white-space: nowrap;\n    +.ais-CurrentRefinements-list {\n        margin-left: .3rem;\n    }\n}\n\n.ais-GeoSearch {\n    position: relative;\n}\n\n.ais-GeoSearch-control {\n    position: absolute;\n    top: .8rem;\n    left: 3.75rem;\n}\n\n.ais-GeoSearch-label {\n    display: block;\n    padding: .3rem .5rem;\n    font-size: .8rem;\n    background-color: #fff;\n    border-radius: 5px;\n    transition: background-color .2s ease-out;\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n    outline: none;\n}\n\n.ais-GeoSearch-input {\n    margin: 0 .25rem 0 0;\n}\n\n.ais-GeoSearch-label,\n.ais-GeoSearch-redo {\n    white-space: nowrap;\n}\n\n.ais-GeoSearch-reset {\n    white-space: nowrap;\n    position: absolute;\n    bottom: 1.25rem;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n}\n\n.ais-HierarchicalMenu-link,\n.ais-Menu-link {\n    display: block;\n    line-height: 1.5;\n}\n\n.ais-HierarchicalMenu-list,\n.ais-Menu-list,\n.ais-NumericMenu-list,\n.ais-RatingMenu-list,\n.ais-RefinementList-list {\n    font-weight: 400;\n    line-height: 1.5;\n}\n\n.ais-HierarchicalMenu-link:after {\n    margin-left: .3em;\n    content: \"\";\n    width: 10px;\n    height: 10px;\n    display: none;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M7.3 24l-2.8-2.8 9.3-9.2-9.3-9.2L7.3 0l12.2 12z' fill='%233A4570'/%3E%3C/svg%3E\");\n    background-size: 100% 100%;\n}\n\n.ais-HierarchicalMenu-item--parent>.ais-HierarchicalMenu-link:after {\n    display: inline-block;\n}\n\n.ais-HierarchicalMenu-item--selected>.ais-HierarchicalMenu-link:after {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n\n.ais-CurrentRefinements-count,\n.ais-RatingMenu-count {\n    font-size: .8rem;\n}\n\n.ais-CurrentRefinements-count:before,\n.ais-RatingMenu-count:before {\n    content: \"(\";\n}\n\n.ais-CurrentRefinements-count:after,\n.ais-RatingMenu-count:after {\n    content: \")\";\n}\n\n.ais-HierarchicalMenu-count,\n.ais-Menu-count,\n.ais-RefinementList-count,\n.ais-ToggleRefinement-count {\n    padding: .1rem .4rem;\n    font-size: .8rem;\n    color: #3a4570;\n    background-color: #dfe2ee;\n    border-radius: 8px;\n}\n\n.ais-HierarchicalMenu-showMore,\n.ais-Menu-showMore,\n.ais-RefinementList-showMore {\n    margin-top: .5rem;\n}\n\n.ais-Highlight-highlighted,\n.ais-Snippet-highlighted {\n    background-color: #ffc168;\n}\n\n.ais-Hits-list,\n.ais-InfiniteHits-list,\n.ais-InfiniteResults-list,\n.ais-Results-list {\n    margin-top: -1rem;\n    margin-left: -1rem;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n.ais-Panel-body {\n    .ais-Hits-list,\n    .ais-InfiniteHits-list,\n    .ais-InfiniteResults-list,\n    .ais-Results-list {\n        margin: .5rem 0 0 -1rem;\n    }\n}\n\n.ais-Hits-item,\n.ais-InfiniteHits-item,\n.ais-InfiniteResults-item,\n.ais-Results-item {\n    margin-top: 1rem;\n    margin-left: 1rem;\n    padding: 1rem;\n    width: calc(25% - 1rem);\n    border: 1px solid #c4c8d8;\n    box-shadow: 0 2px 5px 0 #e3e5ec;\n}\n\n.ais-Panel-body {\n    .ais-Hits-item,\n    .ais-InfiniteHits-item,\n    .ais-InfiniteResults-item,\n    .ais-Results-item {\n        margin: .5rem 0 .5rem 1rem;\n    }\n}\n\n.ais-InfiniteHits-loadMore,\n.ais-InfiniteResults-loadMore {\n    margin-top: 1rem;\n}\n\n.ais-InfiniteHits-loadPrevious {\n    margin-bottom: 1rem;\n}\n\n.ais-HitsPerPage-select,\n.ais-MenuSelect-select,\n.ais-NumericSelector-select,\n.ais-ResultsPerPage-select,\n.ais-SortBy-select {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    padding: .3rem 2rem .3rem .3rem;\n    max-width: 100%;\n    background-color: #fff;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M0 7.3l2.8-2.8 9.2 9.3 9.2-9.3L24 7.3 12 19.5z' fill='%233A4570'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-size: 10px 10px;\n    background-position: 92% 50%;\n    border: 1px solid #c4c8d8;\n    border-radius: 5px;\n}\n\n.ais-Panel--collapsible {\n    position: relative;\n    &.ais-Panel--collapsed {\n        .ais-Panel-body,\n        .ais-Panel-footer {\n            display: none;\n        }\n    }\n    .ais-Panel-collapseButton {\n        position: absolute;\n        top: 0;\n        right: 0;\n        padding: 0;\n        border: none;\n        background: none;\n    }\n}\n\n.ais-Panel-header {\n    margin-bottom: .5rem;\n    padding-bottom: .5rem;\n    font-size: .8rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    border-bottom: 1px solid #c4c8d8;\n}\n\n.ais-Panel-footer {\n    margin-top: .5rem;\n    font-size: .8rem;\n}\n\n.ais-RangeInput-input {\n    padding: 0 .2rem;\n    width: 5rem;\n    height: 1.5rem;\n    line-height: 1.5rem;\n}\n\n.ais-RangeInput-separator {\n    margin: 0 .3rem;\n}\n\n.ais-RangeInput-submit {\n    margin-left: .3rem;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    padding: 0 .5rem;\n    height: 1.5rem;\n    line-height: 1.5rem;\n    font-size: .8rem;\n    color: #fff;\n    background-color: #0096db;\n    border: none;\n    border-radius: 5px;\n    transition: .2s ease-out;\n    outline: none;\n    &:focus,\n    &:hover {\n        background-color: #0073a8;\n    }\n}\n\n.ais-RatingMenu-count {\n    color: #3a4570;\n}\n\n.ais-Pagination-list {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n.ais-Pagination-item+.ais-Pagination-item {\n    margin-left: .3rem;\n}\n\n.ais-Pagination-link {\n    padding: .3rem .6rem;\n    display: block;\n    border: 1px solid #c4c8d8;\n    border-radius: 5px;\n    transition: background-color .2s ease-out;\n    &:focus,\n    &:hover {\n        background-color: #e3e5ec;\n    }\n}\n\n.ais-Pagination-item--disabled .ais-Pagination-link {\n    opacity: .6;\n    cursor: not-allowed;\n    color: #a5abc4;\n    &:focus,\n    &:hover {\n        color: #a5abc4;\n        background-color: #fff;\n    }\n}\n\n.ais-Pagination-item--selected .ais-Pagination-link {\n    color: #fff;\n    background-color: #0096db;\n    border-color: #0096db;\n    &:focus,\n    &:hover {\n        color: #fff;\n    }\n}\n\n.ais-PoweredBy-text,\n.ais-Stats-text,\n.rheostat-tooltip,\n.rheostat-value {\n    font-size: .8rem;\n}\n\n.ais-PoweredBy-logo {\n    margin-left: .3rem;\n}\n\n.ais-RangeSlider {\n    .rheostat-progress {\n        background-color: #495588;\n    }\n    .rheostat-background {\n        border-color: #878faf;\n        box-sizing: border-box;\n    }\n    .rheostat-handle {\n        border-color: #878faf;\n    }\n    .rheostat-marker {\n        background-color: #878faf;\n    }\n}\n\n.ais-Panel-body .ais-RangeSlider {\n    margin: 2rem 0;\n}\n\n.ais-RangeSlider-handle {\n    width: 20px;\n    height: 20px;\n    position: relative;\n    z-index: 1;\n    background: #fff;\n    border: 1px solid #46aeda;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.ais-RangeSlider-tooltip {\n    position: absolute;\n    background: #fff;\n    top: -22px;\n    font-size: .8em;\n}\n\n.ais-RangeSlider-value {\n    width: 40px;\n    position: absolute;\n    text-align: center;\n    margin-left: -20px;\n    padding-top: 15px;\n    font-size: .8em;\n}\n\n.ais-RangeSlider-marker {\n    position: absolute;\n    background: #ddd;\n    margin-left: -1px;\n    width: 1px;\n    height: 5px;\n}\n\n.ais-RatingMenu-item--disabled {\n    .ais-RatingMenu-count,\n    .ais-RatingMenu-label {\n        color: #c4c8d8;\n    }\n}\n\n.ais-RatingMenu-item--selected {\n    font-weight: 700;\n}\n\n.ais-RatingMenu-link {\n    line-height: 1.5;\n    >*+* {\n        margin-left: .3rem;\n    }\n}\n\n.ais-RatingMenu-starIcon {\n    position: relative;\n    top: -1px;\n    width: 15px;\n    fill: #ffc168;\n}\n\n.ais-RatingMenu-item--disabled .ais-RatingMenu-starIcon {\n    fill: #c4c8d8;\n}\n\n.ais-HierarchicalMenu-searchBox>*,\n.ais-Menu-searchBox>*,\n.ais-RefinementList-searchBox>* {\n    margin-bottom: .5rem;\n}\n\n.ais-SearchBox-form {\n    display: block;\n    position: relative;\n}\n\n.ais-SearchBox-input {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    padding: .3rem 1.7rem;\n    width: 100%;\n    position: relative;\n    background-color: #fff;\n    border: 1px solid #c4c8d8;\n    border-radius: 5px;\n    &::-webkit-input-placeholder,\n    &::-moz-placeholder,\n    &:-ms-input-placeholder,\n    &:-moz-placeholder {\n        color: #a5aed1;\n    }\n}\n\n.ais-SearchBox-loadingIndicator,\n.ais-SearchBox-reset {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    position: absolute;\n    z-index: 1;\n    width: 20px;\n    height: 20px;\n    top: 50%;\n    right: .3rem;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n.ais-SearchBox-submit {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    position: absolute;\n    z-index: 1;\n    width: 20px;\n    height: 20px;\n    top: 50%;\n    right: .3rem;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    left: .3rem;\n}\n\n.ais-SearchBox-reset {\n    right: .3rem;\n}\n\n.ais-SearchBox-loadingIcon,\n.ais-SearchBox-resetIcon,\n.ais-SearchBox-submitIcon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translateX(-50%) translateY(-50%);\n    transform: translateX(-50%) translateY(-50%);\n}\n\n.ais-SearchBox-resetIcon path {\n    fill: #495588;\n}\n\n.ais-SearchBox-submitIcon {\n    path {\n        fill: #495588;\n    }\n    width: 14px;\n    height: 14px;\n}\n\n.ais-SearchBox-resetIcon {\n    width: 12px;\n    height: 12px;\n}\n\n.ais-SearchBox-loadingIcon {\n    width: 16px;\n    height: 16px;\n}\n\n.ais-VoiceSearch-button {\n    border: none;\n    width: 24px;\n    height: 24px;\n    padding: 4px;\n    border-radius: 50%;\n    color: #3a4570;\n    background-color: transparent;\n    svg {\n        color: currentColor;\n    }\n    &:hover {\n        cursor: pointer;\n        background-color: #a5aed1;\n        color: #fff;\n    }\n    &:disabled {\n        color: #a5aed1;\n        &:hover {\n            color: #a5aed1;\n            cursor: not-allowed;\n            background: inherit;\n        }\n    }\n}",".btn {\n    padding: 7.5px 15px;\n    background: $royalblue;\n    border: 1px $white solid;\n    border-radius: 4px;\n    &:hover {\n        text-decoration: none;\n        background-color: $white;\n        color: $blueviolet;\n        transition: ease-in 0.5s;\n    }\n}\n\n.btn.secondary {\n    background: $royalblue;\n    border-radius: 5px;\n    border: 2px solid $royalblue;\n    color: $white;\n    &:hover {\n        background-color: transparent;\n        color: $blueviolet;\n        border-radius: 5px;\n        border: 1px solid $blueviolet;\n        transition: ease-in 0.5s;\n    }\n}\n\n.btn.rounded {\n    border-radius: 20px;\n    padding: 15px;\n}","$irisblue: #07BAD6;\n$safron: #F4BB38;\n$fuego: #C3D830;\n$tahitigold: #D97C30;\n$royalblue: #306BD9;\n$blueviolet: #9230D9;\n$white: #ffffff;","/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n// Font Awesome core compile (Web Fonts-based)\n// -------------------------\n\n@import 'functions';\n@import 'variables';\n@import 'mixins';\n@import 'core';\n@import 'sizing';\n@import 'fixed-width';\n@import 'list';\n@import 'bordered-pulled';\n@import 'animated';\n@import 'rotated-flipped';\n@import 'stacked';\n@import 'icons';\n@import 'screen-reader';\n","// base icon class definition\n// -------------------------\n\n.#{$fa-css-prefix} {\n  font-family: var(--#{$fa-css-prefix}-style-family, '#{$fa-style-family}');\n  font-weight: var(--#{$fa-css-prefix}-style, #{$fa-style});\n}\n\n.#{$fa-css-prefix},\n.#{$fa-css-prefix}-classic,\n.#{$fa-css-prefix}-sharp,\n.fas,\n.#{$fa-css-prefix}-solid,\n.far,\n.#{$fa-css-prefix}-regular,\n.fab,\n.#{$fa-css-prefix}-brands {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: var(--#{$fa-css-prefix}-display, #{$fa-display});\n  font-style: normal;\n  font-variant: normal;\n  line-height: 1;\n  text-rendering: auto;\n}\n\n.fas,\n.#{$fa-css-prefix}-classic,\n.#{$fa-css-prefix}-solid,\n.far,\n.#{$fa-css-prefix}-regular {\n  font-family: 'Font Awesome 6 Free';\n}\n\n.fab,\n.#{$fa-css-prefix}-brands {\n  font-family: 'Font Awesome 6 Brands';\n}\n\n\n%fa-icon {\n  @include fa-icon;\n}\n","// sizing icons\n// -------------------------\n\n// literal magnification scale\n@for $i from 1 through 10 {\n  .#{$fa-css-prefix}-#{$i}x {\n    font-size: $i * 1em;\n  }\n}\n\n// step-based scale (with alignment)\n@each $size, $value in $fa-sizes {\n  .#{$fa-css-prefix}-#{$size} {\n     @include fa-size($value);\n  }\n}\n","// mixins\n// --------------------------\n\n// base rendering for an icon\n@mixin fa-icon {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  line-height: 1;\n}\n\n// sets relative font-sizing and alignment (in _sizing)\n@mixin fa-size ($font-size) {\n  font-size: fa-divide($font-size, $fa-size-scale-base) * 1em; // converts step in sizing scale into an em-based value that's relative to the scale's base\n  line-height: fa-divide(1, $font-size) * 1em; // sets the line-height of the icon back to that of it's parent\n  vertical-align: (fa-divide(6, $font-size) - fa-divide(3, 8)) * 1em; // vertically centers the icon taking into account the surrounding text's descender\n}\n\n// only display content to screen readers\n// see: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// see: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n@mixin fa-sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n@mixin fa-sr-only-focusable() {\n  &:not(:focus) {\n    @include fa-sr-only();\n  }\n}\n\n// sets a specific icon family to use alongside style + icon mixins\n\n// convenience mixins for declaring pseudo-elements by CSS variable,\n// including all style-specific font properties, and both the ::before\n// and ::after elements in the duotone case.\n@mixin fa-icon-solid($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-solid;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n@mixin fa-icon-regular($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-regular;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n@mixin fa-icon-brands($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-brands;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n","// fixed-width icons\n// -------------------------\n\n.#{$fa-css-prefix}-fw {\n  text-align: center;\n  width: $fa-fw-width;\n}\n","// variables\n// --------------------------\n\n$fa-css-prefix          : fa !default;\n$fa-style               : 900 !default;\n$fa-style-family        : \"Font Awesome 6 Free\" !default;\n\n$fa-display             : inline-block !default;\n\n$fa-fw-width            : fa-divide(20em, 16) !default;\n$fa-inverse             : #fff !default;\n\n$fa-border-color        : #eee !default;\n$fa-border-padding      : .2em .25em .15em !default;\n$fa-border-radius       : .1em !default;\n$fa-border-style        : solid !default;\n$fa-border-width        : .08em !default;\n\n$fa-size-scale-2xs      : 10 !default;\n$fa-size-scale-xs       : 12 !default;\n$fa-size-scale-sm       : 14 !default;\n$fa-size-scale-base     : 16 !default;\n$fa-size-scale-lg       : 20 !default;\n$fa-size-scale-xl       : 24 !default;\n$fa-size-scale-2xl      : 32 !default;\n\n$fa-sizes: (\n  \"2xs\"                 : $fa-size-scale-2xs,\n  \"xs\"                  : $fa-size-scale-xs,\n  \"sm\"                  : $fa-size-scale-sm,\n  \"lg\"                  : $fa-size-scale-lg,\n  \"xl\"                  : $fa-size-scale-xl,\n  \"2xl\"                 : $fa-size-scale-2xl\n) !default;\n\n$fa-li-width            : 2em !default;\n$fa-li-margin           : $fa-li-width * fa-divide(5, 4) !default;\n\n$fa-pull-margin         : .3em !default;\n\n$fa-primary-opacity     : 1 !default;\n$fa-secondary-opacity   : .4 !default;\n\n$fa-stack-vertical-align: middle !default;\n$fa-stack-width         : ($fa-fw-width * 2) !default;\n$fa-stack-z-index       : auto !default;\n\n$fa-font-display        : block !default;\n$fa-font-path           : \"../webfonts\" !default;\n\n$fa-var-0: \\30;\n$fa-var-1: \\31;\n$fa-var-2: \\32;\n$fa-var-3: \\33;\n$fa-var-4: \\34;\n$fa-var-5: \\35;\n$fa-var-6: \\36;\n$fa-var-7: \\37;\n$fa-var-8: \\38;\n$fa-var-9: \\39;\n$fa-var-fill-drip: \\f576;\n$fa-var-arrows-to-circle: \\e4bd;\n$fa-var-circle-chevron-right: \\f138;\n$fa-var-chevron-circle-right: \\f138;\n$fa-var-at: \\40;\n$fa-var-trash-can: \\f2ed;\n$fa-var-trash-alt: \\f2ed;\n$fa-var-text-height: \\f034;\n$fa-var-user-xmark: \\f235;\n$fa-var-user-times: \\f235;\n$fa-var-stethoscope: \\f0f1;\n$fa-var-message: \\f27a;\n$fa-var-comment-alt: \\f27a;\n$fa-var-info: \\f129;\n$fa-var-down-left-and-up-right-to-center: \\f422;\n$fa-var-compress-alt: \\f422;\n$fa-var-explosion: \\e4e9;\n$fa-var-file-lines: \\f15c;\n$fa-var-file-alt: \\f15c;\n$fa-var-file-text: \\f15c;\n$fa-var-wave-square: \\f83e;\n$fa-var-ring: \\f70b;\n$fa-var-building-un: \\e4d9;\n$fa-var-dice-three: \\f527;\n$fa-var-calendar-days: \\f073;\n$fa-var-calendar-alt: \\f073;\n$fa-var-anchor-circle-check: \\e4aa;\n$fa-var-building-circle-arrow-right: \\e4d1;\n$fa-var-volleyball: \\f45f;\n$fa-var-volleyball-ball: \\f45f;\n$fa-var-arrows-up-to-line: \\e4c2;\n$fa-var-sort-down: \\f0dd;\n$fa-var-sort-desc: \\f0dd;\n$fa-var-circle-minus: \\f056;\n$fa-var-minus-circle: \\f056;\n$fa-var-door-open: \\f52b;\n$fa-var-right-from-bracket: \\f2f5;\n$fa-var-sign-out-alt: \\f2f5;\n$fa-var-atom: \\f5d2;\n$fa-var-soap: \\e06e;\n$fa-var-icons: \\f86d;\n$fa-var-heart-music-camera-bolt: \\f86d;\n$fa-var-microphone-lines-slash: \\f539;\n$fa-var-microphone-alt-slash: \\f539;\n$fa-var-bridge-circle-check: \\e4c9;\n$fa-var-pump-medical: \\e06a;\n$fa-var-fingerprint: \\f577;\n$fa-var-hand-point-right: \\f0a4;\n$fa-var-magnifying-glass-location: \\f689;\n$fa-var-search-location: \\f689;\n$fa-var-forward-step: \\f051;\n$fa-var-step-forward: \\f051;\n$fa-var-face-smile-beam: \\f5b8;\n$fa-var-smile-beam: \\f5b8;\n$fa-var-flag-checkered: \\f11e;\n$fa-var-football: \\f44e;\n$fa-var-football-ball: \\f44e;\n$fa-var-school-circle-exclamation: \\e56c;\n$fa-var-crop: \\f125;\n$fa-var-angles-down: \\f103;\n$fa-var-angle-double-down: \\f103;\n$fa-var-users-rectangle: \\e594;\n$fa-var-people-roof: \\e537;\n$fa-var-people-line: \\e534;\n$fa-var-beer-mug-empty: \\f0fc;\n$fa-var-beer: \\f0fc;\n$fa-var-diagram-predecessor: \\e477;\n$fa-var-arrow-up-long: \\f176;\n$fa-var-long-arrow-up: \\f176;\n$fa-var-fire-flame-simple: \\f46a;\n$fa-var-burn: \\f46a;\n$fa-var-person: \\f183;\n$fa-var-male: \\f183;\n$fa-var-laptop: \\f109;\n$fa-var-file-csv: \\f6dd;\n$fa-var-menorah: \\f676;\n$fa-var-truck-plane: \\e58f;\n$fa-var-record-vinyl: \\f8d9;\n$fa-var-face-grin-stars: \\f587;\n$fa-var-grin-stars: \\f587;\n$fa-var-bong: \\f55c;\n$fa-var-spaghetti-monster-flying: \\f67b;\n$fa-var-pastafarianism: \\f67b;\n$fa-var-arrow-down-up-across-line: \\e4af;\n$fa-var-spoon: \\f2e5;\n$fa-var-utensil-spoon: \\f2e5;\n$fa-var-jar-wheat: \\e517;\n$fa-var-envelopes-bulk: \\f674;\n$fa-var-mail-bulk: \\f674;\n$fa-var-file-circle-exclamation: \\e4eb;\n$fa-var-circle-h: \\f47e;\n$fa-var-hospital-symbol: \\f47e;\n$fa-var-pager: \\f815;\n$fa-var-address-book: \\f2b9;\n$fa-var-contact-book: \\f2b9;\n$fa-var-strikethrough: \\f0cc;\n$fa-var-k: \\4b;\n$fa-var-landmark-flag: \\e51c;\n$fa-var-pencil: \\f303;\n$fa-var-pencil-alt: \\f303;\n$fa-var-backward: \\f04a;\n$fa-var-caret-right: \\f0da;\n$fa-var-comments: \\f086;\n$fa-var-paste: \\f0ea;\n$fa-var-file-clipboard: \\f0ea;\n$fa-var-code-pull-request: \\e13c;\n$fa-var-clipboard-list: \\f46d;\n$fa-var-truck-ramp-box: \\f4de;\n$fa-var-truck-loading: \\f4de;\n$fa-var-user-check: \\f4fc;\n$fa-var-vial-virus: \\e597;\n$fa-var-sheet-plastic: \\e571;\n$fa-var-blog: \\f781;\n$fa-var-user-ninja: \\f504;\n$fa-var-person-arrow-up-from-line: \\e539;\n$fa-var-scroll-torah: \\f6a0;\n$fa-var-torah: \\f6a0;\n$fa-var-broom-ball: \\f458;\n$fa-var-quidditch: \\f458;\n$fa-var-quidditch-broom-ball: \\f458;\n$fa-var-toggle-off: \\f204;\n$fa-var-box-archive: \\f187;\n$fa-var-archive: \\f187;\n$fa-var-person-drowning: \\e545;\n$fa-var-arrow-down-9-1: \\f886;\n$fa-var-sort-numeric-desc: \\f886;\n$fa-var-sort-numeric-down-alt: \\f886;\n$fa-var-face-grin-tongue-squint: \\f58a;\n$fa-var-grin-tongue-squint: \\f58a;\n$fa-var-spray-can: \\f5bd;\n$fa-var-truck-monster: \\f63b;\n$fa-var-w: \\57;\n$fa-var-earth-africa: \\f57c;\n$fa-var-globe-africa: \\f57c;\n$fa-var-rainbow: \\f75b;\n$fa-var-circle-notch: \\f1ce;\n$fa-var-tablet-screen-button: \\f3fa;\n$fa-var-tablet-alt: \\f3fa;\n$fa-var-paw: \\f1b0;\n$fa-var-cloud: \\f0c2;\n$fa-var-trowel-bricks: \\e58a;\n$fa-var-face-flushed: \\f579;\n$fa-var-flushed: \\f579;\n$fa-var-hospital-user: \\f80d;\n$fa-var-tent-arrow-left-right: \\e57f;\n$fa-var-gavel: \\f0e3;\n$fa-var-legal: \\f0e3;\n$fa-var-binoculars: \\f1e5;\n$fa-var-microphone-slash: \\f131;\n$fa-var-box-tissue: \\e05b;\n$fa-var-motorcycle: \\f21c;\n$fa-var-bell-concierge: \\f562;\n$fa-var-concierge-bell: \\f562;\n$fa-var-pen-ruler: \\f5ae;\n$fa-var-pencil-ruler: \\f5ae;\n$fa-var-people-arrows: \\e068;\n$fa-var-people-arrows-left-right: \\e068;\n$fa-var-mars-and-venus-burst: \\e523;\n$fa-var-square-caret-right: \\f152;\n$fa-var-caret-square-right: \\f152;\n$fa-var-scissors: \\f0c4;\n$fa-var-cut: \\f0c4;\n$fa-var-sun-plant-wilt: \\e57a;\n$fa-var-toilets-portable: \\e584;\n$fa-var-hockey-puck: \\f453;\n$fa-var-table: \\f0ce;\n$fa-var-magnifying-glass-arrow-right: \\e521;\n$fa-var-tachograph-digital: \\f566;\n$fa-var-digital-tachograph: \\f566;\n$fa-var-users-slash: \\e073;\n$fa-var-clover: \\e139;\n$fa-var-reply: \\f3e5;\n$fa-var-mail-reply: \\f3e5;\n$fa-var-star-and-crescent: \\f699;\n$fa-var-house-fire: \\e50c;\n$fa-var-square-minus: \\f146;\n$fa-var-minus-square: \\f146;\n$fa-var-helicopter: \\f533;\n$fa-var-compass: \\f14e;\n$fa-var-square-caret-down: \\f150;\n$fa-var-caret-square-down: \\f150;\n$fa-var-file-circle-question: \\e4ef;\n$fa-var-laptop-code: \\f5fc;\n$fa-var-swatchbook: \\f5c3;\n$fa-var-prescription-bottle: \\f485;\n$fa-var-bars: \\f0c9;\n$fa-var-navicon: \\f0c9;\n$fa-var-people-group: \\e533;\n$fa-var-hourglass-end: \\f253;\n$fa-var-hourglass-3: \\f253;\n$fa-var-heart-crack: \\f7a9;\n$fa-var-heart-broken: \\f7a9;\n$fa-var-square-up-right: \\f360;\n$fa-var-external-link-square-alt: \\f360;\n$fa-var-face-kiss-beam: \\f597;\n$fa-var-kiss-beam: \\f597;\n$fa-var-film: \\f008;\n$fa-var-ruler-horizontal: \\f547;\n$fa-var-people-robbery: \\e536;\n$fa-var-lightbulb: \\f0eb;\n$fa-var-caret-left: \\f0d9;\n$fa-var-circle-exclamation: \\f06a;\n$fa-var-exclamation-circle: \\f06a;\n$fa-var-school-circle-xmark: \\e56d;\n$fa-var-arrow-right-from-bracket: \\f08b;\n$fa-var-sign-out: \\f08b;\n$fa-var-circle-chevron-down: \\f13a;\n$fa-var-chevron-circle-down: \\f13a;\n$fa-var-unlock-keyhole: \\f13e;\n$fa-var-unlock-alt: \\f13e;\n$fa-var-cloud-showers-heavy: \\f740;\n$fa-var-headphones-simple: \\f58f;\n$fa-var-headphones-alt: \\f58f;\n$fa-var-sitemap: \\f0e8;\n$fa-var-circle-dollar-to-slot: \\f4b9;\n$fa-var-donate: \\f4b9;\n$fa-var-memory: \\f538;\n$fa-var-road-spikes: \\e568;\n$fa-var-fire-burner: \\e4f1;\n$fa-var-flag: \\f024;\n$fa-var-hanukiah: \\f6e6;\n$fa-var-feather: \\f52d;\n$fa-var-volume-low: \\f027;\n$fa-var-volume-down: \\f027;\n$fa-var-comment-slash: \\f4b3;\n$fa-var-cloud-sun-rain: \\f743;\n$fa-var-compress: \\f066;\n$fa-var-wheat-awn: \\e2cd;\n$fa-var-wheat-alt: \\e2cd;\n$fa-var-ankh: \\f644;\n$fa-var-hands-holding-child: \\e4fa;\n$fa-var-asterisk: \\2a;\n$fa-var-square-check: \\f14a;\n$fa-var-check-square: \\f14a;\n$fa-var-peseta-sign: \\e221;\n$fa-var-heading: \\f1dc;\n$fa-var-header: \\f1dc;\n$fa-var-ghost: \\f6e2;\n$fa-var-list: \\f03a;\n$fa-var-list-squares: \\f03a;\n$fa-var-square-phone-flip: \\f87b;\n$fa-var-phone-square-alt: \\f87b;\n$fa-var-cart-plus: \\f217;\n$fa-var-gamepad: \\f11b;\n$fa-var-circle-dot: \\f192;\n$fa-var-dot-circle: \\f192;\n$fa-var-face-dizzy: \\f567;\n$fa-var-dizzy: \\f567;\n$fa-var-egg: \\f7fb;\n$fa-var-house-medical-circle-xmark: \\e513;\n$fa-var-campground: \\f6bb;\n$fa-var-folder-plus: \\f65e;\n$fa-var-futbol: \\f1e3;\n$fa-var-futbol-ball: \\f1e3;\n$fa-var-soccer-ball: \\f1e3;\n$fa-var-paintbrush: \\f1fc;\n$fa-var-paint-brush: \\f1fc;\n$fa-var-lock: \\f023;\n$fa-var-gas-pump: \\f52f;\n$fa-var-hot-tub-person: \\f593;\n$fa-var-hot-tub: \\f593;\n$fa-var-map-location: \\f59f;\n$fa-var-map-marked: \\f59f;\n$fa-var-house-flood-water: \\e50e;\n$fa-var-tree: \\f1bb;\n$fa-var-bridge-lock: \\e4cc;\n$fa-var-sack-dollar: \\f81d;\n$fa-var-pen-to-square: \\f044;\n$fa-var-edit: \\f044;\n$fa-var-car-side: \\f5e4;\n$fa-var-share-nodes: \\f1e0;\n$fa-var-share-alt: \\f1e0;\n$fa-var-heart-circle-minus: \\e4ff;\n$fa-var-hourglass-half: \\f252;\n$fa-var-hourglass-2: \\f252;\n$fa-var-microscope: \\f610;\n$fa-var-sink: \\e06d;\n$fa-var-bag-shopping: \\f290;\n$fa-var-shopping-bag: \\f290;\n$fa-var-arrow-down-z-a: \\f881;\n$fa-var-sort-alpha-desc: \\f881;\n$fa-var-sort-alpha-down-alt: \\f881;\n$fa-var-mitten: \\f7b5;\n$fa-var-person-rays: \\e54d;\n$fa-var-users: \\f0c0;\n$fa-var-eye-slash: \\f070;\n$fa-var-flask-vial: \\e4f3;\n$fa-var-hand: \\f256;\n$fa-var-hand-paper: \\f256;\n$fa-var-om: \\f679;\n$fa-var-worm: \\e599;\n$fa-var-house-circle-xmark: \\e50b;\n$fa-var-plug: \\f1e6;\n$fa-var-chevron-up: \\f077;\n$fa-var-hand-spock: \\f259;\n$fa-var-stopwatch: \\f2f2;\n$fa-var-face-kiss: \\f596;\n$fa-var-kiss: \\f596;\n$fa-var-bridge-circle-xmark: \\e4cb;\n$fa-var-face-grin-tongue: \\f589;\n$fa-var-grin-tongue: \\f589;\n$fa-var-chess-bishop: \\f43a;\n$fa-var-face-grin-wink: \\f58c;\n$fa-var-grin-wink: \\f58c;\n$fa-var-ear-deaf: \\f2a4;\n$fa-var-deaf: \\f2a4;\n$fa-var-deafness: \\f2a4;\n$fa-var-hard-of-hearing: \\f2a4;\n$fa-var-road-circle-check: \\e564;\n$fa-var-dice-five: \\f523;\n$fa-var-square-rss: \\f143;\n$fa-var-rss-square: \\f143;\n$fa-var-land-mine-on: \\e51b;\n$fa-var-i-cursor: \\f246;\n$fa-var-stamp: \\f5bf;\n$fa-var-stairs: \\e289;\n$fa-var-i: \\49;\n$fa-var-hryvnia-sign: \\f6f2;\n$fa-var-hryvnia: \\f6f2;\n$fa-var-pills: \\f484;\n$fa-var-face-grin-wide: \\f581;\n$fa-var-grin-alt: \\f581;\n$fa-var-tooth: \\f5c9;\n$fa-var-v: \\56;\n$fa-var-bangladeshi-taka-sign: \\e2e6;\n$fa-var-bicycle: \\f206;\n$fa-var-staff-snake: \\e579;\n$fa-var-rod-asclepius: \\e579;\n$fa-var-rod-snake: \\e579;\n$fa-var-staff-aesculapius: \\e579;\n$fa-var-head-side-cough-slash: \\e062;\n$fa-var-truck-medical: \\f0f9;\n$fa-var-ambulance: \\f0f9;\n$fa-var-wheat-awn-circle-exclamation: \\e598;\n$fa-var-snowman: \\f7d0;\n$fa-var-mortar-pestle: \\f5a7;\n$fa-var-road-barrier: \\e562;\n$fa-var-school: \\f549;\n$fa-var-igloo: \\f7ae;\n$fa-var-joint: \\f595;\n$fa-var-angle-right: \\f105;\n$fa-var-horse: \\f6f0;\n$fa-var-q: \\51;\n$fa-var-g: \\47;\n$fa-var-notes-medical: \\f481;\n$fa-var-temperature-half: \\f2c9;\n$fa-var-temperature-2: \\f2c9;\n$fa-var-thermometer-2: \\f2c9;\n$fa-var-thermometer-half: \\f2c9;\n$fa-var-dong-sign: \\e169;\n$fa-var-capsules: \\f46b;\n$fa-var-poo-storm: \\f75a;\n$fa-var-poo-bolt: \\f75a;\n$fa-var-face-frown-open: \\f57a;\n$fa-var-frown-open: \\f57a;\n$fa-var-hand-point-up: \\f0a6;\n$fa-var-money-bill: \\f0d6;\n$fa-var-bookmark: \\f02e;\n$fa-var-align-justify: \\f039;\n$fa-var-umbrella-beach: \\f5ca;\n$fa-var-helmet-un: \\e503;\n$fa-var-bullseye: \\f140;\n$fa-var-bacon: \\f7e5;\n$fa-var-hand-point-down: \\f0a7;\n$fa-var-arrow-up-from-bracket: \\e09a;\n$fa-var-folder: \\f07b;\n$fa-var-folder-blank: \\f07b;\n$fa-var-file-waveform: \\f478;\n$fa-var-file-medical-alt: \\f478;\n$fa-var-radiation: \\f7b9;\n$fa-var-chart-simple: \\e473;\n$fa-var-mars-stroke: \\f229;\n$fa-var-vial: \\f492;\n$fa-var-gauge: \\f624;\n$fa-var-dashboard: \\f624;\n$fa-var-gauge-med: \\f624;\n$fa-var-tachometer-alt-average: \\f624;\n$fa-var-wand-magic-sparkles: \\e2ca;\n$fa-var-magic-wand-sparkles: \\e2ca;\n$fa-var-e: \\45;\n$fa-var-pen-clip: \\f305;\n$fa-var-pen-alt: \\f305;\n$fa-var-bridge-circle-exclamation: \\e4ca;\n$fa-var-user: \\f007;\n$fa-var-school-circle-check: \\e56b;\n$fa-var-dumpster: \\f793;\n$fa-var-van-shuttle: \\f5b6;\n$fa-var-shuttle-van: \\f5b6;\n$fa-var-building-user: \\e4da;\n$fa-var-square-caret-left: \\f191;\n$fa-var-caret-square-left: \\f191;\n$fa-var-highlighter: \\f591;\n$fa-var-key: \\f084;\n$fa-var-bullhorn: \\f0a1;\n$fa-var-globe: \\f0ac;\n$fa-var-synagogue: \\f69b;\n$fa-var-person-half-dress: \\e548;\n$fa-var-road-bridge: \\e563;\n$fa-var-location-arrow: \\f124;\n$fa-var-c: \\43;\n$fa-var-tablet-button: \\f10a;\n$fa-var-building-lock: \\e4d6;\n$fa-var-pizza-slice: \\f818;\n$fa-var-money-bill-wave: \\f53a;\n$fa-var-chart-area: \\f1fe;\n$fa-var-area-chart: \\f1fe;\n$fa-var-house-flag: \\e50d;\n$fa-var-person-circle-minus: \\e540;\n$fa-var-ban: \\f05e;\n$fa-var-cancel: \\f05e;\n$fa-var-camera-rotate: \\e0d8;\n$fa-var-spray-can-sparkles: \\f5d0;\n$fa-var-air-freshener: \\f5d0;\n$fa-var-star: \\f005;\n$fa-var-repeat: \\f363;\n$fa-var-cross: \\f654;\n$fa-var-box: \\f466;\n$fa-var-venus-mars: \\f228;\n$fa-var-arrow-pointer: \\f245;\n$fa-var-mouse-pointer: \\f245;\n$fa-var-maximize: \\f31e;\n$fa-var-expand-arrows-alt: \\f31e;\n$fa-var-charging-station: \\f5e7;\n$fa-var-shapes: \\f61f;\n$fa-var-triangle-circle-square: \\f61f;\n$fa-var-shuffle: \\f074;\n$fa-var-random: \\f074;\n$fa-var-person-running: \\f70c;\n$fa-var-running: \\f70c;\n$fa-var-mobile-retro: \\e527;\n$fa-var-grip-lines-vertical: \\f7a5;\n$fa-var-spider: \\f717;\n$fa-var-hands-bound: \\e4f9;\n$fa-var-file-invoice-dollar: \\f571;\n$fa-var-plane-circle-exclamation: \\e556;\n$fa-var-x-ray: \\f497;\n$fa-var-spell-check: \\f891;\n$fa-var-slash: \\f715;\n$fa-var-computer-mouse: \\f8cc;\n$fa-var-mouse: \\f8cc;\n$fa-var-arrow-right-to-bracket: \\f090;\n$fa-var-sign-in: \\f090;\n$fa-var-shop-slash: \\e070;\n$fa-var-store-alt-slash: \\e070;\n$fa-var-server: \\f233;\n$fa-var-virus-covid-slash: \\e4a9;\n$fa-var-shop-lock: \\e4a5;\n$fa-var-hourglass-start: \\f251;\n$fa-var-hourglass-1: \\f251;\n$fa-var-blender-phone: \\f6b6;\n$fa-var-building-wheat: \\e4db;\n$fa-var-person-breastfeeding: \\e53a;\n$fa-var-right-to-bracket: \\f2f6;\n$fa-var-sign-in-alt: \\f2f6;\n$fa-var-venus: \\f221;\n$fa-var-passport: \\f5ab;\n$fa-var-heart-pulse: \\f21e;\n$fa-var-heartbeat: \\f21e;\n$fa-var-people-carry-box: \\f4ce;\n$fa-var-people-carry: \\f4ce;\n$fa-var-temperature-high: \\f769;\n$fa-var-microchip: \\f2db;\n$fa-var-crown: \\f521;\n$fa-var-weight-hanging: \\f5cd;\n$fa-var-xmarks-lines: \\e59a;\n$fa-var-file-prescription: \\f572;\n$fa-var-weight-scale: \\f496;\n$fa-var-weight: \\f496;\n$fa-var-user-group: \\f500;\n$fa-var-user-friends: \\f500;\n$fa-var-arrow-up-a-z: \\f15e;\n$fa-var-sort-alpha-up: \\f15e;\n$fa-var-chess-knight: \\f441;\n$fa-var-face-laugh-squint: \\f59b;\n$fa-var-laugh-squint: \\f59b;\n$fa-var-wheelchair: \\f193;\n$fa-var-circle-arrow-up: \\f0aa;\n$fa-var-arrow-circle-up: \\f0aa;\n$fa-var-toggle-on: \\f205;\n$fa-var-person-walking: \\f554;\n$fa-var-walking: \\f554;\n$fa-var-l: \\4c;\n$fa-var-fire: \\f06d;\n$fa-var-bed-pulse: \\f487;\n$fa-var-procedures: \\f487;\n$fa-var-shuttle-space: \\f197;\n$fa-var-space-shuttle: \\f197;\n$fa-var-face-laugh: \\f599;\n$fa-var-laugh: \\f599;\n$fa-var-folder-open: \\f07c;\n$fa-var-heart-circle-plus: \\e500;\n$fa-var-code-fork: \\e13b;\n$fa-var-city: \\f64f;\n$fa-var-microphone-lines: \\f3c9;\n$fa-var-microphone-alt: \\f3c9;\n$fa-var-pepper-hot: \\f816;\n$fa-var-unlock: \\f09c;\n$fa-var-colon-sign: \\e140;\n$fa-var-headset: \\f590;\n$fa-var-store-slash: \\e071;\n$fa-var-road-circle-xmark: \\e566;\n$fa-var-user-minus: \\f503;\n$fa-var-mars-stroke-up: \\f22a;\n$fa-var-mars-stroke-v: \\f22a;\n$fa-var-champagne-glasses: \\f79f;\n$fa-var-glass-cheers: \\f79f;\n$fa-var-clipboard: \\f328;\n$fa-var-house-circle-exclamation: \\e50a;\n$fa-var-file-arrow-up: \\f574;\n$fa-var-file-upload: \\f574;\n$fa-var-wifi: \\f1eb;\n$fa-var-wifi-3: \\f1eb;\n$fa-var-wifi-strong: \\f1eb;\n$fa-var-bath: \\f2cd;\n$fa-var-bathtub: \\f2cd;\n$fa-var-underline: \\f0cd;\n$fa-var-user-pen: \\f4ff;\n$fa-var-user-edit: \\f4ff;\n$fa-var-signature: \\f5b7;\n$fa-var-stroopwafel: \\f551;\n$fa-var-bold: \\f032;\n$fa-var-anchor-lock: \\e4ad;\n$fa-var-building-ngo: \\e4d7;\n$fa-var-manat-sign: \\e1d5;\n$fa-var-not-equal: \\f53e;\n$fa-var-border-top-left: \\f853;\n$fa-var-border-style: \\f853;\n$fa-var-map-location-dot: \\f5a0;\n$fa-var-map-marked-alt: \\f5a0;\n$fa-var-jedi: \\f669;\n$fa-var-square-poll-vertical: \\f681;\n$fa-var-poll: \\f681;\n$fa-var-mug-hot: \\f7b6;\n$fa-var-car-battery: \\f5df;\n$fa-var-battery-car: \\f5df;\n$fa-var-gift: \\f06b;\n$fa-var-dice-two: \\f528;\n$fa-var-chess-queen: \\f445;\n$fa-var-glasses: \\f530;\n$fa-var-chess-board: \\f43c;\n$fa-var-building-circle-check: \\e4d2;\n$fa-var-person-chalkboard: \\e53d;\n$fa-var-mars-stroke-right: \\f22b;\n$fa-var-mars-stroke-h: \\f22b;\n$fa-var-hand-back-fist: \\f255;\n$fa-var-hand-rock: \\f255;\n$fa-var-square-caret-up: \\f151;\n$fa-var-caret-square-up: \\f151;\n$fa-var-cloud-showers-water: \\e4e4;\n$fa-var-chart-bar: \\f080;\n$fa-var-bar-chart: \\f080;\n$fa-var-hands-bubbles: \\e05e;\n$fa-var-hands-wash: \\e05e;\n$fa-var-less-than-equal: \\f537;\n$fa-var-train: \\f238;\n$fa-var-eye-low-vision: \\f2a8;\n$fa-var-low-vision: \\f2a8;\n$fa-var-crow: \\f520;\n$fa-var-sailboat: \\e445;\n$fa-var-window-restore: \\f2d2;\n$fa-var-square-plus: \\f0fe;\n$fa-var-plus-square: \\f0fe;\n$fa-var-torii-gate: \\f6a1;\n$fa-var-frog: \\f52e;\n$fa-var-bucket: \\e4cf;\n$fa-var-image: \\f03e;\n$fa-var-microphone: \\f130;\n$fa-var-cow: \\f6c8;\n$fa-var-caret-up: \\f0d8;\n$fa-var-screwdriver: \\f54a;\n$fa-var-folder-closed: \\e185;\n$fa-var-house-tsunami: \\e515;\n$fa-var-square-nfi: \\e576;\n$fa-var-arrow-up-from-ground-water: \\e4b5;\n$fa-var-martini-glass: \\f57b;\n$fa-var-glass-martini-alt: \\f57b;\n$fa-var-rotate-left: \\f2ea;\n$fa-var-rotate-back: \\f2ea;\n$fa-var-rotate-backward: \\f2ea;\n$fa-var-undo-alt: \\f2ea;\n$fa-var-table-columns: \\f0db;\n$fa-var-columns: \\f0db;\n$fa-var-lemon: \\f094;\n$fa-var-head-side-mask: \\e063;\n$fa-var-handshake: \\f2b5;\n$fa-var-gem: \\f3a5;\n$fa-var-dolly: \\f472;\n$fa-var-dolly-box: \\f472;\n$fa-var-smoking: \\f48d;\n$fa-var-minimize: \\f78c;\n$fa-var-compress-arrows-alt: \\f78c;\n$fa-var-monument: \\f5a6;\n$fa-var-snowplow: \\f7d2;\n$fa-var-angles-right: \\f101;\n$fa-var-angle-double-right: \\f101;\n$fa-var-cannabis: \\f55f;\n$fa-var-circle-play: \\f144;\n$fa-var-play-circle: \\f144;\n$fa-var-tablets: \\f490;\n$fa-var-ethernet: \\f796;\n$fa-var-euro-sign: \\f153;\n$fa-var-eur: \\f153;\n$fa-var-euro: \\f153;\n$fa-var-chair: \\f6c0;\n$fa-var-circle-check: \\f058;\n$fa-var-check-circle: \\f058;\n$fa-var-circle-stop: \\f28d;\n$fa-var-stop-circle: \\f28d;\n$fa-var-compass-drafting: \\f568;\n$fa-var-drafting-compass: \\f568;\n$fa-var-plate-wheat: \\e55a;\n$fa-var-icicles: \\f7ad;\n$fa-var-person-shelter: \\e54f;\n$fa-var-neuter: \\f22c;\n$fa-var-id-badge: \\f2c1;\n$fa-var-marker: \\f5a1;\n$fa-var-face-laugh-beam: \\f59a;\n$fa-var-laugh-beam: \\f59a;\n$fa-var-helicopter-symbol: \\e502;\n$fa-var-universal-access: \\f29a;\n$fa-var-circle-chevron-up: \\f139;\n$fa-var-chevron-circle-up: \\f139;\n$fa-var-lari-sign: \\e1c8;\n$fa-var-volcano: \\f770;\n$fa-var-person-walking-dashed-line-arrow-right: \\e553;\n$fa-var-sterling-sign: \\f154;\n$fa-var-gbp: \\f154;\n$fa-var-pound-sign: \\f154;\n$fa-var-viruses: \\e076;\n$fa-var-square-person-confined: \\e577;\n$fa-var-user-tie: \\f508;\n$fa-var-arrow-down-long: \\f175;\n$fa-var-long-arrow-down: \\f175;\n$fa-var-tent-arrow-down-to-line: \\e57e;\n$fa-var-certificate: \\f0a3;\n$fa-var-reply-all: \\f122;\n$fa-var-mail-reply-all: \\f122;\n$fa-var-suitcase: \\f0f2;\n$fa-var-person-skating: \\f7c5;\n$fa-var-skating: \\f7c5;\n$fa-var-filter-circle-dollar: \\f662;\n$fa-var-funnel-dollar: \\f662;\n$fa-var-camera-retro: \\f083;\n$fa-var-circle-arrow-down: \\f0ab;\n$fa-var-arrow-circle-down: \\f0ab;\n$fa-var-file-import: \\f56f;\n$fa-var-arrow-right-to-file: \\f56f;\n$fa-var-square-arrow-up-right: \\f14c;\n$fa-var-external-link-square: \\f14c;\n$fa-var-box-open: \\f49e;\n$fa-var-scroll: \\f70e;\n$fa-var-spa: \\f5bb;\n$fa-var-location-pin-lock: \\e51f;\n$fa-var-pause: \\f04c;\n$fa-var-hill-avalanche: \\e507;\n$fa-var-temperature-empty: \\f2cb;\n$fa-var-temperature-0: \\f2cb;\n$fa-var-thermometer-0: \\f2cb;\n$fa-var-thermometer-empty: \\f2cb;\n$fa-var-bomb: \\f1e2;\n$fa-var-registered: \\f25d;\n$fa-var-address-card: \\f2bb;\n$fa-var-contact-card: \\f2bb;\n$fa-var-vcard: \\f2bb;\n$fa-var-scale-unbalanced-flip: \\f516;\n$fa-var-balance-scale-right: \\f516;\n$fa-var-subscript: \\f12c;\n$fa-var-diamond-turn-right: \\f5eb;\n$fa-var-directions: \\f5eb;\n$fa-var-burst: \\e4dc;\n$fa-var-house-laptop: \\e066;\n$fa-var-laptop-house: \\e066;\n$fa-var-face-tired: \\f5c8;\n$fa-var-tired: \\f5c8;\n$fa-var-money-bills: \\e1f3;\n$fa-var-smog: \\f75f;\n$fa-var-crutch: \\f7f7;\n$fa-var-cloud-arrow-up: \\f0ee;\n$fa-var-cloud-upload: \\f0ee;\n$fa-var-cloud-upload-alt: \\f0ee;\n$fa-var-palette: \\f53f;\n$fa-var-arrows-turn-right: \\e4c0;\n$fa-var-vest: \\e085;\n$fa-var-ferry: \\e4ea;\n$fa-var-arrows-down-to-people: \\e4b9;\n$fa-var-seedling: \\f4d8;\n$fa-var-sprout: \\f4d8;\n$fa-var-left-right: \\f337;\n$fa-var-arrows-alt-h: \\f337;\n$fa-var-boxes-packing: \\e4c7;\n$fa-var-circle-arrow-left: \\f0a8;\n$fa-var-arrow-circle-left: \\f0a8;\n$fa-var-group-arrows-rotate: \\e4f6;\n$fa-var-bowl-food: \\e4c6;\n$fa-var-candy-cane: \\f786;\n$fa-var-arrow-down-wide-short: \\f160;\n$fa-var-sort-amount-asc: \\f160;\n$fa-var-sort-amount-down: \\f160;\n$fa-var-cloud-bolt: \\f76c;\n$fa-var-thunderstorm: \\f76c;\n$fa-var-text-slash: \\f87d;\n$fa-var-remove-format: \\f87d;\n$fa-var-face-smile-wink: \\f4da;\n$fa-var-smile-wink: \\f4da;\n$fa-var-file-word: \\f1c2;\n$fa-var-file-powerpoint: \\f1c4;\n$fa-var-arrows-left-right: \\f07e;\n$fa-var-arrows-h: \\f07e;\n$fa-var-house-lock: \\e510;\n$fa-var-cloud-arrow-down: \\f0ed;\n$fa-var-cloud-download: \\f0ed;\n$fa-var-cloud-download-alt: \\f0ed;\n$fa-var-children: \\e4e1;\n$fa-var-chalkboard: \\f51b;\n$fa-var-blackboard: \\f51b;\n$fa-var-user-large-slash: \\f4fa;\n$fa-var-user-alt-slash: \\f4fa;\n$fa-var-envelope-open: \\f2b6;\n$fa-var-handshake-simple-slash: \\e05f;\n$fa-var-handshake-alt-slash: \\e05f;\n$fa-var-mattress-pillow: \\e525;\n$fa-var-guarani-sign: \\e19a;\n$fa-var-arrows-rotate: \\f021;\n$fa-var-refresh: \\f021;\n$fa-var-sync: \\f021;\n$fa-var-fire-extinguisher: \\f134;\n$fa-var-cruzeiro-sign: \\e152;\n$fa-var-greater-than-equal: \\f532;\n$fa-var-shield-halved: \\f3ed;\n$fa-var-shield-alt: \\f3ed;\n$fa-var-book-atlas: \\f558;\n$fa-var-atlas: \\f558;\n$fa-var-virus: \\e074;\n$fa-var-envelope-circle-check: \\e4e8;\n$fa-var-layer-group: \\f5fd;\n$fa-var-arrows-to-dot: \\e4be;\n$fa-var-archway: \\f557;\n$fa-var-heart-circle-check: \\e4fd;\n$fa-var-house-chimney-crack: \\f6f1;\n$fa-var-house-damage: \\f6f1;\n$fa-var-file-zipper: \\f1c6;\n$fa-var-file-archive: \\f1c6;\n$fa-var-square: \\f0c8;\n$fa-var-martini-glass-empty: \\f000;\n$fa-var-glass-martini: \\f000;\n$fa-var-couch: \\f4b8;\n$fa-var-cedi-sign: \\e0df;\n$fa-var-italic: \\f033;\n$fa-var-table-cells-column-lock: \\e678;\n$fa-var-church: \\f51d;\n$fa-var-comments-dollar: \\f653;\n$fa-var-democrat: \\f747;\n$fa-var-z: \\5a;\n$fa-var-person-skiing: \\f7c9;\n$fa-var-skiing: \\f7c9;\n$fa-var-road-lock: \\e567;\n$fa-var-a: \\41;\n$fa-var-temperature-arrow-down: \\e03f;\n$fa-var-temperature-down: \\e03f;\n$fa-var-feather-pointed: \\f56b;\n$fa-var-feather-alt: \\f56b;\n$fa-var-p: \\50;\n$fa-var-snowflake: \\f2dc;\n$fa-var-newspaper: \\f1ea;\n$fa-var-rectangle-ad: \\f641;\n$fa-var-ad: \\f641;\n$fa-var-circle-arrow-right: \\f0a9;\n$fa-var-arrow-circle-right: \\f0a9;\n$fa-var-filter-circle-xmark: \\e17b;\n$fa-var-locust: \\e520;\n$fa-var-sort: \\f0dc;\n$fa-var-unsorted: \\f0dc;\n$fa-var-list-ol: \\f0cb;\n$fa-var-list-1-2: \\f0cb;\n$fa-var-list-numeric: \\f0cb;\n$fa-var-person-dress-burst: \\e544;\n$fa-var-money-check-dollar: \\f53d;\n$fa-var-money-check-alt: \\f53d;\n$fa-var-vector-square: \\f5cb;\n$fa-var-bread-slice: \\f7ec;\n$fa-var-language: \\f1ab;\n$fa-var-face-kiss-wink-heart: \\f598;\n$fa-var-kiss-wink-heart: \\f598;\n$fa-var-filter: \\f0b0;\n$fa-var-question: \\3f;\n$fa-var-file-signature: \\f573;\n$fa-var-up-down-left-right: \\f0b2;\n$fa-var-arrows-alt: \\f0b2;\n$fa-var-house-chimney-user: \\e065;\n$fa-var-hand-holding-heart: \\f4be;\n$fa-var-puzzle-piece: \\f12e;\n$fa-var-money-check: \\f53c;\n$fa-var-star-half-stroke: \\f5c0;\n$fa-var-star-half-alt: \\f5c0;\n$fa-var-code: \\f121;\n$fa-var-whiskey-glass: \\f7a0;\n$fa-var-glass-whiskey: \\f7a0;\n$fa-var-building-circle-exclamation: \\e4d3;\n$fa-var-magnifying-glass-chart: \\e522;\n$fa-var-arrow-up-right-from-square: \\f08e;\n$fa-var-external-link: \\f08e;\n$fa-var-cubes-stacked: \\e4e6;\n$fa-var-won-sign: \\f159;\n$fa-var-krw: \\f159;\n$fa-var-won: \\f159;\n$fa-var-virus-covid: \\e4a8;\n$fa-var-austral-sign: \\e0a9;\n$fa-var-f: \\46;\n$fa-var-leaf: \\f06c;\n$fa-var-road: \\f018;\n$fa-var-taxi: \\f1ba;\n$fa-var-cab: \\f1ba;\n$fa-var-person-circle-plus: \\e541;\n$fa-var-chart-pie: \\f200;\n$fa-var-pie-chart: \\f200;\n$fa-var-bolt-lightning: \\e0b7;\n$fa-var-sack-xmark: \\e56a;\n$fa-var-file-excel: \\f1c3;\n$fa-var-file-contract: \\f56c;\n$fa-var-fish-fins: \\e4f2;\n$fa-var-building-flag: \\e4d5;\n$fa-var-face-grin-beam: \\f582;\n$fa-var-grin-beam: \\f582;\n$fa-var-object-ungroup: \\f248;\n$fa-var-poop: \\f619;\n$fa-var-location-pin: \\f041;\n$fa-var-map-marker: \\f041;\n$fa-var-kaaba: \\f66b;\n$fa-var-toilet-paper: \\f71e;\n$fa-var-helmet-safety: \\f807;\n$fa-var-hard-hat: \\f807;\n$fa-var-hat-hard: \\f807;\n$fa-var-eject: \\f052;\n$fa-var-circle-right: \\f35a;\n$fa-var-arrow-alt-circle-right: \\f35a;\n$fa-var-plane-circle-check: \\e555;\n$fa-var-face-rolling-eyes: \\f5a5;\n$fa-var-meh-rolling-eyes: \\f5a5;\n$fa-var-object-group: \\f247;\n$fa-var-chart-line: \\f201;\n$fa-var-line-chart: \\f201;\n$fa-var-mask-ventilator: \\e524;\n$fa-var-arrow-right: \\f061;\n$fa-var-signs-post: \\f277;\n$fa-var-map-signs: \\f277;\n$fa-var-cash-register: \\f788;\n$fa-var-person-circle-question: \\e542;\n$fa-var-h: \\48;\n$fa-var-tarp: \\e57b;\n$fa-var-screwdriver-wrench: \\f7d9;\n$fa-var-tools: \\f7d9;\n$fa-var-arrows-to-eye: \\e4bf;\n$fa-var-plug-circle-bolt: \\e55b;\n$fa-var-heart: \\f004;\n$fa-var-mars-and-venus: \\f224;\n$fa-var-house-user: \\e1b0;\n$fa-var-home-user: \\e1b0;\n$fa-var-dumpster-fire: \\f794;\n$fa-var-house-crack: \\e3b1;\n$fa-var-martini-glass-citrus: \\f561;\n$fa-var-cocktail: \\f561;\n$fa-var-face-surprise: \\f5c2;\n$fa-var-surprise: \\f5c2;\n$fa-var-bottle-water: \\e4c5;\n$fa-var-circle-pause: \\f28b;\n$fa-var-pause-circle: \\f28b;\n$fa-var-toilet-paper-slash: \\e072;\n$fa-var-apple-whole: \\f5d1;\n$fa-var-apple-alt: \\f5d1;\n$fa-var-kitchen-set: \\e51a;\n$fa-var-r: \\52;\n$fa-var-temperature-quarter: \\f2ca;\n$fa-var-temperature-1: \\f2ca;\n$fa-var-thermometer-1: \\f2ca;\n$fa-var-thermometer-quarter: \\f2ca;\n$fa-var-cube: \\f1b2;\n$fa-var-bitcoin-sign: \\e0b4;\n$fa-var-shield-dog: \\e573;\n$fa-var-solar-panel: \\f5ba;\n$fa-var-lock-open: \\f3c1;\n$fa-var-elevator: \\e16d;\n$fa-var-money-bill-transfer: \\e528;\n$fa-var-money-bill-trend-up: \\e529;\n$fa-var-house-flood-water-circle-arrow-right: \\e50f;\n$fa-var-square-poll-horizontal: \\f682;\n$fa-var-poll-h: \\f682;\n$fa-var-circle: \\f111;\n$fa-var-backward-fast: \\f049;\n$fa-var-fast-backward: \\f049;\n$fa-var-recycle: \\f1b8;\n$fa-var-user-astronaut: \\f4fb;\n$fa-var-plane-slash: \\e069;\n$fa-var-trademark: \\f25c;\n$fa-var-basketball: \\f434;\n$fa-var-basketball-ball: \\f434;\n$fa-var-satellite-dish: \\f7c0;\n$fa-var-circle-up: \\f35b;\n$fa-var-arrow-alt-circle-up: \\f35b;\n$fa-var-mobile-screen-button: \\f3cd;\n$fa-var-mobile-alt: \\f3cd;\n$fa-var-volume-high: \\f028;\n$fa-var-volume-up: \\f028;\n$fa-var-users-rays: \\e593;\n$fa-var-wallet: \\f555;\n$fa-var-clipboard-check: \\f46c;\n$fa-var-file-audio: \\f1c7;\n$fa-var-burger: \\f805;\n$fa-var-hamburger: \\f805;\n$fa-var-wrench: \\f0ad;\n$fa-var-bugs: \\e4d0;\n$fa-var-rupee-sign: \\f156;\n$fa-var-rupee: \\f156;\n$fa-var-file-image: \\f1c5;\n$fa-var-circle-question: \\f059;\n$fa-var-question-circle: \\f059;\n$fa-var-plane-departure: \\f5b0;\n$fa-var-handshake-slash: \\e060;\n$fa-var-book-bookmark: \\e0bb;\n$fa-var-code-branch: \\f126;\n$fa-var-hat-cowboy: \\f8c0;\n$fa-var-bridge: \\e4c8;\n$fa-var-phone-flip: \\f879;\n$fa-var-phone-alt: \\f879;\n$fa-var-truck-front: \\e2b7;\n$fa-var-cat: \\f6be;\n$fa-var-anchor-circle-exclamation: \\e4ab;\n$fa-var-truck-field: \\e58d;\n$fa-var-route: \\f4d7;\n$fa-var-clipboard-question: \\e4e3;\n$fa-var-panorama: \\e209;\n$fa-var-comment-medical: \\f7f5;\n$fa-var-teeth-open: \\f62f;\n$fa-var-file-circle-minus: \\e4ed;\n$fa-var-tags: \\f02c;\n$fa-var-wine-glass: \\f4e3;\n$fa-var-forward-fast: \\f050;\n$fa-var-fast-forward: \\f050;\n$fa-var-face-meh-blank: \\f5a4;\n$fa-var-meh-blank: \\f5a4;\n$fa-var-square-parking: \\f540;\n$fa-var-parking: \\f540;\n$fa-var-house-signal: \\e012;\n$fa-var-bars-progress: \\f828;\n$fa-var-tasks-alt: \\f828;\n$fa-var-faucet-drip: \\e006;\n$fa-var-cart-flatbed: \\f474;\n$fa-var-dolly-flatbed: \\f474;\n$fa-var-ban-smoking: \\f54d;\n$fa-var-smoking-ban: \\f54d;\n$fa-var-terminal: \\f120;\n$fa-var-mobile-button: \\f10b;\n$fa-var-house-medical-flag: \\e514;\n$fa-var-basket-shopping: \\f291;\n$fa-var-shopping-basket: \\f291;\n$fa-var-tape: \\f4db;\n$fa-var-bus-simple: \\f55e;\n$fa-var-bus-alt: \\f55e;\n$fa-var-eye: \\f06e;\n$fa-var-face-sad-cry: \\f5b3;\n$fa-var-sad-cry: \\f5b3;\n$fa-var-audio-description: \\f29e;\n$fa-var-person-military-to-person: \\e54c;\n$fa-var-file-shield: \\e4f0;\n$fa-var-user-slash: \\f506;\n$fa-var-pen: \\f304;\n$fa-var-tower-observation: \\e586;\n$fa-var-file-code: \\f1c9;\n$fa-var-signal: \\f012;\n$fa-var-signal-5: \\f012;\n$fa-var-signal-perfect: \\f012;\n$fa-var-bus: \\f207;\n$fa-var-heart-circle-xmark: \\e501;\n$fa-var-house-chimney: \\e3af;\n$fa-var-home-lg: \\e3af;\n$fa-var-window-maximize: \\f2d0;\n$fa-var-face-frown: \\f119;\n$fa-var-frown: \\f119;\n$fa-var-prescription: \\f5b1;\n$fa-var-shop: \\f54f;\n$fa-var-store-alt: \\f54f;\n$fa-var-floppy-disk: \\f0c7;\n$fa-var-save: \\f0c7;\n$fa-var-vihara: \\f6a7;\n$fa-var-scale-unbalanced: \\f515;\n$fa-var-balance-scale-left: \\f515;\n$fa-var-sort-up: \\f0de;\n$fa-var-sort-asc: \\f0de;\n$fa-var-comment-dots: \\f4ad;\n$fa-var-commenting: \\f4ad;\n$fa-var-plant-wilt: \\e5aa;\n$fa-var-diamond: \\f219;\n$fa-var-face-grin-squint: \\f585;\n$fa-var-grin-squint: \\f585;\n$fa-var-hand-holding-dollar: \\f4c0;\n$fa-var-hand-holding-usd: \\f4c0;\n$fa-var-bacterium: \\e05a;\n$fa-var-hand-pointer: \\f25a;\n$fa-var-drum-steelpan: \\f56a;\n$fa-var-hand-scissors: \\f257;\n$fa-var-hands-praying: \\f684;\n$fa-var-praying-hands: \\f684;\n$fa-var-arrow-rotate-right: \\f01e;\n$fa-var-arrow-right-rotate: \\f01e;\n$fa-var-arrow-rotate-forward: \\f01e;\n$fa-var-redo: \\f01e;\n$fa-var-biohazard: \\f780;\n$fa-var-location-crosshairs: \\f601;\n$fa-var-location: \\f601;\n$fa-var-mars-double: \\f227;\n$fa-var-child-dress: \\e59c;\n$fa-var-users-between-lines: \\e591;\n$fa-var-lungs-virus: \\e067;\n$fa-var-face-grin-tears: \\f588;\n$fa-var-grin-tears: \\f588;\n$fa-var-phone: \\f095;\n$fa-var-calendar-xmark: \\f273;\n$fa-var-calendar-times: \\f273;\n$fa-var-child-reaching: \\e59d;\n$fa-var-head-side-virus: \\e064;\n$fa-var-user-gear: \\f4fe;\n$fa-var-user-cog: \\f4fe;\n$fa-var-arrow-up-1-9: \\f163;\n$fa-var-sort-numeric-up: \\f163;\n$fa-var-door-closed: \\f52a;\n$fa-var-shield-virus: \\e06c;\n$fa-var-dice-six: \\f526;\n$fa-var-mosquito-net: \\e52c;\n$fa-var-bridge-water: \\e4ce;\n$fa-var-person-booth: \\f756;\n$fa-var-text-width: \\f035;\n$fa-var-hat-wizard: \\f6e8;\n$fa-var-pen-fancy: \\f5ac;\n$fa-var-person-digging: \\f85e;\n$fa-var-digging: \\f85e;\n$fa-var-trash: \\f1f8;\n$fa-var-gauge-simple: \\f629;\n$fa-var-gauge-simple-med: \\f629;\n$fa-var-tachometer-average: \\f629;\n$fa-var-book-medical: \\f7e6;\n$fa-var-poo: \\f2fe;\n$fa-var-quote-right: \\f10e;\n$fa-var-quote-right-alt: \\f10e;\n$fa-var-shirt: \\f553;\n$fa-var-t-shirt: \\f553;\n$fa-var-tshirt: \\f553;\n$fa-var-cubes: \\f1b3;\n$fa-var-divide: \\f529;\n$fa-var-tenge-sign: \\f7d7;\n$fa-var-tenge: \\f7d7;\n$fa-var-headphones: \\f025;\n$fa-var-hands-holding: \\f4c2;\n$fa-var-hands-clapping: \\e1a8;\n$fa-var-republican: \\f75e;\n$fa-var-arrow-left: \\f060;\n$fa-var-person-circle-xmark: \\e543;\n$fa-var-ruler: \\f545;\n$fa-var-align-left: \\f036;\n$fa-var-dice-d6: \\f6d1;\n$fa-var-restroom: \\f7bd;\n$fa-var-j: \\4a;\n$fa-var-users-viewfinder: \\e595;\n$fa-var-file-video: \\f1c8;\n$fa-var-up-right-from-square: \\f35d;\n$fa-var-external-link-alt: \\f35d;\n$fa-var-table-cells: \\f00a;\n$fa-var-th: \\f00a;\n$fa-var-file-pdf: \\f1c1;\n$fa-var-book-bible: \\f647;\n$fa-var-bible: \\f647;\n$fa-var-o: \\4f;\n$fa-var-suitcase-medical: \\f0fa;\n$fa-var-medkit: \\f0fa;\n$fa-var-user-secret: \\f21b;\n$fa-var-otter: \\f700;\n$fa-var-person-dress: \\f182;\n$fa-var-female: \\f182;\n$fa-var-comment-dollar: \\f651;\n$fa-var-business-time: \\f64a;\n$fa-var-briefcase-clock: \\f64a;\n$fa-var-table-cells-large: \\f009;\n$fa-var-th-large: \\f009;\n$fa-var-book-tanakh: \\f827;\n$fa-var-tanakh: \\f827;\n$fa-var-phone-volume: \\f2a0;\n$fa-var-volume-control-phone: \\f2a0;\n$fa-var-hat-cowboy-side: \\f8c1;\n$fa-var-clipboard-user: \\f7f3;\n$fa-var-child: \\f1ae;\n$fa-var-lira-sign: \\f195;\n$fa-var-satellite: \\f7bf;\n$fa-var-plane-lock: \\e558;\n$fa-var-tag: \\f02b;\n$fa-var-comment: \\f075;\n$fa-var-cake-candles: \\f1fd;\n$fa-var-birthday-cake: \\f1fd;\n$fa-var-cake: \\f1fd;\n$fa-var-envelope: \\f0e0;\n$fa-var-angles-up: \\f102;\n$fa-var-angle-double-up: \\f102;\n$fa-var-paperclip: \\f0c6;\n$fa-var-arrow-right-to-city: \\e4b3;\n$fa-var-ribbon: \\f4d6;\n$fa-var-lungs: \\f604;\n$fa-var-arrow-up-9-1: \\f887;\n$fa-var-sort-numeric-up-alt: \\f887;\n$fa-var-litecoin-sign: \\e1d3;\n$fa-var-border-none: \\f850;\n$fa-var-circle-nodes: \\e4e2;\n$fa-var-parachute-box: \\f4cd;\n$fa-var-indent: \\f03c;\n$fa-var-truck-field-un: \\e58e;\n$fa-var-hourglass: \\f254;\n$fa-var-hourglass-empty: \\f254;\n$fa-var-mountain: \\f6fc;\n$fa-var-user-doctor: \\f0f0;\n$fa-var-user-md: \\f0f0;\n$fa-var-circle-info: \\f05a;\n$fa-var-info-circle: \\f05a;\n$fa-var-cloud-meatball: \\f73b;\n$fa-var-camera: \\f030;\n$fa-var-camera-alt: \\f030;\n$fa-var-square-virus: \\e578;\n$fa-var-meteor: \\f753;\n$fa-var-car-on: \\e4dd;\n$fa-var-sleigh: \\f7cc;\n$fa-var-arrow-down-1-9: \\f162;\n$fa-var-sort-numeric-asc: \\f162;\n$fa-var-sort-numeric-down: \\f162;\n$fa-var-hand-holding-droplet: \\f4c1;\n$fa-var-hand-holding-water: \\f4c1;\n$fa-var-water: \\f773;\n$fa-var-calendar-check: \\f274;\n$fa-var-braille: \\f2a1;\n$fa-var-prescription-bottle-medical: \\f486;\n$fa-var-prescription-bottle-alt: \\f486;\n$fa-var-landmark: \\f66f;\n$fa-var-truck: \\f0d1;\n$fa-var-crosshairs: \\f05b;\n$fa-var-person-cane: \\e53c;\n$fa-var-tent: \\e57d;\n$fa-var-vest-patches: \\e086;\n$fa-var-check-double: \\f560;\n$fa-var-arrow-down-a-z: \\f15d;\n$fa-var-sort-alpha-asc: \\f15d;\n$fa-var-sort-alpha-down: \\f15d;\n$fa-var-money-bill-wheat: \\e52a;\n$fa-var-cookie: \\f563;\n$fa-var-arrow-rotate-left: \\f0e2;\n$fa-var-arrow-left-rotate: \\f0e2;\n$fa-var-arrow-rotate-back: \\f0e2;\n$fa-var-arrow-rotate-backward: \\f0e2;\n$fa-var-undo: \\f0e2;\n$fa-var-hard-drive: \\f0a0;\n$fa-var-hdd: \\f0a0;\n$fa-var-face-grin-squint-tears: \\f586;\n$fa-var-grin-squint-tears: \\f586;\n$fa-var-dumbbell: \\f44b;\n$fa-var-rectangle-list: \\f022;\n$fa-var-list-alt: \\f022;\n$fa-var-tarp-droplet: \\e57c;\n$fa-var-house-medical-circle-check: \\e511;\n$fa-var-person-skiing-nordic: \\f7ca;\n$fa-var-skiing-nordic: \\f7ca;\n$fa-var-calendar-plus: \\f271;\n$fa-var-plane-arrival: \\f5af;\n$fa-var-circle-left: \\f359;\n$fa-var-arrow-alt-circle-left: \\f359;\n$fa-var-train-subway: \\f239;\n$fa-var-subway: \\f239;\n$fa-var-chart-gantt: \\e0e4;\n$fa-var-indian-rupee-sign: \\e1bc;\n$fa-var-indian-rupee: \\e1bc;\n$fa-var-inr: \\e1bc;\n$fa-var-crop-simple: \\f565;\n$fa-var-crop-alt: \\f565;\n$fa-var-money-bill-1: \\f3d1;\n$fa-var-money-bill-alt: \\f3d1;\n$fa-var-left-long: \\f30a;\n$fa-var-long-arrow-alt-left: \\f30a;\n$fa-var-dna: \\f471;\n$fa-var-virus-slash: \\e075;\n$fa-var-minus: \\f068;\n$fa-var-subtract: \\f068;\n$fa-var-chess: \\f439;\n$fa-var-arrow-left-long: \\f177;\n$fa-var-long-arrow-left: \\f177;\n$fa-var-plug-circle-check: \\e55c;\n$fa-var-street-view: \\f21d;\n$fa-var-franc-sign: \\e18f;\n$fa-var-volume-off: \\f026;\n$fa-var-hands-asl-interpreting: \\f2a3;\n$fa-var-american-sign-language-interpreting: \\f2a3;\n$fa-var-asl-interpreting: \\f2a3;\n$fa-var-hands-american-sign-language-interpreting: \\f2a3;\n$fa-var-gear: \\f013;\n$fa-var-cog: \\f013;\n$fa-var-droplet-slash: \\f5c7;\n$fa-var-tint-slash: \\f5c7;\n$fa-var-mosque: \\f678;\n$fa-var-mosquito: \\e52b;\n$fa-var-star-of-david: \\f69a;\n$fa-var-person-military-rifle: \\e54b;\n$fa-var-cart-shopping: \\f07a;\n$fa-var-shopping-cart: \\f07a;\n$fa-var-vials: \\f493;\n$fa-var-plug-circle-plus: \\e55f;\n$fa-var-place-of-worship: \\f67f;\n$fa-var-grip-vertical: \\f58e;\n$fa-var-arrow-turn-up: \\f148;\n$fa-var-level-up: \\f148;\n$fa-var-u: \\55;\n$fa-var-square-root-variable: \\f698;\n$fa-var-square-root-alt: \\f698;\n$fa-var-clock: \\f017;\n$fa-var-clock-four: \\f017;\n$fa-var-backward-step: \\f048;\n$fa-var-step-backward: \\f048;\n$fa-var-pallet: \\f482;\n$fa-var-faucet: \\e005;\n$fa-var-baseball-bat-ball: \\f432;\n$fa-var-s: \\53;\n$fa-var-timeline: \\e29c;\n$fa-var-keyboard: \\f11c;\n$fa-var-caret-down: \\f0d7;\n$fa-var-house-chimney-medical: \\f7f2;\n$fa-var-clinic-medical: \\f7f2;\n$fa-var-temperature-three-quarters: \\f2c8;\n$fa-var-temperature-3: \\f2c8;\n$fa-var-thermometer-3: \\f2c8;\n$fa-var-thermometer-three-quarters: \\f2c8;\n$fa-var-mobile-screen: \\f3cf;\n$fa-var-mobile-android-alt: \\f3cf;\n$fa-var-plane-up: \\e22d;\n$fa-var-piggy-bank: \\f4d3;\n$fa-var-battery-half: \\f242;\n$fa-var-battery-3: \\f242;\n$fa-var-mountain-city: \\e52e;\n$fa-var-coins: \\f51e;\n$fa-var-khanda: \\f66d;\n$fa-var-sliders: \\f1de;\n$fa-var-sliders-h: \\f1de;\n$fa-var-folder-tree: \\f802;\n$fa-var-network-wired: \\f6ff;\n$fa-var-map-pin: \\f276;\n$fa-var-hamsa: \\f665;\n$fa-var-cent-sign: \\e3f5;\n$fa-var-flask: \\f0c3;\n$fa-var-person-pregnant: \\e31e;\n$fa-var-wand-sparkles: \\f72b;\n$fa-var-ellipsis-vertical: \\f142;\n$fa-var-ellipsis-v: \\f142;\n$fa-var-ticket: \\f145;\n$fa-var-power-off: \\f011;\n$fa-var-right-long: \\f30b;\n$fa-var-long-arrow-alt-right: \\f30b;\n$fa-var-flag-usa: \\f74d;\n$fa-var-laptop-file: \\e51d;\n$fa-var-tty: \\f1e4;\n$fa-var-teletype: \\f1e4;\n$fa-var-diagram-next: \\e476;\n$fa-var-person-rifle: \\e54e;\n$fa-var-house-medical-circle-exclamation: \\e512;\n$fa-var-closed-captioning: \\f20a;\n$fa-var-person-hiking: \\f6ec;\n$fa-var-hiking: \\f6ec;\n$fa-var-venus-double: \\f226;\n$fa-var-images: \\f302;\n$fa-var-calculator: \\f1ec;\n$fa-var-people-pulling: \\e535;\n$fa-var-n: \\4e;\n$fa-var-cable-car: \\f7da;\n$fa-var-tram: \\f7da;\n$fa-var-cloud-rain: \\f73d;\n$fa-var-building-circle-xmark: \\e4d4;\n$fa-var-ship: \\f21a;\n$fa-var-arrows-down-to-line: \\e4b8;\n$fa-var-download: \\f019;\n$fa-var-face-grin: \\f580;\n$fa-var-grin: \\f580;\n$fa-var-delete-left: \\f55a;\n$fa-var-backspace: \\f55a;\n$fa-var-eye-dropper: \\f1fb;\n$fa-var-eye-dropper-empty: \\f1fb;\n$fa-var-eyedropper: \\f1fb;\n$fa-var-file-circle-check: \\e5a0;\n$fa-var-forward: \\f04e;\n$fa-var-mobile: \\f3ce;\n$fa-var-mobile-android: \\f3ce;\n$fa-var-mobile-phone: \\f3ce;\n$fa-var-face-meh: \\f11a;\n$fa-var-meh: \\f11a;\n$fa-var-align-center: \\f037;\n$fa-var-book-skull: \\f6b7;\n$fa-var-book-dead: \\f6b7;\n$fa-var-id-card: \\f2c2;\n$fa-var-drivers-license: \\f2c2;\n$fa-var-outdent: \\f03b;\n$fa-var-dedent: \\f03b;\n$fa-var-heart-circle-exclamation: \\e4fe;\n$fa-var-house: \\f015;\n$fa-var-home: \\f015;\n$fa-var-home-alt: \\f015;\n$fa-var-home-lg-alt: \\f015;\n$fa-var-calendar-week: \\f784;\n$fa-var-laptop-medical: \\f812;\n$fa-var-b: \\42;\n$fa-var-file-medical: \\f477;\n$fa-var-dice-one: \\f525;\n$fa-var-kiwi-bird: \\f535;\n$fa-var-arrow-right-arrow-left: \\f0ec;\n$fa-var-exchange: \\f0ec;\n$fa-var-rotate-right: \\f2f9;\n$fa-var-redo-alt: \\f2f9;\n$fa-var-rotate-forward: \\f2f9;\n$fa-var-utensils: \\f2e7;\n$fa-var-cutlery: \\f2e7;\n$fa-var-arrow-up-wide-short: \\f161;\n$fa-var-sort-amount-up: \\f161;\n$fa-var-mill-sign: \\e1ed;\n$fa-var-bowl-rice: \\e2eb;\n$fa-var-skull: \\f54c;\n$fa-var-tower-broadcast: \\f519;\n$fa-var-broadcast-tower: \\f519;\n$fa-var-truck-pickup: \\f63c;\n$fa-var-up-long: \\f30c;\n$fa-var-long-arrow-alt-up: \\f30c;\n$fa-var-stop: \\f04d;\n$fa-var-code-merge: \\f387;\n$fa-var-upload: \\f093;\n$fa-var-hurricane: \\f751;\n$fa-var-mound: \\e52d;\n$fa-var-toilet-portable: \\e583;\n$fa-var-compact-disc: \\f51f;\n$fa-var-file-arrow-down: \\f56d;\n$fa-var-file-download: \\f56d;\n$fa-var-caravan: \\f8ff;\n$fa-var-shield-cat: \\e572;\n$fa-var-bolt: \\f0e7;\n$fa-var-zap: \\f0e7;\n$fa-var-glass-water: \\e4f4;\n$fa-var-oil-well: \\e532;\n$fa-var-vault: \\e2c5;\n$fa-var-mars: \\f222;\n$fa-var-toilet: \\f7d8;\n$fa-var-plane-circle-xmark: \\e557;\n$fa-var-yen-sign: \\f157;\n$fa-var-cny: \\f157;\n$fa-var-jpy: \\f157;\n$fa-var-rmb: \\f157;\n$fa-var-yen: \\f157;\n$fa-var-ruble-sign: \\f158;\n$fa-var-rouble: \\f158;\n$fa-var-rub: \\f158;\n$fa-var-ruble: \\f158;\n$fa-var-sun: \\f185;\n$fa-var-guitar: \\f7a6;\n$fa-var-face-laugh-wink: \\f59c;\n$fa-var-laugh-wink: \\f59c;\n$fa-var-horse-head: \\f7ab;\n$fa-var-bore-hole: \\e4c3;\n$fa-var-industry: \\f275;\n$fa-var-circle-down: \\f358;\n$fa-var-arrow-alt-circle-down: \\f358;\n$fa-var-arrows-turn-to-dots: \\e4c1;\n$fa-var-florin-sign: \\e184;\n$fa-var-arrow-down-short-wide: \\f884;\n$fa-var-sort-amount-desc: \\f884;\n$fa-var-sort-amount-down-alt: \\f884;\n$fa-var-less-than: \\3c;\n$fa-var-angle-down: \\f107;\n$fa-var-car-tunnel: \\e4de;\n$fa-var-head-side-cough: \\e061;\n$fa-var-grip-lines: \\f7a4;\n$fa-var-thumbs-down: \\f165;\n$fa-var-user-lock: \\f502;\n$fa-var-arrow-right-long: \\f178;\n$fa-var-long-arrow-right: \\f178;\n$fa-var-anchor-circle-xmark: \\e4ac;\n$fa-var-ellipsis: \\f141;\n$fa-var-ellipsis-h: \\f141;\n$fa-var-chess-pawn: \\f443;\n$fa-var-kit-medical: \\f479;\n$fa-var-first-aid: \\f479;\n$fa-var-person-through-window: \\e5a9;\n$fa-var-toolbox: \\f552;\n$fa-var-hands-holding-circle: \\e4fb;\n$fa-var-bug: \\f188;\n$fa-var-credit-card: \\f09d;\n$fa-var-credit-card-alt: \\f09d;\n$fa-var-car: \\f1b9;\n$fa-var-automobile: \\f1b9;\n$fa-var-hand-holding-hand: \\e4f7;\n$fa-var-book-open-reader: \\f5da;\n$fa-var-book-reader: \\f5da;\n$fa-var-mountain-sun: \\e52f;\n$fa-var-arrows-left-right-to-line: \\e4ba;\n$fa-var-dice-d20: \\f6cf;\n$fa-var-truck-droplet: \\e58c;\n$fa-var-file-circle-xmark: \\e5a1;\n$fa-var-temperature-arrow-up: \\e040;\n$fa-var-temperature-up: \\e040;\n$fa-var-medal: \\f5a2;\n$fa-var-bed: \\f236;\n$fa-var-square-h: \\f0fd;\n$fa-var-h-square: \\f0fd;\n$fa-var-podcast: \\f2ce;\n$fa-var-temperature-full: \\f2c7;\n$fa-var-temperature-4: \\f2c7;\n$fa-var-thermometer-4: \\f2c7;\n$fa-var-thermometer-full: \\f2c7;\n$fa-var-bell: \\f0f3;\n$fa-var-superscript: \\f12b;\n$fa-var-plug-circle-xmark: \\e560;\n$fa-var-star-of-life: \\f621;\n$fa-var-phone-slash: \\f3dd;\n$fa-var-paint-roller: \\f5aa;\n$fa-var-handshake-angle: \\f4c4;\n$fa-var-hands-helping: \\f4c4;\n$fa-var-location-dot: \\f3c5;\n$fa-var-map-marker-alt: \\f3c5;\n$fa-var-file: \\f15b;\n$fa-var-greater-than: \\3e;\n$fa-var-person-swimming: \\f5c4;\n$fa-var-swimmer: \\f5c4;\n$fa-var-arrow-down: \\f063;\n$fa-var-droplet: \\f043;\n$fa-var-tint: \\f043;\n$fa-var-eraser: \\f12d;\n$fa-var-earth-americas: \\f57d;\n$fa-var-earth: \\f57d;\n$fa-var-earth-america: \\f57d;\n$fa-var-globe-americas: \\f57d;\n$fa-var-person-burst: \\e53b;\n$fa-var-dove: \\f4ba;\n$fa-var-battery-empty: \\f244;\n$fa-var-battery-0: \\f244;\n$fa-var-socks: \\f696;\n$fa-var-inbox: \\f01c;\n$fa-var-section: \\e447;\n$fa-var-gauge-high: \\f625;\n$fa-var-tachometer-alt: \\f625;\n$fa-var-tachometer-alt-fast: \\f625;\n$fa-var-envelope-open-text: \\f658;\n$fa-var-hospital: \\f0f8;\n$fa-var-hospital-alt: \\f0f8;\n$fa-var-hospital-wide: \\f0f8;\n$fa-var-wine-bottle: \\f72f;\n$fa-var-chess-rook: \\f447;\n$fa-var-bars-staggered: \\f550;\n$fa-var-reorder: \\f550;\n$fa-var-stream: \\f550;\n$fa-var-dharmachakra: \\f655;\n$fa-var-hotdog: \\f80f;\n$fa-var-person-walking-with-cane: \\f29d;\n$fa-var-blind: \\f29d;\n$fa-var-drum: \\f569;\n$fa-var-ice-cream: \\f810;\n$fa-var-heart-circle-bolt: \\e4fc;\n$fa-var-fax: \\f1ac;\n$fa-var-paragraph: \\f1dd;\n$fa-var-check-to-slot: \\f772;\n$fa-var-vote-yea: \\f772;\n$fa-var-star-half: \\f089;\n$fa-var-boxes-stacked: \\f468;\n$fa-var-boxes: \\f468;\n$fa-var-boxes-alt: \\f468;\n$fa-var-link: \\f0c1;\n$fa-var-chain: \\f0c1;\n$fa-var-ear-listen: \\f2a2;\n$fa-var-assistive-listening-systems: \\f2a2;\n$fa-var-tree-city: \\e587;\n$fa-var-play: \\f04b;\n$fa-var-font: \\f031;\n$fa-var-table-cells-row-lock: \\e67a;\n$fa-var-rupiah-sign: \\e23d;\n$fa-var-magnifying-glass: \\f002;\n$fa-var-search: \\f002;\n$fa-var-table-tennis-paddle-ball: \\f45d;\n$fa-var-ping-pong-paddle-ball: \\f45d;\n$fa-var-table-tennis: \\f45d;\n$fa-var-person-dots-from-line: \\f470;\n$fa-var-diagnoses: \\f470;\n$fa-var-trash-can-arrow-up: \\f82a;\n$fa-var-trash-restore-alt: \\f82a;\n$fa-var-naira-sign: \\e1f6;\n$fa-var-cart-arrow-down: \\f218;\n$fa-var-walkie-talkie: \\f8ef;\n$fa-var-file-pen: \\f31c;\n$fa-var-file-edit: \\f31c;\n$fa-var-receipt: \\f543;\n$fa-var-square-pen: \\f14b;\n$fa-var-pen-square: \\f14b;\n$fa-var-pencil-square: \\f14b;\n$fa-var-suitcase-rolling: \\f5c1;\n$fa-var-person-circle-exclamation: \\e53f;\n$fa-var-chevron-down: \\f078;\n$fa-var-battery-full: \\f240;\n$fa-var-battery: \\f240;\n$fa-var-battery-5: \\f240;\n$fa-var-skull-crossbones: \\f714;\n$fa-var-code-compare: \\e13a;\n$fa-var-list-ul: \\f0ca;\n$fa-var-list-dots: \\f0ca;\n$fa-var-school-lock: \\e56f;\n$fa-var-tower-cell: \\e585;\n$fa-var-down-long: \\f309;\n$fa-var-long-arrow-alt-down: \\f309;\n$fa-var-ranking-star: \\e561;\n$fa-var-chess-king: \\f43f;\n$fa-var-person-harassing: \\e549;\n$fa-var-brazilian-real-sign: \\e46c;\n$fa-var-landmark-dome: \\f752;\n$fa-var-landmark-alt: \\f752;\n$fa-var-arrow-up: \\f062;\n$fa-var-tv: \\f26c;\n$fa-var-television: \\f26c;\n$fa-var-tv-alt: \\f26c;\n$fa-var-shrimp: \\e448;\n$fa-var-list-check: \\f0ae;\n$fa-var-tasks: \\f0ae;\n$fa-var-jug-detergent: \\e519;\n$fa-var-circle-user: \\f2bd;\n$fa-var-user-circle: \\f2bd;\n$fa-var-user-shield: \\f505;\n$fa-var-wind: \\f72e;\n$fa-var-car-burst: \\f5e1;\n$fa-var-car-crash: \\f5e1;\n$fa-var-y: \\59;\n$fa-var-person-snowboarding: \\f7ce;\n$fa-var-snowboarding: \\f7ce;\n$fa-var-truck-fast: \\f48b;\n$fa-var-shipping-fast: \\f48b;\n$fa-var-fish: \\f578;\n$fa-var-user-graduate: \\f501;\n$fa-var-circle-half-stroke: \\f042;\n$fa-var-adjust: \\f042;\n$fa-var-clapperboard: \\e131;\n$fa-var-circle-radiation: \\f7ba;\n$fa-var-radiation-alt: \\f7ba;\n$fa-var-baseball: \\f433;\n$fa-var-baseball-ball: \\f433;\n$fa-var-jet-fighter-up: \\e518;\n$fa-var-diagram-project: \\f542;\n$fa-var-project-diagram: \\f542;\n$fa-var-copy: \\f0c5;\n$fa-var-volume-xmark: \\f6a9;\n$fa-var-volume-mute: \\f6a9;\n$fa-var-volume-times: \\f6a9;\n$fa-var-hand-sparkles: \\e05d;\n$fa-var-grip: \\f58d;\n$fa-var-grip-horizontal: \\f58d;\n$fa-var-share-from-square: \\f14d;\n$fa-var-share-square: \\f14d;\n$fa-var-child-combatant: \\e4e0;\n$fa-var-child-rifle: \\e4e0;\n$fa-var-gun: \\e19b;\n$fa-var-square-phone: \\f098;\n$fa-var-phone-square: \\f098;\n$fa-var-plus: \\2b;\n$fa-var-add: \\2b;\n$fa-var-expand: \\f065;\n$fa-var-computer: \\e4e5;\n$fa-var-xmark: \\f00d;\n$fa-var-close: \\f00d;\n$fa-var-multiply: \\f00d;\n$fa-var-remove: \\f00d;\n$fa-var-times: \\f00d;\n$fa-var-arrows-up-down-left-right: \\f047;\n$fa-var-arrows: \\f047;\n$fa-var-chalkboard-user: \\f51c;\n$fa-var-chalkboard-teacher: \\f51c;\n$fa-var-peso-sign: \\e222;\n$fa-var-building-shield: \\e4d8;\n$fa-var-baby: \\f77c;\n$fa-var-users-line: \\e592;\n$fa-var-quote-left: \\f10d;\n$fa-var-quote-left-alt: \\f10d;\n$fa-var-tractor: \\f722;\n$fa-var-trash-arrow-up: \\f829;\n$fa-var-trash-restore: \\f829;\n$fa-var-arrow-down-up-lock: \\e4b0;\n$fa-var-lines-leaning: \\e51e;\n$fa-var-ruler-combined: \\f546;\n$fa-var-copyright: \\f1f9;\n$fa-var-equals: \\3d;\n$fa-var-blender: \\f517;\n$fa-var-teeth: \\f62e;\n$fa-var-shekel-sign: \\f20b;\n$fa-var-ils: \\f20b;\n$fa-var-shekel: \\f20b;\n$fa-var-sheqel: \\f20b;\n$fa-var-sheqel-sign: \\f20b;\n$fa-var-map: \\f279;\n$fa-var-rocket: \\f135;\n$fa-var-photo-film: \\f87c;\n$fa-var-photo-video: \\f87c;\n$fa-var-folder-minus: \\f65d;\n$fa-var-store: \\f54e;\n$fa-var-arrow-trend-up: \\e098;\n$fa-var-plug-circle-minus: \\e55e;\n$fa-var-sign-hanging: \\f4d9;\n$fa-var-sign: \\f4d9;\n$fa-var-bezier-curve: \\f55b;\n$fa-var-bell-slash: \\f1f6;\n$fa-var-tablet: \\f3fb;\n$fa-var-tablet-android: \\f3fb;\n$fa-var-school-flag: \\e56e;\n$fa-var-fill: \\f575;\n$fa-var-angle-up: \\f106;\n$fa-var-drumstick-bite: \\f6d7;\n$fa-var-holly-berry: \\f7aa;\n$fa-var-chevron-left: \\f053;\n$fa-var-bacteria: \\e059;\n$fa-var-hand-lizard: \\f258;\n$fa-var-notdef: \\e1fe;\n$fa-var-disease: \\f7fa;\n$fa-var-briefcase-medical: \\f469;\n$fa-var-genderless: \\f22d;\n$fa-var-chevron-right: \\f054;\n$fa-var-retweet: \\f079;\n$fa-var-car-rear: \\f5de;\n$fa-var-car-alt: \\f5de;\n$fa-var-pump-soap: \\e06b;\n$fa-var-video-slash: \\f4e2;\n$fa-var-battery-quarter: \\f243;\n$fa-var-battery-2: \\f243;\n$fa-var-radio: \\f8d7;\n$fa-var-baby-carriage: \\f77d;\n$fa-var-carriage-baby: \\f77d;\n$fa-var-traffic-light: \\f637;\n$fa-var-thermometer: \\f491;\n$fa-var-vr-cardboard: \\f729;\n$fa-var-hand-middle-finger: \\f806;\n$fa-var-percent: \\25;\n$fa-var-percentage: \\25;\n$fa-var-truck-moving: \\f4df;\n$fa-var-glass-water-droplet: \\e4f5;\n$fa-var-display: \\e163;\n$fa-var-face-smile: \\f118;\n$fa-var-smile: \\f118;\n$fa-var-thumbtack: \\f08d;\n$fa-var-thumb-tack: \\f08d;\n$fa-var-trophy: \\f091;\n$fa-var-person-praying: \\f683;\n$fa-var-pray: \\f683;\n$fa-var-hammer: \\f6e3;\n$fa-var-hand-peace: \\f25b;\n$fa-var-rotate: \\f2f1;\n$fa-var-sync-alt: \\f2f1;\n$fa-var-spinner: \\f110;\n$fa-var-robot: \\f544;\n$fa-var-peace: \\f67c;\n$fa-var-gears: \\f085;\n$fa-var-cogs: \\f085;\n$fa-var-warehouse: \\f494;\n$fa-var-arrow-up-right-dots: \\e4b7;\n$fa-var-splotch: \\f5bc;\n$fa-var-face-grin-hearts: \\f584;\n$fa-var-grin-hearts: \\f584;\n$fa-var-dice-four: \\f524;\n$fa-var-sim-card: \\f7c4;\n$fa-var-transgender: \\f225;\n$fa-var-transgender-alt: \\f225;\n$fa-var-mercury: \\f223;\n$fa-var-arrow-turn-down: \\f149;\n$fa-var-level-down: \\f149;\n$fa-var-person-falling-burst: \\e547;\n$fa-var-award: \\f559;\n$fa-var-ticket-simple: \\f3ff;\n$fa-var-ticket-alt: \\f3ff;\n$fa-var-building: \\f1ad;\n$fa-var-angles-left: \\f100;\n$fa-var-angle-double-left: \\f100;\n$fa-var-qrcode: \\f029;\n$fa-var-clock-rotate-left: \\f1da;\n$fa-var-history: \\f1da;\n$fa-var-face-grin-beam-sweat: \\f583;\n$fa-var-grin-beam-sweat: \\f583;\n$fa-var-file-export: \\f56e;\n$fa-var-arrow-right-from-file: \\f56e;\n$fa-var-shield: \\f132;\n$fa-var-shield-blank: \\f132;\n$fa-var-arrow-up-short-wide: \\f885;\n$fa-var-sort-amount-up-alt: \\f885;\n$fa-var-house-medical: \\e3b2;\n$fa-var-golf-ball-tee: \\f450;\n$fa-var-golf-ball: \\f450;\n$fa-var-circle-chevron-left: \\f137;\n$fa-var-chevron-circle-left: \\f137;\n$fa-var-house-chimney-window: \\e00d;\n$fa-var-pen-nib: \\f5ad;\n$fa-var-tent-arrow-turn-left: \\e580;\n$fa-var-tents: \\e582;\n$fa-var-wand-magic: \\f0d0;\n$fa-var-magic: \\f0d0;\n$fa-var-dog: \\f6d3;\n$fa-var-carrot: \\f787;\n$fa-var-moon: \\f186;\n$fa-var-wine-glass-empty: \\f5ce;\n$fa-var-wine-glass-alt: \\f5ce;\n$fa-var-cheese: \\f7ef;\n$fa-var-yin-yang: \\f6ad;\n$fa-var-music: \\f001;\n$fa-var-code-commit: \\f386;\n$fa-var-temperature-low: \\f76b;\n$fa-var-person-biking: \\f84a;\n$fa-var-biking: \\f84a;\n$fa-var-broom: \\f51a;\n$fa-var-shield-heart: \\e574;\n$fa-var-gopuram: \\f664;\n$fa-var-earth-oceania: \\e47b;\n$fa-var-globe-oceania: \\e47b;\n$fa-var-square-xmark: \\f2d3;\n$fa-var-times-square: \\f2d3;\n$fa-var-xmark-square: \\f2d3;\n$fa-var-hashtag: \\23;\n$fa-var-up-right-and-down-left-from-center: \\f424;\n$fa-var-expand-alt: \\f424;\n$fa-var-oil-can: \\f613;\n$fa-var-t: \\54;\n$fa-var-hippo: \\f6ed;\n$fa-var-chart-column: \\e0e3;\n$fa-var-infinity: \\f534;\n$fa-var-vial-circle-check: \\e596;\n$fa-var-person-arrow-down-to-line: \\e538;\n$fa-var-voicemail: \\f897;\n$fa-var-fan: \\f863;\n$fa-var-person-walking-luggage: \\e554;\n$fa-var-up-down: \\f338;\n$fa-var-arrows-alt-v: \\f338;\n$fa-var-cloud-moon-rain: \\f73c;\n$fa-var-calendar: \\f133;\n$fa-var-trailer: \\e041;\n$fa-var-bahai: \\f666;\n$fa-var-haykal: \\f666;\n$fa-var-sd-card: \\f7c2;\n$fa-var-dragon: \\f6d5;\n$fa-var-shoe-prints: \\f54b;\n$fa-var-circle-plus: \\f055;\n$fa-var-plus-circle: \\f055;\n$fa-var-face-grin-tongue-wink: \\f58b;\n$fa-var-grin-tongue-wink: \\f58b;\n$fa-var-hand-holding: \\f4bd;\n$fa-var-plug-circle-exclamation: \\e55d;\n$fa-var-link-slash: \\f127;\n$fa-var-chain-broken: \\f127;\n$fa-var-chain-slash: \\f127;\n$fa-var-unlink: \\f127;\n$fa-var-clone: \\f24d;\n$fa-var-person-walking-arrow-loop-left: \\e551;\n$fa-var-arrow-up-z-a: \\f882;\n$fa-var-sort-alpha-up-alt: \\f882;\n$fa-var-fire-flame-curved: \\f7e4;\n$fa-var-fire-alt: \\f7e4;\n$fa-var-tornado: \\f76f;\n$fa-var-file-circle-plus: \\e494;\n$fa-var-book-quran: \\f687;\n$fa-var-quran: \\f687;\n$fa-var-anchor: \\f13d;\n$fa-var-border-all: \\f84c;\n$fa-var-face-angry: \\f556;\n$fa-var-angry: \\f556;\n$fa-var-cookie-bite: \\f564;\n$fa-var-arrow-trend-down: \\e097;\n$fa-var-rss: \\f09e;\n$fa-var-feed: \\f09e;\n$fa-var-draw-polygon: \\f5ee;\n$fa-var-scale-balanced: \\f24e;\n$fa-var-balance-scale: \\f24e;\n$fa-var-gauge-simple-high: \\f62a;\n$fa-var-tachometer: \\f62a;\n$fa-var-tachometer-fast: \\f62a;\n$fa-var-shower: \\f2cc;\n$fa-var-desktop: \\f390;\n$fa-var-desktop-alt: \\f390;\n$fa-var-m: \\4d;\n$fa-var-table-list: \\f00b;\n$fa-var-th-list: \\f00b;\n$fa-var-comment-sms: \\f7cd;\n$fa-var-sms: \\f7cd;\n$fa-var-book: \\f02d;\n$fa-var-user-plus: \\f234;\n$fa-var-check: \\f00c;\n$fa-var-battery-three-quarters: \\f241;\n$fa-var-battery-4: \\f241;\n$fa-var-house-circle-check: \\e509;\n$fa-var-angle-left: \\f104;\n$fa-var-diagram-successor: \\e47a;\n$fa-var-truck-arrow-right: \\e58b;\n$fa-var-arrows-split-up-and-left: \\e4bc;\n$fa-var-hand-fist: \\f6de;\n$fa-var-fist-raised: \\f6de;\n$fa-var-cloud-moon: \\f6c3;\n$fa-var-briefcase: \\f0b1;\n$fa-var-person-falling: \\e546;\n$fa-var-image-portrait: \\f3e0;\n$fa-var-portrait: \\f3e0;\n$fa-var-user-tag: \\f507;\n$fa-var-rug: \\e569;\n$fa-var-earth-europe: \\f7a2;\n$fa-var-globe-europe: \\f7a2;\n$fa-var-cart-flatbed-suitcase: \\f59d;\n$fa-var-luggage-cart: \\f59d;\n$fa-var-rectangle-xmark: \\f410;\n$fa-var-rectangle-times: \\f410;\n$fa-var-times-rectangle: \\f410;\n$fa-var-window-close: \\f410;\n$fa-var-baht-sign: \\e0ac;\n$fa-var-book-open: \\f518;\n$fa-var-book-journal-whills: \\f66a;\n$fa-var-journal-whills: \\f66a;\n$fa-var-handcuffs: \\e4f8;\n$fa-var-triangle-exclamation: \\f071;\n$fa-var-exclamation-triangle: \\f071;\n$fa-var-warning: \\f071;\n$fa-var-database: \\f1c0;\n$fa-var-share: \\f064;\n$fa-var-mail-forward: \\f064;\n$fa-var-bottle-droplet: \\e4c4;\n$fa-var-mask-face: \\e1d7;\n$fa-var-hill-rockslide: \\e508;\n$fa-var-right-left: \\f362;\n$fa-var-exchange-alt: \\f362;\n$fa-var-paper-plane: \\f1d8;\n$fa-var-road-circle-exclamation: \\e565;\n$fa-var-dungeon: \\f6d9;\n$fa-var-align-right: \\f038;\n$fa-var-money-bill-1-wave: \\f53b;\n$fa-var-money-bill-wave-alt: \\f53b;\n$fa-var-life-ring: \\f1cd;\n$fa-var-hands: \\f2a7;\n$fa-var-sign-language: \\f2a7;\n$fa-var-signing: \\f2a7;\n$fa-var-calendar-day: \\f783;\n$fa-var-water-ladder: \\f5c5;\n$fa-var-ladder-water: \\f5c5;\n$fa-var-swimming-pool: \\f5c5;\n$fa-var-arrows-up-down: \\f07d;\n$fa-var-arrows-v: \\f07d;\n$fa-var-face-grimace: \\f57f;\n$fa-var-grimace: \\f57f;\n$fa-var-wheelchair-move: \\e2ce;\n$fa-var-wheelchair-alt: \\e2ce;\n$fa-var-turn-down: \\f3be;\n$fa-var-level-down-alt: \\f3be;\n$fa-var-person-walking-arrow-right: \\e552;\n$fa-var-square-envelope: \\f199;\n$fa-var-envelope-square: \\f199;\n$fa-var-dice: \\f522;\n$fa-var-bowling-ball: \\f436;\n$fa-var-brain: \\f5dc;\n$fa-var-bandage: \\f462;\n$fa-var-band-aid: \\f462;\n$fa-var-calendar-minus: \\f272;\n$fa-var-circle-xmark: \\f057;\n$fa-var-times-circle: \\f057;\n$fa-var-xmark-circle: \\f057;\n$fa-var-gifts: \\f79c;\n$fa-var-hotel: \\f594;\n$fa-var-earth-asia: \\f57e;\n$fa-var-globe-asia: \\f57e;\n$fa-var-id-card-clip: \\f47f;\n$fa-var-id-card-alt: \\f47f;\n$fa-var-magnifying-glass-plus: \\f00e;\n$fa-var-search-plus: \\f00e;\n$fa-var-thumbs-up: \\f164;\n$fa-var-user-clock: \\f4fd;\n$fa-var-hand-dots: \\f461;\n$fa-var-allergies: \\f461;\n$fa-var-file-invoice: \\f570;\n$fa-var-window-minimize: \\f2d1;\n$fa-var-mug-saucer: \\f0f4;\n$fa-var-coffee: \\f0f4;\n$fa-var-brush: \\f55d;\n$fa-var-mask: \\f6fa;\n$fa-var-magnifying-glass-minus: \\f010;\n$fa-var-search-minus: \\f010;\n$fa-var-ruler-vertical: \\f548;\n$fa-var-user-large: \\f406;\n$fa-var-user-alt: \\f406;\n$fa-var-train-tram: \\e5b4;\n$fa-var-user-nurse: \\f82f;\n$fa-var-syringe: \\f48e;\n$fa-var-cloud-sun: \\f6c4;\n$fa-var-stopwatch-20: \\e06f;\n$fa-var-square-full: \\f45c;\n$fa-var-magnet: \\f076;\n$fa-var-jar: \\e516;\n$fa-var-note-sticky: \\f249;\n$fa-var-sticky-note: \\f249;\n$fa-var-bug-slash: \\e490;\n$fa-var-arrow-up-from-water-pump: \\e4b6;\n$fa-var-bone: \\f5d7;\n$fa-var-user-injured: \\f728;\n$fa-var-face-sad-tear: \\f5b4;\n$fa-var-sad-tear: \\f5b4;\n$fa-var-plane: \\f072;\n$fa-var-tent-arrows-down: \\e581;\n$fa-var-exclamation: \\21;\n$fa-var-arrows-spin: \\e4bb;\n$fa-var-print: \\f02f;\n$fa-var-turkish-lira-sign: \\e2bb;\n$fa-var-try: \\e2bb;\n$fa-var-turkish-lira: \\e2bb;\n$fa-var-dollar-sign: \\24;\n$fa-var-dollar: \\24;\n$fa-var-usd: \\24;\n$fa-var-x: \\58;\n$fa-var-magnifying-glass-dollar: \\f688;\n$fa-var-search-dollar: \\f688;\n$fa-var-users-gear: \\f509;\n$fa-var-users-cog: \\f509;\n$fa-var-person-military-pointing: \\e54a;\n$fa-var-building-columns: \\f19c;\n$fa-var-bank: \\f19c;\n$fa-var-institution: \\f19c;\n$fa-var-museum: \\f19c;\n$fa-var-university: \\f19c;\n$fa-var-umbrella: \\f0e9;\n$fa-var-trowel: \\e589;\n$fa-var-d: \\44;\n$fa-var-stapler: \\e5af;\n$fa-var-masks-theater: \\f630;\n$fa-var-theater-masks: \\f630;\n$fa-var-kip-sign: \\e1c4;\n$fa-var-hand-point-left: \\f0a5;\n$fa-var-handshake-simple: \\f4c6;\n$fa-var-handshake-alt: \\f4c6;\n$fa-var-jet-fighter: \\f0fb;\n$fa-var-fighter-jet: \\f0fb;\n$fa-var-square-share-nodes: \\f1e1;\n$fa-var-share-alt-square: \\f1e1;\n$fa-var-barcode: \\f02a;\n$fa-var-plus-minus: \\e43c;\n$fa-var-video: \\f03d;\n$fa-var-video-camera: \\f03d;\n$fa-var-graduation-cap: \\f19d;\n$fa-var-mortar-board: \\f19d;\n$fa-var-hand-holding-medical: \\e05c;\n$fa-var-person-circle-check: \\e53e;\n$fa-var-turn-up: \\f3bf;\n$fa-var-level-up-alt: \\f3bf;\n\n$fa-var-monero: \\f3d0;\n$fa-var-hooli: \\f427;\n$fa-var-yelp: \\f1e9;\n$fa-var-cc-visa: \\f1f0;\n$fa-var-lastfm: \\f202;\n$fa-var-shopware: \\f5b5;\n$fa-var-creative-commons-nc: \\f4e8;\n$fa-var-aws: \\f375;\n$fa-var-redhat: \\f7bc;\n$fa-var-yoast: \\f2b1;\n$fa-var-cloudflare: \\e07d;\n$fa-var-ups: \\f7e0;\n$fa-var-pixiv: \\e640;\n$fa-var-wpexplorer: \\f2de;\n$fa-var-dyalog: \\f399;\n$fa-var-bity: \\f37a;\n$fa-var-stackpath: \\f842;\n$fa-var-buysellads: \\f20d;\n$fa-var-first-order: \\f2b0;\n$fa-var-modx: \\f285;\n$fa-var-guilded: \\e07e;\n$fa-var-vnv: \\f40b;\n$fa-var-square-js: \\f3b9;\n$fa-var-js-square: \\f3b9;\n$fa-var-microsoft: \\f3ca;\n$fa-var-qq: \\f1d6;\n$fa-var-orcid: \\f8d2;\n$fa-var-java: \\f4e4;\n$fa-var-invision: \\f7b0;\n$fa-var-creative-commons-pd-alt: \\f4ed;\n$fa-var-centercode: \\f380;\n$fa-var-glide-g: \\f2a6;\n$fa-var-drupal: \\f1a9;\n$fa-var-jxl: \\e67b;\n$fa-var-hire-a-helper: \\f3b0;\n$fa-var-creative-commons-by: \\f4e7;\n$fa-var-unity: \\e049;\n$fa-var-whmcs: \\f40d;\n$fa-var-rocketchat: \\f3e8;\n$fa-var-vk: \\f189;\n$fa-var-untappd: \\f405;\n$fa-var-mailchimp: \\f59e;\n$fa-var-css3-alt: \\f38b;\n$fa-var-square-reddit: \\f1a2;\n$fa-var-reddit-square: \\f1a2;\n$fa-var-vimeo-v: \\f27d;\n$fa-var-contao: \\f26d;\n$fa-var-square-font-awesome: \\e5ad;\n$fa-var-deskpro: \\f38f;\n$fa-var-brave: \\e63c;\n$fa-var-sistrix: \\f3ee;\n$fa-var-square-instagram: \\e055;\n$fa-var-instagram-square: \\e055;\n$fa-var-battle-net: \\f835;\n$fa-var-the-red-yeti: \\f69d;\n$fa-var-square-hacker-news: \\f3af;\n$fa-var-hacker-news-square: \\f3af;\n$fa-var-edge: \\f282;\n$fa-var-threads: \\e618;\n$fa-var-napster: \\f3d2;\n$fa-var-square-snapchat: \\f2ad;\n$fa-var-snapchat-square: \\f2ad;\n$fa-var-google-plus-g: \\f0d5;\n$fa-var-artstation: \\f77a;\n$fa-var-markdown: \\f60f;\n$fa-var-sourcetree: \\f7d3;\n$fa-var-google-plus: \\f2b3;\n$fa-var-diaspora: \\f791;\n$fa-var-foursquare: \\f180;\n$fa-var-stack-overflow: \\f16c;\n$fa-var-github-alt: \\f113;\n$fa-var-phoenix-squadron: \\f511;\n$fa-var-pagelines: \\f18c;\n$fa-var-algolia: \\f36c;\n$fa-var-red-river: \\f3e3;\n$fa-var-creative-commons-sa: \\f4ef;\n$fa-var-safari: \\f267;\n$fa-var-google: \\f1a0;\n$fa-var-square-font-awesome-stroke: \\f35c;\n$fa-var-font-awesome-alt: \\f35c;\n$fa-var-atlassian: \\f77b;\n$fa-var-linkedin-in: \\f0e1;\n$fa-var-digital-ocean: \\f391;\n$fa-var-nimblr: \\f5a8;\n$fa-var-chromecast: \\f838;\n$fa-var-evernote: \\f839;\n$fa-var-hacker-news: \\f1d4;\n$fa-var-creative-commons-sampling: \\f4f0;\n$fa-var-adversal: \\f36a;\n$fa-var-creative-commons: \\f25e;\n$fa-var-watchman-monitoring: \\e087;\n$fa-var-fonticons: \\f280;\n$fa-var-weixin: \\f1d7;\n$fa-var-shirtsinbulk: \\f214;\n$fa-var-codepen: \\f1cb;\n$fa-var-git-alt: \\f841;\n$fa-var-lyft: \\f3c3;\n$fa-var-rev: \\f5b2;\n$fa-var-windows: \\f17a;\n$fa-var-wizards-of-the-coast: \\f730;\n$fa-var-square-viadeo: \\f2aa;\n$fa-var-viadeo-square: \\f2aa;\n$fa-var-meetup: \\f2e0;\n$fa-var-centos: \\f789;\n$fa-var-adn: \\f170;\n$fa-var-cloudsmith: \\f384;\n$fa-var-opensuse: \\e62b;\n$fa-var-pied-piper-alt: \\f1a8;\n$fa-var-square-dribbble: \\f397;\n$fa-var-dribbble-square: \\f397;\n$fa-var-codiepie: \\f284;\n$fa-var-node: \\f419;\n$fa-var-mix: \\f3cb;\n$fa-var-steam: \\f1b6;\n$fa-var-cc-apple-pay: \\f416;\n$fa-var-scribd: \\f28a;\n$fa-var-debian: \\e60b;\n$fa-var-openid: \\f19b;\n$fa-var-instalod: \\e081;\n$fa-var-expeditedssl: \\f23e;\n$fa-var-sellcast: \\f2da;\n$fa-var-square-twitter: \\f081;\n$fa-var-twitter-square: \\f081;\n$fa-var-r-project: \\f4f7;\n$fa-var-delicious: \\f1a5;\n$fa-var-freebsd: \\f3a4;\n$fa-var-vuejs: \\f41f;\n$fa-var-accusoft: \\f369;\n$fa-var-ioxhost: \\f208;\n$fa-var-fonticons-fi: \\f3a2;\n$fa-var-app-store: \\f36f;\n$fa-var-cc-mastercard: \\f1f1;\n$fa-var-itunes-note: \\f3b5;\n$fa-var-golang: \\e40f;\n$fa-var-kickstarter: \\f3bb;\n$fa-var-square-kickstarter: \\f3bb;\n$fa-var-grav: \\f2d6;\n$fa-var-weibo: \\f18a;\n$fa-var-uncharted: \\e084;\n$fa-var-firstdraft: \\f3a1;\n$fa-var-square-youtube: \\f431;\n$fa-var-youtube-square: \\f431;\n$fa-var-wikipedia-w: \\f266;\n$fa-var-wpressr: \\f3e4;\n$fa-var-rendact: \\f3e4;\n$fa-var-angellist: \\f209;\n$fa-var-galactic-republic: \\f50c;\n$fa-var-nfc-directional: \\e530;\n$fa-var-skype: \\f17e;\n$fa-var-joget: \\f3b7;\n$fa-var-fedora: \\f798;\n$fa-var-stripe-s: \\f42a;\n$fa-var-meta: \\e49b;\n$fa-var-laravel: \\f3bd;\n$fa-var-hotjar: \\f3b1;\n$fa-var-bluetooth-b: \\f294;\n$fa-var-square-letterboxd: \\e62e;\n$fa-var-sticker-mule: \\f3f7;\n$fa-var-creative-commons-zero: \\f4f3;\n$fa-var-hips: \\f452;\n$fa-var-behance: \\f1b4;\n$fa-var-reddit: \\f1a1;\n$fa-var-discord: \\f392;\n$fa-var-chrome: \\f268;\n$fa-var-app-store-ios: \\f370;\n$fa-var-cc-discover: \\f1f2;\n$fa-var-wpbeginner: \\f297;\n$fa-var-confluence: \\f78d;\n$fa-var-shoelace: \\e60c;\n$fa-var-mdb: \\f8ca;\n$fa-var-dochub: \\f394;\n$fa-var-accessible-icon: \\f368;\n$fa-var-ebay: \\f4f4;\n$fa-var-amazon: \\f270;\n$fa-var-unsplash: \\e07c;\n$fa-var-yarn: \\f7e3;\n$fa-var-square-steam: \\f1b7;\n$fa-var-steam-square: \\f1b7;\n$fa-var-500px: \\f26e;\n$fa-var-square-vimeo: \\f194;\n$fa-var-vimeo-square: \\f194;\n$fa-var-asymmetrik: \\f372;\n$fa-var-font-awesome: \\f2b4;\n$fa-var-font-awesome-flag: \\f2b4;\n$fa-var-font-awesome-logo-full: \\f2b4;\n$fa-var-gratipay: \\f184;\n$fa-var-apple: \\f179;\n$fa-var-hive: \\e07f;\n$fa-var-gitkraken: \\f3a6;\n$fa-var-keybase: \\f4f5;\n$fa-var-apple-pay: \\f415;\n$fa-var-padlet: \\e4a0;\n$fa-var-amazon-pay: \\f42c;\n$fa-var-square-github: \\f092;\n$fa-var-github-square: \\f092;\n$fa-var-stumbleupon: \\f1a4;\n$fa-var-fedex: \\f797;\n$fa-var-phoenix-framework: \\f3dc;\n$fa-var-shopify: \\e057;\n$fa-var-neos: \\f612;\n$fa-var-square-threads: \\e619;\n$fa-var-hackerrank: \\f5f7;\n$fa-var-researchgate: \\f4f8;\n$fa-var-swift: \\f8e1;\n$fa-var-angular: \\f420;\n$fa-var-speakap: \\f3f3;\n$fa-var-angrycreative: \\f36e;\n$fa-var-y-combinator: \\f23b;\n$fa-var-empire: \\f1d1;\n$fa-var-envira: \\f299;\n$fa-var-google-scholar: \\e63b;\n$fa-var-square-gitlab: \\e5ae;\n$fa-var-gitlab-square: \\e5ae;\n$fa-var-studiovinari: \\f3f8;\n$fa-var-pied-piper: \\f2ae;\n$fa-var-wordpress: \\f19a;\n$fa-var-product-hunt: \\f288;\n$fa-var-firefox: \\f269;\n$fa-var-linode: \\f2b8;\n$fa-var-goodreads: \\f3a8;\n$fa-var-square-odnoklassniki: \\f264;\n$fa-var-odnoklassniki-square: \\f264;\n$fa-var-jsfiddle: \\f1cc;\n$fa-var-sith: \\f512;\n$fa-var-themeisle: \\f2b2;\n$fa-var-page4: \\f3d7;\n$fa-var-hashnode: \\e499;\n$fa-var-react: \\f41b;\n$fa-var-cc-paypal: \\f1f4;\n$fa-var-squarespace: \\f5be;\n$fa-var-cc-stripe: \\f1f5;\n$fa-var-creative-commons-share: \\f4f2;\n$fa-var-bitcoin: \\f379;\n$fa-var-keycdn: \\f3ba;\n$fa-var-opera: \\f26a;\n$fa-var-itch-io: \\f83a;\n$fa-var-umbraco: \\f8e8;\n$fa-var-galactic-senate: \\f50d;\n$fa-var-ubuntu: \\f7df;\n$fa-var-draft2digital: \\f396;\n$fa-var-stripe: \\f429;\n$fa-var-houzz: \\f27c;\n$fa-var-gg: \\f260;\n$fa-var-dhl: \\f790;\n$fa-var-square-pinterest: \\f0d3;\n$fa-var-pinterest-square: \\f0d3;\n$fa-var-xing: \\f168;\n$fa-var-blackberry: \\f37b;\n$fa-var-creative-commons-pd: \\f4ec;\n$fa-var-playstation: \\f3df;\n$fa-var-quinscape: \\f459;\n$fa-var-less: \\f41d;\n$fa-var-blogger-b: \\f37d;\n$fa-var-opencart: \\f23d;\n$fa-var-vine: \\f1ca;\n$fa-var-signal-messenger: \\e663;\n$fa-var-paypal: \\f1ed;\n$fa-var-gitlab: \\f296;\n$fa-var-typo3: \\f42b;\n$fa-var-reddit-alien: \\f281;\n$fa-var-yahoo: \\f19e;\n$fa-var-dailymotion: \\e052;\n$fa-var-affiliatetheme: \\f36b;\n$fa-var-pied-piper-pp: \\f1a7;\n$fa-var-bootstrap: \\f836;\n$fa-var-odnoklassniki: \\f263;\n$fa-var-nfc-symbol: \\e531;\n$fa-var-mintbit: \\e62f;\n$fa-var-ethereum: \\f42e;\n$fa-var-speaker-deck: \\f83c;\n$fa-var-creative-commons-nc-eu: \\f4e9;\n$fa-var-patreon: \\f3d9;\n$fa-var-avianex: \\f374;\n$fa-var-ello: \\f5f1;\n$fa-var-gofore: \\f3a7;\n$fa-var-bimobject: \\f378;\n$fa-var-brave-reverse: \\e63d;\n$fa-var-facebook-f: \\f39e;\n$fa-var-square-google-plus: \\f0d4;\n$fa-var-google-plus-square: \\f0d4;\n$fa-var-web-awesome: \\e682;\n$fa-var-mandalorian: \\f50f;\n$fa-var-first-order-alt: \\f50a;\n$fa-var-osi: \\f41a;\n$fa-var-google-wallet: \\f1ee;\n$fa-var-d-and-d-beyond: \\f6ca;\n$fa-var-periscope: \\f3da;\n$fa-var-fulcrum: \\f50b;\n$fa-var-cloudscale: \\f383;\n$fa-var-forumbee: \\f211;\n$fa-var-mizuni: \\f3cc;\n$fa-var-schlix: \\f3ea;\n$fa-var-square-xing: \\f169;\n$fa-var-xing-square: \\f169;\n$fa-var-bandcamp: \\f2d5;\n$fa-var-wpforms: \\f298;\n$fa-var-cloudversify: \\f385;\n$fa-var-usps: \\f7e1;\n$fa-var-megaport: \\f5a3;\n$fa-var-magento: \\f3c4;\n$fa-var-spotify: \\f1bc;\n$fa-var-optin-monster: \\f23c;\n$fa-var-fly: \\f417;\n$fa-var-aviato: \\f421;\n$fa-var-itunes: \\f3b4;\n$fa-var-cuttlefish: \\f38c;\n$fa-var-blogger: \\f37c;\n$fa-var-flickr: \\f16e;\n$fa-var-viber: \\f409;\n$fa-var-soundcloud: \\f1be;\n$fa-var-digg: \\f1a6;\n$fa-var-tencent-weibo: \\f1d5;\n$fa-var-letterboxd: \\e62d;\n$fa-var-symfony: \\f83d;\n$fa-var-maxcdn: \\f136;\n$fa-var-etsy: \\f2d7;\n$fa-var-facebook-messenger: \\f39f;\n$fa-var-audible: \\f373;\n$fa-var-think-peaks: \\f731;\n$fa-var-bilibili: \\e3d9;\n$fa-var-erlang: \\f39d;\n$fa-var-x-twitter: \\e61b;\n$fa-var-cotton-bureau: \\f89e;\n$fa-var-dashcube: \\f210;\n$fa-var-42-group: \\e080;\n$fa-var-innosoft: \\e080;\n$fa-var-stack-exchange: \\f18d;\n$fa-var-elementor: \\f430;\n$fa-var-square-pied-piper: \\e01e;\n$fa-var-pied-piper-square: \\e01e;\n$fa-var-creative-commons-nd: \\f4eb;\n$fa-var-palfed: \\f3d8;\n$fa-var-superpowers: \\f2dd;\n$fa-var-resolving: \\f3e7;\n$fa-var-xbox: \\f412;\n$fa-var-square-web-awesome-stroke: \\e684;\n$fa-var-searchengin: \\f3eb;\n$fa-var-tiktok: \\e07b;\n$fa-var-square-facebook: \\f082;\n$fa-var-facebook-square: \\f082;\n$fa-var-renren: \\f18b;\n$fa-var-linux: \\f17c;\n$fa-var-glide: \\f2a5;\n$fa-var-linkedin: \\f08c;\n$fa-var-hubspot: \\f3b2;\n$fa-var-deploydog: \\f38e;\n$fa-var-twitch: \\f1e8;\n$fa-var-ravelry: \\f2d9;\n$fa-var-mixer: \\e056;\n$fa-var-square-lastfm: \\f203;\n$fa-var-lastfm-square: \\f203;\n$fa-var-vimeo: \\f40a;\n$fa-var-mendeley: \\f7b3;\n$fa-var-uniregistry: \\f404;\n$fa-var-figma: \\f799;\n$fa-var-creative-commons-remix: \\f4ee;\n$fa-var-cc-amazon-pay: \\f42d;\n$fa-var-dropbox: \\f16b;\n$fa-var-instagram: \\f16d;\n$fa-var-cmplid: \\e360;\n$fa-var-upwork: \\e641;\n$fa-var-facebook: \\f09a;\n$fa-var-gripfire: \\f3ac;\n$fa-var-jedi-order: \\f50e;\n$fa-var-uikit: \\f403;\n$fa-var-fort-awesome-alt: \\f3a3;\n$fa-var-phabricator: \\f3db;\n$fa-var-ussunnah: \\f407;\n$fa-var-earlybirds: \\f39a;\n$fa-var-trade-federation: \\f513;\n$fa-var-autoprefixer: \\f41c;\n$fa-var-whatsapp: \\f232;\n$fa-var-square-upwork: \\e67c;\n$fa-var-slideshare: \\f1e7;\n$fa-var-google-play: \\f3ab;\n$fa-var-viadeo: \\f2a9;\n$fa-var-line: \\f3c0;\n$fa-var-google-drive: \\f3aa;\n$fa-var-servicestack: \\f3ec;\n$fa-var-simplybuilt: \\f215;\n$fa-var-bitbucket: \\f171;\n$fa-var-imdb: \\f2d8;\n$fa-var-deezer: \\e077;\n$fa-var-raspberry-pi: \\f7bb;\n$fa-var-jira: \\f7b1;\n$fa-var-docker: \\f395;\n$fa-var-screenpal: \\e570;\n$fa-var-bluetooth: \\f293;\n$fa-var-gitter: \\f426;\n$fa-var-d-and-d: \\f38d;\n$fa-var-microblog: \\e01a;\n$fa-var-cc-diners-club: \\f24c;\n$fa-var-gg-circle: \\f261;\n$fa-var-pied-piper-hat: \\f4e5;\n$fa-var-kickstarter-k: \\f3bc;\n$fa-var-yandex: \\f413;\n$fa-var-readme: \\f4d5;\n$fa-var-html5: \\f13b;\n$fa-var-sellsy: \\f213;\n$fa-var-square-web-awesome: \\e683;\n$fa-var-sass: \\f41e;\n$fa-var-wirsindhandwerk: \\e2d0;\n$fa-var-wsh: \\e2d0;\n$fa-var-buromobelexperte: \\f37f;\n$fa-var-salesforce: \\f83b;\n$fa-var-octopus-deploy: \\e082;\n$fa-var-medapps: \\f3c6;\n$fa-var-ns8: \\f3d5;\n$fa-var-pinterest-p: \\f231;\n$fa-var-apper: \\f371;\n$fa-var-fort-awesome: \\f286;\n$fa-var-waze: \\f83f;\n$fa-var-bluesky: \\e671;\n$fa-var-cc-jcb: \\f24b;\n$fa-var-snapchat: \\f2ab;\n$fa-var-snapchat-ghost: \\f2ab;\n$fa-var-fantasy-flight-games: \\f6dc;\n$fa-var-rust: \\e07a;\n$fa-var-wix: \\f5cf;\n$fa-var-square-behance: \\f1b5;\n$fa-var-behance-square: \\f1b5;\n$fa-var-supple: \\f3f9;\n$fa-var-webflow: \\e65c;\n$fa-var-rebel: \\f1d0;\n$fa-var-css3: \\f13c;\n$fa-var-staylinked: \\f3f5;\n$fa-var-kaggle: \\f5fa;\n$fa-var-space-awesome: \\e5ac;\n$fa-var-deviantart: \\f1bd;\n$fa-var-cpanel: \\f388;\n$fa-var-goodreads-g: \\f3a9;\n$fa-var-square-git: \\f1d2;\n$fa-var-git-square: \\f1d2;\n$fa-var-square-tumblr: \\f174;\n$fa-var-tumblr-square: \\f174;\n$fa-var-trello: \\f181;\n$fa-var-creative-commons-nc-jp: \\f4ea;\n$fa-var-get-pocket: \\f265;\n$fa-var-perbyte: \\e083;\n$fa-var-grunt: \\f3ad;\n$fa-var-weebly: \\f5cc;\n$fa-var-connectdevelop: \\f20e;\n$fa-var-leanpub: \\f212;\n$fa-var-black-tie: \\f27e;\n$fa-var-themeco: \\f5c6;\n$fa-var-python: \\f3e2;\n$fa-var-android: \\f17b;\n$fa-var-bots: \\e340;\n$fa-var-free-code-camp: \\f2c5;\n$fa-var-hornbill: \\f592;\n$fa-var-js: \\f3b8;\n$fa-var-ideal: \\e013;\n$fa-var-git: \\f1d3;\n$fa-var-dev: \\f6cc;\n$fa-var-sketch: \\f7c6;\n$fa-var-yandex-international: \\f414;\n$fa-var-cc-amex: \\f1f3;\n$fa-var-uber: \\f402;\n$fa-var-github: \\f09b;\n$fa-var-php: \\f457;\n$fa-var-alipay: \\f642;\n$fa-var-youtube: \\f167;\n$fa-var-skyatlas: \\f216;\n$fa-var-firefox-browser: \\e007;\n$fa-var-replyd: \\f3e6;\n$fa-var-suse: \\f7d6;\n$fa-var-jenkins: \\f3b6;\n$fa-var-twitter: \\f099;\n$fa-var-rockrms: \\f3e9;\n$fa-var-pinterest: \\f0d2;\n$fa-var-buffer: \\f837;\n$fa-var-npm: \\f3d4;\n$fa-var-yammer: \\f840;\n$fa-var-btc: \\f15a;\n$fa-var-dribbble: \\f17d;\n$fa-var-stumbleupon-circle: \\f1a3;\n$fa-var-internet-explorer: \\f26b;\n$fa-var-stubber: \\e5c7;\n$fa-var-telegram: \\f2c6;\n$fa-var-telegram-plane: \\f2c6;\n$fa-var-old-republic: \\f510;\n$fa-var-odysee: \\e5c6;\n$fa-var-square-whatsapp: \\f40c;\n$fa-var-whatsapp-square: \\f40c;\n$fa-var-node-js: \\f3d3;\n$fa-var-edge-legacy: \\e078;\n$fa-var-slack: \\f198;\n$fa-var-slack-hash: \\f198;\n$fa-var-medrt: \\f3c8;\n$fa-var-usb: \\f287;\n$fa-var-tumblr: \\f173;\n$fa-var-vaadin: \\f408;\n$fa-var-quora: \\f2c4;\n$fa-var-square-x-twitter: \\e61a;\n$fa-var-reacteurope: \\f75d;\n$fa-var-medium: \\f23a;\n$fa-var-medium-m: \\f23a;\n$fa-var-amilia: \\f36d;\n$fa-var-mixcloud: \\f289;\n$fa-var-flipboard: \\f44d;\n$fa-var-viacoin: \\f237;\n$fa-var-critical-role: \\f6c9;\n$fa-var-sitrox: \\e44a;\n$fa-var-discourse: \\f393;\n$fa-var-joomla: \\f1aa;\n$fa-var-mastodon: \\f4f6;\n$fa-var-airbnb: \\f834;\n$fa-var-wolf-pack-battalion: \\f514;\n$fa-var-buy-n-large: \\f8a6;\n$fa-var-gulp: \\f3ae;\n$fa-var-creative-commons-sampling-plus: \\f4f1;\n$fa-var-strava: \\f428;\n$fa-var-ember: \\f423;\n$fa-var-canadian-maple-leaf: \\f785;\n$fa-var-teamspeak: \\f4f9;\n$fa-var-pushed: \\f3e1;\n$fa-var-wordpress-simple: \\f411;\n$fa-var-nutritionix: \\f3d6;\n$fa-var-wodu: \\e088;\n$fa-var-google-pay: \\e079;\n$fa-var-intercom: \\f7af;\n$fa-var-zhihu: \\f63f;\n$fa-var-korvue: \\f42f;\n$fa-var-pix: \\e43a;\n$fa-var-steam-symbol: \\f3f6;\n\n$fa-icons: (\n  \"0\": $fa-var-0,\n  \"1\": $fa-var-1,\n  \"2\": $fa-var-2,\n  \"3\": $fa-var-3,\n  \"4\": $fa-var-4,\n  \"5\": $fa-var-5,\n  \"6\": $fa-var-6,\n  \"7\": $fa-var-7,\n  \"8\": $fa-var-8,\n  \"9\": $fa-var-9,\n  \"fill-drip\": $fa-var-fill-drip,\n  \"arrows-to-circle\": $fa-var-arrows-to-circle,\n  \"circle-chevron-right\": $fa-var-circle-chevron-right,\n  \"chevron-circle-right\": $fa-var-chevron-circle-right,\n  \"at\": $fa-var-at,\n  \"trash-can\": $fa-var-trash-can,\n  \"trash-alt\": $fa-var-trash-alt,\n  \"text-height\": $fa-var-text-height,\n  \"user-xmark\": $fa-var-user-xmark,\n  \"user-times\": $fa-var-user-times,\n  \"stethoscope\": $fa-var-stethoscope,\n  \"message\": $fa-var-message,\n  \"comment-alt\": $fa-var-comment-alt,\n  \"info\": $fa-var-info,\n  \"down-left-and-up-right-to-center\": $fa-var-down-left-and-up-right-to-center,\n  \"compress-alt\": $fa-var-compress-alt,\n  \"explosion\": $fa-var-explosion,\n  \"file-lines\": $fa-var-file-lines,\n  \"file-alt\": $fa-var-file-alt,\n  \"file-text\": $fa-var-file-text,\n  \"wave-square\": $fa-var-wave-square,\n  \"ring\": $fa-var-ring,\n  \"building-un\": $fa-var-building-un,\n  \"dice-three\": $fa-var-dice-three,\n  \"calendar-days\": $fa-var-calendar-days,\n  \"calendar-alt\": $fa-var-calendar-alt,\n  \"anchor-circle-check\": $fa-var-anchor-circle-check,\n  \"building-circle-arrow-right\": $fa-var-building-circle-arrow-right,\n  \"volleyball\": $fa-var-volleyball,\n  \"volleyball-ball\": $fa-var-volleyball-ball,\n  \"arrows-up-to-line\": $fa-var-arrows-up-to-line,\n  \"sort-down\": $fa-var-sort-down,\n  \"sort-desc\": $fa-var-sort-desc,\n  \"circle-minus\": $fa-var-circle-minus,\n  \"minus-circle\": $fa-var-minus-circle,\n  \"door-open\": $fa-var-door-open,\n  \"right-from-bracket\": $fa-var-right-from-bracket,\n  \"sign-out-alt\": $fa-var-sign-out-alt,\n  \"atom\": $fa-var-atom,\n  \"soap\": $fa-var-soap,\n  \"icons\": $fa-var-icons,\n  \"heart-music-camera-bolt\": $fa-var-heart-music-camera-bolt,\n  \"microphone-lines-slash\": $fa-var-microphone-lines-slash,\n  \"microphone-alt-slash\": $fa-var-microphone-alt-slash,\n  \"bridge-circle-check\": $fa-var-bridge-circle-check,\n  \"pump-medical\": $fa-var-pump-medical,\n  \"fingerprint\": $fa-var-fingerprint,\n  \"hand-point-right\": $fa-var-hand-point-right,\n  \"magnifying-glass-location\": $fa-var-magnifying-glass-location,\n  \"search-location\": $fa-var-search-location,\n  \"forward-step\": $fa-var-forward-step,\n  \"step-forward\": $fa-var-step-forward,\n  \"face-smile-beam\": $fa-var-face-smile-beam,\n  \"smile-beam\": $fa-var-smile-beam,\n  \"flag-checkered\": $fa-var-flag-checkered,\n  \"football\": $fa-var-football,\n  \"football-ball\": $fa-var-football-ball,\n  \"school-circle-exclamation\": $fa-var-school-circle-exclamation,\n  \"crop\": $fa-var-crop,\n  \"angles-down\": $fa-var-angles-down,\n  \"angle-double-down\": $fa-var-angle-double-down,\n  \"users-rectangle\": $fa-var-users-rectangle,\n  \"people-roof\": $fa-var-people-roof,\n  \"people-line\": $fa-var-people-line,\n  \"beer-mug-empty\": $fa-var-beer-mug-empty,\n  \"beer\": $fa-var-beer,\n  \"diagram-predecessor\": $fa-var-diagram-predecessor,\n  \"arrow-up-long\": $fa-var-arrow-up-long,\n  \"long-arrow-up\": $fa-var-long-arrow-up,\n  \"fire-flame-simple\": $fa-var-fire-flame-simple,\n  \"burn\": $fa-var-burn,\n  \"person\": $fa-var-person,\n  \"male\": $fa-var-male,\n  \"laptop\": $fa-var-laptop,\n  \"file-csv\": $fa-var-file-csv,\n  \"menorah\": $fa-var-menorah,\n  \"truck-plane\": $fa-var-truck-plane,\n  \"record-vinyl\": $fa-var-record-vinyl,\n  \"face-grin-stars\": $fa-var-face-grin-stars,\n  \"grin-stars\": $fa-var-grin-stars,\n  \"bong\": $fa-var-bong,\n  \"spaghetti-monster-flying\": $fa-var-spaghetti-monster-flying,\n  \"pastafarianism\": $fa-var-pastafarianism,\n  \"arrow-down-up-across-line\": $fa-var-arrow-down-up-across-line,\n  \"spoon\": $fa-var-spoon,\n  \"utensil-spoon\": $fa-var-utensil-spoon,\n  \"jar-wheat\": $fa-var-jar-wheat,\n  \"envelopes-bulk\": $fa-var-envelopes-bulk,\n  \"mail-bulk\": $fa-var-mail-bulk,\n  \"file-circle-exclamation\": $fa-var-file-circle-exclamation,\n  \"circle-h\": $fa-var-circle-h,\n  \"hospital-symbol\": $fa-var-hospital-symbol,\n  \"pager\": $fa-var-pager,\n  \"address-book\": $fa-var-address-book,\n  \"contact-book\": $fa-var-contact-book,\n  \"strikethrough\": $fa-var-strikethrough,\n  \"k\": $fa-var-k,\n  \"landmark-flag\": $fa-var-landmark-flag,\n  \"pencil\": $fa-var-pencil,\n  \"pencil-alt\": $fa-var-pencil-alt,\n  \"backward\": $fa-var-backward,\n  \"caret-right\": $fa-var-caret-right,\n  \"comments\": $fa-var-comments,\n  \"paste\": $fa-var-paste,\n  \"file-clipboard\": $fa-var-file-clipboard,\n  \"code-pull-request\": $fa-var-code-pull-request,\n  \"clipboard-list\": $fa-var-clipboard-list,\n  \"truck-ramp-box\": $fa-var-truck-ramp-box,\n  \"truck-loading\": $fa-var-truck-loading,\n  \"user-check\": $fa-var-user-check,\n  \"vial-virus\": $fa-var-vial-virus,\n  \"sheet-plastic\": $fa-var-sheet-plastic,\n  \"blog\": $fa-var-blog,\n  \"user-ninja\": $fa-var-user-ninja,\n  \"person-arrow-up-from-line\": $fa-var-person-arrow-up-from-line,\n  \"scroll-torah\": $fa-var-scroll-torah,\n  \"torah\": $fa-var-torah,\n  \"broom-ball\": $fa-var-broom-ball,\n  \"quidditch\": $fa-var-quidditch,\n  \"quidditch-broom-ball\": $fa-var-quidditch-broom-ball,\n  \"toggle-off\": $fa-var-toggle-off,\n  \"box-archive\": $fa-var-box-archive,\n  \"archive\": $fa-var-archive,\n  \"person-drowning\": $fa-var-person-drowning,\n  \"arrow-down-9-1\": $fa-var-arrow-down-9-1,\n  \"sort-numeric-desc\": $fa-var-sort-numeric-desc,\n  \"sort-numeric-down-alt\": $fa-var-sort-numeric-down-alt,\n  \"face-grin-tongue-squint\": $fa-var-face-grin-tongue-squint,\n  \"grin-tongue-squint\": $fa-var-grin-tongue-squint,\n  \"spray-can\": $fa-var-spray-can,\n  \"truck-monster\": $fa-var-truck-monster,\n  \"w\": $fa-var-w,\n  \"earth-africa\": $fa-var-earth-africa,\n  \"globe-africa\": $fa-var-globe-africa,\n  \"rainbow\": $fa-var-rainbow,\n  \"circle-notch\": $fa-var-circle-notch,\n  \"tablet-screen-button\": $fa-var-tablet-screen-button,\n  \"tablet-alt\": $fa-var-tablet-alt,\n  \"paw\": $fa-var-paw,\n  \"cloud\": $fa-var-cloud,\n  \"trowel-bricks\": $fa-var-trowel-bricks,\n  \"face-flushed\": $fa-var-face-flushed,\n  \"flushed\": $fa-var-flushed,\n  \"hospital-user\": $fa-var-hospital-user,\n  \"tent-arrow-left-right\": $fa-var-tent-arrow-left-right,\n  \"gavel\": $fa-var-gavel,\n  \"legal\": $fa-var-legal,\n  \"binoculars\": $fa-var-binoculars,\n  \"microphone-slash\": $fa-var-microphone-slash,\n  \"box-tissue\": $fa-var-box-tissue,\n  \"motorcycle\": $fa-var-motorcycle,\n  \"bell-concierge\": $fa-var-bell-concierge,\n  \"concierge-bell\": $fa-var-concierge-bell,\n  \"pen-ruler\": $fa-var-pen-ruler,\n  \"pencil-ruler\": $fa-var-pencil-ruler,\n  \"people-arrows\": $fa-var-people-arrows,\n  \"people-arrows-left-right\": $fa-var-people-arrows-left-right,\n  \"mars-and-venus-burst\": $fa-var-mars-and-venus-burst,\n  \"square-caret-right\": $fa-var-square-caret-right,\n  \"caret-square-right\": $fa-var-caret-square-right,\n  \"scissors\": $fa-var-scissors,\n  \"cut\": $fa-var-cut,\n  \"sun-plant-wilt\": $fa-var-sun-plant-wilt,\n  \"toilets-portable\": $fa-var-toilets-portable,\n  \"hockey-puck\": $fa-var-hockey-puck,\n  \"table\": $fa-var-table,\n  \"magnifying-glass-arrow-right\": $fa-var-magnifying-glass-arrow-right,\n  \"tachograph-digital\": $fa-var-tachograph-digital,\n  \"digital-tachograph\": $fa-var-digital-tachograph,\n  \"users-slash\": $fa-var-users-slash,\n  \"clover\": $fa-var-clover,\n  \"reply\": $fa-var-reply,\n  \"mail-reply\": $fa-var-mail-reply,\n  \"star-and-crescent\": $fa-var-star-and-crescent,\n  \"house-fire\": $fa-var-house-fire,\n  \"square-minus\": $fa-var-square-minus,\n  \"minus-square\": $fa-var-minus-square,\n  \"helicopter\": $fa-var-helicopter,\n  \"compass\": $fa-var-compass,\n  \"square-caret-down\": $fa-var-square-caret-down,\n  \"caret-square-down\": $fa-var-caret-square-down,\n  \"file-circle-question\": $fa-var-file-circle-question,\n  \"laptop-code\": $fa-var-laptop-code,\n  \"swatchbook\": $fa-var-swatchbook,\n  \"prescription-bottle\": $fa-var-prescription-bottle,\n  \"bars\": $fa-var-bars,\n  \"navicon\": $fa-var-navicon,\n  \"people-group\": $fa-var-people-group,\n  \"hourglass-end\": $fa-var-hourglass-end,\n  \"hourglass-3\": $fa-var-hourglass-3,\n  \"heart-crack\": $fa-var-heart-crack,\n  \"heart-broken\": $fa-var-heart-broken,\n  \"square-up-right\": $fa-var-square-up-right,\n  \"external-link-square-alt\": $fa-var-external-link-square-alt,\n  \"face-kiss-beam\": $fa-var-face-kiss-beam,\n  \"kiss-beam\": $fa-var-kiss-beam,\n  \"film\": $fa-var-film,\n  \"ruler-horizontal\": $fa-var-ruler-horizontal,\n  \"people-robbery\": $fa-var-people-robbery,\n  \"lightbulb\": $fa-var-lightbulb,\n  \"caret-left\": $fa-var-caret-left,\n  \"circle-exclamation\": $fa-var-circle-exclamation,\n  \"exclamation-circle\": $fa-var-exclamation-circle,\n  \"school-circle-xmark\": $fa-var-school-circle-xmark,\n  \"arrow-right-from-bracket\": $fa-var-arrow-right-from-bracket,\n  \"sign-out\": $fa-var-sign-out,\n  \"circle-chevron-down\": $fa-var-circle-chevron-down,\n  \"chevron-circle-down\": $fa-var-chevron-circle-down,\n  \"unlock-keyhole\": $fa-var-unlock-keyhole,\n  \"unlock-alt\": $fa-var-unlock-alt,\n  \"cloud-showers-heavy\": $fa-var-cloud-showers-heavy,\n  \"headphones-simple\": $fa-var-headphones-simple,\n  \"headphones-alt\": $fa-var-headphones-alt,\n  \"sitemap\": $fa-var-sitemap,\n  \"circle-dollar-to-slot\": $fa-var-circle-dollar-to-slot,\n  \"donate\": $fa-var-donate,\n  \"memory\": $fa-var-memory,\n  \"road-spikes\": $fa-var-road-spikes,\n  \"fire-burner\": $fa-var-fire-burner,\n  \"flag\": $fa-var-flag,\n  \"hanukiah\": $fa-var-hanukiah,\n  \"feather\": $fa-var-feather,\n  \"volume-low\": $fa-var-volume-low,\n  \"volume-down\": $fa-var-volume-down,\n  \"comment-slash\": $fa-var-comment-slash,\n  \"cloud-sun-rain\": $fa-var-cloud-sun-rain,\n  \"compress\": $fa-var-compress,\n  \"wheat-awn\": $fa-var-wheat-awn,\n  \"wheat-alt\": $fa-var-wheat-alt,\n  \"ankh\": $fa-var-ankh,\n  \"hands-holding-child\": $fa-var-hands-holding-child,\n  \"asterisk\": $fa-var-asterisk,\n  \"square-check\": $fa-var-square-check,\n  \"check-square\": $fa-var-check-square,\n  \"peseta-sign\": $fa-var-peseta-sign,\n  \"heading\": $fa-var-heading,\n  \"header\": $fa-var-header,\n  \"ghost\": $fa-var-ghost,\n  \"list\": $fa-var-list,\n  \"list-squares\": $fa-var-list-squares,\n  \"square-phone-flip\": $fa-var-square-phone-flip,\n  \"phone-square-alt\": $fa-var-phone-square-alt,\n  \"cart-plus\": $fa-var-cart-plus,\n  \"gamepad\": $fa-var-gamepad,\n  \"circle-dot\": $fa-var-circle-dot,\n  \"dot-circle\": $fa-var-dot-circle,\n  \"face-dizzy\": $fa-var-face-dizzy,\n  \"dizzy\": $fa-var-dizzy,\n  \"egg\": $fa-var-egg,\n  \"house-medical-circle-xmark\": $fa-var-house-medical-circle-xmark,\n  \"campground\": $fa-var-campground,\n  \"folder-plus\": $fa-var-folder-plus,\n  \"futbol\": $fa-var-futbol,\n  \"futbol-ball\": $fa-var-futbol-ball,\n  \"soccer-ball\": $fa-var-soccer-ball,\n  \"paintbrush\": $fa-var-paintbrush,\n  \"paint-brush\": $fa-var-paint-brush,\n  \"lock\": $fa-var-lock,\n  \"gas-pump\": $fa-var-gas-pump,\n  \"hot-tub-person\": $fa-var-hot-tub-person,\n  \"hot-tub\": $fa-var-hot-tub,\n  \"map-location\": $fa-var-map-location,\n  \"map-marked\": $fa-var-map-marked,\n  \"house-flood-water\": $fa-var-house-flood-water,\n  \"tree\": $fa-var-tree,\n  \"bridge-lock\": $fa-var-bridge-lock,\n  \"sack-dollar\": $fa-var-sack-dollar,\n  \"pen-to-square\": $fa-var-pen-to-square,\n  \"edit\": $fa-var-edit,\n  \"car-side\": $fa-var-car-side,\n  \"share-nodes\": $fa-var-share-nodes,\n  \"share-alt\": $fa-var-share-alt,\n  \"heart-circle-minus\": $fa-var-heart-circle-minus,\n  \"hourglass-half\": $fa-var-hourglass-half,\n  \"hourglass-2\": $fa-var-hourglass-2,\n  \"microscope\": $fa-var-microscope,\n  \"sink\": $fa-var-sink,\n  \"bag-shopping\": $fa-var-bag-shopping,\n  \"shopping-bag\": $fa-var-shopping-bag,\n  \"arrow-down-z-a\": $fa-var-arrow-down-z-a,\n  \"sort-alpha-desc\": $fa-var-sort-alpha-desc,\n  \"sort-alpha-down-alt\": $fa-var-sort-alpha-down-alt,\n  \"mitten\": $fa-var-mitten,\n  \"person-rays\": $fa-var-person-rays,\n  \"users\": $fa-var-users,\n  \"eye-slash\": $fa-var-eye-slash,\n  \"flask-vial\": $fa-var-flask-vial,\n  \"hand\": $fa-var-hand,\n  \"hand-paper\": $fa-var-hand-paper,\n  \"om\": $fa-var-om,\n  \"worm\": $fa-var-worm,\n  \"house-circle-xmark\": $fa-var-house-circle-xmark,\n  \"plug\": $fa-var-plug,\n  \"chevron-up\": $fa-var-chevron-up,\n  \"hand-spock\": $fa-var-hand-spock,\n  \"stopwatch\": $fa-var-stopwatch,\n  \"face-kiss\": $fa-var-face-kiss,\n  \"kiss\": $fa-var-kiss,\n  \"bridge-circle-xmark\": $fa-var-bridge-circle-xmark,\n  \"face-grin-tongue\": $fa-var-face-grin-tongue,\n  \"grin-tongue\": $fa-var-grin-tongue,\n  \"chess-bishop\": $fa-var-chess-bishop,\n  \"face-grin-wink\": $fa-var-face-grin-wink,\n  \"grin-wink\": $fa-var-grin-wink,\n  \"ear-deaf\": $fa-var-ear-deaf,\n  \"deaf\": $fa-var-deaf,\n  \"deafness\": $fa-var-deafness,\n  \"hard-of-hearing\": $fa-var-hard-of-hearing,\n  \"road-circle-check\": $fa-var-road-circle-check,\n  \"dice-five\": $fa-var-dice-five,\n  \"square-rss\": $fa-var-square-rss,\n  \"rss-square\": $fa-var-rss-square,\n  \"land-mine-on\": $fa-var-land-mine-on,\n  \"i-cursor\": $fa-var-i-cursor,\n  \"stamp\": $fa-var-stamp,\n  \"stairs\": $fa-var-stairs,\n  \"i\": $fa-var-i,\n  \"hryvnia-sign\": $fa-var-hryvnia-sign,\n  \"hryvnia\": $fa-var-hryvnia,\n  \"pills\": $fa-var-pills,\n  \"face-grin-wide\": $fa-var-face-grin-wide,\n  \"grin-alt\": $fa-var-grin-alt,\n  \"tooth\": $fa-var-tooth,\n  \"v\": $fa-var-v,\n  \"bangladeshi-taka-sign\": $fa-var-bangladeshi-taka-sign,\n  \"bicycle\": $fa-var-bicycle,\n  \"staff-snake\": $fa-var-staff-snake,\n  \"rod-asclepius\": $fa-var-rod-asclepius,\n  \"rod-snake\": $fa-var-rod-snake,\n  \"staff-aesculapius\": $fa-var-staff-aesculapius,\n  \"head-side-cough-slash\": $fa-var-head-side-cough-slash,\n  \"truck-medical\": $fa-var-truck-medical,\n  \"ambulance\": $fa-var-ambulance,\n  \"wheat-awn-circle-exclamation\": $fa-var-wheat-awn-circle-exclamation,\n  \"snowman\": $fa-var-snowman,\n  \"mortar-pestle\": $fa-var-mortar-pestle,\n  \"road-barrier\": $fa-var-road-barrier,\n  \"school\": $fa-var-school,\n  \"igloo\": $fa-var-igloo,\n  \"joint\": $fa-var-joint,\n  \"angle-right\": $fa-var-angle-right,\n  \"horse\": $fa-var-horse,\n  \"q\": $fa-var-q,\n  \"g\": $fa-var-g,\n  \"notes-medical\": $fa-var-notes-medical,\n  \"temperature-half\": $fa-var-temperature-half,\n  \"temperature-2\": $fa-var-temperature-2,\n  \"thermometer-2\": $fa-var-thermometer-2,\n  \"thermometer-half\": $fa-var-thermometer-half,\n  \"dong-sign\": $fa-var-dong-sign,\n  \"capsules\": $fa-var-capsules,\n  \"poo-storm\": $fa-var-poo-storm,\n  \"poo-bolt\": $fa-var-poo-bolt,\n  \"face-frown-open\": $fa-var-face-frown-open,\n  \"frown-open\": $fa-var-frown-open,\n  \"hand-point-up\": $fa-var-hand-point-up,\n  \"money-bill\": $fa-var-money-bill,\n  \"bookmark\": $fa-var-bookmark,\n  \"align-justify\": $fa-var-align-justify,\n  \"umbrella-beach\": $fa-var-umbrella-beach,\n  \"helmet-un\": $fa-var-helmet-un,\n  \"bullseye\": $fa-var-bullseye,\n  \"bacon\": $fa-var-bacon,\n  \"hand-point-down\": $fa-var-hand-point-down,\n  \"arrow-up-from-bracket\": $fa-var-arrow-up-from-bracket,\n  \"folder\": $fa-var-folder,\n  \"folder-blank\": $fa-var-folder-blank,\n  \"file-waveform\": $fa-var-file-waveform,\n  \"file-medical-alt\": $fa-var-file-medical-alt,\n  \"radiation\": $fa-var-radiation,\n  \"chart-simple\": $fa-var-chart-simple,\n  \"mars-stroke\": $fa-var-mars-stroke,\n  \"vial\": $fa-var-vial,\n  \"gauge\": $fa-var-gauge,\n  \"dashboard\": $fa-var-dashboard,\n  \"gauge-med\": $fa-var-gauge-med,\n  \"tachometer-alt-average\": $fa-var-tachometer-alt-average,\n  \"wand-magic-sparkles\": $fa-var-wand-magic-sparkles,\n  \"magic-wand-sparkles\": $fa-var-magic-wand-sparkles,\n  \"e\": $fa-var-e,\n  \"pen-clip\": $fa-var-pen-clip,\n  \"pen-alt\": $fa-var-pen-alt,\n  \"bridge-circle-exclamation\": $fa-var-bridge-circle-exclamation,\n  \"user\": $fa-var-user,\n  \"school-circle-check\": $fa-var-school-circle-check,\n  \"dumpster\": $fa-var-dumpster,\n  \"van-shuttle\": $fa-var-van-shuttle,\n  \"shuttle-van\": $fa-var-shuttle-van,\n  \"building-user\": $fa-var-building-user,\n  \"square-caret-left\": $fa-var-square-caret-left,\n  \"caret-square-left\": $fa-var-caret-square-left,\n  \"highlighter\": $fa-var-highlighter,\n  \"key\": $fa-var-key,\n  \"bullhorn\": $fa-var-bullhorn,\n  \"globe\": $fa-var-globe,\n  \"synagogue\": $fa-var-synagogue,\n  \"person-half-dress\": $fa-var-person-half-dress,\n  \"road-bridge\": $fa-var-road-bridge,\n  \"location-arrow\": $fa-var-location-arrow,\n  \"c\": $fa-var-c,\n  \"tablet-button\": $fa-var-tablet-button,\n  \"building-lock\": $fa-var-building-lock,\n  \"pizza-slice\": $fa-var-pizza-slice,\n  \"money-bill-wave\": $fa-var-money-bill-wave,\n  \"chart-area\": $fa-var-chart-area,\n  \"area-chart\": $fa-var-area-chart,\n  \"house-flag\": $fa-var-house-flag,\n  \"person-circle-minus\": $fa-var-person-circle-minus,\n  \"ban\": $fa-var-ban,\n  \"cancel\": $fa-var-cancel,\n  \"camera-rotate\": $fa-var-camera-rotate,\n  \"spray-can-sparkles\": $fa-var-spray-can-sparkles,\n  \"air-freshener\": $fa-var-air-freshener,\n  \"star\": $fa-var-star,\n  \"repeat\": $fa-var-repeat,\n  \"cross\": $fa-var-cross,\n  \"box\": $fa-var-box,\n  \"venus-mars\": $fa-var-venus-mars,\n  \"arrow-pointer\": $fa-var-arrow-pointer,\n  \"mouse-pointer\": $fa-var-mouse-pointer,\n  \"maximize\": $fa-var-maximize,\n  \"expand-arrows-alt\": $fa-var-expand-arrows-alt,\n  \"charging-station\": $fa-var-charging-station,\n  \"shapes\": $fa-var-shapes,\n  \"triangle-circle-square\": $fa-var-triangle-circle-square,\n  \"shuffle\": $fa-var-shuffle,\n  \"random\": $fa-var-random,\n  \"person-running\": $fa-var-person-running,\n  \"running\": $fa-var-running,\n  \"mobile-retro\": $fa-var-mobile-retro,\n  \"grip-lines-vertical\": $fa-var-grip-lines-vertical,\n  \"spider\": $fa-var-spider,\n  \"hands-bound\": $fa-var-hands-bound,\n  \"file-invoice-dollar\": $fa-var-file-invoice-dollar,\n  \"plane-circle-exclamation\": $fa-var-plane-circle-exclamation,\n  \"x-ray\": $fa-var-x-ray,\n  \"spell-check\": $fa-var-spell-check,\n  \"slash\": $fa-var-slash,\n  \"computer-mouse\": $fa-var-computer-mouse,\n  \"mouse\": $fa-var-mouse,\n  \"arrow-right-to-bracket\": $fa-var-arrow-right-to-bracket,\n  \"sign-in\": $fa-var-sign-in,\n  \"shop-slash\": $fa-var-shop-slash,\n  \"store-alt-slash\": $fa-var-store-alt-slash,\n  \"server\": $fa-var-server,\n  \"virus-covid-slash\": $fa-var-virus-covid-slash,\n  \"shop-lock\": $fa-var-shop-lock,\n  \"hourglass-start\": $fa-var-hourglass-start,\n  \"hourglass-1\": $fa-var-hourglass-1,\n  \"blender-phone\": $fa-var-blender-phone,\n  \"building-wheat\": $fa-var-building-wheat,\n  \"person-breastfeeding\": $fa-var-person-breastfeeding,\n  \"right-to-bracket\": $fa-var-right-to-bracket,\n  \"sign-in-alt\": $fa-var-sign-in-alt,\n  \"venus\": $fa-var-venus,\n  \"passport\": $fa-var-passport,\n  \"heart-pulse\": $fa-var-heart-pulse,\n  \"heartbeat\": $fa-var-heartbeat,\n  \"people-carry-box\": $fa-var-people-carry-box,\n  \"people-carry\": $fa-var-people-carry,\n  \"temperature-high\": $fa-var-temperature-high,\n  \"microchip\": $fa-var-microchip,\n  \"crown\": $fa-var-crown,\n  \"weight-hanging\": $fa-var-weight-hanging,\n  \"xmarks-lines\": $fa-var-xmarks-lines,\n  \"file-prescription\": $fa-var-file-prescription,\n  \"weight-scale\": $fa-var-weight-scale,\n  \"weight\": $fa-var-weight,\n  \"user-group\": $fa-var-user-group,\n  \"user-friends\": $fa-var-user-friends,\n  \"arrow-up-a-z\": $fa-var-arrow-up-a-z,\n  \"sort-alpha-up\": $fa-var-sort-alpha-up,\n  \"chess-knight\": $fa-var-chess-knight,\n  \"face-laugh-squint\": $fa-var-face-laugh-squint,\n  \"laugh-squint\": $fa-var-laugh-squint,\n  \"wheelchair\": $fa-var-wheelchair,\n  \"circle-arrow-up\": $fa-var-circle-arrow-up,\n  \"arrow-circle-up\": $fa-var-arrow-circle-up,\n  \"toggle-on\": $fa-var-toggle-on,\n  \"person-walking\": $fa-var-person-walking,\n  \"walking\": $fa-var-walking,\n  \"l\": $fa-var-l,\n  \"fire\": $fa-var-fire,\n  \"bed-pulse\": $fa-var-bed-pulse,\n  \"procedures\": $fa-var-procedures,\n  \"shuttle-space\": $fa-var-shuttle-space,\n  \"space-shuttle\": $fa-var-space-shuttle,\n  \"face-laugh\": $fa-var-face-laugh,\n  \"laugh\": $fa-var-laugh,\n  \"folder-open\": $fa-var-folder-open,\n  \"heart-circle-plus\": $fa-var-heart-circle-plus,\n  \"code-fork\": $fa-var-code-fork,\n  \"city\": $fa-var-city,\n  \"microphone-lines\": $fa-var-microphone-lines,\n  \"microphone-alt\": $fa-var-microphone-alt,\n  \"pepper-hot\": $fa-var-pepper-hot,\n  \"unlock\": $fa-var-unlock,\n  \"colon-sign\": $fa-var-colon-sign,\n  \"headset\": $fa-var-headset,\n  \"store-slash\": $fa-var-store-slash,\n  \"road-circle-xmark\": $fa-var-road-circle-xmark,\n  \"user-minus\": $fa-var-user-minus,\n  \"mars-stroke-up\": $fa-var-mars-stroke-up,\n  \"mars-stroke-v\": $fa-var-mars-stroke-v,\n  \"champagne-glasses\": $fa-var-champagne-glasses,\n  \"glass-cheers\": $fa-var-glass-cheers,\n  \"clipboard\": $fa-var-clipboard,\n  \"house-circle-exclamation\": $fa-var-house-circle-exclamation,\n  \"file-arrow-up\": $fa-var-file-arrow-up,\n  \"file-upload\": $fa-var-file-upload,\n  \"wifi\": $fa-var-wifi,\n  \"wifi-3\": $fa-var-wifi-3,\n  \"wifi-strong\": $fa-var-wifi-strong,\n  \"bath\": $fa-var-bath,\n  \"bathtub\": $fa-var-bathtub,\n  \"underline\": $fa-var-underline,\n  \"user-pen\": $fa-var-user-pen,\n  \"user-edit\": $fa-var-user-edit,\n  \"signature\": $fa-var-signature,\n  \"stroopwafel\": $fa-var-stroopwafel,\n  \"bold\": $fa-var-bold,\n  \"anchor-lock\": $fa-var-anchor-lock,\n  \"building-ngo\": $fa-var-building-ngo,\n  \"manat-sign\": $fa-var-manat-sign,\n  \"not-equal\": $fa-var-not-equal,\n  \"border-top-left\": $fa-var-border-top-left,\n  \"border-style\": $fa-var-border-style,\n  \"map-location-dot\": $fa-var-map-location-dot,\n  \"map-marked-alt\": $fa-var-map-marked-alt,\n  \"jedi\": $fa-var-jedi,\n  \"square-poll-vertical\": $fa-var-square-poll-vertical,\n  \"poll\": $fa-var-poll,\n  \"mug-hot\": $fa-var-mug-hot,\n  \"car-battery\": $fa-var-car-battery,\n  \"battery-car\": $fa-var-battery-car,\n  \"gift\": $fa-var-gift,\n  \"dice-two\": $fa-var-dice-two,\n  \"chess-queen\": $fa-var-chess-queen,\n  \"glasses\": $fa-var-glasses,\n  \"chess-board\": $fa-var-chess-board,\n  \"building-circle-check\": $fa-var-building-circle-check,\n  \"person-chalkboard\": $fa-var-person-chalkboard,\n  \"mars-stroke-right\": $fa-var-mars-stroke-right,\n  \"mars-stroke-h\": $fa-var-mars-stroke-h,\n  \"hand-back-fist\": $fa-var-hand-back-fist,\n  \"hand-rock\": $fa-var-hand-rock,\n  \"square-caret-up\": $fa-var-square-caret-up,\n  \"caret-square-up\": $fa-var-caret-square-up,\n  \"cloud-showers-water\": $fa-var-cloud-showers-water,\n  \"chart-bar\": $fa-var-chart-bar,\n  \"bar-chart\": $fa-var-bar-chart,\n  \"hands-bubbles\": $fa-var-hands-bubbles,\n  \"hands-wash\": $fa-var-hands-wash,\n  \"less-than-equal\": $fa-var-less-than-equal,\n  \"train\": $fa-var-train,\n  \"eye-low-vision\": $fa-var-eye-low-vision,\n  \"low-vision\": $fa-var-low-vision,\n  \"crow\": $fa-var-crow,\n  \"sailboat\": $fa-var-sailboat,\n  \"window-restore\": $fa-var-window-restore,\n  \"square-plus\": $fa-var-square-plus,\n  \"plus-square\": $fa-var-plus-square,\n  \"torii-gate\": $fa-var-torii-gate,\n  \"frog\": $fa-var-frog,\n  \"bucket\": $fa-var-bucket,\n  \"image\": $fa-var-image,\n  \"microphone\": $fa-var-microphone,\n  \"cow\": $fa-var-cow,\n  \"caret-up\": $fa-var-caret-up,\n  \"screwdriver\": $fa-var-screwdriver,\n  \"folder-closed\": $fa-var-folder-closed,\n  \"house-tsunami\": $fa-var-house-tsunami,\n  \"square-nfi\": $fa-var-square-nfi,\n  \"arrow-up-from-ground-water\": $fa-var-arrow-up-from-ground-water,\n  \"martini-glass\": $fa-var-martini-glass,\n  \"glass-martini-alt\": $fa-var-glass-martini-alt,\n  \"rotate-left\": $fa-var-rotate-left,\n  \"rotate-back\": $fa-var-rotate-back,\n  \"rotate-backward\": $fa-var-rotate-backward,\n  \"undo-alt\": $fa-var-undo-alt,\n  \"table-columns\": $fa-var-table-columns,\n  \"columns\": $fa-var-columns,\n  \"lemon\": $fa-var-lemon,\n  \"head-side-mask\": $fa-var-head-side-mask,\n  \"handshake\": $fa-var-handshake,\n  \"gem\": $fa-var-gem,\n  \"dolly\": $fa-var-dolly,\n  \"dolly-box\": $fa-var-dolly-box,\n  \"smoking\": $fa-var-smoking,\n  \"minimize\": $fa-var-minimize,\n  \"compress-arrows-alt\": $fa-var-compress-arrows-alt,\n  \"monument\": $fa-var-monument,\n  \"snowplow\": $fa-var-snowplow,\n  \"angles-right\": $fa-var-angles-right,\n  \"angle-double-right\": $fa-var-angle-double-right,\n  \"cannabis\": $fa-var-cannabis,\n  \"circle-play\": $fa-var-circle-play,\n  \"play-circle\": $fa-var-play-circle,\n  \"tablets\": $fa-var-tablets,\n  \"ethernet\": $fa-var-ethernet,\n  \"euro-sign\": $fa-var-euro-sign,\n  \"eur\": $fa-var-eur,\n  \"euro\": $fa-var-euro,\n  \"chair\": $fa-var-chair,\n  \"circle-check\": $fa-var-circle-check,\n  \"check-circle\": $fa-var-check-circle,\n  \"circle-stop\": $fa-var-circle-stop,\n  \"stop-circle\": $fa-var-stop-circle,\n  \"compass-drafting\": $fa-var-compass-drafting,\n  \"drafting-compass\": $fa-var-drafting-compass,\n  \"plate-wheat\": $fa-var-plate-wheat,\n  \"icicles\": $fa-var-icicles,\n  \"person-shelter\": $fa-var-person-shelter,\n  \"neuter\": $fa-var-neuter,\n  \"id-badge\": $fa-var-id-badge,\n  \"marker\": $fa-var-marker,\n  \"face-laugh-beam\": $fa-var-face-laugh-beam,\n  \"laugh-beam\": $fa-var-laugh-beam,\n  \"helicopter-symbol\": $fa-var-helicopter-symbol,\n  \"universal-access\": $fa-var-universal-access,\n  \"circle-chevron-up\": $fa-var-circle-chevron-up,\n  \"chevron-circle-up\": $fa-var-chevron-circle-up,\n  \"lari-sign\": $fa-var-lari-sign,\n  \"volcano\": $fa-var-volcano,\n  \"person-walking-dashed-line-arrow-right\": $fa-var-person-walking-dashed-line-arrow-right,\n  \"sterling-sign\": $fa-var-sterling-sign,\n  \"gbp\": $fa-var-gbp,\n  \"pound-sign\": $fa-var-pound-sign,\n  \"viruses\": $fa-var-viruses,\n  \"square-person-confined\": $fa-var-square-person-confined,\n  \"user-tie\": $fa-var-user-tie,\n  \"arrow-down-long\": $fa-var-arrow-down-long,\n  \"long-arrow-down\": $fa-var-long-arrow-down,\n  \"tent-arrow-down-to-line\": $fa-var-tent-arrow-down-to-line,\n  \"certificate\": $fa-var-certificate,\n  \"reply-all\": $fa-var-reply-all,\n  \"mail-reply-all\": $fa-var-mail-reply-all,\n  \"suitcase\": $fa-var-suitcase,\n  \"person-skating\": $fa-var-person-skating,\n  \"skating\": $fa-var-skating,\n  \"filter-circle-dollar\": $fa-var-filter-circle-dollar,\n  \"funnel-dollar\": $fa-var-funnel-dollar,\n  \"camera-retro\": $fa-var-camera-retro,\n  \"circle-arrow-down\": $fa-var-circle-arrow-down,\n  \"arrow-circle-down\": $fa-var-arrow-circle-down,\n  \"file-import\": $fa-var-file-import,\n  \"arrow-right-to-file\": $fa-var-arrow-right-to-file,\n  \"square-arrow-up-right\": $fa-var-square-arrow-up-right,\n  \"external-link-square\": $fa-var-external-link-square,\n  \"box-open\": $fa-var-box-open,\n  \"scroll\": $fa-var-scroll,\n  \"spa\": $fa-var-spa,\n  \"location-pin-lock\": $fa-var-location-pin-lock,\n  \"pause\": $fa-var-pause,\n  \"hill-avalanche\": $fa-var-hill-avalanche,\n  \"temperature-empty\": $fa-var-temperature-empty,\n  \"temperature-0\": $fa-var-temperature-0,\n  \"thermometer-0\": $fa-var-thermometer-0,\n  \"thermometer-empty\": $fa-var-thermometer-empty,\n  \"bomb\": $fa-var-bomb,\n  \"registered\": $fa-var-registered,\n  \"address-card\": $fa-var-address-card,\n  \"contact-card\": $fa-var-contact-card,\n  \"vcard\": $fa-var-vcard,\n  \"scale-unbalanced-flip\": $fa-var-scale-unbalanced-flip,\n  \"balance-scale-right\": $fa-var-balance-scale-right,\n  \"subscript\": $fa-var-subscript,\n  \"diamond-turn-right\": $fa-var-diamond-turn-right,\n  \"directions\": $fa-var-directions,\n  \"burst\": $fa-var-burst,\n  \"house-laptop\": $fa-var-house-laptop,\n  \"laptop-house\": $fa-var-laptop-house,\n  \"face-tired\": $fa-var-face-tired,\n  \"tired\": $fa-var-tired,\n  \"money-bills\": $fa-var-money-bills,\n  \"smog\": $fa-var-smog,\n  \"crutch\": $fa-var-crutch,\n  \"cloud-arrow-up\": $fa-var-cloud-arrow-up,\n  \"cloud-upload\": $fa-var-cloud-upload,\n  \"cloud-upload-alt\": $fa-var-cloud-upload-alt,\n  \"palette\": $fa-var-palette,\n  \"arrows-turn-right\": $fa-var-arrows-turn-right,\n  \"vest\": $fa-var-vest,\n  \"ferry\": $fa-var-ferry,\n  \"arrows-down-to-people\": $fa-var-arrows-down-to-people,\n  \"seedling\": $fa-var-seedling,\n  \"sprout\": $fa-var-sprout,\n  \"left-right\": $fa-var-left-right,\n  \"arrows-alt-h\": $fa-var-arrows-alt-h,\n  \"boxes-packing\": $fa-var-boxes-packing,\n  \"circle-arrow-left\": $fa-var-circle-arrow-left,\n  \"arrow-circle-left\": $fa-var-arrow-circle-left,\n  \"group-arrows-rotate\": $fa-var-group-arrows-rotate,\n  \"bowl-food\": $fa-var-bowl-food,\n  \"candy-cane\": $fa-var-candy-cane,\n  \"arrow-down-wide-short\": $fa-var-arrow-down-wide-short,\n  \"sort-amount-asc\": $fa-var-sort-amount-asc,\n  \"sort-amount-down\": $fa-var-sort-amount-down,\n  \"cloud-bolt\": $fa-var-cloud-bolt,\n  \"thunderstorm\": $fa-var-thunderstorm,\n  \"text-slash\": $fa-var-text-slash,\n  \"remove-format\": $fa-var-remove-format,\n  \"face-smile-wink\": $fa-var-face-smile-wink,\n  \"smile-wink\": $fa-var-smile-wink,\n  \"file-word\": $fa-var-file-word,\n  \"file-powerpoint\": $fa-var-file-powerpoint,\n  \"arrows-left-right\": $fa-var-arrows-left-right,\n  \"arrows-h\": $fa-var-arrows-h,\n  \"house-lock\": $fa-var-house-lock,\n  \"cloud-arrow-down\": $fa-var-cloud-arrow-down,\n  \"cloud-download\": $fa-var-cloud-download,\n  \"cloud-download-alt\": $fa-var-cloud-download-alt,\n  \"children\": $fa-var-children,\n  \"chalkboard\": $fa-var-chalkboard,\n  \"blackboard\": $fa-var-blackboard,\n  \"user-large-slash\": $fa-var-user-large-slash,\n  \"user-alt-slash\": $fa-var-user-alt-slash,\n  \"envelope-open\": $fa-var-envelope-open,\n  \"handshake-simple-slash\": $fa-var-handshake-simple-slash,\n  \"handshake-alt-slash\": $fa-var-handshake-alt-slash,\n  \"mattress-pillow\": $fa-var-mattress-pillow,\n  \"guarani-sign\": $fa-var-guarani-sign,\n  \"arrows-rotate\": $fa-var-arrows-rotate,\n  \"refresh\": $fa-var-refresh,\n  \"sync\": $fa-var-sync,\n  \"fire-extinguisher\": $fa-var-fire-extinguisher,\n  \"cruzeiro-sign\": $fa-var-cruzeiro-sign,\n  \"greater-than-equal\": $fa-var-greater-than-equal,\n  \"shield-halved\": $fa-var-shield-halved,\n  \"shield-alt\": $fa-var-shield-alt,\n  \"book-atlas\": $fa-var-book-atlas,\n  \"atlas\": $fa-var-atlas,\n  \"virus\": $fa-var-virus,\n  \"envelope-circle-check\": $fa-var-envelope-circle-check,\n  \"layer-group\": $fa-var-layer-group,\n  \"arrows-to-dot\": $fa-var-arrows-to-dot,\n  \"archway\": $fa-var-archway,\n  \"heart-circle-check\": $fa-var-heart-circle-check,\n  \"house-chimney-crack\": $fa-var-house-chimney-crack,\n  \"house-damage\": $fa-var-house-damage,\n  \"file-zipper\": $fa-var-file-zipper,\n  \"file-archive\": $fa-var-file-archive,\n  \"square\": $fa-var-square,\n  \"martini-glass-empty\": $fa-var-martini-glass-empty,\n  \"glass-martini\": $fa-var-glass-martini,\n  \"couch\": $fa-var-couch,\n  \"cedi-sign\": $fa-var-cedi-sign,\n  \"italic\": $fa-var-italic,\n  \"table-cells-column-lock\": $fa-var-table-cells-column-lock,\n  \"church\": $fa-var-church,\n  \"comments-dollar\": $fa-var-comments-dollar,\n  \"democrat\": $fa-var-democrat,\n  \"z\": $fa-var-z,\n  \"person-skiing\": $fa-var-person-skiing,\n  \"skiing\": $fa-var-skiing,\n  \"road-lock\": $fa-var-road-lock,\n  \"a\": $fa-var-a,\n  \"temperature-arrow-down\": $fa-var-temperature-arrow-down,\n  \"temperature-down\": $fa-var-temperature-down,\n  \"feather-pointed\": $fa-var-feather-pointed,\n  \"feather-alt\": $fa-var-feather-alt,\n  \"p\": $fa-var-p,\n  \"snowflake\": $fa-var-snowflake,\n  \"newspaper\": $fa-var-newspaper,\n  \"rectangle-ad\": $fa-var-rectangle-ad,\n  \"ad\": $fa-var-ad,\n  \"circle-arrow-right\": $fa-var-circle-arrow-right,\n  \"arrow-circle-right\": $fa-var-arrow-circle-right,\n  \"filter-circle-xmark\": $fa-var-filter-circle-xmark,\n  \"locust\": $fa-var-locust,\n  \"sort\": $fa-var-sort,\n  \"unsorted\": $fa-var-unsorted,\n  \"list-ol\": $fa-var-list-ol,\n  \"list-1-2\": $fa-var-list-1-2,\n  \"list-numeric\": $fa-var-list-numeric,\n  \"person-dress-burst\": $fa-var-person-dress-burst,\n  \"money-check-dollar\": $fa-var-money-check-dollar,\n  \"money-check-alt\": $fa-var-money-check-alt,\n  \"vector-square\": $fa-var-vector-square,\n  \"bread-slice\": $fa-var-bread-slice,\n  \"language\": $fa-var-language,\n  \"face-kiss-wink-heart\": $fa-var-face-kiss-wink-heart,\n  \"kiss-wink-heart\": $fa-var-kiss-wink-heart,\n  \"filter\": $fa-var-filter,\n  \"question\": $fa-var-question,\n  \"file-signature\": $fa-var-file-signature,\n  \"up-down-left-right\": $fa-var-up-down-left-right,\n  \"arrows-alt\": $fa-var-arrows-alt,\n  \"house-chimney-user\": $fa-var-house-chimney-user,\n  \"hand-holding-heart\": $fa-var-hand-holding-heart,\n  \"puzzle-piece\": $fa-var-puzzle-piece,\n  \"money-check\": $fa-var-money-check,\n  \"star-half-stroke\": $fa-var-star-half-stroke,\n  \"star-half-alt\": $fa-var-star-half-alt,\n  \"code\": $fa-var-code,\n  \"whiskey-glass\": $fa-var-whiskey-glass,\n  \"glass-whiskey\": $fa-var-glass-whiskey,\n  \"building-circle-exclamation\": $fa-var-building-circle-exclamation,\n  \"magnifying-glass-chart\": $fa-var-magnifying-glass-chart,\n  \"arrow-up-right-from-square\": $fa-var-arrow-up-right-from-square,\n  \"external-link\": $fa-var-external-link,\n  \"cubes-stacked\": $fa-var-cubes-stacked,\n  \"won-sign\": $fa-var-won-sign,\n  \"krw\": $fa-var-krw,\n  \"won\": $fa-var-won,\n  \"virus-covid\": $fa-var-virus-covid,\n  \"austral-sign\": $fa-var-austral-sign,\n  \"f\": $fa-var-f,\n  \"leaf\": $fa-var-leaf,\n  \"road\": $fa-var-road,\n  \"taxi\": $fa-var-taxi,\n  \"cab\": $fa-var-cab,\n  \"person-circle-plus\": $fa-var-person-circle-plus,\n  \"chart-pie\": $fa-var-chart-pie,\n  \"pie-chart\": $fa-var-pie-chart,\n  \"bolt-lightning\": $fa-var-bolt-lightning,\n  \"sack-xmark\": $fa-var-sack-xmark,\n  \"file-excel\": $fa-var-file-excel,\n  \"file-contract\": $fa-var-file-contract,\n  \"fish-fins\": $fa-var-fish-fins,\n  \"building-flag\": $fa-var-building-flag,\n  \"face-grin-beam\": $fa-var-face-grin-beam,\n  \"grin-beam\": $fa-var-grin-beam,\n  \"object-ungroup\": $fa-var-object-ungroup,\n  \"poop\": $fa-var-poop,\n  \"location-pin\": $fa-var-location-pin,\n  \"map-marker\": $fa-var-map-marker,\n  \"kaaba\": $fa-var-kaaba,\n  \"toilet-paper\": $fa-var-toilet-paper,\n  \"helmet-safety\": $fa-var-helmet-safety,\n  \"hard-hat\": $fa-var-hard-hat,\n  \"hat-hard\": $fa-var-hat-hard,\n  \"eject\": $fa-var-eject,\n  \"circle-right\": $fa-var-circle-right,\n  \"arrow-alt-circle-right\": $fa-var-arrow-alt-circle-right,\n  \"plane-circle-check\": $fa-var-plane-circle-check,\n  \"face-rolling-eyes\": $fa-var-face-rolling-eyes,\n  \"meh-rolling-eyes\": $fa-var-meh-rolling-eyes,\n  \"object-group\": $fa-var-object-group,\n  \"chart-line\": $fa-var-chart-line,\n  \"line-chart\": $fa-var-line-chart,\n  \"mask-ventilator\": $fa-var-mask-ventilator,\n  \"arrow-right\": $fa-var-arrow-right,\n  \"signs-post\": $fa-var-signs-post,\n  \"map-signs\": $fa-var-map-signs,\n  \"cash-register\": $fa-var-cash-register,\n  \"person-circle-question\": $fa-var-person-circle-question,\n  \"h\": $fa-var-h,\n  \"tarp\": $fa-var-tarp,\n  \"screwdriver-wrench\": $fa-var-screwdriver-wrench,\n  \"tools\": $fa-var-tools,\n  \"arrows-to-eye\": $fa-var-arrows-to-eye,\n  \"plug-circle-bolt\": $fa-var-plug-circle-bolt,\n  \"heart\": $fa-var-heart,\n  \"mars-and-venus\": $fa-var-mars-and-venus,\n  \"house-user\": $fa-var-house-user,\n  \"home-user\": $fa-var-home-user,\n  \"dumpster-fire\": $fa-var-dumpster-fire,\n  \"house-crack\": $fa-var-house-crack,\n  \"martini-glass-citrus\": $fa-var-martini-glass-citrus,\n  \"cocktail\": $fa-var-cocktail,\n  \"face-surprise\": $fa-var-face-surprise,\n  \"surprise\": $fa-var-surprise,\n  \"bottle-water\": $fa-var-bottle-water,\n  \"circle-pause\": $fa-var-circle-pause,\n  \"pause-circle\": $fa-var-pause-circle,\n  \"toilet-paper-slash\": $fa-var-toilet-paper-slash,\n  \"apple-whole\": $fa-var-apple-whole,\n  \"apple-alt\": $fa-var-apple-alt,\n  \"kitchen-set\": $fa-var-kitchen-set,\n  \"r\": $fa-var-r,\n  \"temperature-quarter\": $fa-var-temperature-quarter,\n  \"temperature-1\": $fa-var-temperature-1,\n  \"thermometer-1\": $fa-var-thermometer-1,\n  \"thermometer-quarter\": $fa-var-thermometer-quarter,\n  \"cube\": $fa-var-cube,\n  \"bitcoin-sign\": $fa-var-bitcoin-sign,\n  \"shield-dog\": $fa-var-shield-dog,\n  \"solar-panel\": $fa-var-solar-panel,\n  \"lock-open\": $fa-var-lock-open,\n  \"elevator\": $fa-var-elevator,\n  \"money-bill-transfer\": $fa-var-money-bill-transfer,\n  \"money-bill-trend-up\": $fa-var-money-bill-trend-up,\n  \"house-flood-water-circle-arrow-right\": $fa-var-house-flood-water-circle-arrow-right,\n  \"square-poll-horizontal\": $fa-var-square-poll-horizontal,\n  \"poll-h\": $fa-var-poll-h,\n  \"circle\": $fa-var-circle,\n  \"backward-fast\": $fa-var-backward-fast,\n  \"fast-backward\": $fa-var-fast-backward,\n  \"recycle\": $fa-var-recycle,\n  \"user-astronaut\": $fa-var-user-astronaut,\n  \"plane-slash\": $fa-var-plane-slash,\n  \"trademark\": $fa-var-trademark,\n  \"basketball\": $fa-var-basketball,\n  \"basketball-ball\": $fa-var-basketball-ball,\n  \"satellite-dish\": $fa-var-satellite-dish,\n  \"circle-up\": $fa-var-circle-up,\n  \"arrow-alt-circle-up\": $fa-var-arrow-alt-circle-up,\n  \"mobile-screen-button\": $fa-var-mobile-screen-button,\n  \"mobile-alt\": $fa-var-mobile-alt,\n  \"volume-high\": $fa-var-volume-high,\n  \"volume-up\": $fa-var-volume-up,\n  \"users-rays\": $fa-var-users-rays,\n  \"wallet\": $fa-var-wallet,\n  \"clipboard-check\": $fa-var-clipboard-check,\n  \"file-audio\": $fa-var-file-audio,\n  \"burger\": $fa-var-burger,\n  \"hamburger\": $fa-var-hamburger,\n  \"wrench\": $fa-var-wrench,\n  \"bugs\": $fa-var-bugs,\n  \"rupee-sign\": $fa-var-rupee-sign,\n  \"rupee\": $fa-var-rupee,\n  \"file-image\": $fa-var-file-image,\n  \"circle-question\": $fa-var-circle-question,\n  \"question-circle\": $fa-var-question-circle,\n  \"plane-departure\": $fa-var-plane-departure,\n  \"handshake-slash\": $fa-var-handshake-slash,\n  \"book-bookmark\": $fa-var-book-bookmark,\n  \"code-branch\": $fa-var-code-branch,\n  \"hat-cowboy\": $fa-var-hat-cowboy,\n  \"bridge\": $fa-var-bridge,\n  \"phone-flip\": $fa-var-phone-flip,\n  \"phone-alt\": $fa-var-phone-alt,\n  \"truck-front\": $fa-var-truck-front,\n  \"cat\": $fa-var-cat,\n  \"anchor-circle-exclamation\": $fa-var-anchor-circle-exclamation,\n  \"truck-field\": $fa-var-truck-field,\n  \"route\": $fa-var-route,\n  \"clipboard-question\": $fa-var-clipboard-question,\n  \"panorama\": $fa-var-panorama,\n  \"comment-medical\": $fa-var-comment-medical,\n  \"teeth-open\": $fa-var-teeth-open,\n  \"file-circle-minus\": $fa-var-file-circle-minus,\n  \"tags\": $fa-var-tags,\n  \"wine-glass\": $fa-var-wine-glass,\n  \"forward-fast\": $fa-var-forward-fast,\n  \"fast-forward\": $fa-var-fast-forward,\n  \"face-meh-blank\": $fa-var-face-meh-blank,\n  \"meh-blank\": $fa-var-meh-blank,\n  \"square-parking\": $fa-var-square-parking,\n  \"parking\": $fa-var-parking,\n  \"house-signal\": $fa-var-house-signal,\n  \"bars-progress\": $fa-var-bars-progress,\n  \"tasks-alt\": $fa-var-tasks-alt,\n  \"faucet-drip\": $fa-var-faucet-drip,\n  \"cart-flatbed\": $fa-var-cart-flatbed,\n  \"dolly-flatbed\": $fa-var-dolly-flatbed,\n  \"ban-smoking\": $fa-var-ban-smoking,\n  \"smoking-ban\": $fa-var-smoking-ban,\n  \"terminal\": $fa-var-terminal,\n  \"mobile-button\": $fa-var-mobile-button,\n  \"house-medical-flag\": $fa-var-house-medical-flag,\n  \"basket-shopping\": $fa-var-basket-shopping,\n  \"shopping-basket\": $fa-var-shopping-basket,\n  \"tape\": $fa-var-tape,\n  \"bus-simple\": $fa-var-bus-simple,\n  \"bus-alt\": $fa-var-bus-alt,\n  \"eye\": $fa-var-eye,\n  \"face-sad-cry\": $fa-var-face-sad-cry,\n  \"sad-cry\": $fa-var-sad-cry,\n  \"audio-description\": $fa-var-audio-description,\n  \"person-military-to-person\": $fa-var-person-military-to-person,\n  \"file-shield\": $fa-var-file-shield,\n  \"user-slash\": $fa-var-user-slash,\n  \"pen\": $fa-var-pen,\n  \"tower-observation\": $fa-var-tower-observation,\n  \"file-code\": $fa-var-file-code,\n  \"signal\": $fa-var-signal,\n  \"signal-5\": $fa-var-signal-5,\n  \"signal-perfect\": $fa-var-signal-perfect,\n  \"bus\": $fa-var-bus,\n  \"heart-circle-xmark\": $fa-var-heart-circle-xmark,\n  \"house-chimney\": $fa-var-house-chimney,\n  \"home-lg\": $fa-var-home-lg,\n  \"window-maximize\": $fa-var-window-maximize,\n  \"face-frown\": $fa-var-face-frown,\n  \"frown\": $fa-var-frown,\n  \"prescription\": $fa-var-prescription,\n  \"shop\": $fa-var-shop,\n  \"store-alt\": $fa-var-store-alt,\n  \"floppy-disk\": $fa-var-floppy-disk,\n  \"save\": $fa-var-save,\n  \"vihara\": $fa-var-vihara,\n  \"scale-unbalanced\": $fa-var-scale-unbalanced,\n  \"balance-scale-left\": $fa-var-balance-scale-left,\n  \"sort-up\": $fa-var-sort-up,\n  \"sort-asc\": $fa-var-sort-asc,\n  \"comment-dots\": $fa-var-comment-dots,\n  \"commenting\": $fa-var-commenting,\n  \"plant-wilt\": $fa-var-plant-wilt,\n  \"diamond\": $fa-var-diamond,\n  \"face-grin-squint\": $fa-var-face-grin-squint,\n  \"grin-squint\": $fa-var-grin-squint,\n  \"hand-holding-dollar\": $fa-var-hand-holding-dollar,\n  \"hand-holding-usd\": $fa-var-hand-holding-usd,\n  \"bacterium\": $fa-var-bacterium,\n  \"hand-pointer\": $fa-var-hand-pointer,\n  \"drum-steelpan\": $fa-var-drum-steelpan,\n  \"hand-scissors\": $fa-var-hand-scissors,\n  \"hands-praying\": $fa-var-hands-praying,\n  \"praying-hands\": $fa-var-praying-hands,\n  \"arrow-rotate-right\": $fa-var-arrow-rotate-right,\n  \"arrow-right-rotate\": $fa-var-arrow-right-rotate,\n  \"arrow-rotate-forward\": $fa-var-arrow-rotate-forward,\n  \"redo\": $fa-var-redo,\n  \"biohazard\": $fa-var-biohazard,\n  \"location-crosshairs\": $fa-var-location-crosshairs,\n  \"location\": $fa-var-location,\n  \"mars-double\": $fa-var-mars-double,\n  \"child-dress\": $fa-var-child-dress,\n  \"users-between-lines\": $fa-var-users-between-lines,\n  \"lungs-virus\": $fa-var-lungs-virus,\n  \"face-grin-tears\": $fa-var-face-grin-tears,\n  \"grin-tears\": $fa-var-grin-tears,\n  \"phone\": $fa-var-phone,\n  \"calendar-xmark\": $fa-var-calendar-xmark,\n  \"calendar-times\": $fa-var-calendar-times,\n  \"child-reaching\": $fa-var-child-reaching,\n  \"head-side-virus\": $fa-var-head-side-virus,\n  \"user-gear\": $fa-var-user-gear,\n  \"user-cog\": $fa-var-user-cog,\n  \"arrow-up-1-9\": $fa-var-arrow-up-1-9,\n  \"sort-numeric-up\": $fa-var-sort-numeric-up,\n  \"door-closed\": $fa-var-door-closed,\n  \"shield-virus\": $fa-var-shield-virus,\n  \"dice-six\": $fa-var-dice-six,\n  \"mosquito-net\": $fa-var-mosquito-net,\n  \"bridge-water\": $fa-var-bridge-water,\n  \"person-booth\": $fa-var-person-booth,\n  \"text-width\": $fa-var-text-width,\n  \"hat-wizard\": $fa-var-hat-wizard,\n  \"pen-fancy\": $fa-var-pen-fancy,\n  \"person-digging\": $fa-var-person-digging,\n  \"digging\": $fa-var-digging,\n  \"trash\": $fa-var-trash,\n  \"gauge-simple\": $fa-var-gauge-simple,\n  \"gauge-simple-med\": $fa-var-gauge-simple-med,\n  \"tachometer-average\": $fa-var-tachometer-average,\n  \"book-medical\": $fa-var-book-medical,\n  \"poo\": $fa-var-poo,\n  \"quote-right\": $fa-var-quote-right,\n  \"quote-right-alt\": $fa-var-quote-right-alt,\n  \"shirt\": $fa-var-shirt,\n  \"t-shirt\": $fa-var-t-shirt,\n  \"tshirt\": $fa-var-tshirt,\n  \"cubes\": $fa-var-cubes,\n  \"divide\": $fa-var-divide,\n  \"tenge-sign\": $fa-var-tenge-sign,\n  \"tenge\": $fa-var-tenge,\n  \"headphones\": $fa-var-headphones,\n  \"hands-holding\": $fa-var-hands-holding,\n  \"hands-clapping\": $fa-var-hands-clapping,\n  \"republican\": $fa-var-republican,\n  \"arrow-left\": $fa-var-arrow-left,\n  \"person-circle-xmark\": $fa-var-person-circle-xmark,\n  \"ruler\": $fa-var-ruler,\n  \"align-left\": $fa-var-align-left,\n  \"dice-d6\": $fa-var-dice-d6,\n  \"restroom\": $fa-var-restroom,\n  \"j\": $fa-var-j,\n  \"users-viewfinder\": $fa-var-users-viewfinder,\n  \"file-video\": $fa-var-file-video,\n  \"up-right-from-square\": $fa-var-up-right-from-square,\n  \"external-link-alt\": $fa-var-external-link-alt,\n  \"table-cells\": $fa-var-table-cells,\n  \"th\": $fa-var-th,\n  \"file-pdf\": $fa-var-file-pdf,\n  \"book-bible\": $fa-var-book-bible,\n  \"bible\": $fa-var-bible,\n  \"o\": $fa-var-o,\n  \"suitcase-medical\": $fa-var-suitcase-medical,\n  \"medkit\": $fa-var-medkit,\n  \"user-secret\": $fa-var-user-secret,\n  \"otter\": $fa-var-otter,\n  \"person-dress\": $fa-var-person-dress,\n  \"female\": $fa-var-female,\n  \"comment-dollar\": $fa-var-comment-dollar,\n  \"business-time\": $fa-var-business-time,\n  \"briefcase-clock\": $fa-var-briefcase-clock,\n  \"table-cells-large\": $fa-var-table-cells-large,\n  \"th-large\": $fa-var-th-large,\n  \"book-tanakh\": $fa-var-book-tanakh,\n  \"tanakh\": $fa-var-tanakh,\n  \"phone-volume\": $fa-var-phone-volume,\n  \"volume-control-phone\": $fa-var-volume-control-phone,\n  \"hat-cowboy-side\": $fa-var-hat-cowboy-side,\n  \"clipboard-user\": $fa-var-clipboard-user,\n  \"child\": $fa-var-child,\n  \"lira-sign\": $fa-var-lira-sign,\n  \"satellite\": $fa-var-satellite,\n  \"plane-lock\": $fa-var-plane-lock,\n  \"tag\": $fa-var-tag,\n  \"comment\": $fa-var-comment,\n  \"cake-candles\": $fa-var-cake-candles,\n  \"birthday-cake\": $fa-var-birthday-cake,\n  \"cake\": $fa-var-cake,\n  \"envelope\": $fa-var-envelope,\n  \"angles-up\": $fa-var-angles-up,\n  \"angle-double-up\": $fa-var-angle-double-up,\n  \"paperclip\": $fa-var-paperclip,\n  \"arrow-right-to-city\": $fa-var-arrow-right-to-city,\n  \"ribbon\": $fa-var-ribbon,\n  \"lungs\": $fa-var-lungs,\n  \"arrow-up-9-1\": $fa-var-arrow-up-9-1,\n  \"sort-numeric-up-alt\": $fa-var-sort-numeric-up-alt,\n  \"litecoin-sign\": $fa-var-litecoin-sign,\n  \"border-none\": $fa-var-border-none,\n  \"circle-nodes\": $fa-var-circle-nodes,\n  \"parachute-box\": $fa-var-parachute-box,\n  \"indent\": $fa-var-indent,\n  \"truck-field-un\": $fa-var-truck-field-un,\n  \"hourglass\": $fa-var-hourglass,\n  \"hourglass-empty\": $fa-var-hourglass-empty,\n  \"mountain\": $fa-var-mountain,\n  \"user-doctor\": $fa-var-user-doctor,\n  \"user-md\": $fa-var-user-md,\n  \"circle-info\": $fa-var-circle-info,\n  \"info-circle\": $fa-var-info-circle,\n  \"cloud-meatball\": $fa-var-cloud-meatball,\n  \"camera\": $fa-var-camera,\n  \"camera-alt\": $fa-var-camera-alt,\n  \"square-virus\": $fa-var-square-virus,\n  \"meteor\": $fa-var-meteor,\n  \"car-on\": $fa-var-car-on,\n  \"sleigh\": $fa-var-sleigh,\n  \"arrow-down-1-9\": $fa-var-arrow-down-1-9,\n  \"sort-numeric-asc\": $fa-var-sort-numeric-asc,\n  \"sort-numeric-down\": $fa-var-sort-numeric-down,\n  \"hand-holding-droplet\": $fa-var-hand-holding-droplet,\n  \"hand-holding-water\": $fa-var-hand-holding-water,\n  \"water\": $fa-var-water,\n  \"calendar-check\": $fa-var-calendar-check,\n  \"braille\": $fa-var-braille,\n  \"prescription-bottle-medical\": $fa-var-prescription-bottle-medical,\n  \"prescription-bottle-alt\": $fa-var-prescription-bottle-alt,\n  \"landmark\": $fa-var-landmark,\n  \"truck\": $fa-var-truck,\n  \"crosshairs\": $fa-var-crosshairs,\n  \"person-cane\": $fa-var-person-cane,\n  \"tent\": $fa-var-tent,\n  \"vest-patches\": $fa-var-vest-patches,\n  \"check-double\": $fa-var-check-double,\n  \"arrow-down-a-z\": $fa-var-arrow-down-a-z,\n  \"sort-alpha-asc\": $fa-var-sort-alpha-asc,\n  \"sort-alpha-down\": $fa-var-sort-alpha-down,\n  \"money-bill-wheat\": $fa-var-money-bill-wheat,\n  \"cookie\": $fa-var-cookie,\n  \"arrow-rotate-left\": $fa-var-arrow-rotate-left,\n  \"arrow-left-rotate\": $fa-var-arrow-left-rotate,\n  \"arrow-rotate-back\": $fa-var-arrow-rotate-back,\n  \"arrow-rotate-backward\": $fa-var-arrow-rotate-backward,\n  \"undo\": $fa-var-undo,\n  \"hard-drive\": $fa-var-hard-drive,\n  \"hdd\": $fa-var-hdd,\n  \"face-grin-squint-tears\": $fa-var-face-grin-squint-tears,\n  \"grin-squint-tears\": $fa-var-grin-squint-tears,\n  \"dumbbell\": $fa-var-dumbbell,\n  \"rectangle-list\": $fa-var-rectangle-list,\n  \"list-alt\": $fa-var-list-alt,\n  \"tarp-droplet\": $fa-var-tarp-droplet,\n  \"house-medical-circle-check\": $fa-var-house-medical-circle-check,\n  \"person-skiing-nordic\": $fa-var-person-skiing-nordic,\n  \"skiing-nordic\": $fa-var-skiing-nordic,\n  \"calendar-plus\": $fa-var-calendar-plus,\n  \"plane-arrival\": $fa-var-plane-arrival,\n  \"circle-left\": $fa-var-circle-left,\n  \"arrow-alt-circle-left\": $fa-var-arrow-alt-circle-left,\n  \"train-subway\": $fa-var-train-subway,\n  \"subway\": $fa-var-subway,\n  \"chart-gantt\": $fa-var-chart-gantt,\n  \"indian-rupee-sign\": $fa-var-indian-rupee-sign,\n  \"indian-rupee\": $fa-var-indian-rupee,\n  \"inr\": $fa-var-inr,\n  \"crop-simple\": $fa-var-crop-simple,\n  \"crop-alt\": $fa-var-crop-alt,\n  \"money-bill-1\": $fa-var-money-bill-1,\n  \"money-bill-alt\": $fa-var-money-bill-alt,\n  \"left-long\": $fa-var-left-long,\n  \"long-arrow-alt-left\": $fa-var-long-arrow-alt-left,\n  \"dna\": $fa-var-dna,\n  \"virus-slash\": $fa-var-virus-slash,\n  \"minus\": $fa-var-minus,\n  \"subtract\": $fa-var-subtract,\n  \"chess\": $fa-var-chess,\n  \"arrow-left-long\": $fa-var-arrow-left-long,\n  \"long-arrow-left\": $fa-var-long-arrow-left,\n  \"plug-circle-check\": $fa-var-plug-circle-check,\n  \"street-view\": $fa-var-street-view,\n  \"franc-sign\": $fa-var-franc-sign,\n  \"volume-off\": $fa-var-volume-off,\n  \"hands-asl-interpreting\": $fa-var-hands-asl-interpreting,\n  \"american-sign-language-interpreting\": $fa-var-american-sign-language-interpreting,\n  \"asl-interpreting\": $fa-var-asl-interpreting,\n  \"hands-american-sign-language-interpreting\": $fa-var-hands-american-sign-language-interpreting,\n  \"gear\": $fa-var-gear,\n  \"cog\": $fa-var-cog,\n  \"droplet-slash\": $fa-var-droplet-slash,\n  \"tint-slash\": $fa-var-tint-slash,\n  \"mosque\": $fa-var-mosque,\n  \"mosquito\": $fa-var-mosquito,\n  \"star-of-david\": $fa-var-star-of-david,\n  \"person-military-rifle\": $fa-var-person-military-rifle,\n  \"cart-shopping\": $fa-var-cart-shopping,\n  \"shopping-cart\": $fa-var-shopping-cart,\n  \"vials\": $fa-var-vials,\n  \"plug-circle-plus\": $fa-var-plug-circle-plus,\n  \"place-of-worship\": $fa-var-place-of-worship,\n  \"grip-vertical\": $fa-var-grip-vertical,\n  \"arrow-turn-up\": $fa-var-arrow-turn-up,\n  \"level-up\": $fa-var-level-up,\n  \"u\": $fa-var-u,\n  \"square-root-variable\": $fa-var-square-root-variable,\n  \"square-root-alt\": $fa-var-square-root-alt,\n  \"clock\": $fa-var-clock,\n  \"clock-four\": $fa-var-clock-four,\n  \"backward-step\": $fa-var-backward-step,\n  \"step-backward\": $fa-var-step-backward,\n  \"pallet\": $fa-var-pallet,\n  \"faucet\": $fa-var-faucet,\n  \"baseball-bat-ball\": $fa-var-baseball-bat-ball,\n  \"s\": $fa-var-s,\n  \"timeline\": $fa-var-timeline,\n  \"keyboard\": $fa-var-keyboard,\n  \"caret-down\": $fa-var-caret-down,\n  \"house-chimney-medical\": $fa-var-house-chimney-medical,\n  \"clinic-medical\": $fa-var-clinic-medical,\n  \"temperature-three-quarters\": $fa-var-temperature-three-quarters,\n  \"temperature-3\": $fa-var-temperature-3,\n  \"thermometer-3\": $fa-var-thermometer-3,\n  \"thermometer-three-quarters\": $fa-var-thermometer-three-quarters,\n  \"mobile-screen\": $fa-var-mobile-screen,\n  \"mobile-android-alt\": $fa-var-mobile-android-alt,\n  \"plane-up\": $fa-var-plane-up,\n  \"piggy-bank\": $fa-var-piggy-bank,\n  \"battery-half\": $fa-var-battery-half,\n  \"battery-3\": $fa-var-battery-3,\n  \"mountain-city\": $fa-var-mountain-city,\n  \"coins\": $fa-var-coins,\n  \"khanda\": $fa-var-khanda,\n  \"sliders\": $fa-var-sliders,\n  \"sliders-h\": $fa-var-sliders-h,\n  \"folder-tree\": $fa-var-folder-tree,\n  \"network-wired\": $fa-var-network-wired,\n  \"map-pin\": $fa-var-map-pin,\n  \"hamsa\": $fa-var-hamsa,\n  \"cent-sign\": $fa-var-cent-sign,\n  \"flask\": $fa-var-flask,\n  \"person-pregnant\": $fa-var-person-pregnant,\n  \"wand-sparkles\": $fa-var-wand-sparkles,\n  \"ellipsis-vertical\": $fa-var-ellipsis-vertical,\n  \"ellipsis-v\": $fa-var-ellipsis-v,\n  \"ticket\": $fa-var-ticket,\n  \"power-off\": $fa-var-power-off,\n  \"right-long\": $fa-var-right-long,\n  \"long-arrow-alt-right\": $fa-var-long-arrow-alt-right,\n  \"flag-usa\": $fa-var-flag-usa,\n  \"laptop-file\": $fa-var-laptop-file,\n  \"tty\": $fa-var-tty,\n  \"teletype\": $fa-var-teletype,\n  \"diagram-next\": $fa-var-diagram-next,\n  \"person-rifle\": $fa-var-person-rifle,\n  \"house-medical-circle-exclamation\": $fa-var-house-medical-circle-exclamation,\n  \"closed-captioning\": $fa-var-closed-captioning,\n  \"person-hiking\": $fa-var-person-hiking,\n  \"hiking\": $fa-var-hiking,\n  \"venus-double\": $fa-var-venus-double,\n  \"images\": $fa-var-images,\n  \"calculator\": $fa-var-calculator,\n  \"people-pulling\": $fa-var-people-pulling,\n  \"n\": $fa-var-n,\n  \"cable-car\": $fa-var-cable-car,\n  \"tram\": $fa-var-tram,\n  \"cloud-rain\": $fa-var-cloud-rain,\n  \"building-circle-xmark\": $fa-var-building-circle-xmark,\n  \"ship\": $fa-var-ship,\n  \"arrows-down-to-line\": $fa-var-arrows-down-to-line,\n  \"download\": $fa-var-download,\n  \"face-grin\": $fa-var-face-grin,\n  \"grin\": $fa-var-grin,\n  \"delete-left\": $fa-var-delete-left,\n  \"backspace\": $fa-var-backspace,\n  \"eye-dropper\": $fa-var-eye-dropper,\n  \"eye-dropper-empty\": $fa-var-eye-dropper-empty,\n  \"eyedropper\": $fa-var-eyedropper,\n  \"file-circle-check\": $fa-var-file-circle-check,\n  \"forward\": $fa-var-forward,\n  \"mobile\": $fa-var-mobile,\n  \"mobile-android\": $fa-var-mobile-android,\n  \"mobile-phone\": $fa-var-mobile-phone,\n  \"face-meh\": $fa-var-face-meh,\n  \"meh\": $fa-var-meh,\n  \"align-center\": $fa-var-align-center,\n  \"book-skull\": $fa-var-book-skull,\n  \"book-dead\": $fa-var-book-dead,\n  \"id-card\": $fa-var-id-card,\n  \"drivers-license\": $fa-var-drivers-license,\n  \"outdent\": $fa-var-outdent,\n  \"dedent\": $fa-var-dedent,\n  \"heart-circle-exclamation\": $fa-var-heart-circle-exclamation,\n  \"house\": $fa-var-house,\n  \"home\": $fa-var-home,\n  \"home-alt\": $fa-var-home-alt,\n  \"home-lg-alt\": $fa-var-home-lg-alt,\n  \"calendar-week\": $fa-var-calendar-week,\n  \"laptop-medical\": $fa-var-laptop-medical,\n  \"b\": $fa-var-b,\n  \"file-medical\": $fa-var-file-medical,\n  \"dice-one\": $fa-var-dice-one,\n  \"kiwi-bird\": $fa-var-kiwi-bird,\n  \"arrow-right-arrow-left\": $fa-var-arrow-right-arrow-left,\n  \"exchange\": $fa-var-exchange,\n  \"rotate-right\": $fa-var-rotate-right,\n  \"redo-alt\": $fa-var-redo-alt,\n  \"rotate-forward\": $fa-var-rotate-forward,\n  \"utensils\": $fa-var-utensils,\n  \"cutlery\": $fa-var-cutlery,\n  \"arrow-up-wide-short\": $fa-var-arrow-up-wide-short,\n  \"sort-amount-up\": $fa-var-sort-amount-up,\n  \"mill-sign\": $fa-var-mill-sign,\n  \"bowl-rice\": $fa-var-bowl-rice,\n  \"skull\": $fa-var-skull,\n  \"tower-broadcast\": $fa-var-tower-broadcast,\n  \"broadcast-tower\": $fa-var-broadcast-tower,\n  \"truck-pickup\": $fa-var-truck-pickup,\n  \"up-long\": $fa-var-up-long,\n  \"long-arrow-alt-up\": $fa-var-long-arrow-alt-up,\n  \"stop\": $fa-var-stop,\n  \"code-merge\": $fa-var-code-merge,\n  \"upload\": $fa-var-upload,\n  \"hurricane\": $fa-var-hurricane,\n  \"mound\": $fa-var-mound,\n  \"toilet-portable\": $fa-var-toilet-portable,\n  \"compact-disc\": $fa-var-compact-disc,\n  \"file-arrow-down\": $fa-var-file-arrow-down,\n  \"file-download\": $fa-var-file-download,\n  \"caravan\": $fa-var-caravan,\n  \"shield-cat\": $fa-var-shield-cat,\n  \"bolt\": $fa-var-bolt,\n  \"zap\": $fa-var-zap,\n  \"glass-water\": $fa-var-glass-water,\n  \"oil-well\": $fa-var-oil-well,\n  \"vault\": $fa-var-vault,\n  \"mars\": $fa-var-mars,\n  \"toilet\": $fa-var-toilet,\n  \"plane-circle-xmark\": $fa-var-plane-circle-xmark,\n  \"yen-sign\": $fa-var-yen-sign,\n  \"cny\": $fa-var-cny,\n  \"jpy\": $fa-var-jpy,\n  \"rmb\": $fa-var-rmb,\n  \"yen\": $fa-var-yen,\n  \"ruble-sign\": $fa-var-ruble-sign,\n  \"rouble\": $fa-var-rouble,\n  \"rub\": $fa-var-rub,\n  \"ruble\": $fa-var-ruble,\n  \"sun\": $fa-var-sun,\n  \"guitar\": $fa-var-guitar,\n  \"face-laugh-wink\": $fa-var-face-laugh-wink,\n  \"laugh-wink\": $fa-var-laugh-wink,\n  \"horse-head\": $fa-var-horse-head,\n  \"bore-hole\": $fa-var-bore-hole,\n  \"industry\": $fa-var-industry,\n  \"circle-down\": $fa-var-circle-down,\n  \"arrow-alt-circle-down\": $fa-var-arrow-alt-circle-down,\n  \"arrows-turn-to-dots\": $fa-var-arrows-turn-to-dots,\n  \"florin-sign\": $fa-var-florin-sign,\n  \"arrow-down-short-wide\": $fa-var-arrow-down-short-wide,\n  \"sort-amount-desc\": $fa-var-sort-amount-desc,\n  \"sort-amount-down-alt\": $fa-var-sort-amount-down-alt,\n  \"less-than\": $fa-var-less-than,\n  \"angle-down\": $fa-var-angle-down,\n  \"car-tunnel\": $fa-var-car-tunnel,\n  \"head-side-cough\": $fa-var-head-side-cough,\n  \"grip-lines\": $fa-var-grip-lines,\n  \"thumbs-down\": $fa-var-thumbs-down,\n  \"user-lock\": $fa-var-user-lock,\n  \"arrow-right-long\": $fa-var-arrow-right-long,\n  \"long-arrow-right\": $fa-var-long-arrow-right,\n  \"anchor-circle-xmark\": $fa-var-anchor-circle-xmark,\n  \"ellipsis\": $fa-var-ellipsis,\n  \"ellipsis-h\": $fa-var-ellipsis-h,\n  \"chess-pawn\": $fa-var-chess-pawn,\n  \"kit-medical\": $fa-var-kit-medical,\n  \"first-aid\": $fa-var-first-aid,\n  \"person-through-window\": $fa-var-person-through-window,\n  \"toolbox\": $fa-var-toolbox,\n  \"hands-holding-circle\": $fa-var-hands-holding-circle,\n  \"bug\": $fa-var-bug,\n  \"credit-card\": $fa-var-credit-card,\n  \"credit-card-alt\": $fa-var-credit-card-alt,\n  \"car\": $fa-var-car,\n  \"automobile\": $fa-var-automobile,\n  \"hand-holding-hand\": $fa-var-hand-holding-hand,\n  \"book-open-reader\": $fa-var-book-open-reader,\n  \"book-reader\": $fa-var-book-reader,\n  \"mountain-sun\": $fa-var-mountain-sun,\n  \"arrows-left-right-to-line\": $fa-var-arrows-left-right-to-line,\n  \"dice-d20\": $fa-var-dice-d20,\n  \"truck-droplet\": $fa-var-truck-droplet,\n  \"file-circle-xmark\": $fa-var-file-circle-xmark,\n  \"temperature-arrow-up\": $fa-var-temperature-arrow-up,\n  \"temperature-up\": $fa-var-temperature-up,\n  \"medal\": $fa-var-medal,\n  \"bed\": $fa-var-bed,\n  \"square-h\": $fa-var-square-h,\n  \"h-square\": $fa-var-h-square,\n  \"podcast\": $fa-var-podcast,\n  \"temperature-full\": $fa-var-temperature-full,\n  \"temperature-4\": $fa-var-temperature-4,\n  \"thermometer-4\": $fa-var-thermometer-4,\n  \"thermometer-full\": $fa-var-thermometer-full,\n  \"bell\": $fa-var-bell,\n  \"superscript\": $fa-var-superscript,\n  \"plug-circle-xmark\": $fa-var-plug-circle-xmark,\n  \"star-of-life\": $fa-var-star-of-life,\n  \"phone-slash\": $fa-var-phone-slash,\n  \"paint-roller\": $fa-var-paint-roller,\n  \"handshake-angle\": $fa-var-handshake-angle,\n  \"hands-helping\": $fa-var-hands-helping,\n  \"location-dot\": $fa-var-location-dot,\n  \"map-marker-alt\": $fa-var-map-marker-alt,\n  \"file\": $fa-var-file,\n  \"greater-than\": $fa-var-greater-than,\n  \"person-swimming\": $fa-var-person-swimming,\n  \"swimmer\": $fa-var-swimmer,\n  \"arrow-down\": $fa-var-arrow-down,\n  \"droplet\": $fa-var-droplet,\n  \"tint\": $fa-var-tint,\n  \"eraser\": $fa-var-eraser,\n  \"earth-americas\": $fa-var-earth-americas,\n  \"earth\": $fa-var-earth,\n  \"earth-america\": $fa-var-earth-america,\n  \"globe-americas\": $fa-var-globe-americas,\n  \"person-burst\": $fa-var-person-burst,\n  \"dove\": $fa-var-dove,\n  \"battery-empty\": $fa-var-battery-empty,\n  \"battery-0\": $fa-var-battery-0,\n  \"socks\": $fa-var-socks,\n  \"inbox\": $fa-var-inbox,\n  \"section\": $fa-var-section,\n  \"gauge-high\": $fa-var-gauge-high,\n  \"tachometer-alt\": $fa-var-tachometer-alt,\n  \"tachometer-alt-fast\": $fa-var-tachometer-alt-fast,\n  \"envelope-open-text\": $fa-var-envelope-open-text,\n  \"hospital\": $fa-var-hospital,\n  \"hospital-alt\": $fa-var-hospital-alt,\n  \"hospital-wide\": $fa-var-hospital-wide,\n  \"wine-bottle\": $fa-var-wine-bottle,\n  \"chess-rook\": $fa-var-chess-rook,\n  \"bars-staggered\": $fa-var-bars-staggered,\n  \"reorder\": $fa-var-reorder,\n  \"stream\": $fa-var-stream,\n  \"dharmachakra\": $fa-var-dharmachakra,\n  \"hotdog\": $fa-var-hotdog,\n  \"person-walking-with-cane\": $fa-var-person-walking-with-cane,\n  \"blind\": $fa-var-blind,\n  \"drum\": $fa-var-drum,\n  \"ice-cream\": $fa-var-ice-cream,\n  \"heart-circle-bolt\": $fa-var-heart-circle-bolt,\n  \"fax\": $fa-var-fax,\n  \"paragraph\": $fa-var-paragraph,\n  \"check-to-slot\": $fa-var-check-to-slot,\n  \"vote-yea\": $fa-var-vote-yea,\n  \"star-half\": $fa-var-star-half,\n  \"boxes-stacked\": $fa-var-boxes-stacked,\n  \"boxes\": $fa-var-boxes,\n  \"boxes-alt\": $fa-var-boxes-alt,\n  \"link\": $fa-var-link,\n  \"chain\": $fa-var-chain,\n  \"ear-listen\": $fa-var-ear-listen,\n  \"assistive-listening-systems\": $fa-var-assistive-listening-systems,\n  \"tree-city\": $fa-var-tree-city,\n  \"play\": $fa-var-play,\n  \"font\": $fa-var-font,\n  \"table-cells-row-lock\": $fa-var-table-cells-row-lock,\n  \"rupiah-sign\": $fa-var-rupiah-sign,\n  \"magnifying-glass\": $fa-var-magnifying-glass,\n  \"search\": $fa-var-search,\n  \"table-tennis-paddle-ball\": $fa-var-table-tennis-paddle-ball,\n  \"ping-pong-paddle-ball\": $fa-var-ping-pong-paddle-ball,\n  \"table-tennis\": $fa-var-table-tennis,\n  \"person-dots-from-line\": $fa-var-person-dots-from-line,\n  \"diagnoses\": $fa-var-diagnoses,\n  \"trash-can-arrow-up\": $fa-var-trash-can-arrow-up,\n  \"trash-restore-alt\": $fa-var-trash-restore-alt,\n  \"naira-sign\": $fa-var-naira-sign,\n  \"cart-arrow-down\": $fa-var-cart-arrow-down,\n  \"walkie-talkie\": $fa-var-walkie-talkie,\n  \"file-pen\": $fa-var-file-pen,\n  \"file-edit\": $fa-var-file-edit,\n  \"receipt\": $fa-var-receipt,\n  \"square-pen\": $fa-var-square-pen,\n  \"pen-square\": $fa-var-pen-square,\n  \"pencil-square\": $fa-var-pencil-square,\n  \"suitcase-rolling\": $fa-var-suitcase-rolling,\n  \"person-circle-exclamation\": $fa-var-person-circle-exclamation,\n  \"chevron-down\": $fa-var-chevron-down,\n  \"battery-full\": $fa-var-battery-full,\n  \"battery\": $fa-var-battery,\n  \"battery-5\": $fa-var-battery-5,\n  \"skull-crossbones\": $fa-var-skull-crossbones,\n  \"code-compare\": $fa-var-code-compare,\n  \"list-ul\": $fa-var-list-ul,\n  \"list-dots\": $fa-var-list-dots,\n  \"school-lock\": $fa-var-school-lock,\n  \"tower-cell\": $fa-var-tower-cell,\n  \"down-long\": $fa-var-down-long,\n  \"long-arrow-alt-down\": $fa-var-long-arrow-alt-down,\n  \"ranking-star\": $fa-var-ranking-star,\n  \"chess-king\": $fa-var-chess-king,\n  \"person-harassing\": $fa-var-person-harassing,\n  \"brazilian-real-sign\": $fa-var-brazilian-real-sign,\n  \"landmark-dome\": $fa-var-landmark-dome,\n  \"landmark-alt\": $fa-var-landmark-alt,\n  \"arrow-up\": $fa-var-arrow-up,\n  \"tv\": $fa-var-tv,\n  \"television\": $fa-var-television,\n  \"tv-alt\": $fa-var-tv-alt,\n  \"shrimp\": $fa-var-shrimp,\n  \"list-check\": $fa-var-list-check,\n  \"tasks\": $fa-var-tasks,\n  \"jug-detergent\": $fa-var-jug-detergent,\n  \"circle-user\": $fa-var-circle-user,\n  \"user-circle\": $fa-var-user-circle,\n  \"user-shield\": $fa-var-user-shield,\n  \"wind\": $fa-var-wind,\n  \"car-burst\": $fa-var-car-burst,\n  \"car-crash\": $fa-var-car-crash,\n  \"y\": $fa-var-y,\n  \"person-snowboarding\": $fa-var-person-snowboarding,\n  \"snowboarding\": $fa-var-snowboarding,\n  \"truck-fast\": $fa-var-truck-fast,\n  \"shipping-fast\": $fa-var-shipping-fast,\n  \"fish\": $fa-var-fish,\n  \"user-graduate\": $fa-var-user-graduate,\n  \"circle-half-stroke\": $fa-var-circle-half-stroke,\n  \"adjust\": $fa-var-adjust,\n  \"clapperboard\": $fa-var-clapperboard,\n  \"circle-radiation\": $fa-var-circle-radiation,\n  \"radiation-alt\": $fa-var-radiation-alt,\n  \"baseball\": $fa-var-baseball,\n  \"baseball-ball\": $fa-var-baseball-ball,\n  \"jet-fighter-up\": $fa-var-jet-fighter-up,\n  \"diagram-project\": $fa-var-diagram-project,\n  \"project-diagram\": $fa-var-project-diagram,\n  \"copy\": $fa-var-copy,\n  \"volume-xmark\": $fa-var-volume-xmark,\n  \"volume-mute\": $fa-var-volume-mute,\n  \"volume-times\": $fa-var-volume-times,\n  \"hand-sparkles\": $fa-var-hand-sparkles,\n  \"grip\": $fa-var-grip,\n  \"grip-horizontal\": $fa-var-grip-horizontal,\n  \"share-from-square\": $fa-var-share-from-square,\n  \"share-square\": $fa-var-share-square,\n  \"child-combatant\": $fa-var-child-combatant,\n  \"child-rifle\": $fa-var-child-rifle,\n  \"gun\": $fa-var-gun,\n  \"square-phone\": $fa-var-square-phone,\n  \"phone-square\": $fa-var-phone-square,\n  \"plus\": $fa-var-plus,\n  \"add\": $fa-var-add,\n  \"expand\": $fa-var-expand,\n  \"computer\": $fa-var-computer,\n  \"xmark\": $fa-var-xmark,\n  \"close\": $fa-var-close,\n  \"multiply\": $fa-var-multiply,\n  \"remove\": $fa-var-remove,\n  \"times\": $fa-var-times,\n  \"arrows-up-down-left-right\": $fa-var-arrows-up-down-left-right,\n  \"arrows\": $fa-var-arrows,\n  \"chalkboard-user\": $fa-var-chalkboard-user,\n  \"chalkboard-teacher\": $fa-var-chalkboard-teacher,\n  \"peso-sign\": $fa-var-peso-sign,\n  \"building-shield\": $fa-var-building-shield,\n  \"baby\": $fa-var-baby,\n  \"users-line\": $fa-var-users-line,\n  \"quote-left\": $fa-var-quote-left,\n  \"quote-left-alt\": $fa-var-quote-left-alt,\n  \"tractor\": $fa-var-tractor,\n  \"trash-arrow-up\": $fa-var-trash-arrow-up,\n  \"trash-restore\": $fa-var-trash-restore,\n  \"arrow-down-up-lock\": $fa-var-arrow-down-up-lock,\n  \"lines-leaning\": $fa-var-lines-leaning,\n  \"ruler-combined\": $fa-var-ruler-combined,\n  \"copyright\": $fa-var-copyright,\n  \"equals\": $fa-var-equals,\n  \"blender\": $fa-var-blender,\n  \"teeth\": $fa-var-teeth,\n  \"shekel-sign\": $fa-var-shekel-sign,\n  \"ils\": $fa-var-ils,\n  \"shekel\": $fa-var-shekel,\n  \"sheqel\": $fa-var-sheqel,\n  \"sheqel-sign\": $fa-var-sheqel-sign,\n  \"map\": $fa-var-map,\n  \"rocket\": $fa-var-rocket,\n  \"photo-film\": $fa-var-photo-film,\n  \"photo-video\": $fa-var-photo-video,\n  \"folder-minus\": $fa-var-folder-minus,\n  \"store\": $fa-var-store,\n  \"arrow-trend-up\": $fa-var-arrow-trend-up,\n  \"plug-circle-minus\": $fa-var-plug-circle-minus,\n  \"sign-hanging\": $fa-var-sign-hanging,\n  \"sign\": $fa-var-sign,\n  \"bezier-curve\": $fa-var-bezier-curve,\n  \"bell-slash\": $fa-var-bell-slash,\n  \"tablet\": $fa-var-tablet,\n  \"tablet-android\": $fa-var-tablet-android,\n  \"school-flag\": $fa-var-school-flag,\n  \"fill\": $fa-var-fill,\n  \"angle-up\": $fa-var-angle-up,\n  \"drumstick-bite\": $fa-var-drumstick-bite,\n  \"holly-berry\": $fa-var-holly-berry,\n  \"chevron-left\": $fa-var-chevron-left,\n  \"bacteria\": $fa-var-bacteria,\n  \"hand-lizard\": $fa-var-hand-lizard,\n  \"notdef\": $fa-var-notdef,\n  \"disease\": $fa-var-disease,\n  \"briefcase-medical\": $fa-var-briefcase-medical,\n  \"genderless\": $fa-var-genderless,\n  \"chevron-right\": $fa-var-chevron-right,\n  \"retweet\": $fa-var-retweet,\n  \"car-rear\": $fa-var-car-rear,\n  \"car-alt\": $fa-var-car-alt,\n  \"pump-soap\": $fa-var-pump-soap,\n  \"video-slash\": $fa-var-video-slash,\n  \"battery-quarter\": $fa-var-battery-quarter,\n  \"battery-2\": $fa-var-battery-2,\n  \"radio\": $fa-var-radio,\n  \"baby-carriage\": $fa-var-baby-carriage,\n  \"carriage-baby\": $fa-var-carriage-baby,\n  \"traffic-light\": $fa-var-traffic-light,\n  \"thermometer\": $fa-var-thermometer,\n  \"vr-cardboard\": $fa-var-vr-cardboard,\n  \"hand-middle-finger\": $fa-var-hand-middle-finger,\n  \"percent\": $fa-var-percent,\n  \"percentage\": $fa-var-percentage,\n  \"truck-moving\": $fa-var-truck-moving,\n  \"glass-water-droplet\": $fa-var-glass-water-droplet,\n  \"display\": $fa-var-display,\n  \"face-smile\": $fa-var-face-smile,\n  \"smile\": $fa-var-smile,\n  \"thumbtack\": $fa-var-thumbtack,\n  \"thumb-tack\": $fa-var-thumb-tack,\n  \"trophy\": $fa-var-trophy,\n  \"person-praying\": $fa-var-person-praying,\n  \"pray\": $fa-var-pray,\n  \"hammer\": $fa-var-hammer,\n  \"hand-peace\": $fa-var-hand-peace,\n  \"rotate\": $fa-var-rotate,\n  \"sync-alt\": $fa-var-sync-alt,\n  \"spinner\": $fa-var-spinner,\n  \"robot\": $fa-var-robot,\n  \"peace\": $fa-var-peace,\n  \"gears\": $fa-var-gears,\n  \"cogs\": $fa-var-cogs,\n  \"warehouse\": $fa-var-warehouse,\n  \"arrow-up-right-dots\": $fa-var-arrow-up-right-dots,\n  \"splotch\": $fa-var-splotch,\n  \"face-grin-hearts\": $fa-var-face-grin-hearts,\n  \"grin-hearts\": $fa-var-grin-hearts,\n  \"dice-four\": $fa-var-dice-four,\n  \"sim-card\": $fa-var-sim-card,\n  \"transgender\": $fa-var-transgender,\n  \"transgender-alt\": $fa-var-transgender-alt,\n  \"mercury\": $fa-var-mercury,\n  \"arrow-turn-down\": $fa-var-arrow-turn-down,\n  \"level-down\": $fa-var-level-down,\n  \"person-falling-burst\": $fa-var-person-falling-burst,\n  \"award\": $fa-var-award,\n  \"ticket-simple\": $fa-var-ticket-simple,\n  \"ticket-alt\": $fa-var-ticket-alt,\n  \"building\": $fa-var-building,\n  \"angles-left\": $fa-var-angles-left,\n  \"angle-double-left\": $fa-var-angle-double-left,\n  \"qrcode\": $fa-var-qrcode,\n  \"clock-rotate-left\": $fa-var-clock-rotate-left,\n  \"history\": $fa-var-history,\n  \"face-grin-beam-sweat\": $fa-var-face-grin-beam-sweat,\n  \"grin-beam-sweat\": $fa-var-grin-beam-sweat,\n  \"file-export\": $fa-var-file-export,\n  \"arrow-right-from-file\": $fa-var-arrow-right-from-file,\n  \"shield\": $fa-var-shield,\n  \"shield-blank\": $fa-var-shield-blank,\n  \"arrow-up-short-wide\": $fa-var-arrow-up-short-wide,\n  \"sort-amount-up-alt\": $fa-var-sort-amount-up-alt,\n  \"house-medical\": $fa-var-house-medical,\n  \"golf-ball-tee\": $fa-var-golf-ball-tee,\n  \"golf-ball\": $fa-var-golf-ball,\n  \"circle-chevron-left\": $fa-var-circle-chevron-left,\n  \"chevron-circle-left\": $fa-var-chevron-circle-left,\n  \"house-chimney-window\": $fa-var-house-chimney-window,\n  \"pen-nib\": $fa-var-pen-nib,\n  \"tent-arrow-turn-left\": $fa-var-tent-arrow-turn-left,\n  \"tents\": $fa-var-tents,\n  \"wand-magic\": $fa-var-wand-magic,\n  \"magic\": $fa-var-magic,\n  \"dog\": $fa-var-dog,\n  \"carrot\": $fa-var-carrot,\n  \"moon\": $fa-var-moon,\n  \"wine-glass-empty\": $fa-var-wine-glass-empty,\n  \"wine-glass-alt\": $fa-var-wine-glass-alt,\n  \"cheese\": $fa-var-cheese,\n  \"yin-yang\": $fa-var-yin-yang,\n  \"music\": $fa-var-music,\n  \"code-commit\": $fa-var-code-commit,\n  \"temperature-low\": $fa-var-temperature-low,\n  \"person-biking\": $fa-var-person-biking,\n  \"biking\": $fa-var-biking,\n  \"broom\": $fa-var-broom,\n  \"shield-heart\": $fa-var-shield-heart,\n  \"gopuram\": $fa-var-gopuram,\n  \"earth-oceania\": $fa-var-earth-oceania,\n  \"globe-oceania\": $fa-var-globe-oceania,\n  \"square-xmark\": $fa-var-square-xmark,\n  \"times-square\": $fa-var-times-square,\n  \"xmark-square\": $fa-var-xmark-square,\n  \"hashtag\": $fa-var-hashtag,\n  \"up-right-and-down-left-from-center\": $fa-var-up-right-and-down-left-from-center,\n  \"expand-alt\": $fa-var-expand-alt,\n  \"oil-can\": $fa-var-oil-can,\n  \"t\": $fa-var-t,\n  \"hippo\": $fa-var-hippo,\n  \"chart-column\": $fa-var-chart-column,\n  \"infinity\": $fa-var-infinity,\n  \"vial-circle-check\": $fa-var-vial-circle-check,\n  \"person-arrow-down-to-line\": $fa-var-person-arrow-down-to-line,\n  \"voicemail\": $fa-var-voicemail,\n  \"fan\": $fa-var-fan,\n  \"person-walking-luggage\": $fa-var-person-walking-luggage,\n  \"up-down\": $fa-var-up-down,\n  \"arrows-alt-v\": $fa-var-arrows-alt-v,\n  \"cloud-moon-rain\": $fa-var-cloud-moon-rain,\n  \"calendar\": $fa-var-calendar,\n  \"trailer\": $fa-var-trailer,\n  \"bahai\": $fa-var-bahai,\n  \"haykal\": $fa-var-haykal,\n  \"sd-card\": $fa-var-sd-card,\n  \"dragon\": $fa-var-dragon,\n  \"shoe-prints\": $fa-var-shoe-prints,\n  \"circle-plus\": $fa-var-circle-plus,\n  \"plus-circle\": $fa-var-plus-circle,\n  \"face-grin-tongue-wink\": $fa-var-face-grin-tongue-wink,\n  \"grin-tongue-wink\": $fa-var-grin-tongue-wink,\n  \"hand-holding\": $fa-var-hand-holding,\n  \"plug-circle-exclamation\": $fa-var-plug-circle-exclamation,\n  \"link-slash\": $fa-var-link-slash,\n  \"chain-broken\": $fa-var-chain-broken,\n  \"chain-slash\": $fa-var-chain-slash,\n  \"unlink\": $fa-var-unlink,\n  \"clone\": $fa-var-clone,\n  \"person-walking-arrow-loop-left\": $fa-var-person-walking-arrow-loop-left,\n  \"arrow-up-z-a\": $fa-var-arrow-up-z-a,\n  \"sort-alpha-up-alt\": $fa-var-sort-alpha-up-alt,\n  \"fire-flame-curved\": $fa-var-fire-flame-curved,\n  \"fire-alt\": $fa-var-fire-alt,\n  \"tornado\": $fa-var-tornado,\n  \"file-circle-plus\": $fa-var-file-circle-plus,\n  \"book-quran\": $fa-var-book-quran,\n  \"quran\": $fa-var-quran,\n  \"anchor\": $fa-var-anchor,\n  \"border-all\": $fa-var-border-all,\n  \"face-angry\": $fa-var-face-angry,\n  \"angry\": $fa-var-angry,\n  \"cookie-bite\": $fa-var-cookie-bite,\n  \"arrow-trend-down\": $fa-var-arrow-trend-down,\n  \"rss\": $fa-var-rss,\n  \"feed\": $fa-var-feed,\n  \"draw-polygon\": $fa-var-draw-polygon,\n  \"scale-balanced\": $fa-var-scale-balanced,\n  \"balance-scale\": $fa-var-balance-scale,\n  \"gauge-simple-high\": $fa-var-gauge-simple-high,\n  \"tachometer\": $fa-var-tachometer,\n  \"tachometer-fast\": $fa-var-tachometer-fast,\n  \"shower\": $fa-var-shower,\n  \"desktop\": $fa-var-desktop,\n  \"desktop-alt\": $fa-var-desktop-alt,\n  \"m\": $fa-var-m,\n  \"table-list\": $fa-var-table-list,\n  \"th-list\": $fa-var-th-list,\n  \"comment-sms\": $fa-var-comment-sms,\n  \"sms\": $fa-var-sms,\n  \"book\": $fa-var-book,\n  \"user-plus\": $fa-var-user-plus,\n  \"check\": $fa-var-check,\n  \"battery-three-quarters\": $fa-var-battery-three-quarters,\n  \"battery-4\": $fa-var-battery-4,\n  \"house-circle-check\": $fa-var-house-circle-check,\n  \"angle-left\": $fa-var-angle-left,\n  \"diagram-successor\": $fa-var-diagram-successor,\n  \"truck-arrow-right\": $fa-var-truck-arrow-right,\n  \"arrows-split-up-and-left\": $fa-var-arrows-split-up-and-left,\n  \"hand-fist\": $fa-var-hand-fist,\n  \"fist-raised\": $fa-var-fist-raised,\n  \"cloud-moon\": $fa-var-cloud-moon,\n  \"briefcase\": $fa-var-briefcase,\n  \"person-falling\": $fa-var-person-falling,\n  \"image-portrait\": $fa-var-image-portrait,\n  \"portrait\": $fa-var-portrait,\n  \"user-tag\": $fa-var-user-tag,\n  \"rug\": $fa-var-rug,\n  \"earth-europe\": $fa-var-earth-europe,\n  \"globe-europe\": $fa-var-globe-europe,\n  \"cart-flatbed-suitcase\": $fa-var-cart-flatbed-suitcase,\n  \"luggage-cart\": $fa-var-luggage-cart,\n  \"rectangle-xmark\": $fa-var-rectangle-xmark,\n  \"rectangle-times\": $fa-var-rectangle-times,\n  \"times-rectangle\": $fa-var-times-rectangle,\n  \"window-close\": $fa-var-window-close,\n  \"baht-sign\": $fa-var-baht-sign,\n  \"book-open\": $fa-var-book-open,\n  \"book-journal-whills\": $fa-var-book-journal-whills,\n  \"journal-whills\": $fa-var-journal-whills,\n  \"handcuffs\": $fa-var-handcuffs,\n  \"triangle-exclamation\": $fa-var-triangle-exclamation,\n  \"exclamation-triangle\": $fa-var-exclamation-triangle,\n  \"warning\": $fa-var-warning,\n  \"database\": $fa-var-database,\n  \"share\": $fa-var-share,\n  \"mail-forward\": $fa-var-mail-forward,\n  \"bottle-droplet\": $fa-var-bottle-droplet,\n  \"mask-face\": $fa-var-mask-face,\n  \"hill-rockslide\": $fa-var-hill-rockslide,\n  \"right-left\": $fa-var-right-left,\n  \"exchange-alt\": $fa-var-exchange-alt,\n  \"paper-plane\": $fa-var-paper-plane,\n  \"road-circle-exclamation\": $fa-var-road-circle-exclamation,\n  \"dungeon\": $fa-var-dungeon,\n  \"align-right\": $fa-var-align-right,\n  \"money-bill-1-wave\": $fa-var-money-bill-1-wave,\n  \"money-bill-wave-alt\": $fa-var-money-bill-wave-alt,\n  \"life-ring\": $fa-var-life-ring,\n  \"hands\": $fa-var-hands,\n  \"sign-language\": $fa-var-sign-language,\n  \"signing\": $fa-var-signing,\n  \"calendar-day\": $fa-var-calendar-day,\n  \"water-ladder\": $fa-var-water-ladder,\n  \"ladder-water\": $fa-var-ladder-water,\n  \"swimming-pool\": $fa-var-swimming-pool,\n  \"arrows-up-down\": $fa-var-arrows-up-down,\n  \"arrows-v\": $fa-var-arrows-v,\n  \"face-grimace\": $fa-var-face-grimace,\n  \"grimace\": $fa-var-grimace,\n  \"wheelchair-move\": $fa-var-wheelchair-move,\n  \"wheelchair-alt\": $fa-var-wheelchair-alt,\n  \"turn-down\": $fa-var-turn-down,\n  \"level-down-alt\": $fa-var-level-down-alt,\n  \"person-walking-arrow-right\": $fa-var-person-walking-arrow-right,\n  \"square-envelope\": $fa-var-square-envelope,\n  \"envelope-square\": $fa-var-envelope-square,\n  \"dice\": $fa-var-dice,\n  \"bowling-ball\": $fa-var-bowling-ball,\n  \"brain\": $fa-var-brain,\n  \"bandage\": $fa-var-bandage,\n  \"band-aid\": $fa-var-band-aid,\n  \"calendar-minus\": $fa-var-calendar-minus,\n  \"circle-xmark\": $fa-var-circle-xmark,\n  \"times-circle\": $fa-var-times-circle,\n  \"xmark-circle\": $fa-var-xmark-circle,\n  \"gifts\": $fa-var-gifts,\n  \"hotel\": $fa-var-hotel,\n  \"earth-asia\": $fa-var-earth-asia,\n  \"globe-asia\": $fa-var-globe-asia,\n  \"id-card-clip\": $fa-var-id-card-clip,\n  \"id-card-alt\": $fa-var-id-card-alt,\n  \"magnifying-glass-plus\": $fa-var-magnifying-glass-plus,\n  \"search-plus\": $fa-var-search-plus,\n  \"thumbs-up\": $fa-var-thumbs-up,\n  \"user-clock\": $fa-var-user-clock,\n  \"hand-dots\": $fa-var-hand-dots,\n  \"allergies\": $fa-var-allergies,\n  \"file-invoice\": $fa-var-file-invoice,\n  \"window-minimize\": $fa-var-window-minimize,\n  \"mug-saucer\": $fa-var-mug-saucer,\n  \"coffee\": $fa-var-coffee,\n  \"brush\": $fa-var-brush,\n  \"mask\": $fa-var-mask,\n  \"magnifying-glass-minus\": $fa-var-magnifying-glass-minus,\n  \"search-minus\": $fa-var-search-minus,\n  \"ruler-vertical\": $fa-var-ruler-vertical,\n  \"user-large\": $fa-var-user-large,\n  \"user-alt\": $fa-var-user-alt,\n  \"train-tram\": $fa-var-train-tram,\n  \"user-nurse\": $fa-var-user-nurse,\n  \"syringe\": $fa-var-syringe,\n  \"cloud-sun\": $fa-var-cloud-sun,\n  \"stopwatch-20\": $fa-var-stopwatch-20,\n  \"square-full\": $fa-var-square-full,\n  \"magnet\": $fa-var-magnet,\n  \"jar\": $fa-var-jar,\n  \"note-sticky\": $fa-var-note-sticky,\n  \"sticky-note\": $fa-var-sticky-note,\n  \"bug-slash\": $fa-var-bug-slash,\n  \"arrow-up-from-water-pump\": $fa-var-arrow-up-from-water-pump,\n  \"bone\": $fa-var-bone,\n  \"user-injured\": $fa-var-user-injured,\n  \"face-sad-tear\": $fa-var-face-sad-tear,\n  \"sad-tear\": $fa-var-sad-tear,\n  \"plane\": $fa-var-plane,\n  \"tent-arrows-down\": $fa-var-tent-arrows-down,\n  \"exclamation\": $fa-var-exclamation,\n  \"arrows-spin\": $fa-var-arrows-spin,\n  \"print\": $fa-var-print,\n  \"turkish-lira-sign\": $fa-var-turkish-lira-sign,\n  \"try\": $fa-var-try,\n  \"turkish-lira\": $fa-var-turkish-lira,\n  \"dollar-sign\": $fa-var-dollar-sign,\n  \"dollar\": $fa-var-dollar,\n  \"usd\": $fa-var-usd,\n  \"x\": $fa-var-x,\n  \"magnifying-glass-dollar\": $fa-var-magnifying-glass-dollar,\n  \"search-dollar\": $fa-var-search-dollar,\n  \"users-gear\": $fa-var-users-gear,\n  \"users-cog\": $fa-var-users-cog,\n  \"person-military-pointing\": $fa-var-person-military-pointing,\n  \"building-columns\": $fa-var-building-columns,\n  \"bank\": $fa-var-bank,\n  \"institution\": $fa-var-institution,\n  \"museum\": $fa-var-museum,\n  \"university\": $fa-var-university,\n  \"umbrella\": $fa-var-umbrella,\n  \"trowel\": $fa-var-trowel,\n  \"d\": $fa-var-d,\n  \"stapler\": $fa-var-stapler,\n  \"masks-theater\": $fa-var-masks-theater,\n  \"theater-masks\": $fa-var-theater-masks,\n  \"kip-sign\": $fa-var-kip-sign,\n  \"hand-point-left\": $fa-var-hand-point-left,\n  \"handshake-simple\": $fa-var-handshake-simple,\n  \"handshake-alt\": $fa-var-handshake-alt,\n  \"jet-fighter\": $fa-var-jet-fighter,\n  \"fighter-jet\": $fa-var-fighter-jet,\n  \"square-share-nodes\": $fa-var-square-share-nodes,\n  \"share-alt-square\": $fa-var-share-alt-square,\n  \"barcode\": $fa-var-barcode,\n  \"plus-minus\": $fa-var-plus-minus,\n  \"video\": $fa-var-video,\n  \"video-camera\": $fa-var-video-camera,\n  \"graduation-cap\": $fa-var-graduation-cap,\n  \"mortar-board\": $fa-var-mortar-board,\n  \"hand-holding-medical\": $fa-var-hand-holding-medical,\n  \"person-circle-check\": $fa-var-person-circle-check,\n  \"turn-up\": $fa-var-turn-up,\n  \"level-up-alt\": $fa-var-level-up-alt,\n);\n\n$fa-brand-icons: (\n  \"monero\": $fa-var-monero,\n  \"hooli\": $fa-var-hooli,\n  \"yelp\": $fa-var-yelp,\n  \"cc-visa\": $fa-var-cc-visa,\n  \"lastfm\": $fa-var-lastfm,\n  \"shopware\": $fa-var-shopware,\n  \"creative-commons-nc\": $fa-var-creative-commons-nc,\n  \"aws\": $fa-var-aws,\n  \"redhat\": $fa-var-redhat,\n  \"yoast\": $fa-var-yoast,\n  \"cloudflare\": $fa-var-cloudflare,\n  \"ups\": $fa-var-ups,\n  \"pixiv\": $fa-var-pixiv,\n  \"wpexplorer\": $fa-var-wpexplorer,\n  \"dyalog\": $fa-var-dyalog,\n  \"bity\": $fa-var-bity,\n  \"stackpath\": $fa-var-stackpath,\n  \"buysellads\": $fa-var-buysellads,\n  \"first-order\": $fa-var-first-order,\n  \"modx\": $fa-var-modx,\n  \"guilded\": $fa-var-guilded,\n  \"vnv\": $fa-var-vnv,\n  \"square-js\": $fa-var-square-js,\n  \"js-square\": $fa-var-js-square,\n  \"microsoft\": $fa-var-microsoft,\n  \"qq\": $fa-var-qq,\n  \"orcid\": $fa-var-orcid,\n  \"java\": $fa-var-java,\n  \"invision\": $fa-var-invision,\n  \"creative-commons-pd-alt\": $fa-var-creative-commons-pd-alt,\n  \"centercode\": $fa-var-centercode,\n  \"glide-g\": $fa-var-glide-g,\n  \"drupal\": $fa-var-drupal,\n  \"jxl\": $fa-var-jxl,\n  \"hire-a-helper\": $fa-var-hire-a-helper,\n  \"creative-commons-by\": $fa-var-creative-commons-by,\n  \"unity\": $fa-var-unity,\n  \"whmcs\": $fa-var-whmcs,\n  \"rocketchat\": $fa-var-rocketchat,\n  \"vk\": $fa-var-vk,\n  \"untappd\": $fa-var-untappd,\n  \"mailchimp\": $fa-var-mailchimp,\n  \"css3-alt\": $fa-var-css3-alt,\n  \"square-reddit\": $fa-var-square-reddit,\n  \"reddit-square\": $fa-var-reddit-square,\n  \"vimeo-v\": $fa-var-vimeo-v,\n  \"contao\": $fa-var-contao,\n  \"square-font-awesome\": $fa-var-square-font-awesome,\n  \"deskpro\": $fa-var-deskpro,\n  \"brave\": $fa-var-brave,\n  \"sistrix\": $fa-var-sistrix,\n  \"square-instagram\": $fa-var-square-instagram,\n  \"instagram-square\": $fa-var-instagram-square,\n  \"battle-net\": $fa-var-battle-net,\n  \"the-red-yeti\": $fa-var-the-red-yeti,\n  \"square-hacker-news\": $fa-var-square-hacker-news,\n  \"hacker-news-square\": $fa-var-hacker-news-square,\n  \"edge\": $fa-var-edge,\n  \"threads\": $fa-var-threads,\n  \"napster\": $fa-var-napster,\n  \"square-snapchat\": $fa-var-square-snapchat,\n  \"snapchat-square\": $fa-var-snapchat-square,\n  \"google-plus-g\": $fa-var-google-plus-g,\n  \"artstation\": $fa-var-artstation,\n  \"markdown\": $fa-var-markdown,\n  \"sourcetree\": $fa-var-sourcetree,\n  \"google-plus\": $fa-var-google-plus,\n  \"diaspora\": $fa-var-diaspora,\n  \"foursquare\": $fa-var-foursquare,\n  \"stack-overflow\": $fa-var-stack-overflow,\n  \"github-alt\": $fa-var-github-alt,\n  \"phoenix-squadron\": $fa-var-phoenix-squadron,\n  \"pagelines\": $fa-var-pagelines,\n  \"algolia\": $fa-var-algolia,\n  \"red-river\": $fa-var-red-river,\n  \"creative-commons-sa\": $fa-var-creative-commons-sa,\n  \"safari\": $fa-var-safari,\n  \"google\": $fa-var-google,\n  \"square-font-awesome-stroke\": $fa-var-square-font-awesome-stroke,\n  \"font-awesome-alt\": $fa-var-font-awesome-alt,\n  \"atlassian\": $fa-var-atlassian,\n  \"linkedin-in\": $fa-var-linkedin-in,\n  \"digital-ocean\": $fa-var-digital-ocean,\n  \"nimblr\": $fa-var-nimblr,\n  \"chromecast\": $fa-var-chromecast,\n  \"evernote\": $fa-var-evernote,\n  \"hacker-news\": $fa-var-hacker-news,\n  \"creative-commons-sampling\": $fa-var-creative-commons-sampling,\n  \"adversal\": $fa-var-adversal,\n  \"creative-commons\": $fa-var-creative-commons,\n  \"watchman-monitoring\": $fa-var-watchman-monitoring,\n  \"fonticons\": $fa-var-fonticons,\n  \"weixin\": $fa-var-weixin,\n  \"shirtsinbulk\": $fa-var-shirtsinbulk,\n  \"codepen\": $fa-var-codepen,\n  \"git-alt\": $fa-var-git-alt,\n  \"lyft\": $fa-var-lyft,\n  \"rev\": $fa-var-rev,\n  \"windows\": $fa-var-windows,\n  \"wizards-of-the-coast\": $fa-var-wizards-of-the-coast,\n  \"square-viadeo\": $fa-var-square-viadeo,\n  \"viadeo-square\": $fa-var-viadeo-square,\n  \"meetup\": $fa-var-meetup,\n  \"centos\": $fa-var-centos,\n  \"adn\": $fa-var-adn,\n  \"cloudsmith\": $fa-var-cloudsmith,\n  \"opensuse\": $fa-var-opensuse,\n  \"pied-piper-alt\": $fa-var-pied-piper-alt,\n  \"square-dribbble\": $fa-var-square-dribbble,\n  \"dribbble-square\": $fa-var-dribbble-square,\n  \"codiepie\": $fa-var-codiepie,\n  \"node\": $fa-var-node,\n  \"mix\": $fa-var-mix,\n  \"steam\": $fa-var-steam,\n  \"cc-apple-pay\": $fa-var-cc-apple-pay,\n  \"scribd\": $fa-var-scribd,\n  \"debian\": $fa-var-debian,\n  \"openid\": $fa-var-openid,\n  \"instalod\": $fa-var-instalod,\n  \"expeditedssl\": $fa-var-expeditedssl,\n  \"sellcast\": $fa-var-sellcast,\n  \"square-twitter\": $fa-var-square-twitter,\n  \"twitter-square\": $fa-var-twitter-square,\n  \"r-project\": $fa-var-r-project,\n  \"delicious\": $fa-var-delicious,\n  \"freebsd\": $fa-var-freebsd,\n  \"vuejs\": $fa-var-vuejs,\n  \"accusoft\": $fa-var-accusoft,\n  \"ioxhost\": $fa-var-ioxhost,\n  \"fonticons-fi\": $fa-var-fonticons-fi,\n  \"app-store\": $fa-var-app-store,\n  \"cc-mastercard\": $fa-var-cc-mastercard,\n  \"itunes-note\": $fa-var-itunes-note,\n  \"golang\": $fa-var-golang,\n  \"kickstarter\": $fa-var-kickstarter,\n  \"square-kickstarter\": $fa-var-square-kickstarter,\n  \"grav\": $fa-var-grav,\n  \"weibo\": $fa-var-weibo,\n  \"uncharted\": $fa-var-uncharted,\n  \"firstdraft\": $fa-var-firstdraft,\n  \"square-youtube\": $fa-var-square-youtube,\n  \"youtube-square\": $fa-var-youtube-square,\n  \"wikipedia-w\": $fa-var-wikipedia-w,\n  \"wpressr\": $fa-var-wpressr,\n  \"rendact\": $fa-var-rendact,\n  \"angellist\": $fa-var-angellist,\n  \"galactic-republic\": $fa-var-galactic-republic,\n  \"nfc-directional\": $fa-var-nfc-directional,\n  \"skype\": $fa-var-skype,\n  \"joget\": $fa-var-joget,\n  \"fedora\": $fa-var-fedora,\n  \"stripe-s\": $fa-var-stripe-s,\n  \"meta\": $fa-var-meta,\n  \"laravel\": $fa-var-laravel,\n  \"hotjar\": $fa-var-hotjar,\n  \"bluetooth-b\": $fa-var-bluetooth-b,\n  \"square-letterboxd\": $fa-var-square-letterboxd,\n  \"sticker-mule\": $fa-var-sticker-mule,\n  \"creative-commons-zero\": $fa-var-creative-commons-zero,\n  \"hips\": $fa-var-hips,\n  \"behance\": $fa-var-behance,\n  \"reddit\": $fa-var-reddit,\n  \"discord\": $fa-var-discord,\n  \"chrome\": $fa-var-chrome,\n  \"app-store-ios\": $fa-var-app-store-ios,\n  \"cc-discover\": $fa-var-cc-discover,\n  \"wpbeginner\": $fa-var-wpbeginner,\n  \"confluence\": $fa-var-confluence,\n  \"shoelace\": $fa-var-shoelace,\n  \"mdb\": $fa-var-mdb,\n  \"dochub\": $fa-var-dochub,\n  \"accessible-icon\": $fa-var-accessible-icon,\n  \"ebay\": $fa-var-ebay,\n  \"amazon\": $fa-var-amazon,\n  \"unsplash\": $fa-var-unsplash,\n  \"yarn\": $fa-var-yarn,\n  \"square-steam\": $fa-var-square-steam,\n  \"steam-square\": $fa-var-steam-square,\n  \"500px\": $fa-var-500px,\n  \"square-vimeo\": $fa-var-square-vimeo,\n  \"vimeo-square\": $fa-var-vimeo-square,\n  \"asymmetrik\": $fa-var-asymmetrik,\n  \"font-awesome\": $fa-var-font-awesome,\n  \"font-awesome-flag\": $fa-var-font-awesome-flag,\n  \"font-awesome-logo-full\": $fa-var-font-awesome-logo-full,\n  \"gratipay\": $fa-var-gratipay,\n  \"apple\": $fa-var-apple,\n  \"hive\": $fa-var-hive,\n  \"gitkraken\": $fa-var-gitkraken,\n  \"keybase\": $fa-var-keybase,\n  \"apple-pay\": $fa-var-apple-pay,\n  \"padlet\": $fa-var-padlet,\n  \"amazon-pay\": $fa-var-amazon-pay,\n  \"square-github\": $fa-var-square-github,\n  \"github-square\": $fa-var-github-square,\n  \"stumbleupon\": $fa-var-stumbleupon,\n  \"fedex\": $fa-var-fedex,\n  \"phoenix-framework\": $fa-var-phoenix-framework,\n  \"shopify\": $fa-var-shopify,\n  \"neos\": $fa-var-neos,\n  \"square-threads\": $fa-var-square-threads,\n  \"hackerrank\": $fa-var-hackerrank,\n  \"researchgate\": $fa-var-researchgate,\n  \"swift\": $fa-var-swift,\n  \"angular\": $fa-var-angular,\n  \"speakap\": $fa-var-speakap,\n  \"angrycreative\": $fa-var-angrycreative,\n  \"y-combinator\": $fa-var-y-combinator,\n  \"empire\": $fa-var-empire,\n  \"envira\": $fa-var-envira,\n  \"google-scholar\": $fa-var-google-scholar,\n  \"square-gitlab\": $fa-var-square-gitlab,\n  \"gitlab-square\": $fa-var-gitlab-square,\n  \"studiovinari\": $fa-var-studiovinari,\n  \"pied-piper\": $fa-var-pied-piper,\n  \"wordpress\": $fa-var-wordpress,\n  \"product-hunt\": $fa-var-product-hunt,\n  \"firefox\": $fa-var-firefox,\n  \"linode\": $fa-var-linode,\n  \"goodreads\": $fa-var-goodreads,\n  \"square-odnoklassniki\": $fa-var-square-odnoklassniki,\n  \"odnoklassniki-square\": $fa-var-odnoklassniki-square,\n  \"jsfiddle\": $fa-var-jsfiddle,\n  \"sith\": $fa-var-sith,\n  \"themeisle\": $fa-var-themeisle,\n  \"page4\": $fa-var-page4,\n  \"hashnode\": $fa-var-hashnode,\n  \"react\": $fa-var-react,\n  \"cc-paypal\": $fa-var-cc-paypal,\n  \"squarespace\": $fa-var-squarespace,\n  \"cc-stripe\": $fa-var-cc-stripe,\n  \"creative-commons-share\": $fa-var-creative-commons-share,\n  \"bitcoin\": $fa-var-bitcoin,\n  \"keycdn\": $fa-var-keycdn,\n  \"opera\": $fa-var-opera,\n  \"itch-io\": $fa-var-itch-io,\n  \"umbraco\": $fa-var-umbraco,\n  \"galactic-senate\": $fa-var-galactic-senate,\n  \"ubuntu\": $fa-var-ubuntu,\n  \"draft2digital\": $fa-var-draft2digital,\n  \"stripe\": $fa-var-stripe,\n  \"houzz\": $fa-var-houzz,\n  \"gg\": $fa-var-gg,\n  \"dhl\": $fa-var-dhl,\n  \"square-pinterest\": $fa-var-square-pinterest,\n  \"pinterest-square\": $fa-var-pinterest-square,\n  \"xing\": $fa-var-xing,\n  \"blackberry\": $fa-var-blackberry,\n  \"creative-commons-pd\": $fa-var-creative-commons-pd,\n  \"playstation\": $fa-var-playstation,\n  \"quinscape\": $fa-var-quinscape,\n  \"less\": $fa-var-less,\n  \"blogger-b\": $fa-var-blogger-b,\n  \"opencart\": $fa-var-opencart,\n  \"vine\": $fa-var-vine,\n  \"signal-messenger\": $fa-var-signal-messenger,\n  \"paypal\": $fa-var-paypal,\n  \"gitlab\": $fa-var-gitlab,\n  \"typo3\": $fa-var-typo3,\n  \"reddit-alien\": $fa-var-reddit-alien,\n  \"yahoo\": $fa-var-yahoo,\n  \"dailymotion\": $fa-var-dailymotion,\n  \"affiliatetheme\": $fa-var-affiliatetheme,\n  \"pied-piper-pp\": $fa-var-pied-piper-pp,\n  \"bootstrap\": $fa-var-bootstrap,\n  \"odnoklassniki\": $fa-var-odnoklassniki,\n  \"nfc-symbol\": $fa-var-nfc-symbol,\n  \"mintbit\": $fa-var-mintbit,\n  \"ethereum\": $fa-var-ethereum,\n  \"speaker-deck\": $fa-var-speaker-deck,\n  \"creative-commons-nc-eu\": $fa-var-creative-commons-nc-eu,\n  \"patreon\": $fa-var-patreon,\n  \"avianex\": $fa-var-avianex,\n  \"ello\": $fa-var-ello,\n  \"gofore\": $fa-var-gofore,\n  \"bimobject\": $fa-var-bimobject,\n  \"brave-reverse\": $fa-var-brave-reverse,\n  \"facebook-f\": $fa-var-facebook-f,\n  \"square-google-plus\": $fa-var-square-google-plus,\n  \"google-plus-square\": $fa-var-google-plus-square,\n  \"web-awesome\": $fa-var-web-awesome,\n  \"mandalorian\": $fa-var-mandalorian,\n  \"first-order-alt\": $fa-var-first-order-alt,\n  \"osi\": $fa-var-osi,\n  \"google-wallet\": $fa-var-google-wallet,\n  \"d-and-d-beyond\": $fa-var-d-and-d-beyond,\n  \"periscope\": $fa-var-periscope,\n  \"fulcrum\": $fa-var-fulcrum,\n  \"cloudscale\": $fa-var-cloudscale,\n  \"forumbee\": $fa-var-forumbee,\n  \"mizuni\": $fa-var-mizuni,\n  \"schlix\": $fa-var-schlix,\n  \"square-xing\": $fa-var-square-xing,\n  \"xing-square\": $fa-var-xing-square,\n  \"bandcamp\": $fa-var-bandcamp,\n  \"wpforms\": $fa-var-wpforms,\n  \"cloudversify\": $fa-var-cloudversify,\n  \"usps\": $fa-var-usps,\n  \"megaport\": $fa-var-megaport,\n  \"magento\": $fa-var-magento,\n  \"spotify\": $fa-var-spotify,\n  \"optin-monster\": $fa-var-optin-monster,\n  \"fly\": $fa-var-fly,\n  \"aviato\": $fa-var-aviato,\n  \"itunes\": $fa-var-itunes,\n  \"cuttlefish\": $fa-var-cuttlefish,\n  \"blogger\": $fa-var-blogger,\n  \"flickr\": $fa-var-flickr,\n  \"viber\": $fa-var-viber,\n  \"soundcloud\": $fa-var-soundcloud,\n  \"digg\": $fa-var-digg,\n  \"tencent-weibo\": $fa-var-tencent-weibo,\n  \"letterboxd\": $fa-var-letterboxd,\n  \"symfony\": $fa-var-symfony,\n  \"maxcdn\": $fa-var-maxcdn,\n  \"etsy\": $fa-var-etsy,\n  \"facebook-messenger\": $fa-var-facebook-messenger,\n  \"audible\": $fa-var-audible,\n  \"think-peaks\": $fa-var-think-peaks,\n  \"bilibili\": $fa-var-bilibili,\n  \"erlang\": $fa-var-erlang,\n  \"x-twitter\": $fa-var-x-twitter,\n  \"cotton-bureau\": $fa-var-cotton-bureau,\n  \"dashcube\": $fa-var-dashcube,\n  \"42-group\": $fa-var-42-group,\n  \"innosoft\": $fa-var-innosoft,\n  \"stack-exchange\": $fa-var-stack-exchange,\n  \"elementor\": $fa-var-elementor,\n  \"square-pied-piper\": $fa-var-square-pied-piper,\n  \"pied-piper-square\": $fa-var-pied-piper-square,\n  \"creative-commons-nd\": $fa-var-creative-commons-nd,\n  \"palfed\": $fa-var-palfed,\n  \"superpowers\": $fa-var-superpowers,\n  \"resolving\": $fa-var-resolving,\n  \"xbox\": $fa-var-xbox,\n  \"square-web-awesome-stroke\": $fa-var-square-web-awesome-stroke,\n  \"searchengin\": $fa-var-searchengin,\n  \"tiktok\": $fa-var-tiktok,\n  \"square-facebook\": $fa-var-square-facebook,\n  \"facebook-square\": $fa-var-facebook-square,\n  \"renren\": $fa-var-renren,\n  \"linux\": $fa-var-linux,\n  \"glide\": $fa-var-glide,\n  \"linkedin\": $fa-var-linkedin,\n  \"hubspot\": $fa-var-hubspot,\n  \"deploydog\": $fa-var-deploydog,\n  \"twitch\": $fa-var-twitch,\n  \"ravelry\": $fa-var-ravelry,\n  \"mixer\": $fa-var-mixer,\n  \"square-lastfm\": $fa-var-square-lastfm,\n  \"lastfm-square\": $fa-var-lastfm-square,\n  \"vimeo\": $fa-var-vimeo,\n  \"mendeley\": $fa-var-mendeley,\n  \"uniregistry\": $fa-var-uniregistry,\n  \"figma\": $fa-var-figma,\n  \"creative-commons-remix\": $fa-var-creative-commons-remix,\n  \"cc-amazon-pay\": $fa-var-cc-amazon-pay,\n  \"dropbox\": $fa-var-dropbox,\n  \"instagram\": $fa-var-instagram,\n  \"cmplid\": $fa-var-cmplid,\n  \"upwork\": $fa-var-upwork,\n  \"facebook\": $fa-var-facebook,\n  \"gripfire\": $fa-var-gripfire,\n  \"jedi-order\": $fa-var-jedi-order,\n  \"uikit\": $fa-var-uikit,\n  \"fort-awesome-alt\": $fa-var-fort-awesome-alt,\n  \"phabricator\": $fa-var-phabricator,\n  \"ussunnah\": $fa-var-ussunnah,\n  \"earlybirds\": $fa-var-earlybirds,\n  \"trade-federation\": $fa-var-trade-federation,\n  \"autoprefixer\": $fa-var-autoprefixer,\n  \"whatsapp\": $fa-var-whatsapp,\n  \"square-upwork\": $fa-var-square-upwork,\n  \"slideshare\": $fa-var-slideshare,\n  \"google-play\": $fa-var-google-play,\n  \"viadeo\": $fa-var-viadeo,\n  \"line\": $fa-var-line,\n  \"google-drive\": $fa-var-google-drive,\n  \"servicestack\": $fa-var-servicestack,\n  \"simplybuilt\": $fa-var-simplybuilt,\n  \"bitbucket\": $fa-var-bitbucket,\n  \"imdb\": $fa-var-imdb,\n  \"deezer\": $fa-var-deezer,\n  \"raspberry-pi\": $fa-var-raspberry-pi,\n  \"jira\": $fa-var-jira,\n  \"docker\": $fa-var-docker,\n  \"screenpal\": $fa-var-screenpal,\n  \"bluetooth\": $fa-var-bluetooth,\n  \"gitter\": $fa-var-gitter,\n  \"d-and-d\": $fa-var-d-and-d,\n  \"microblog\": $fa-var-microblog,\n  \"cc-diners-club\": $fa-var-cc-diners-club,\n  \"gg-circle\": $fa-var-gg-circle,\n  \"pied-piper-hat\": $fa-var-pied-piper-hat,\n  \"kickstarter-k\": $fa-var-kickstarter-k,\n  \"yandex\": $fa-var-yandex,\n  \"readme\": $fa-var-readme,\n  \"html5\": $fa-var-html5,\n  \"sellsy\": $fa-var-sellsy,\n  \"square-web-awesome\": $fa-var-square-web-awesome,\n  \"sass\": $fa-var-sass,\n  \"wirsindhandwerk\": $fa-var-wirsindhandwerk,\n  \"wsh\": $fa-var-wsh,\n  \"buromobelexperte\": $fa-var-buromobelexperte,\n  \"salesforce\": $fa-var-salesforce,\n  \"octopus-deploy\": $fa-var-octopus-deploy,\n  \"medapps\": $fa-var-medapps,\n  \"ns8\": $fa-var-ns8,\n  \"pinterest-p\": $fa-var-pinterest-p,\n  \"apper\": $fa-var-apper,\n  \"fort-awesome\": $fa-var-fort-awesome,\n  \"waze\": $fa-var-waze,\n  \"bluesky\": $fa-var-bluesky,\n  \"cc-jcb\": $fa-var-cc-jcb,\n  \"snapchat\": $fa-var-snapchat,\n  \"snapchat-ghost\": $fa-var-snapchat-ghost,\n  \"fantasy-flight-games\": $fa-var-fantasy-flight-games,\n  \"rust\": $fa-var-rust,\n  \"wix\": $fa-var-wix,\n  \"square-behance\": $fa-var-square-behance,\n  \"behance-square\": $fa-var-behance-square,\n  \"supple\": $fa-var-supple,\n  \"webflow\": $fa-var-webflow,\n  \"rebel\": $fa-var-rebel,\n  \"css3\": $fa-var-css3,\n  \"staylinked\": $fa-var-staylinked,\n  \"kaggle\": $fa-var-kaggle,\n  \"space-awesome\": $fa-var-space-awesome,\n  \"deviantart\": $fa-var-deviantart,\n  \"cpanel\": $fa-var-cpanel,\n  \"goodreads-g\": $fa-var-goodreads-g,\n  \"square-git\": $fa-var-square-git,\n  \"git-square\": $fa-var-git-square,\n  \"square-tumblr\": $fa-var-square-tumblr,\n  \"tumblr-square\": $fa-var-tumblr-square,\n  \"trello\": $fa-var-trello,\n  \"creative-commons-nc-jp\": $fa-var-creative-commons-nc-jp,\n  \"get-pocket\": $fa-var-get-pocket,\n  \"perbyte\": $fa-var-perbyte,\n  \"grunt\": $fa-var-grunt,\n  \"weebly\": $fa-var-weebly,\n  \"connectdevelop\": $fa-var-connectdevelop,\n  \"leanpub\": $fa-var-leanpub,\n  \"black-tie\": $fa-var-black-tie,\n  \"themeco\": $fa-var-themeco,\n  \"python\": $fa-var-python,\n  \"android\": $fa-var-android,\n  \"bots\": $fa-var-bots,\n  \"free-code-camp\": $fa-var-free-code-camp,\n  \"hornbill\": $fa-var-hornbill,\n  \"js\": $fa-var-js,\n  \"ideal\": $fa-var-ideal,\n  \"git\": $fa-var-git,\n  \"dev\": $fa-var-dev,\n  \"sketch\": $fa-var-sketch,\n  \"yandex-international\": $fa-var-yandex-international,\n  \"cc-amex\": $fa-var-cc-amex,\n  \"uber\": $fa-var-uber,\n  \"github\": $fa-var-github,\n  \"php\": $fa-var-php,\n  \"alipay\": $fa-var-alipay,\n  \"youtube\": $fa-var-youtube,\n  \"skyatlas\": $fa-var-skyatlas,\n  \"firefox-browser\": $fa-var-firefox-browser,\n  \"replyd\": $fa-var-replyd,\n  \"suse\": $fa-var-suse,\n  \"jenkins\": $fa-var-jenkins,\n  \"twitter\": $fa-var-twitter,\n  \"rockrms\": $fa-var-rockrms,\n  \"pinterest\": $fa-var-pinterest,\n  \"buffer\": $fa-var-buffer,\n  \"npm\": $fa-var-npm,\n  \"yammer\": $fa-var-yammer,\n  \"btc\": $fa-var-btc,\n  \"dribbble\": $fa-var-dribbble,\n  \"stumbleupon-circle\": $fa-var-stumbleupon-circle,\n  \"internet-explorer\": $fa-var-internet-explorer,\n  \"stubber\": $fa-var-stubber,\n  \"telegram\": $fa-var-telegram,\n  \"telegram-plane\": $fa-var-telegram-plane,\n  \"old-republic\": $fa-var-old-republic,\n  \"odysee\": $fa-var-odysee,\n  \"square-whatsapp\": $fa-var-square-whatsapp,\n  \"whatsapp-square\": $fa-var-whatsapp-square,\n  \"node-js\": $fa-var-node-js,\n  \"edge-legacy\": $fa-var-edge-legacy,\n  \"slack\": $fa-var-slack,\n  \"slack-hash\": $fa-var-slack-hash,\n  \"medrt\": $fa-var-medrt,\n  \"usb\": $fa-var-usb,\n  \"tumblr\": $fa-var-tumblr,\n  \"vaadin\": $fa-var-vaadin,\n  \"quora\": $fa-var-quora,\n  \"square-x-twitter\": $fa-var-square-x-twitter,\n  \"reacteurope\": $fa-var-reacteurope,\n  \"medium\": $fa-var-medium,\n  \"medium-m\": $fa-var-medium-m,\n  \"amilia\": $fa-var-amilia,\n  \"mixcloud\": $fa-var-mixcloud,\n  \"flipboard\": $fa-var-flipboard,\n  \"viacoin\": $fa-var-viacoin,\n  \"critical-role\": $fa-var-critical-role,\n  \"sitrox\": $fa-var-sitrox,\n  \"discourse\": $fa-var-discourse,\n  \"joomla\": $fa-var-joomla,\n  \"mastodon\": $fa-var-mastodon,\n  \"airbnb\": $fa-var-airbnb,\n  \"wolf-pack-battalion\": $fa-var-wolf-pack-battalion,\n  \"buy-n-large\": $fa-var-buy-n-large,\n  \"gulp\": $fa-var-gulp,\n  \"creative-commons-sampling-plus\": $fa-var-creative-commons-sampling-plus,\n  \"strava\": $fa-var-strava,\n  \"ember\": $fa-var-ember,\n  \"canadian-maple-leaf\": $fa-var-canadian-maple-leaf,\n  \"teamspeak\": $fa-var-teamspeak,\n  \"pushed\": $fa-var-pushed,\n  \"wordpress-simple\": $fa-var-wordpress-simple,\n  \"nutritionix\": $fa-var-nutritionix,\n  \"wodu\": $fa-var-wodu,\n  \"google-pay\": $fa-var-google-pay,\n  \"intercom\": $fa-var-intercom,\n  \"zhihu\": $fa-var-zhihu,\n  \"korvue\": $fa-var-korvue,\n  \"pix\": $fa-var-pix,\n  \"steam-symbol\": $fa-var-steam-symbol,\n);\n","// icons in a list\n// -------------------------\n\n.#{$fa-css-prefix}-ul {\n  list-style-type: none;\n  margin-left: var(--#{$fa-css-prefix}-li-margin, #{$fa-li-margin});\n  padding-left: 0;\n\n  > li { position: relative; }\n}\n\n.#{$fa-css-prefix}-li {\n  left: calc(var(--#{$fa-css-prefix}-li-width, #{$fa-li-width}) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--#{$fa-css-prefix}-li-width, #{$fa-li-width});\n  line-height: inherit;\n}\n","// bordered + pulled icons\n// -------------------------\n\n.#{$fa-css-prefix}-border {\n  border-color: var(--#{$fa-css-prefix}-border-color, #{$fa-border-color});\n  border-radius: var(--#{$fa-css-prefix}-border-radius, #{$fa-border-radius});\n  border-style: var(--#{$fa-css-prefix}-border-style, #{$fa-border-style});\n  border-width: var(--#{$fa-css-prefix}-border-width, #{$fa-border-width});\n  padding: var(--#{$fa-css-prefix}-border-padding, #{$fa-border-padding});\n}\n\n.#{$fa-css-prefix}-pull-left {\n  float: left;\n  margin-right: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n\n.#{$fa-css-prefix}-pull-right {\n  float: right;\n  margin-left: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n","// animating icons\n// --------------------------\n\n.#{$fa-css-prefix}-beat {\n  animation-name: #{$fa-css-prefix}-beat;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-bounce {\n  animation-name: #{$fa-css-prefix}-bounce;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(0.280, 0.840, 0.420, 1));\n}\n\n.#{$fa-css-prefix}-fade {\n  animation-name: #{$fa-css-prefix}-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-beat-fade {\n  animation-name: #{$fa-css-prefix}-beat-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-flip {\n  animation-name: #{$fa-css-prefix}-flip;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-shake {\n  animation-name: #{$fa-css-prefix}-shake;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 2s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin-reverse {\n  --#{$fa-css-prefix}-animation-direction: reverse;\n}\n\n.#{$fa-css-prefix}-pulse,\n.#{$fa-css-prefix}-spin-pulse {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, steps(8));\n}\n\n// if agent or operating system prefers reduced motion, disable animations\n// see: https://www.smashingmagazine.com/2020/09/design-reduced-motion-sensitivities/\n// see: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion\n@media (prefers-reduced-motion: reduce) {\n  .#{$fa-css-prefix}-beat,\n  .#{$fa-css-prefix}-bounce,\n  .#{$fa-css-prefix}-fade,\n  .#{$fa-css-prefix}-beat-fade,\n  .#{$fa-css-prefix}-flip,\n  .#{$fa-css-prefix}-pulse,\n  .#{$fa-css-prefix}-shake,\n  .#{$fa-css-prefix}-spin,\n  .#{$fa-css-prefix}-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n\n@keyframes #{$fa-css-prefix}-beat {\n  0%, 90% { transform: scale(1); }\n  45% { transform: scale(var(--#{$fa-css-prefix}-beat-scale, 1.25)); }\n}\n\n@keyframes #{$fa-css-prefix}-bounce {\n  0%   { transform: scale(1,1) translateY(0); }\n  10%  { transform: scale(var(--#{$fa-css-prefix}-bounce-start-scale-x, 1.1),var(--#{$fa-css-prefix}-bounce-start-scale-y, 0.9)) translateY(0); }\n  30%  { transform: scale(var(--#{$fa-css-prefix}-bounce-jump-scale-x, 0.9),var(--#{$fa-css-prefix}-bounce-jump-scale-y, 1.1)) translateY(var(--#{$fa-css-prefix}-bounce-height, -0.5em)); }\n  50%  { transform: scale(var(--#{$fa-css-prefix}-bounce-land-scale-x, 1.05),var(--#{$fa-css-prefix}-bounce-land-scale-y, 0.95)) translateY(0); }\n  57%  { transform: scale(1,1) translateY(var(--#{$fa-css-prefix}-bounce-rebound, -0.125em)); }\n  64%  { transform: scale(1,1) translateY(0); }\n  100% { transform: scale(1,1) translateY(0); }\n}\n\n@keyframes #{$fa-css-prefix}-fade {\n  50% { opacity: var(--#{$fa-css-prefix}-fade-opacity, 0.4); }\n}\n\n@keyframes #{$fa-css-prefix}-beat-fade {\n  0%, 100% {\n    opacity: var(--#{$fa-css-prefix}-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--#{$fa-css-prefix}-beat-fade-scale, 1.125));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-flip {\n  50% {\n    transform: rotate3d(var(--#{$fa-css-prefix}-flip-x, 0), var(--#{$fa-css-prefix}-flip-y, 1), var(--#{$fa-css-prefix}-flip-z, 0), var(--#{$fa-css-prefix}-flip-angle, -180deg));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-shake {\n  0% { transform: rotate(-15deg); }\n  4% { transform: rotate(15deg); }\n  8%, 24% { transform: rotate(-18deg); }\n  12%, 28% { transform: rotate(18deg); }\n  16% { transform: rotate(-22deg); }\n  20% { transform: rotate(22deg); }\n  32% { transform: rotate(-12deg); }\n  36% { transform: rotate(12deg); }\n  40%, 100% { transform: rotate(0deg); }\n}\n\n@keyframes #{$fa-css-prefix}-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n","// rotating + flipping icons\n// -------------------------\n\n.#{$fa-css-prefix}-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.#{$fa-css-prefix}-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.#{$fa-css-prefix}-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.#{$fa-css-prefix}-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.#{$fa-css-prefix}-flip-both,\n.#{$fa-css-prefix}-flip-horizontal.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.#{$fa-css-prefix}-rotate-by {\n  transform: rotate(var(--#{$fa-css-prefix}-rotate-angle, 0));\n}\n","// stacking icons\n// -------------------------\n\n.#{$fa-css-prefix}-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: $fa-stack-vertical-align;\n  width: $fa-stack-width;\n}\n\n.#{$fa-css-prefix}-stack-1x,\n.#{$fa-css-prefix}-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: var(--#{$fa-css-prefix}-stack-z-index, #{$fa-stack-z-index});\n}\n\n.#{$fa-css-prefix}-stack-1x {\n  line-height: inherit;\n}\n\n.#{$fa-css-prefix}-stack-2x {\n  font-size: 2em;\n}\n\n.#{$fa-css-prefix}-inverse {\n  color: var(--#{$fa-css-prefix}-inverse, #{$fa-inverse});\n}\n","// specific icon class definition\n// -------------------------\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n\n@each $name, $icon in $fa-icons {\n  .#{$fa-css-prefix}-#{$name}::before { content: unquote(\"\\\"#{ $icon }\\\"\"); }\n}\n\n","// screen-reader utilities\n// -------------------------\n\n// only display content to screen readers\n.sr-only,\n.#{$fa-css-prefix}-sr-only {\n  @include fa-sr-only;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n.sr-only-focusable,\n.#{$fa-css-prefix}-sr-only-focusable {\n  @include fa-sr-only-focusable;\n}\n","/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n@import 'functions';\n@import 'variables';\n\n:root, :host {\n  --#{$fa-css-prefix}-style-family-classic: '#{ $fa-style-family }';\n  --#{$fa-css-prefix}-font-solid: normal 900 1em/1 '#{ $fa-style-family }';\n}\n\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-solid-900.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-solid-900.ttf') format('truetype');\n}\n\n.fas,\n.#{$fa-css-prefix}-solid {\n  font-weight: 900;\n}\n","/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n@import 'functions';\n@import 'variables';\n\n:root, :host {\n  --#{$fa-css-prefix}-style-family-brands: 'Font Awesome 6 Brands';\n  --#{$fa-css-prefix}-font-brands: normal 400 1em/1 'Font Awesome 6 Brands';\n}\n\n@font-face {\n  font-family: 'Font Awesome 6 Brands';\n  font-style: normal;\n  font-weight: 400;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-brands-400.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-brands-400.ttf') format('truetype');\n}\n\n.fab,\n.#{$fa-css-prefix}-brands {\n  font-weight: 400;\n}\n\n@each $name, $icon in $fa-brand-icons {\n  .#{$fa-css-prefix}-#{$name}:before { content: unquote(\"\\\"#{ $icon }\\\"\"); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
